{
	"metadata": {
		"version": "87"
	},
	"contests": {
		"contest-2020-1": {
			"title": {
				"en": "Contest {contestId}",
				"ru": "Конкурс {contestId}"
			},
			"description": {
				"en": "<h5>On July 13, 2020 a two-week trader contest on the 50x.com exchange starts:</h5><ul><li>1st place 1500 USDT</li><li>2nd place 500 USDT</li><li>3rd place 300 USDT</li><li>4th-10th place 100 USDT</li></ul><HR><h5>Terms and conditions of participation in the contest:</h5><ol><li>The contest will be held from 00:00 UTC  July 13, 2020, to 00:00 UTC July 27, 2020. </li><li>All orders participating in the contest must be placed in any of trading pairs with Take Profit and “contest-2020-1” order note field</li><li>The order note field has to be specified when creating an order because it is impossible to change the order note to “contest-2020-1” or clear it once the order has been placed.</li><li>For participation of your account in the contest, you must have at least 10 closed by take profit positions with total equity turnover not less than 0.1 BTC. </li><li>The price of Take Profit orders can be changed at any time.</li><li>If you have opened positions with a “contest-2020-1” order note field after the contest, then the percentage of profit will be calculated according to market prices at the end of the contest.</li><li>The rating of participants in the competition is based on the value of the weighted average percentage of profit from the deals for the period of the competition.</li><li>The awarding will be held on July 27, 2020.</li></ol><p>For trading, you can use your own or borrowed funds in any cryptocurrency available for the loans on the 50x.com exchange.</p>",
				"ru": "<h5>13 июля 2020 стартует двухнедельный конкурс трейдеров на платформе 50x.com:</h5><ul><li>1500 USDT первое место</li><li>500 USDT второе место</li><li>300 USDT третье место</li><li>100 USDT с 4 по 10 места</li></ul><HR><h5>Правила проведения:</h5><ol><li>В конкурсе участвуют ордера, установленные в любых парах с 00:00 UTC 13 июля 2020 года, имеющие тейк-профит и поле 'Примечание', которое должно содержать текст contest-2020-1</li><li>Примечание необходимо указать при создании ордера. Изменить примечание на contest-2020-1 у уже установленных ордеров невозможно. Также как невозможно его убрать, если оно было установлено при создании ордера.</li><li>Для получения приза необходимо за период конкурса иметь не менее 10 завершенных по тейк-профиту позиций на <b>суммарный (за весь период конкурса)</b> эквивалентный обьем не менее 0.1 BTC с 13 июля 2020 по 26 июля 2020 включительно.</li><li>Изменять цену и уровень тейк-профита ордеров можно неограниченное количество раз.</li><li>Если на момент окончания конкурса у вас останутся незакрытые позиции с комментарием contest-2020-1, то условный процент прибыли по ним будет рассчитан исходя из рыночных цен на момент окончания конкурса.</li><li>Рейтинг участников конкурса составляется по значению средневзвешенного процента прибыли по сделкам за период конкурса.</li><li>Распределение призов состоится  27 июля 2020 года.</li></ol><p>Для торговли вы можете использовать как свои собственные, так и заемные средства в любой доступной для займов криптовалюте на бирже 50x.com</p>"
			}
		}
	},
	"advcash": {
		"supportEmail": {
            "en": "support@advcash.com "
		}
	},
    "statistic:ordersProfit": {
        "ru": "Профит ордеров",
        "en": "Orders profit"
    },
    "statistic:sltpProfit": {
        "ru": "Профит позиций",
        "en": "SLTP profit"
    },
    "statistic:sltp": {
        "ru": "Профит позиций",
        "en": "SLTP profit"
    },
    "statistic:pair": {
        "ru": "Статистика пары",
        "en": "Pair stats"
    },
    "statistic:ordersCount": {
        "ru": "Статистика ордеров",
        "en": "Orders stats"
    },
    "statistic:tradeVolume": {
        "ru": "Объем торговли",
        "en": "Trade Volume"
    },
    "statistic:canceledOrders": {
        "ru": "Отмененные",
        "en": "Canceled"
    },
    "statistic:totalOrders": {
        "ru": "Всего ордеров",
        "en": "Total orders"
    },
	"actionsTypes": {
		"agreementConfirm": {
			"en": "Signing a user agreement",
            "ru": "Подписание пользовательского соглашения"
		},
		"tpLoss": {
			"en": "Setting Takeprofit price with a loss (negative profit)"
		},
		"convertDust": {
			"en": "Remained {sym} conversion to A2A tokens",
            "ru": "Конвертация остатка {sym} в токены A2A"
		},
		"order2Position": {
            "en": "Order to position conversion",
            "ru": "Преобразование ордера в позицию",
            "uk": "Перетворення ордера в позицію"
        },
		"orderSetFullfilled": {
			"en": "Set order as fulfilled",
			"de": "Setzen Sie den Handelsauftrag als erfüllt",
			"fr": "Définir l'ordre de négociation comme exécuté",
			"it": "Imposta l'ordine di trading come evaso",
			"ja": "成約として取引注文を設定します",
			"ko": "거래 주문이 이행 됨으로 설정",
			"ru": "Перевод ордера в состояние Исполненый",
			"tr": "İşlem emrini yerine getirildi olarak ayarla",
			"uk": "Встановіть торгове замовлення як виконане",
			"zh": "将交易订单设置为已履行"
		},
		"remove_wd_address": {
			"en": "Delete withdrawal address",
			"de": "Abhebungsadresse löschen",
			"fr": "Supprimer l'adresse de retrait",
			"it": "Elimina l'indirizzo di prelievo",
			"ja": "引き出しアドレスを削除する",
			"ko": "출금 주소 삭제",
			"ru": "Удалить адрес вывода",
			"tr": "Para çekme adresini sil",
			"uk": "Видалити адресу вилучення",
			"zh": "删除提款地址"
		},
		"add_or_update_wd_address": {
			"en": "Add/change withdrawal address",
			"de": "Abhebungsadresse hinzufügen/ändern",
			"fr": "Ajouter/modifier l'adresse de retrait",
			"it": "Aggiungi/modifica l'indirizzo di prelievo",
			"ja": "引き出し先住所の追加/変更",
			"ko": "출금 주소 추가 / 변경",
			"ru": "Добавить / изменить адрес вывода",
			"tr": "Para çekme adresi ekle/değiştir",
			"uk": "Додати / змінити адресу для вилучення",
			"zh": "添加/更改提款地址"
		},
		"changeDepositAddress": {
			"en": "Change Deposit Address",
			"de": "Einzahlungsadresse ändern",
			"fr": "Modifier l'adresse de dépôt",
			"it": "Cambia indirizzo di deposito",
			"ja": "預金アドレスの変更",
			"ko": "입금 주소 변경",
			"ru": "Смена адреса пополнения",
			"tr": "Para Yatırma Adresini Değiştir",
			"uk": "Змінити адресу депозиту",
			"zh": "更改存款地址"
		},
		"advCashDeposit": {
			"en": "AdvCash: New deposit",
			"de": "Zahlen Sie Geld über AdvCash ein",
			"fr": "Déposer des fonds via AdvCash",
			"it": "Deposita fondi tramite AdvCash",
			"ja": "AdvCashを介して資金を入金する",
			"ko": "AdvCash를 통해 자금 입금",
			"ru": "AdvCash: Новый депозит",
			"tr": "AdvCash ile para yatırın",
			"uk": "AdvCash: Новий депозит",
			"zh": "通过AdvCash存入资金"
		},
		"2fa_fail": {
			"en": "Received wrong or expired 2FA OTP",
			"fr": "Le 2FA OTP reçu est incorrect ou expiré.",
			"it": "OTP 2FA errato o scaduto",
			"ja": "誤りのある、または期限切れの2FA OTPを受信しました",
			"ru": "Введен неверный или истекший однократный код 2FA",
			"tr": "Hatalı alınan veya süresi dolmuş 2FA OTP",
			"uk": "Введений не вірний або минулий одноразовий код 2FA",
			"zh": "收到错误或过期的2FA OTP"
		},
		"2fa_success": {
			"en": "2FA: Correct 2FA OTP has been used",
			"fr": "2FA: Le 2FA OTP correct a été utilisé.",
			"it": "2FA: è stato utilizzato il OTP 2FA corretto",
			"ja": "2FA: 正しい2FA OTPが使用されています",
			"ru": "2FA: Использован верный однократный код 2FA",
			"tr": "2FA: Doğru 2FA OTP kullanılmıştır",
			"uk": "2FA: Використано правильний одноразовий код 2FA",
			"zh": "2FA：使用了正确的2FA OTP"
		},
		"replace_2fa": {
			"en": "2FA: seed private key replacement",
			"ru": "2FA: Замена приватного ключа"
		},
		"ClosingPMARequest": {
			"en": "PMA closing request",
			"fr": "Demande de fermeture de PMA",
			"it": "Richiesta di chiusura PMA",
			"ja": "PMA終了リクエスト",
			"ru": "Запрос на закрытие PMA",
			"tr": "PMA kapatma talebi",
			"uk": "Запит на закриття PMA",
			"zh": "PMA关闭请求"
		},
		"newEWA": {
			"en": "New EWA has been set",
			"ru": "Установлен новый EWA"
		},
		"lendFund": {
			"en": "Lending order placement",
			"ru": "Установка кредитного ордера"
		},
		"lendCancel": {
			"en": "Lending order cancellation",
			"ru": "Отмена кредитного ордера"
		},
		"getLoan": {
			"en": "Loan request",
			"ru": "Запрос на получение займа"
		},
		"change_wd_delay": {
			"en": "Withdrawal delay change request",
			"ru": "Запрос на изменение Задержки Вывода средств"
		},
		"changeLoan": {
			"en": "Loan parameters change request",
			"ru": "Запрос на изменение займа"
		},
		"payBackLoan": {
			"en": "Loan repayment request",
			"ru": "Запрос на возврат займа"
		},
		"PMAClose": {
			"en": "PMA: PMA closing request",
			"fr": "PMA : Demande de fermeture de PMA",
			"it": "PMA: richiesta di chiusura PMA",
			"ja": "PMA：PMA終了リクエスト",
			"ru": "PMA: Запрос на закрытие PMA",
			"tr": "PMA: PMA kapatma talebi",
			"uk": "PMA: Запит на закриття PMA",
			"zh": "PMA：关闭请求"
		},
		"PMAEdit": {
			"en": "PMA settings change"
		},
		"PMAClose2faFail": {
			"en": "PMA: PMA closing request rejected - wrong OTP",
			"fr": "PMA : Demande de fermeture du PMA est rejeté - OTP incorrect",
			"it": "PMA: richiesta di chiusura PMA rifiutata - OTP errato",
			"ja": "PMA：PMA終了リクエストが拒否されました-OTPに誤りがあります。",
			"ru": "PMA: Ошибка кода 2FA при попытке закрытия PMA",
			"tr": "PMA: PMA kapatma talebi reddedildi - hatalı OTP",
			"uk": "PMA: Помилка коду 2FA при спробі закриття PMA",
			"zh": "PMA：PMA关闭请求被拒绝错误的OTP"
		},
		"PMADepositClose": {
			"en": "PMA: Deposit closing request",
			"fr": "PMA: Demande de fermeture du dépôt",
			"it": "PMA: richiesta di chiusura del deposito",
			"ja": "PMA: 入金終了リクエスト",
			"ru": "PMA: Запрос на закрытие депозита PMA",
			"test": "PMA: Deposit closing request",
			"tr": "PMA: Mevduat kapatma talebi",
			"uk": "PMA: Запит на закриття депозиту PMA",
			"zh": "PMA：存款结清请求"
		},
		"PMADepositClose2faFail": {
			"en": "PMA: Deposit Closing request rejected - wrong OTP",
			"fr": "PMA: Demande de fermeture du dépôt rejeté - OTP incorrect",
			"it": "PMA: richiesta di chiusura del deposito rifiutata - OTP errato",
			"ja": "PMA：入金終了リクエストが拒否されました-OTPに誤りがあります。",
			"ru": "PMA: Ошибка 2FA закрытия депозита на PMA",
			"test": "Deposit Closing request rejected - wrong OTP",
			"tr": "PMA: Mevduat Kapatma talebi reddedildi - hatalı OTP",
			"uk": "PMA: Помилка 2FA закриття депозиту на PMA",
			"zh": "PMA：拒绝存款结帐请求-错误的OTP"
		},
		"PMADepositOpen": {
			"en": "PMA: New deposit to PMA",
			"fr": "PMA: Nouveau dépôt au PMA",
			"it": "PMA: nuovo deposito in PMA",
			"ja": "PMA: PMAに新しい入金があります",
			"ru": "PMA: Новый депозит на PMA",
			"test": "New deposit to PMA",
			"tr": "PMA: PMA'ya yeni para yatırma işlemi",
			"uk": "PMA: Новий депозит на PMA",
			"zh": "PMA：PMA的新存款"
		},
		"PMADepositOpen2faFail": {
			"en": "PMA: PMA Deposit failed - wrong 2FA OTP",
			"fr": "PMA: Dépôt au PMA échoué - 2FA OTP incorrect",
			"it": "PMA: deposito PMA fallito - OFA 2FA errato",
			"ja": "PMA: PMA入金の失敗-2FA OTPに誤りがあります",
			"ru": "PMA: Ошибка 2FA при депозите на PMA",
			"test": "еуые PMA Deposit failed - wrong 2FA OTP",
			"tr": "PMA: PMA'ya Para yatırılamadı - hatalı 2FA OTP",
			"uk": "PMA: Помилка 2FA при відкритті депозиту на PMA",
			"zh": "PMA：PMA存款失败-错误的2FA OTP"
		},
		"PMAOpen": {
			"en": "New PMA created",
			"fr": "Nouveau PMA a été créé",
			"it": "Nuova PMA creata",
			"ja": "新しいPMAが作成されました",
			"ru": "Открытие нового PMA",
			"test": "New PMA created",
			"tr": "Yeni PMA oluşturuldu",
			"uk": "Відкриття нового PMA",
			"zh": "新建PMA"
		},
		"PMAOpen2faFail": {
			"en": "PMA: PMA opening failed, wrong 2FA OTP.",
			"fr": "PMA: Ouverture de PMA échoué, 2FA OPT incorrect.",
			"it": "PMA: apertura PMA non riuscita, OTP 2FA errato.",
			"ja": "PMA：PMAを開けませんでした。2FA OTPに誤りがあります。",
			"ru": "PMA: Ошибка содания PMA, неверный 2FA OTP",
			"test": "PMA opening failed, wrong 2FA OTP.",
			"tr": "PMA: PMA açılamadı, hatalı 2FA OTP.",
			"uk": "PMA: Помилка створення PMA, не вірний 2FA OTP",
			"zh": "PMA：PMA打开失败，2FA OTP错误。"
		},
		"PMASwitch": {
			"en": "Switch to PMA",
			"fr": "Passer au PMA",
			"it": "Passa a PMA",
			"ja": "PMAに切り替え",
			"ru": "Переключение на PMA",
			"test": "Switch to PMA",
			"tr": "PMA'ya geçin",
			"uk": "Перемикання на PMA",
			"zh": "切换到PMA"
		},
		"SLTPset": {
			"en": "Set SLTP parameters for order {o_id}",
			"ru": "Установка параметров SLTP для ордера {o_id}"
		},
		"addApikey": {
			"en": "API: New API key created",
			"fr": "API: Une nouvelle clé API a été créée",
			"it": "API: nuova chiave API creata",
			"ja": "API：新しいAPIキーが作成されました",
			"ru": "API: Создан новый API ключ",
			"tr": "API: Yeni API anahtarı oluşturuldu",
			"uk": "API: Створено новий API ключ",
			"zh": "API:已创建新的API密钥"
		},
		"authfail": {
			"en": "Authorization failed",
			"fr": "Échec de l'autorisation",
			"it": "Autorizzazione fallita",
			"ja": "認証に失敗しました",
			"ru": "Ошибка авторизации",
			"tr": "Yetkilendirme başarısız oldu",
			"uk": "Помилка авторизації",
			"zh": "授权失败"
		},
		"ordersCancellation": {
			"en": "Mass order cancellation",
			"fr": "Annulation de commande en masse",
			"it": "Annullamento dell'ordine in massa",
			"ja": "大量注文のキャンセル",
			"ru": "Отмена нескольких ордеров",
			"tr": "Toplu komut iptali",
			"uk": "Відміна декількох ордерів",
			"zh": "批量订单取消"
		},
		"orderCancellation": {
			"en": "Order cancellation",
			"fr": "Annulation de commande",
			"it": "Annullamento dell'ordine",
			"ja": "注文のキャンセル",
			"ru": "Отмена ордера",
			"tr": "Komut iptali",
			"uk": "Відміна ордера",
			"zh": "订单取消"
		},
		"changeEmail": {
			"en": "Email change",
			"fr": "Email changé",
			"it": "Email cambiato",
			"ja": "メールを変更しました",
			"ru": "Изменение email",
			"tr": "E-posta değiştirildi",
			"uk": "Зміна Email",
			"zh": "电子邮件已更改"
		},
		"orderChange": {
			"en": "Order change",
			"fr": "Commande changée",
			"it": "Ordine cambiato",
			"ja": "注文を変更しました",
			"ru": "Изменение ордера",
			"tr": "Komut değiştirildi",
			"uk": "Зміна ордера",
			"zh": "订单已更改"
		},
		"change_sltp": {
			"en": "Change SLTP parameters",
			"fr": "Modification des paramètres SLTP",
			"it": "Modifica dei parametri SLTP",
			"ja": "SLTPパラメーターの変更",
			"ru": "Изменение параметров SLTP",
			"tr": "SLTP parametreleri değişimi",
			"uk": "Зміна параметрів SLTP",
			"zh": "SLTP参数更改"
		},
		"confirmWithdraw": {
			"en": "Withdrawal confirmation",
			"fr": "Confirmation de prélèvement",
			"it": "Conferma di prelievo",
			"ja": "出金の確認",
			"ru": "Подтверждение вывода",
			"tr": "Para çekme onayı",
			"uk": "Підтвердження виведення",
			"zh": "提款确认书"
		},
		"disable2fa_wd": {
			"en": "Withdrawal OTP has been deleted",
			"fr": "OTP de prélèvement a été supprimé",
			"it": "OTP per i prelevamenti è stato cancellato",
			"ja": "出金OTPが削除されました",
			"ru": "Удален дополнительный OTP на вывод",
			"tr": "Para çekilen OTP silindi",
			"uk": "Видалено додатковий OTP на виведення",
			"zh": "已删除提款OTP"
		},
		"enable_2fa": {
			"en": "2FA: New 2FA SEED has been set",
			"fr": "2FA: Nouveau 2FA SEED a été fixé",
			"it": "2FA: è stato impostato il nuovo 2FA SEED",
			"ja": "2FA：新しい2FAシードが設定されました",
			"ru": "2FA: Установлен новый приватный ключ 2FA",
			"tr": "2FA: Yeni 2FA SEED ayarlanmıştır",
			"uk": "2FA: Встановлено новий приватний ключ 2FA",
			"zh": "2FA:已设置新的2FA种子"
		},
		"enable_2fa_wd": {
			"en": "Withdrawal OTP has been activated",
			"fr": "OTP de prélèvement a été activé",
			"it": "OTP per i prelevamenti è stato attivato",
			"ja": "出金OTPが有効化されました",
			"ru": "Активирован дополнительный OTP на вывод",
			"tr": "Para çekilen OTP etkinleştirildi",
			"uk": "Активовано додатковий OTP на виведення",
			"zh": "已激活提款OTP"
		},
		"initResetPassword": {
			"en": "Password reset request",
			"fr": "Demande de réinitialisation de mot de passe",
			"it": "Richiesta per la reimpostazione della password",
			"ja": "パスワードリセットのリクエスト",
			"ru": "Запрос сброса пароля",
			"tr": "Parola sıfırlama talebi",
			"uk": "Запит скидання пароля",
			"zh": "密码重置请求"
		},
		"signup": {
			"en": "Signup",
			"fr": "Inscription",
			"it": "Registrazione",
			"ja": "登録",
			"ru": "Регистрация",
			"tr": "Kaydol",
			"uk": "Реєстрація",
			"zh": "注册"
		},
		"login": {
			"en": "Login",
			"fr": "Connexion",
			"it": "Login",
			"ja": "ログイン",
			"ru": "Авторизация",
			"tr": "Oturum aç",
			"uk": "Авторизація",
			"zh": "登录"
		},
		"login_success": {
			"en": "Success authorization",
			"fr": "Autorisation réussite",
			"it": "Login effettuato con successo",
			"ja": "認証成功",
			"ru": "Успешная авторизация",
			"tr": "Başarılı yetkilendirme",
			"uk": "Успішна авторизація",
			"zh": "成功授权"
		},
		"logout": {
			"en": "Logout",
			"fr": "Déconnexion",
			"it": "Logout",
			"ja": "ログアウト",
			"ru": "Выход",
			"tr": "Çıkış yap",
			"uk": "Вихід",
			"zh": "注销"
		},
		"logout_all": {
			"en": "Logout from all devices",
			"fr": "Se déconnecter de tous les appareils",
			"it": "Logout da tutti i dispositivi",
			"ja": "全端末からログアウト",
			"ru": "Выход со всех устройств",
			"tr": "Tüm cihazlardan çıkış yap",
			"uk": "Вихід з усіх пристроїв",
			"zh": "从所有设备注销"
		},
		"orderPlacement": {
			"en": "Order placement",
			"fr": "Passer une commande",
			"it": "Effettuare un ordine",
			"ja": "発注",
			"ru": "Размещение ордера",
			"tr": "Komut yerleştirme",
			"uk": "Розміщення ордера",
			"zh": "下单"
		},
		"placeWithdraw": {
			"en": "Withdrawal request",
			"fr": "Demande de prélèvement",
			"it": "Richiesta di prelievo",
			"ja": "出金リクエスト",
			"ru": "Запрос на вывод",
			"tr": "Para çekme talebi",
			"uk": "Запит на виведення",
			"zh": "撤回请求"
		},
		"register_success": {
			"en": "Account created successfully",
			"fr": "Compte crée avec succès",
			"it": "Conto creato con successo",
			"ja": "アカウントが作成されました",
			"ru": "Аккаунт успешно создан",
			"tr": "Hesap başarıyla oluşturuldu",
			"uk": "Аккаунт успішно створено",
			"zh": "已成功创建帐户"
		},
		"resetPassword": {
			"en": "Password reset",
			"fr": "Réinitialiser le mot de passe",
			"it": "Reimpostazione della password",
			"ja": "パスワードのリセット",
			"ru": "Смена пароля",
			"tr": "Parola sıfırlama",
			"uk": "Зміна пароля",
			"zh": "密码重置"
		},
		"reset_2fa_fail": {
			"en": "2FA: 2FA SEED change failed",
			"fr": "2FA: Changement du 2FA SEED échoué",
			"it": "2FA: modifica del SEED 2FA non riuscita",
			"ja": "2FA：2FAシードの変更に失敗しました",
			"ru": "2FA: Не удалось заменить приватный ключ 2FA",
			"tr": "2FA: 2FA SEED değişikliği başarısız oldu",
			"uk": "2FA: Не вдалося замінити приватний ключ 2FA",
			"zh": "2FA:2FA种子更改失败"
		},
		"set_masterkey": {
			"en": "Master Key has been activated",
			"fr": "Le Master Key a été activé",
			"it": "La Master Key è stata attivata",
			"ja": "マスターキーが有効化されました",
			"ru": "Активирован Мастер-ключ",
			"tr": "Ana Anahtar etkinleştirildi",
			"uk": "Активовано Майстер-ключ",
			"zh": "主密钥已激活"
		},
		"set_sltp": {
			"en": "SLTP order has been set",
			"fr": "Commande SLTP a été fixée",
			"it": "L'ordine SLTP è stato impostato",
			"ja": "SLTP注文が設定されました",
			"ru": "Установлен SLTP ордер",
			"tr": "SLTP komutu ayarlanmıştır",
			"uk": "Встановлено SLTP ордер",
			"zh": "已设置SLTP顺序"
		},
		"wd_2fa_fail": {
			"en": "Withdrawal request rejected - wrong OTP",
			"fr": "Demande de prélèvement rejetée - OTP incorrect",
			"it": "Richiesta di prelievo rifiutata - OTP errato",
			"ja": "出金リクエストが拒否されました-OTPに誤りがあります。",
			"ru": "Ошибка 2FA при запросе на вывод токенов",
			"tr": "Para çekme talebi reddedildi - hatalı OTP",
			"uk": "Помилка 2FA при запиті на виведення токенов",
			"zh": "撤回请求被拒绝-错误的OTP"
		}
	},
	"modal_loadNewVersion": {
		"_header": {
            "en": "Update required",
            "de": "Aktualisierung erforderlich",
            "fr": "Mise à jour requise",
            "it": "Aggiornamento richiesto",
            "ja": "アップデートしてください",
            "ko": "업데이트가 필요함",
            "ru": "Требуется обновление",
            "tr": "Güncelleştirme gerekli",
            "uk": "Потрібне оновлення",
            "zh": "需要更新"
		},
		"text1": {
            "en": "Server version is {versionNew}, your version is {versionOld}.",
            "de": "Die Serverversion ist {versionNew}, Ihre Version ist {versionOld}.",
            "fr": "La version du serveur est {versionNew}, votre version est {versionOld}.",
            "it": "La versione del server è {versionNew}, la tua versione è {versionOld}.",
            "ja": "サーバーのバージョンは{versionNew}、バージョンは{versionOld}です。",
            "ko": "서버 버전은 {versionNew}이고 귀하의 버전은 {versionOld}입니다.",
            "ru": "Версия сервера - {versionNew}, ваша версия - {versionOld}.",
            "tr": "Sunucu sürümü {versionNew}, sizin sürümünüz {versionOld}.",
            "uk": "Версія сервера - {versionNew}, ваша версія - {versionOld}.",
            "zh": "服务器版本为{versionNew}，您的版本为{versionOld}。"
		},
		"text2": {
            "en": "If you see this message again and again after reloading the terminal, please clear your browser's cache.",
            "de": "Wenn diese Meldung nach dem erneuten Laden des Terminals immer wieder angezeigt wird, leeren Sie bitte den Cache Ihres Browsers.",
            "fr": "Si vous voyez ce message encore et encore après avoir rechargé le terminal, veuillez vider le cache de votre navigateur.",
            "it": "Se visualizzi questo messaggio ancora e ancora dopo aver ricaricato il terminale, svuota la cache del browser.",
            "ja": "ターミナルをリロードした後にこのメッセージが何度も表示される場合は、ブラウザのキャッシュをクリアしてください。",
            "ko": "터미널을 새로 고침 한 후에도이 메시지가 계속 표시되면 브라우저의 캐시를 지우십시오.",
            "ru": "Если вы видите это сообщение снова и снова после перезагрузки терминала, очистите кеш браузера.",
            "tr": "Terminali yeniden yükledikten sonra bu mesajı tekrar tekrar görürseniz, lütfen tarayıcınızın önbelleğini temizleyin.",
            "uk": "Якщо після перезавантаження терміналу це повідомлення з’являється знову і знову, очистіть кеш браузера.",
            "zh": "如果在重新加载终端后一次又一次看到此消息，请清除浏览器的缓存。"
		}
	},
	"modal_paycard": {
		"_header": {
            "en": "Deposit {sym} through the payment system",
            "de": "Zahlen Sie {sym} über das Zahlungssystem ein",
            "fr": "Déposer {sym} via le système de paiement",
            "it": "Deposita {sym} tramite il sistema di pagamento",
            "ja": "支払いシステムを介して{sym}をデポジットします",
            "ko": "결제 시스템을 통해 {sym} 입금",
            "ru": "Пополнить {sym} покупкой у партнеров",
            "tr": "Ödeme sistemi aracılığıyla {sym} yatırın",
            "uk": "Внесіть депозит {sym} через платіжну систему",
            "zh": "通过付款系统存入{sym}"
		},
		"text1": {
            "en": "You may deposit {sym} paying with {advcashDepositMethods}. After depositing, you can easily trade {sym} for any other cryptocurrency listed on {domain.name}",
            "de": "Sie können {sym} mit {advcashDepositMethods} einzahlen. Nach der Einzahlung können Sie {sym} problemlos gegen jede andere Kryptowährung eintauschen, die unter {domain.name} aufgeführt ist.",
            "fr": "Vous pouvez déposer {sym} avec {advcashDepositMethods}. Après le dépôt, vous pouvez facilement échanger {sym} contre toute autre crypto-monnaie répertoriée sur {domain.name}.",
            "it": "Puoi depositare {sym} con {advcashDepositMethods}. Dopo il deposito, puoi facilmente scambiare USDT con qualsiasi altra criptovaluta elencata su {domain.name}.",
            "ja": "{sym}は、{advcashDepositMethods} で入金できます。入金後、{sym}を{domain.name}にリストされている他の暗号通貨と簡単に交換できます。",
            "ko": "{advcashDepositMethods}로 {sym}를 입금 할 수 있습니다. 입금 후 {sym}를 {domain.name}에 등록 된 다른 암호 화폐로 쉽게 교환 할 수 있습니다.",
            "ru": "Вы можете пополнить свой баланс {sym} оплатив с помощью {advcashDepositMethods}. После зачисления, {sym} можно обменять на любую криптовалюту доступную для торгов на {domain.name}",
            "tr": "{sym}'yi {advcashDepositMethods} ile yatırabilirsiniz. Para yatırma işleminden sonra, {sym}'yi {domain.name} üzerinde listelenen diğer herhangi bir kripto para birimiyle kolayca değiştirebilirsiniz.",
            "uk": "Ви можете внести {sym} на {advcashDepositMethods}. Після депозиту ви можете легко обміняти {sym} на будь-яку іншу криптовалюту, вказану на {domain.name}.",
            "zh": "您可以将{sym}存入{advcashDepositMethods}。存款后，您可以轻松地将USDT兑换为{domain.name}上列出的任何其他加密货币。"
		},
		"text2": {
            "en": "To perform this action, you will be redirected to a third-party service provider's website (KYC/AML verification might be needed), fees might be applied. In case of any problems with the transactions involved please contact service provider's support via e-mail [advcash.supportEmail]",
            "de": "Um diese Aktion auszuführen, werden Sie auf eine Website eines Drittanbieters weitergeleitet (möglicherweise ist eine KYC / AML-Überprüfung erforderlich). Es können Gebühren anfallen. Wenn Sie Probleme mit den Transaktionen haben, senden Sie bitte eine E-Mail an den Support des Dienstanbieters unter [advcash.supportEmail]",
            "fr": "Pour effectuer cette action, vous serez redirigé vers un site Web tiers (une vérification KYC / AML peut être requise). Des frais peuvent s'appliquer. Si vous rencontrez des problèmes avec les transactions, veuillez envoyer un e-mail au support du fournisseur de services à [advcash.supportEmail]",
            "it": "Per eseguire questa azione, verrai reindirizzato al sito Web di un fornitore di servizi di terze parti (potrebbe essere necessaria la verifica KYC / AML), potrebbero essere applicate delle tariffe. In caso di problemi con le transazioni coinvolte, contattare il supporto del fornitore di servizi tramite e-mail [advcash.supportEmail]",
            "ja": "このアクションを実行するには、サードパーティのWebサイトにリダイレクトされます（KYC / AML検証が必要な場合があります）。料金がかかる場合があります。取引に問題がある場合は、サービスプロバイダーのサポート（[advcash.supportEmail]）に電子メールを送信してください。",
            "ko": "이 작업을 수행하려면 타사 서비스 제공 업체의 웹 사이트로 리디렉션되며 (KYC / AML 확인이 필요할 수 있음) 수수료가 적용될 수 있습니다. 관련 거래에 문제가있는 경우 이메일 [advcash.supportEmail]을 통해 서비스 제공 업체의 지원팀에 문의하십시오.",
            "ru": "Чтобы выполнить это действие, вы будете перенаправлены на веб-сайт стороннего поставщика услуг (может потребоваться проверка KYC / AML), могут взиматься сборы. В случае возникновения проблем с транзакциями, пожалуйста, свяжитесь со службой поддержки поставщика услуг по email [advcash.supportEmail]",
            "tr": "Bu eylemi gerçekleştirmek için bir üçüncü taraf hizmet sağlayıcısının web sitesine yönlendirileceksiniz (KYC / AML doğrulaması gerekebilir), ücretler uygulanabilir. İlgili işlemlerle ilgili herhangi bir sorun olması durumunda, lütfen [advcash.supportEmail] e-posta yoluyla servis sağlayıcının desteğiyle iletişime geçin.",
            "uk": "Для виконання цієї дії вас буде перенаправлено на сторонній веб-сайт (може знадобитися підтвердження KYC / AML). Може стягуватися плата. Якщо у вас виникли проблеми з транзакціями, будь ласка, надішліть електронною поштою підтримку постачальника послуг за адресою [advcash.supportEmail]",
            "zh": "要执行此操作，您将被重定向到第三方网站（可能需要KYC / AML验证）。可能需要付费。如果您对交易有任何疑问，请通过[advcash.supportEmail]向服务提供商的支持发送电子邮件"
		},
		"text3": {
            "en": "{symTitle} will be sent to your {domain.name} depositing address {addr}",
            "de": "{symTitle} wird an Ihre {domain.name} Hinterlegungsadresse {addr} gesendet",
            "fr": "{symTitle} sera envoyé à votre adresse de dépôt {domain.name} {addr}",
            "it": "{symTitle} verrà inviato al tuo indirizzo di deposito {domain.name} {addr}",
            "ja": "{symTitle}は{domain.name}のデポジットアドレス{addr}に送信されます",
            "ko": "{symTitle}이 {domain.name} 입금 주소 {addr}로 전송됩니다.",
            "ru": "{symTitle} будет отправлено на ваш {domain.name} адрес депозита {addr}.",
            "tr": "{symTitle}, {domain.name} yatırma adresinize {addr} gönderilecektir.",
            "uk": "{symTitle} буде надіслано на вашу адресу домену {domain.name} {addr}",
            "zh": "{symTitle} 将发送到您的 {domain.name} 存款地址 {addr}"
		}
	},
	"modal_lendingCancel": {
		"text1": {
            "en": "When you send a lending order cancellation request, the unused part of the lending order will be cancelled immediately. However, used part (current loans) will be cancelled within 7 days.",
            "ru": "Когда вы посылаете запрос на отмену кредитного ордера, его неиспользованная часть отменяется немедленно. Использованная часть (уже выданные займы) будет отменена в течение 7 дней."
		}
	},
	"modal_youtube": {
		"_header": {
            "en": "Overview",
            "ru": "Обзор"
		}
	},
	"modal_loanEdit": {
		"_header": {
            "en": "Loan refinance settings",
            "ru": "Настройка рефинансирования займа"
		},
		"text1": {
            "en": "If current loan will be expired, the system will try to find a new loan for you and replace the old one with the given fee.",
            "ru": "Если текущий займ подлежит погашению, система будет пытаться найти для вас новый займ на замену с указанной ставкой."
		}
	},
	"modal_loanInfo": {},
	"modal_lend": {
		"text1": {
			"en": "Interest rate is calculated each time you change the volume to be the best offer for the entered amount.",
			"ru": "Каждый раз, когда вы меняете количество, ставка корректируется так, чтобы ваше предложение было лучшим с учетом введенного объема."
		},
		"text2": {
			"en": "Set volume first, then correct the interest rate.",
			"ru": "Сначала установите количество, затем скорректируйте ставку."
		}
	},
	"loanList": {},
	"loanMy": {
		"_header": {}
	},
    "loans": {
		"text1": {
			"en": "Here you can set a higher refinancing interest rate to avoid unexpected loan withdrawals. When a lender requests a loan back, the system tries to find the same amount from other lenders to replace your loan with the same or lower interest rate. If no loans with the same rates are found within 6 days, the system will notify you 24 hours before the cancellation of the loan, and you can increase the maximum interest rate to refinance the loan. However, it is best to do this beforehand.",
			"ru": "Здесь вы можете установить более высокую процентную ставку рефинансирования, чтобы избежать неожиданного отзыва займа. Когда кредитор запрашивает займ обратно, система пытается найти ту же сумму у других кредиторов, чтобы заменить ваш займ на другой, с такой же или более низкой процентной ставкой. Если в течение 6 дней не будет найдено ссуд с такими же ставками, система уведомит вас за 24 часа до отмены займа, и вы сможете увеличить максимальную процентную ставку для рефинансирования займа. Однако лучше сделать это заранее."
		},
		"text2": {
			"en": "This parameter does not affect the current interest rate on the loan.",
			"ru": "Этот параметр не влияет на текущую процентную ставку по займу."
		}
	},
    "lending": {
        "_header": {
            "en": "Lend funds",
            "ru": "Дать в долг под проценты"
        }
    },
	"messages": {
		"_header": {
		}
	},
	"modal_confirmAction": {
		"text2": {
		"deprecated": "deprecated",
			"en": "Please confirm the following action: {action}.",
			"ru": "Подтвердите следующее действие: {action}."
		}
	},
	"myProfit": {
		"_header": {
			"en": "Your {sym} wallet info",
			"ru": "Информация по кошельку {sym}"
		},
		"statistic": {
			"en": "Your {sym} promo code referral statistic",
			"ru": "Ваша реферальная статистика промокода {sym}"
		},
		"tradeSymInPairs": {
			"en": "Trade {sym} in the following pairs",
			"ru": "Торгуйте {sym} в следующих парах"
		},
		"paraminingLastBase": {
			"en": "{sym} amount valid for Staking Reward in 24H:",
			"ru": "Количество {sym} валидное для стейкинга за 24 часа (база):"
		},
		"paraminingLast": {
			"en": "Staking reward received in 24H:",
			"ru": "Стейкинг (парамайнинг) {sym} за 24 часа:"
		},
		"paraminingLastPercent": {
			"en": "Staking reward 24H profitability:",
			"ru": "Доходность Стейкинга за 24 часа:"
		},
		"paraminingLastPercentAnnualized": {
			"en": "Staking annualized current profitability:",
			"ru": "Текущая Годовая Доходность Стейкинга:"
		},
		"paraminingTotal": {
			"en": "Total amount of staking reward received:",
			"ru": "Получено награды за стейкинг {sym} за все время:"
		},
		"symRefRewardTotal": {
			"en": "Total amount of {sym} referral staking reward received:",
			"ru": "Всего получено реферальной награды {sym}:"
		},
		"symRefReward24h": {
			"en": "Referral staking reward received in 24H:",
			"ru": "Получено реферальной награды {sym} за 24 часа:"
		},
		"symRefRewardReferrals": {
			"en": "Number of your {sym} referrals:",
			"ru": "Количество {sym}-рефералов 1 уровня:"
		},
		"symRefRewardBase": {
			"en": "Sum of your {sym} referrals' {sym} balances:",
			"ru": "Сумма {sym} на балансах ваших рефералов:"
		}
	},
	"myPromo": {
		"_header": {
			"en": "Copy you own {prefix} promo code",
			"ru": "Скопируйте ваш специальный промокод {prefix}"
		},
		"text1": {
			"en": ""
		},
		"text2": {
			"en": "Your {prefix} promo code: {promo}",
			"ru": "Ваш специальный {prefix} промокод: {promo}"
		},
		"text3": {
			"en": "Tell this promo code to the users you direct to {domain.url} website. It should be used during new account registration.",
			"ru": "Сообщите этот промокод пользователям, которых вы направляете на {domain.url} для регистрации. Этот промокод нужно ввести при регистрации нового аккаунта."
		}
	},
	"modal_loanMarginCall": {
		"text1": {
			"en": "",
			"ru": ""
		},
		"text2": {
			"en": "Your current margin coverage is {own_funds_percent}% and too low! Fill your account with one of the trusted tokens ({loanSecuritiesSymString}) to increase margin coverage and prevent loan liquidation which will be done automatically if your margin coverage is less than {loan_liquidation_level}%.",
			"ru": "Ваше текущее маржинальное покрытие {own_funds_percent}%, что слишком мало! Пополните аккаунт одной из трастовых монет ({loanSecuritiesSymString}) для увеличения страхового покрытия и предотвращения автоматической ликвидации займа, которая произойдет если уровень покрытия опустится ниже {loan_liquidation_level}%."
		},
		"text3": {
			"en": "",
			"ru": ""
		}
	},
	"modal_loanLowFunds": {
		"text1": {
			"en": "",
			"ru": ""
		},
		"text2": {
			"en": "There are not enough own funds on your account to get a new loan. Your current margin coverage is {own_funds_percent}%, new loans are available for the accounts with margin coverage more than {new_loan_level}%.",
			"ru": "На вашем аккаунте недостаточно собственных средств для получения нового займа. Текущий уровень маржинального покрытия {own_funds_percent}%, новые займы доступны при уровне покрытия более {new_loan_level}%."
		},
		"text3": {
			"en": "",
			"ru": ""
		}
	},
	"modal_loanGet": {
		"_header": {
			"en": "You are going to get a loan in {sym}.",
			"ru": "Вы собираетесь взять займ в {sym}."
		},
		"text1": {
			"en": "Loans are provided by another users, conditions and availability may change in time.",
			"ru": "Займы предоставлены другими пользователями, их условия и доступность могут меняться с течением времени."
		},
		"text2": {
			"en": "Daily fee is accrued partially at the moment of loan transaction and each upcoming hour by increasing the loan amount.",
			"ru": "Дневная комиссия взимается в момент предоставления займа за текущий час и далее ежечасно путем увеличения суммы текущей задолженности."
		},
		"text3": {
			"en": "Enter desired amount to see expected daily fee for the loan. You may get better or shown fee rates for your loans. Upon success, you will find new incoming transactions on your account.",
			"ru": "Введите желаемый объем, чтобы рассчитать стоимость займов. В случае успешного получения займов вы увидите новые входящие транзакции на вашем аккаунте."
		},
		"available": {
			"en": "Available with given fee",
			"ru": "Доступно по выбранной ставке"
		},
		"accountLimit_description": {
			"en": "Your account has enough trusted coins ({loanSecuritiesSymString}) to cover {limit} {sym} loan. You may increase this limit by depositing more trusted coins or buying them on the exchange.",
			"ru": "На вашем аккаунте достаточно трастовых монет ({loanSecuritiesSymString}) для покрытия займа в {limit} {sym}. Вы можете увеличить этот лимит, пополнив баланс трастовыми монетами или купив их на бирже."
		}
	},
	"modal_otpConfirm": {
	},
	"modal_telegramNotificationPin": {
		"_header": {
			"en": "Get PIN to connect Telegram Bot",
			"ru": "Получите пин для подключения Телеграм-бота"
		},
		"text1": {
			"en": "Each separate Telegram notification to each separate user will be charged at 1 A2A token. If there are no A2A tokens on your account, only free notifications are sent to your MAIN Telegram account. ",
			"ru": "Каждое сообщение каждому отдельному пользователю Telegram стоит 1 A2A token. Если у вас нет A2A токенов на счету, будут отправляться только бесплатные сообщения на ваш ОСНОВНОЙ Telegram аккаунт."
		},
		"text2": {
			"en": " Never enter your login, password or 2FA OTP into the bot no matter what was asked! Only the provided PIN is safe to be used!",
			"ru": "Никогда не вводите ваш логин, пароль или код двухфакторной аутентификации в ботов, независимо от запрашиваемых данных. Безопасно можно вводить только предоставленный ПИН!"
		},
		"text3": {
			"en": "Enter 2FA code to see the PIN. The same PIN is valid for 1 Telegram account. You may connect up to 100 Telegram accounts with different PINs.",
			"ru": "Введите код 2FA чтобы получить ПИН. Один ПИН позволяет подключить только одного пользователя. Всего можно подключить до 100 пользователей."
		},
		"pin": {
			"en": "Your next PIN is<BR>{pin}<BR><BR>Search for <a href='https://t.me/info50x_bot' target='new'>@info50x_bot</a> in Telegram, send '/start' and follow the instructions with the given PIN to connect your account.",
			"ru": "Ваш следующий PIN:<BR>{pin}<BR><BR>Найдите бота <a href='https://t.me/info50x_bot' target='new'>@info50x_bot</a> в мессенджере Telegram, отправьте '/start' и следуйте инструкциям с выданным PIN чтобы присоединить аккаунт."
		}
	},
    "actionslogDeprecated": {
		"deprecated": "deprecated",
        "_header": {
            "en": "Actions log",
            "fr": "Journal d'actions",
            "it": "Registro delle azioni",
            "ja": "アクションログ",
            "ru": "Журнал",
            "tr": "İşlem günlüğü",
            "uk": "Журнал",
            "zh": "操作日志"
        },
        "actiontype": {
            "en": "Action type",
            "fr": "Type d'action",
            "it": "Tipo di azione",
            "ja": "アクションタイプ",
            "ru": "Вид действия",
            "tr": "İşlem türü",
            "uk": "Вид дії",
            "zh": "操作类型"
        },
        "typeDeprecated": {
		"deprecated": "deprecated",
            "orderSetFullfilled": {
                "en": "Set order as fulfilled",
                "de": "Setzen Sie den Handelsauftrag als erfüllt",
                "fr": "Définir l'ordre de négociation comme exécuté",
                "it": "Imposta l'ordine di trading come evaso",
                "ja": "成約として取引注文を設定します",
                "ko": "거래 주문이 이행 됨으로 설정",
                "ru": "Перевод ордера в состояние Исполненый",
                "tr": "İşlem emrini yerine getirildi olarak ayarla",
                "uk": "Встановіть торгове замовлення як виконане",
                "zh": "将交易订单设置为已履行"
            },
            "remove_wd_address": {
                "en": "Delete withdrawal address",
                "de": "Abhebungsadresse löschen",
                "fr": "Supprimer l'adresse de retrait",
                "it": "Elimina l'indirizzo di prelievo",
                "ja": "引き出しアドレスを削除する",
                "ko": "출금 주소 삭제",
                "ru": "Удалить адрес вывода",
                "tr": "Para çekme adresini sil",
                "uk": "Видалити адресу вилучення",
                "zh": "删除提款地址"
            },
            "add_or_update_wd_address": {
                "en": "Add/change withdrawal address",
                "de": "Abhebungsadresse hinzufügen/ändern",
                "fr": "Ajouter/modifier l'adresse de retrait",
                "it": "Aggiungi/modifica l'indirizzo di prelievo",
                "ja": "引き出し先住所の追加/変更",
                "ko": "출금 주소 추가 / 변경",
                "ru": "Добавить / изменить адрес вывода",
                "tr": "Para çekme adresi ekle/değiştir",
                "uk": "Додати / змінити адресу для вилучення",
                "zh": "添加/更改提款地址"
            },
            "changeDepositAddress": {
                "en": "Change Deposit Address",
                "de": "Einzahlungsadresse ändern",
                "fr": "Modifier l'adresse de dépôt",
                "it": "Cambia indirizzo di deposito",
                "ja": "預金アドレスの変更",
                "ko": "입금 주소 변경",
                "ru": "Смена адреса пополнения",
                "tr": "Para Yatırma Adresini Değiştir",
                "uk": "Змінити адресу депозиту",
                "zh": "更改存款地址"
            },
            "advCashDeposit": {
                "en": "AdvCash: New deposit",
                "de": "Zahlen Sie Geld über AdvCash ein",
                "fr": "Déposer des fonds via AdvCash",
                "it": "Deposita fondi tramite AdvCash",
                "ja": "AdvCashを介して資金を入金する",
                "ko": "AdvCash를 통해 자금 입금",
                "ru": "AdvCash: Новый депозит",
                "tr": "AdvCash ile para yatırın",
                "uk": "AdvCash: Новий депозит",
                "zh": "通过AdvCash存入资金"
            },
            "2fa_fail": {
                "en": "Received wrong or expired 2FA OTP",
                "fr": "Le 2FA OTP reçu est incorrect ou expiré.",
                "it": "OTP 2FA errato o scaduto",
                "ja": "誤りのある、または期限切れの2FA OTPを受信しました",
                "ru": "Введен неверный или истекший однократный код 2FA",
                "tr": "Hatalı alınan veya süresi dolmuş 2FA OTP",
                "uk": "Введений не вірний або минулий одноразовий код 2FA",
                "zh": "收到错误或过期的2FA OTP"
            },
            "2fa_success": {
                "en": "2FA: Correct 2FA OTP has been used",
                "fr": "2FA: Le 2FA OTP correct a été utilisé.",
                "it": "2FA: è stato utilizzato il OTP 2FA corretto",
                "ja": "2FA: 正しい2FA OTPが使用されています",
                "ru": "2FA: Использован верный однократный код 2FA",
                "tr": "2FA: Doğru 2FA OTP kullanılmıştır",
                "uk": "2FA: Використано правильний одноразовий код 2FA",
                "zh": "2FA：使用了正确的2FA OTP"
            },
            "replace_2fa": {
                "en": "2FA: seed private key has been replaced",
                "ru": "2FA: Замена приватного ключа"
            },
            "ClosingPMARequest": {
                "en": "PMA closing request",
                "fr": "Demande de fermeture de PMA",
                "it": "Richiesta di chiusura PMA",
                "ja": "PMA終了リクエスト",
                "ru": "Запрос на закрытие PMA",
                "tr": "PMA kapatma talebi",
                "uk": "Запит на закриття PMA",
                "zh": "PMA关闭请求"
            },
            "newEWA": {
                "en": "New EWA has been set",
                "ru": "Установлен новый EWA"
            },
            "cancelLending": {
                "en": "Lending order cancellation",
                "ru": "Отмена кредитного ордера"
            },
            "getLoan": {
                "en": "Loan request",
                "ru": "Запрос на получение займа"
            },
            "change_wd_delay": {
                "en": "Withdrawal delay change request",
                "ru": "Запрос на изменение Задержки Вывода средств"
            },
            "changeLoan": {
                "en": "Loan parameters change request",
                "ru": "Запрос на изменение займа"
            },
            "payBackLoan": {
                "en": "Loan repayment request",
                "ru": "Запрос на возврат займа"
            },
            "PMAClose": {
                "en": "PMA: PMA closing request",
                "fr": "PMA : Demande de fermeture de PMA",
                "it": "PMA: richiesta di chiusura PMA",
                "ja": "PMA：PMA終了リクエスト",
                "ru": "PMA: Запрос на закрытие PMA",
                "tr": "PMA: PMA kapatma talebi",
                "uk": "PMA: Запит на закриття PMA",
                "zh": "PMA：关闭请求"
            },
            "PMAClose2faFail": {
                "en": "PMA: PMA closing request rejected - wrong OTP",
                "fr": "PMA : Demande de fermeture du PMA est rejeté - OTP incorrect",
                "it": "PMA: richiesta di chiusura PMA rifiutata - OTP errato",
                "ja": "PMA：PMA終了リクエストが拒否されました-OTPに誤りがあります。",
                "ru": "PMA: Ошибка кода 2FA при попытке закрытия PMA",
                "tr": "PMA: PMA kapatma talebi reddedildi - hatalı OTP",
                "uk": "PMA: Помилка коду 2FA при спробі закриття PMA",
                "zh": "PMA：PMA关闭请求被拒绝错误的OTP"
            },
            "PMADepositClose": {
                "en": "PMA: Deposit closing request",
                "fr": "PMA: Demande de fermeture du dépôt",
                "it": "PMA: richiesta di chiusura del deposito",
                "ja": "PMA: 入金終了リクエスト",
                "ru": "PMA: Запрос на закрытие депозита PMA",
                "test": "PMA: Deposit closing request",
                "tr": "PMA: Mevduat kapatma talebi",
                "uk": "PMA: Запит на закриття депозиту PMA",
                "zh": "PMA：存款结清请求"
            },
            "PMADepositClose2faFail": {
                "en": "PMA: Deposit Closing request rejected - wrong OTP",
                "fr": "PMA: Demande de fermeture du dépôt rejeté - OTP incorrect",
                "it": "PMA: richiesta di chiusura del deposito rifiutata - OTP errato",
                "ja": "PMA：入金終了リクエストが拒否されました-OTPに誤りがあります。",
                "ru": "PMA: Ошибка 2FA закрытия депозита на PMA",
                "test": "Deposit Closing request rejected - wrong OTP",
                "tr": "PMA: Mevduat Kapatma talebi reddedildi - hatalı OTP",
                "uk": "PMA: Помилка 2FA закриття депозиту на PMA",
                "zh": "PMA：拒绝存款结帐请求-错误的OTP"
            },
            "PMADepositOpen": {
                "en": "PMA: New deposit to PMA",
                "fr": "PMA: Nouveau dépôt au PMA",
                "it": "PMA: nuovo deposito in PMA",
                "ja": "PMA: PMAに新しい入金があります",
                "ru": "PMA: Новый депозит на PMA",
                "test": "New deposit to PMA",
                "tr": "PMA: PMA'ya yeni para yatırma işlemi",
                "uk": "PMA: Новий депозит на PMA",
                "zh": "PMA：PMA的新存款"
            },
            "PMADepositOpen2faFail": {
                "en": "PMA: PMA Deposit failed - wrong 2FA OTP",
                "fr": "PMA: Dépôt au PMA échoué - 2FA OTP incorrect",
                "it": "PMA: deposito PMA fallito - OFA 2FA errato",
                "ja": "PMA: PMA入金の失敗-2FA OTPに誤りがあります",
                "ru": "PMA: Ошибка 2FA при депозите на PMA",
                "test": "еуые PMA Deposit failed - wrong 2FA OTP",
                "tr": "PMA: PMA'ya Para yatırılamadı - hatalı 2FA OTP",
                "uk": "PMA: Помилка 2FA при відкритті депозиту на PMA",
                "zh": "PMA：PMA存款失败-错误的2FA OTP"
            },
            "PMAOpen": {
                "en": "New PMA created",
                "fr": "Nouveau PMA a été créé",
                "it": "Nuova PMA creata",
                "ja": "新しいPMAが作成されました",
                "ru": "Открытие нового PMA",
                "test": "New PMA created",
                "tr": "Yeni PMA oluşturuldu",
                "uk": "Відкриття нового PMA",
                "zh": "新建PMA"
            },
            "PMAOpen2faFail": {
                "en": "PMA: PMA opening failed, wrong 2FA OTP.",
                "fr": "PMA: Ouverture de PMA échoué, 2FA OPT incorrect.",
                "it": "PMA: apertura PMA non riuscita, OTP 2FA errato.",
                "ja": "PMA：PMAを開けませんでした。2FA OTPに誤りがあります。",
                "ru": "PMA: Ошибка содания PMA, неверный 2FA OTP",
                "test": "PMA opening failed, wrong 2FA OTP.",
                "tr": "PMA: PMA açılamadı, hatalı 2FA OTP.",
                "uk": "PMA: Помилка створення PMA, не вірний 2FA OTP",
                "zh": "PMA：PMA打开失败，2FA OTP错误。"
            },
            "PMASwitch": {
                "en": "Switch to PMA",
                "fr": "Passer au PMA",
                "it": "Passa a PMA",
                "ja": "PMAに切り替え",
                "ru": "Переключение на PMA",
                "test": "Switch to PMA",
                "tr": "PMA'ya geçin",
                "uk": "Перемикання на PMA",
                "zh": "切换到PMA"
            },
            "SLTPset": {
                "en": "SLTP parameters set for order {o_id}",
                "fr": "Les paramètres SLTP sont fixées pour la commande {o_id}",
                "it": "Parametri SLTP impostati per l'ordine {o_id}",
                "ja": "注文{o_id}に設定されているSLTPパラメーター",
                "ru": "Установлены папарметры SLTP для ордера {o_id}",
                "tr": "{o_id} komutu için ayarlanan SLTP parametreleri",
                "uk": "Встановлені параметри SLTP для ордера {o_id}",
                "zh": "为订单{o_id}设置的SLTP参数"
            },
            "addApikey": {
                "en": "API: New API key created",
                "fr": "API: Une nouvelle clé API a été créée",
                "it": "API: nuova chiave API creata",
                "ja": "API：新しいAPIキーが作成されました",
                "ru": "API: Создан новый API ключ",
                "tr": "API: Yeni API anahtarı oluşturuldu",
                "uk": "API: Створено новий API ключ",
                "zh": "API:已创建新的API密钥"
            },
            "authfail": {
                "en": "Authorization failed",
                "fr": "Échec de l'autorisation",
                "it": "Autorizzazione fallita",
                "ja": "認証に失敗しました",
                "ru": "Ошибка авторизации",
                "tr": "Yetkilendirme başarısız oldu",
                "uk": "Помилка авторизації",
                "zh": "授权失败"
            },
            "cancelManyOrder": {
                "en": "Mass order cancellation",
                "fr": "Annulation de commande en masse",
                "it": "Annullamento dell'ordine in massa",
                "ja": "大量注文のキャンセル",
                "ru": "Отмена нескольких ордеров",
                "tr": "Toplu komut iptali",
                "uk": "Відміна декількох ордерів",
                "zh": "批量订单取消"
            },
            "cancelOrder": {
                "en": "Order cancellation",
                "fr": "Annulation de commande",
                "it": "Annullamento dell'ordine",
                "ja": "注文のキャンセル",
                "ru": "Отмена ордера",
                "tr": "Komut iptali",
                "uk": "Відміна ордера",
                "zh": "订单取消"
            },
            "changeEmail": {
                "en": "Email change",
                "fr": "Email changé",
                "it": "Email cambiato",
                "ja": "メールを変更しました",
                "ru": "Изменение email",
                "tr": "E-posta değiştirildi",
                "uk": "Зміна Email",
                "zh": "电子邮件已更改"
            },
            "changeOrder": {
                "en": "Order change",
                "fr": "Commande changée",
                "it": "Ordine cambiato",
                "ja": "注文を変更しました",
                "ru": "Изменение ордера",
                "tr": "Komut değiştirildi",
                "uk": "Зміна ордера",
                "zh": "订单已更改"
            },
            "change_sltp": {
                "en": "SLTP parameters change",
                "fr": "Modification des paramètres SLTP",
                "it": "Modifica dei parametri SLTP",
                "ja": "SLTPパラメーターの変更",
                "ru": "Изменение параметров SLTP",
                "test": "qwe",
                "tr": "SLTP parametreleri değişimi",
                "uk": "Зміна параметрів SLTP",
                "zh": "SLTP参数更改"
            },
            "confirmWithdraw": {
                "en": "Withdrawal confirmation",
                "fr": "Confirmation de prélèvement",
                "it": "Conferma di prelievo",
                "ja": "出金の確認",
                "ru": "Подтверждение вывода",
                "tr": "Para çekme onayı",
                "uk": "Підтвердження виведення",
                "zh": "提款确认书"
            },
            "disable2fa_wd": {
                "en": "Withdrawal OTP has been deleted",
                "fr": "OTP de prélèvement a été supprimé",
                "it": "OTP per i prelevamenti è stato cancellato",
                "ja": "出金OTPが削除されました",
                "ru": "Удален дополнительный OTP на вывод",
                "tr": "Para çekilen OTP silindi",
                "uk": "Видалено додатковий OTP на виведення",
                "zh": "已删除提款OTP"
            },
            "enable_2fa": {
                "en": "2FA: New 2FA SEED has been set",
                "fr": "2FA: Nouveau 2FA SEED a été fixé",
                "it": "2FA: è stato impostato il nuovo 2FA SEED",
                "ja": "2FA：新しい2FAシードが設定されました",
                "ru": "2FA: Установлен новый приватный ключ 2FA",
                "tr": "2FA: Yeni 2FA SEED ayarlanmıştır",
                "uk": "2FA: Встановлено новий приватний ключ 2FA",
                "zh": "2FA:已设置新的2FA种子"
            },
            "enable_2fa_wd": {
                "en": "Withdrawal OTP has been activated",
                "fr": "OTP de prélèvement a été activé",
                "it": "OTP per i prelevamenti è stato attivato",
                "ja": "出金OTPが有効化されました",
                "ru": "Активирован дополнительный OTP на вывод",
                "tr": "Para çekilen OTP etkinleştirildi",
                "uk": "Активовано додатковий OTP на виведення",
                "zh": "已激活提款OTP"
            },
            "initResetPassword": {
                "en": "Password reset request",
                "fr": "Demande de réinitialisation de mot de passe",
                "it": "Richiesta per la reimpostazione della password",
                "ja": "パスワードリセットのリクエスト",
                "ru": "Запрос сброса пароля",
                "tr": "Parola sıfırlama talebi",
                "uk": "Запит скидання пароля",
                "zh": "密码重置请求"
            },
            "join": {
                "en": "Signup",
                "fr": "Inscription",
                "it": "Registrazione",
                "ja": "登録",
                "ru": "Регистрация",
                "tr": "Kaydol",
                "uk": "Реєстрація",
                "zh": "注册"
            },
            "login": {
                "en": "Login",
                "fr": "Connexion",
                "it": "Login",
                "ja": "ログイン",
                "ru": "Авторизация",
                "tr": "Oturum aç",
                "uk": "Авторизація",
                "zh": "登录"
            },
            "login_success": {
                "en": "Success authorization",
                "fr": "Autorisation réussite",
                "it": "Login effettuato con successo",
                "ja": "認証成功",
                "ru": "Успешная авторизация",
                "tr": "Başarılı yetkilendirme",
                "uk": "Успішна авторизація",
                "zh": "成功授权"
            },
            "logout": {
                "en": "Logout",
                "fr": "Déconnexion",
                "it": "Logout",
                "ja": "ログアウト",
                "ru": "Выход",
                "tr": "Çıkış yap",
                "uk": "Вихід",
                "zh": "注销"
            },
            "logout_all": {
                "en": "Logout from all devices",
                "fr": "Se déconnecter de tous les appareils",
                "it": "Logout da tutti i dispositivi",
                "ja": "全端末からログアウト",
                "ru": "Выход со всех устройств",
                "tr": "Tüm cihazlardan çıkış yap",
                "uk": "Вихід з усіх пристроїв",
                "zh": "从所有设备注销"
            },
            "placeOrder": {
                "en": "Order placement",
                "fr": "Passer une commande",
                "it": "Effettuare un ordine",
                "ja": "発注",
                "ru": "Размещение ордера",
                "tr": "Komut yerleştirme",
                "uk": "Розміщення ордера",
                "zh": "下单"
            },
            "placeWithdraw": {
                "en": "Withdrawal request",
                "fr": "Demande de prélèvement",
                "it": "Richiesta di prelievo",
                "ja": "出金リクエスト",
                "ru": "Запрос на вывод",
                "tr": "Para çekme talebi",
                "uk": "Запит на виведення",
                "zh": "撤回请求"
            },
            "register_success": {
                "en": "Account successfully created",
                "fr": "Compte crée avec succès",
                "it": "Conto creato con successo",
                "ja": "アカウントが作成されました",
                "ru": "Аккаунт успешно создан",
                "tr": "Hesap başarıyla oluşturuldu",
                "uk": "Аккаунт успішно створено",
                "zh": "已成功创建帐户"
            },
            "resetPassword": {
                "en": "Password reset",
                "fr": "Réinitialiser le mot de passe",
                "it": "Reimpostazione della password",
                "ja": "パスワードのリセット",
                "ru": "Смена пароля",
                "tr": "Parola sıfırlama",
                "uk": "Зміна пароля",
                "zh": "密码重置"
            },
            "reset_2fa_fail": {
                "en": "2FA: 2FA SEED change failed",
                "fr": "2FA: Changement du 2FA SEED échoué",
                "it": "2FA: modifica del SEED 2FA non riuscita",
                "ja": "2FA：2FAシードの変更に失敗しました",
                "ru": "2FA: Не удалось заменить приватный ключ 2FA",
                "tr": "2FA: 2FA SEED değişikliği başarısız oldu",
                "uk": "2FA: Не вдалося замінити приватний ключ 2FA",
                "zh": "2FA:2FA种子更改失败"
            },
            "set_masterkey": {
                "en": "Master Key has been activated",
                "fr": "Le Master Key a été activé",
                "it": "La Master Key è stata attivata",
                "ja": "マスターキーが有効化されました",
                "ru": "Активирован Мастер-ключ",
                "tr": "Ana Anahtar etkinleştirildi",
                "uk": "Активовано Майстер-ключ",
                "zh": "主密钥已激活"
            },
            "set_sltp": {
                "en": "SLTP order has been set",
                "fr": "Commande SLTP a été fixée",
                "it": "L'ordine SLTP è stato impostato",
                "ja": "SLTP注文が設定されました",
                "ru": "Установлен SLTP ордер",
                "tr": "SLTP komutu ayarlanmıştır",
                "uk": "Встановлено SLTP ордер",
                "zh": "已设置SLTP顺序"
            },
            "wd_2fa_fail": {
                "en": "Withdrawal request rejected - wrong OTP",
                "fr": "Demande de prélèvement rejetée - OTP incorrect",
                "it": "Richiesta di prelievo rifiutata - OTP errato",
                "ja": "出金リクエストが拒否されました-OTPに誤りがあります。",
                "ru": "Ошибка 2FA при запросе на вывод токенов",
                "tr": "Para çekme talebi reddedildi - hatalı OTP",
                "uk": "Помилка 2FA при запиті на виведення токенов",
                "zh": "撤回请求被拒绝-错误的OTP"
            }
        }
    },
    "blotter": {
        "_header": {
            "en": "Actions for {sym}",
            "fr": "Actions pour {sym}",
            "it": "Azioni per {sym}",
            "ja": "{sym}のアクション",
            "ko": "에 대한 작업 {sym}",
            "ru": "Движение по счету {sym}",
            "tr": "{sym} için faaliyetler",
            "uk": "Рух по рахунку {sym}",
            "zh": "{sym}的操作"
        },
        "sym_TH": {
            "en": "Changes {sym1}",
            "fr": "Modifications {sym1}",
            "it": "Modificazioni per {sym1}",
            "ja": "{sym1}の変化",
            "ru": "Изменение {sym1}",
            "tr": "{sym1} değişiklikleri",
            "uk": "Зміна {sym1}",
            "zh": "更改{sym1}"
        },
        "valuesTypes": {
            "сrosschain_recovery_fee": {
                "en": "Сrosschain deposit recovery fee",
                "ru": "Комиссия за кроссчейн-восстановление депозита"
            },
            "dustburn": {
                "en": "Burning dust to A2A",
                "ru": "Конвертация остатка в A2A"
            },
            "loan_give": {
                "en": "New loan",
                "ru": "Предоставление займа"
            },
            "loan_pay_back": {
                "en": "Loan repayment",
                "ru": "Погашение займа"
            },
            "pma_deposit": {
                "en": "PMA deposit",
                "fr": "Dépôt PMA",
                "it": "Deposito PMA",
                "ja": "PMAの入金",
                "ru": "Депозит PMA",
                "tr": "PMA mevduatı",
                "uk": "Депозит PMA",
                "zh": "PMA存款"
            },
            "pma_deposit_fee": {
                "en": "PMA deposit fee",
                "fr": "Frais de dépôt PMA",
                "it": "Commissione per deposito PMA",
                "ja": "PMA入金費用",
                "ru": "Комиссия за депозит PMA",
                "tr": "PMA mevduat ücreti",
                "uk": "Комісія за депозит PMA",
                "zh": "PMA存款费"
            },
            "pma_deposit_manager_reward": {
                "en": "Manager's reward on hold",
                "ru": "Награда менеджера на удержании"
            },
            "pma_clearing": {
                "en": "PMA profit distribution",
                "ru": "Распределение прибыли с PMA"
            },
            "pma_clearing_fee": {
                "en": "PMA profit distribution fee",
                "ru": "Комиссия на прибыль с PMA"
            },
            "pma_close_deposit": {
                "en": "PMA Deposit withdrawal",
                "fr": "Prélèvement PMA",
                "it": "Prelevamento PMA",
                "ja": "PMAの出金",
                "ru": "Закрытие депозита PMA",
                "tr": "PMA para çekme işlemi",
                "uk": "Закриття депозиту PMA",
                "zh": "PMA取款"
            },
            "pma_close_deposit_fee": {
                "en": "PMA Deposit withdrawal fee",
                "ru": "Комиссия на вывод депозита с PMA",
                "fr": "Frais de dépôt PMA",
                "it": "Commissione per deposito PMA",
                "ja": "PMA入金費用",
                "tr": "PMA mevduat ücreti",
                "uk": "Комісія за вывод депозита PMA",
                "zh": "PMA存款费"
            },
            "pma_close_deposit_manager_reward": {
                "en": "Manager's reward from closed deposit ",
                "ru": "Награда менеджера по закрытому депозиту"
            },
            "com": {
                "en": "Commission",
                "fr": "Commission",
                "it": "Commissione",
                "ja": "コミッション",
                "ko": "무역",
                "ru": "Комиссия",
                "tr": "Komisyon",
                "uk": "Комісія",
                "zh": "佣金"
            },
            "convert_to_50x": {
                "en": "STE converted to 50X tokens",
                "fr": "STE convertis en jetons 50X",
                "it": "STE convertito in gettoni 50X",
                "ja": "STEを50Xトークンに変換しました",
                "ru": "Конвертация STE в токены 50X",
                "tr": "STE 50X tokene dönüştürüldü",
                "uk": "Конвертація STE в токени 50X",
                "zh": "STE转换为50X代币"
            },
            "convert_to_50x100": {
                "en": "Unmoved STE converted to 50X100 tokens",
                "fr": "STE non déplacé converti en jetons 50X100",
                "it": "STE non modificato convertito in gettoni 50X100",
                "ja": "動きのないSTEを50X100に変換しました",
                "ru": "Конвертация неперемещённых STE в токены 50X100",
                "tr": "Taşınmayan STE 50X100 tokene dönüştürüldü",
                "uk": "Конвертація непереміщених STE в токени 50X100",
                "zh": "未移动的STE转换为50X100代币"
            },
            "fix": {
                "en": "Adjustment",
                "fr": "Rajustement",
                "it": "Aggiustamento",
                "ja": "調整",
                "ko": "조정",
                "ru": "Корректировка",
                "tr": "Ayarlama",
                "uk": "Коригування",
                "zh": "调整"
            },
            "in": {
                "en": "Deposit",
                "fr": "Dépôt",
                "it": "Deposito",
                "ja": "入金",
                "ko": "입금",
                "ru": "Пополнение",
                "tr": "Mevduat",
                "uk": "Поповнення",
                "zh": "存款"
            },
            "paramining": {
                "en": "Paramining",
                "ru": "Парамайнинг"
            },
            "pma_open_fee": {
                "en": "PMA opening commission",
                "fr": "Frais d'ouverture PMA",
                "it": "Commissione per apertura PMA",
                "ja": "PMA開始手数料",
                "ru": "Комиссия за открытие PMA",
                "tr": "PMA açılış komisyonu",
                "uk": "Коміссія за відкриття PMA",
                "zh": "PMA开业佣金"
            },
            "tc": {
                "en": "Trade",
                "fr": "Échange",
                "it": "Trade",
                "ja": "取引",
                "ko": "무역",
                "ru": "Торговля",
                "tr": "Alım satım işlemi",
                "uk": "Торгівля",
                "zh": "交易"
            },
            "tc_fix": {
                "en": "Rounding correction",
                "fr": "Correction d'arrondi",
                "it": "Correzione dell'arrotondamento",
                "ja": "丸め補正",
                "ko": "반올림 보정",
                "ru": "Коррекция округления",
                "tr": "Yuvarlama düzeltmesi",
                "uk": "Корекція округлення",
                "zh": "舍入校正"
            },
            "wd": {
                "en": "Withdrawal",
                "fr": "Prélèvement",
                "it": "Prelevamento",
                "ja": "出金",
                "ru": "Вывод",
                "tr": "Para çekme işlemi",
                "uk": "Виведення",
                "zh": "取款"
            }
        }
    },
    "chart": {
        "_header": {
            "DEPRECATED": "DEPRECATED",
            "en": "Chart",
            "fr": "Graphique",
            "it": "Grafico",
            "ja": "チャート",
            "ru": "График",
            "tr": "Grafik",
            "uk": "Графік",
            "zh": "图表"
        },
        "cndl_close": {
            "en": "Close",
            "fr": "Fermer",
            "it": "Chiudi",
            "ja": "閉じる",
            "ru": "Закрытие",
            "tr": "Kapat",
            "uk": "Закриття",
            "zh": "关闭"
        },
        "cndl_high": {
            "en": "High",
            "fr": "Élevé",
            "it": "Alto",
            "ja": "高い",
            "ru": "Макс",
            "tr": "Yüksek",
            "uk": "Макс",
            "zh": "高的"
        },
        "cndl_low": {
            "en": "Low",
            "fr": "Bas",
            "it": "Basso",
            "ja": "低い",
            "ru": "Мин",
            "tr": "Düşük",
            "uk": "Мін",
            "zh": "低的"
        },
        "cndl_open": {
            "en": "Open",
            "fr": "Ouvrir",
            "it": "Apri",
            "ja": "開く",
            "ru": "Открытие",
            "tr": "Aç",
            "uk": "Відкриття",
            "zh": "打开"
        },
        "typeBidAsk": {
            "en": "Bid/ask",
            "fr": "Demande d'offre",
            "it": "Bid/ask",
            "ja": "買い/売り",
            "ru": "Бид/Аск",
            "tr": "Teklif/sorgu",
            "uk": "Бід/Аск",
            "zh": "出价/要价"
        },
        "typeCandles": {
            "en": "Candles",
            "fr": "Bougies",
            "it": "Candele",
            "ja": "ロウソク",
            "ru": "Свечи",
            "tr": "Candlelar",
            "uk": "Свічки",
            "zh": "蜡烛"
        }
    },
    "code": {
        "100100": {
            "en": "{0} Message system TEST {1} [Message {code}]",
            "ru": "Тест {0} системы сообщений {1} [Сообщение {code}]"
        },
        "0": {
            "en": "The system is currently under maintenance. [code.tryLater][Error {code}]",
            "fr": "Le système est actuellement en cours de maintenance. [code.tryLater][Error {code}]",
            "it": "Il sistema è attualmente in manutenzione. [code.tryLater][Error {code}]",
            "ja": "システムは現在メンテナンス中です。[code.tryLater][エラー {code}]",
            "ko": "시스템은 현재 유지보수 중입니다. [code.tryLater][Error {code}]",
            "ru": "Система остановлена для техобслуживания. [code.tryLater][Error {code}]",
            "tr": "Sistem şu anda bakımdadır. [code.tryLater][{code} hatası]",
            "uk": "Система зупинена для техобслуговування. [code.tryLater][Error {code}]",
            "zh": "系统目前正在维护中。 [code.tryLater][Error {code}]"
        },
        "000": {
            "en": "Connection lost [Error {code}]",
            "fr": "Connexion perdue [Error {code}]",
            "it": "Collegamento perso [Error {code}]",
            "ja": "接続が切れました。[エラー {code}]",
            "ko": "연결이 끊어졌습니다. [Error {code}]",
            "ru": "Нет связи с сервером [Error {code}]",
            "tr": "Bağlantı kesildi [{code} hatası]",
            "uk": "Немає зв'язку з сервером [Error {code}]",
            "zh": "连接失败[Error {code}]"
        },
        "001": {
            "en": "Value {parameter} is invalid or missing. [code.tryNow] [Error {code}]",
            "fr": "La valeur {parameter} est incorrecte ou manquante. [code.tryNow] [Error {code}]",
            "it": "Il valore {parameter} non è corretto o manca. [code.tryNow] [Error {code}]",
            "ja": "値{parameter}が正しくないか、欠落しています。 [code.tryNow] [エラー {code}]",
            "ko": "{parameter} 값이 잘못되었거나 누락되었습니다. [code.tryNow] [Error {code}]",
            "ru": "Значение {parameter} неверно или отсутствует. [code.tryNow] [Error {code}]",
            "tr": "{parameter} değeri yanlış veya eksik. [code.tryNow] [{code} hatası]",
            "uk": "Значення {parameter} неправильне або відсутнє. [code.tryNow] [Error {code}]",
            "zh": "值{parameter}不正确或丢失。 [code.tryNow] [Error {code}]"
        },
        "003": {
            "en": "Result of your request: {0} [Error {code}]"
        },
        "005": {
            "en": "Request rejected: {0} [Error {code}]"
        },
        "0001": {
            "en": "You forgot to enter the {parameter} [Error {code}]"
        },
        "10001": {
            "en": "Your email address has not been confirmed yet. Please find an email with the activation code in your inbox. Check the SPAM folder if it is not there. [Error {code}]",
            "fr": "Votre adresse courriel n'a pas été confirmée. Veuillez trouver un courriel muni d'un code d'activation dans votre boîte de réception. Vérifiez le dossier SPAM si vous ne le trouvez pas. [Error {code}]",
            "it": "Il tuo indirizzo email non è stato ancora confermato. Puoi trovare un'email con il codice di attivazione nella tua casella di posta. Controllare la cartella SPAM se non è presente. [Error {code}]",
            "ja": "あなたのメールアドレスはまだ確認されていません。受信トレイにアクティベーションコードが記載されたメールが送られているはずですのでご確認ください。見つからない場合には、スパムフォルダに入っている可能性もあります。[エラー{code}]",
            "ru": "Ваш email пока не подтвержден вводом проверочного кода (письмо с кодом подтверждения у вас в почте) [Error {code}]",
            "tr": "E-posta adresiniz henüz onaylanmadı. Lütfen gelen kutunuzda etkinleştirme kodunu içeren e-postayı bulunuz. Orada değilse, SPAM klasörünü kontrol edin. [{code} hatası]",
            "uk": "Ваш email поки не підтверджений введенням перевірочного коду. Лист з кодом підтвердження у вас в пошті. Перевірте папку СПАМ, якщо його немає у Вхідних. [Error {code}]",
            "zh": "您的电子邮件地址尚未确认。请在收件箱中找到带有激活码的电子邮件。如果垃圾邮件文件夹不存在，请检查它。[Error {code}]"
        },
        "10002": {
            "en": "Two factor authentication (2FA) is not enabled on your account. Please enable it first [Error {code}]",
            "fr": "L'authentification à deux facteurs (2FA) n'a pas été activé pour votre compte. Veuillez d'abord l'activer [Error {code}]",
            "it": "L'autenticazione a due fattori (2FA) non è abilitata sul tuo account. Per favore di precedere prima con la sua attivazione [Error {code}]",
            "ja": "アカウントで2要素認証（2FA）が有効になっていません。最初に有効にしてください[エラー{code}]",
            "ko": "OTP 인증을 이용할 수 없습니다 [Error {code}]",
            "ru": "Не активирована двухфакторная авторизация (2FA), активируйте ее для начала работы. [Error {code}]",
            "tr": "Hesabınızda iki faktörlü kimlik doğrulama (2FA) etkin durumda değildir. Lütfen öncelikle bunu etkinleştirin [{code} hatası]",
            "uk": "Не активована двухфакторна авторизація (2FA), активуйте її для початку роботи. [Error {code}]",
            "zh": "您的帐户上未启用双因素身份验证（2FA）。请先启用它[Error {code}]"
        },
        "10003": {
            "en": "You must agree with the TERMS by signing the User Agreement first. [Error {code}]",
            "fr": "Vous devez accepter les CONDITIONS en signant le Contrat d'Utilisation d'abord. [Error {code}]",
            "it": "Devi accettare le CONDIZIONI firmando prima l'Accordo con l'Utilizzatore. [Error {code}]",
            "ja": "最初にユーザー契約に署名して、規約に同意する必要があります。 [エラー{code}]",
            "ru": "До начала работы вам необходимо согласиться с Правилами сервиса, подписав ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ. [Error {code}]",
            "tr": "Öncelikle Kullanıcı Sözleşmesi'ni imzalayarak KOŞULLARI kabul etmelisiniz. [{code} hatası]",
            "uk": "До початку роботи вам необхідно погодитися з Правилами сервісу, підписавши УГОДУ КОРИСТУВАЧА. [Error {code}]",
            "zh": "您必须先签署用户协议，同意这些条款。[Error {code}]"
        },
        "10010": {
            "en": "Wrong 2FA OTP:'{0}' [Error {code}]",
            "fr": "2FA OTP Incorrect:'{0}' [Error {code}]",
            "it": "OTP 2FA errato:'{0}' [Error {code}]",
            "ja": "'{0}':2FA OTPに誤りがあります [エラー{code}]",
            "ko": "잘못된 OTP 인증 코드 [Error {code}]",
            "ru": "Неправильный однократный код 2FA:'{0}', попробуйте еще раз. Обратите внимание, код действителен только 30 секунд![Error {code}]",
            "tr": "Hatalı 2FA OTP:'{0}' [{code} hatası]",
            "uk": "Неправильний одноразовий код 2FA:'{0}', спробуйте ще раз. Зверніть увагу, код дійсний тільки 30 секунд! [Error {code}]",
            "zh": "错误的2FA OTP:'{0}' [Error {code}]"
        },
        "10011": {
            "en": "2FA OTP is invalid, please try again [Error {code}]",
            "fr": "2FA OTP non valide, veuillez réessayer [Error {code}]",
            "it": "2FA OTP non è valido, riprovare [Error {code}]",
            "ja": "2FA OTPが有効ではありません。もう一度挑戦してください [エラー{code}]",
            "ko": "OTP 인증 코드가 올바르지 않습니다. 나중에 다시 시도하세요 [Error {code}]",
            "ru": "Введенный неправильный код 2FA [Error {code}]",
            "tr": "2FA OTP geçersizdir, lütfen tekrar deneyiniz [{code} hatası]",
            "uk": "Введений неправильний код 2FA [Error {code}]",
            "zh": "2FA OTP无效，请重试[Error {code}]"
        },
        "10012": {
            "en": "2FA service is currently offline, [tryLater] [Error {code}]",
            "fr": "2FA service is currently offline, [tryLater] [Error {code}]",
            "it": "2FA service is currently offline, [tryLater] [Error {code}]",
            "ja": "2FA service is currently offline, [tryLater] [エラー{code}]",
            "ko": "2FA service is currently offline, [tryLater] [Error {code}]",
            "ru": "2FA service is currently offline, [tryLater] [Error {code}]",
            "tr": "2FA service is currently offline, [tryLater] [{code} hatası]",
            "uk": "2FA service is currently offline, [tryLater] [Error {code}]",
            "zh": "2FA service is currently offline, [tryLater] [Error {code}]"
        },
        "10013": {
            "en": "This OTP has already been used, please wait for a new OTP to be generated and try again.  [Error {code}]",
            "fr": "Cet OTP a déjà été utilisé, veuillez attendre qu'un nouveau OTP soit généré et réessayez.  [Error {code}]",
            "it": "Questo OTP è già stato utilizzato, attendere che venga generato un nuovo OTP e riprovare. [Error {code}]",
            "ja": "このOTPは既に使用されています。新しいOTPが生成されるのを待って、もう一度試してください。 [Error {code}]",
            "ko": "입력하신 2fa 코드는 이미 사용된 것입니다. 새로운 코드가 생성될때 까지 기다려주시고 다시 생성된 코드를 입력해 주세요. [Error {code}]",
            "ru": "Этот код 2fa уже был использован, пожалуйста дождитесь генерации нового OTP кода в приложениии попробуйте опять с новым кодом. [Error {code}]",
            "tr": "Bu OTP zaten kullanılmıştır, lütfen yeni bir OTP'nin oluşturulmasını bekleyin ve tekrar deneyin. [Error {code}]",
            "uk": "Цей код 2FA вже був використаний, будь ласка, дочекайтеся генерації нового OTP коду в додатку та спробуйте знову з новим кодом. [Error {code}]",
            "zh": "此OTP已被使用，请等待生成新的OTP并重试。 [Error {code}]"
        },
        "10015": {
            "en": "2FA OTP or 2FA private key is required [Error {code}]",
            "fr": "Un 2FA OTP ou une clé privée 2FA est requise [Error {code}]",
            "it": "È necessaria la chiave privata 2FA OTP o 2FA [Error {code}]",
            "ja": "2FA OTPまたは2FAプライベートキーが必要です [エラー{code}]",
            "ko": "OTP 인증 코드 또는 OTP 인증 키 필요 [Error {code}]",
            "ru": "Требуется однократный код 2FA или 2FA приватный ключ [Error {code}]",
            "tr": "2FA OTP veya 2FA özel anahtarına gerek duyulmaktadır [{code} hatası]",
            "uk": "Потрібен одноразовий код 2FA або 2FA приватний ключ [Error {code}]",
            "zh": "需要2FA OTP或2FA私钥 [Error {code}]"
        },
        "10017": {
            "en": "Wrong 2FA OTP was entered 3 times in a row for this account. You need to enter 3 different OTP generated one by one to log in.[Error {code}]",
            "fr": "Le 2FA OTP incorrect a été saisi 3 fois d'affilée pour ce compte. Il vous faut saisir 3 OTP différents générés un par un pour pouvoir vous connecter. [Error {code}]",
            "it": "Un OTP 2FA errato è stato inserito 3 volte di seguito per questo account. Per accedere devi inserire 3 diversi OTP generati uno per uno. [Error {code}]",
            "ja": "アカウントで、間違った2FA OTPが3回続けて入力されました。ログインするには、生成された3つのOTPを1つずつ入力する必要があります。[エラー{code}]",
            "ru": "Неверный OTP (однократный пароль) 2FA был введен 3 раза подряд на этом аккаунте. Вам нужно ввести 3 разных OTP последовательно сгенеренных Гугл Аутентификатором.[Error {code}]",
            "tr": "Bu hesap için arka arkaya 3 kez yanlış 2FA OTP girildi. Giriş yapmak için tek tek oluşturulmuş 3 farklı OTP girmeniz gerekmektedir. [{code} hatası]",
            "uk": "Невірний OTP (одноразовий пароль) 2FA був введений 3 рази поспіль на цьому акаунті. Вам потрібно ввести 3 різних OTP послідовно сгенерованих додатком Google Authenticator. [Error {code}]",
            "zh": "此帐户连续输入了3次错误的2FA OTP。你需要输入3个不同的OTP，一个一个地生成才能登录.[Error {code}]"
        },
        "10018": {
            "en": "One or more out of 3 OTP is wrong. Please try again.[Error {code}]",
            "fr": "Un ou plusieurs des 3 OTP sont incorrects. Veuillez réessayer [Error {code}]",
            "it": "Uno o più OTP su 3 sono errati. Riprovate per favore. [Error {code}]",
            "ja": "3つのうち1つ以上のOTPが間違っています。もう一度やり直してください。[エラー{code}]",
            "ru": "Один или более кодов OTP 2FA был введен неверно. Попробуйте еще раз. Вам нужно ввести 3 разных OTP последовательно сгенеренных Гугл Аутентификатором.[Error {code}]",
            "tr": "3 OTP'den biri veya daha fazlası hatalıdır. Lütfen tekrar deneyiniz. [{code} hatası]",
            "uk": "Один або більше кодів OTP 2FA був введений невірно. Спробуйте ще раз. Вам потрібно ввести 3 різних OTP послідовно сгенеренной Гугл аутентифікатор.[Error {code}]",
            "zh": "三个OTP中有一个或多个是错误的。请再试一次。[Error {code}]"
        },
        "10019": {
            "en": "Internal System Error: Your current 2FA SEED has not been activated yet.[Error {code}]",
            "fr": "Erreur interne du système: Votre 2FA SEED actuel n'a pas encore été activé. [Error {code}]",
            "it": "Errore di sistema interno: il vostro SEED 2FA attuale non è stato ancora attivato. [Error {code}]",
            "ja": "内部システムエラー：あなたの現在の2FAシードはまだ有効ではありません。[エラー{code}]",
            "ru": "Внутреннаяя Ошибка Системы: 2FA SEED не активировался [Error {code}]",
            "tr": "Dahili Sistem Hatası: Mevcut 2FA SEED'iniz henüz etkinleştirilmedi. [{code} hatası]",
            "uk": "Внутрішня Помилка Системи: 2FA SEED не активувався. [Error {code}]",
            "zh": "内部系统错误：您当前的2FA种子尚未激活。[Error {code}]"
        },
        "10020": {
            "en": "Requested action is not available on your account. Details: {0} {1} {2} {3}[Error {code}]"
        },
        "10025": {
            "en": "Browser Error: Your browser does not send HTTP referer properly. Use the latest Firefox or Chrome browsers or tune your browser to send HTTP referer. [Error {code}]",
            "ru": "Ошибка Браузера: Ваш браузер не передает заголовки HTTP referer. Используйте последние версии Firefox или Chrome (они точно работают нормально) или настройте свой браузер чтобы он передавал HTTP referer. [Error {code}]"
        },
        "20701": {
            "en": "Master Key was already set for this account and cannot be changed. [Error {code}]",
            "fr": "Un Master Key a déjà été fixé pour ce compte et ne peut pas être changé. [Error {code}]",
            "it": "La Master Key è già impostata per questo account e non può essere modificata. [Error {code}]",
            "ja": "マスターキーは既にこのアカウントに設定されており、変更できません。 [エラー{code}]",
            "ru": "Мастер-ключ уже установлен и активирован на этом аккаунте и не может быть изменен. [Error {code}]",
            "tr": "Bu hesap için Ana Anahtar zaten ayarlanmıştır ve değiştirilemez. [{code} hatası]",
            "uk": "Майстер-ключ вже встановлений і активований на цьому акаунті і не може бути змінений. [Error {code}]",
            "zh": "已为此帐户设置了主密钥，无法更改。[Error {code}]"
        },
        "20702": {
            "en": "Master Key cannot be set for this account (PMA). Please return to your main account to set the Master Key. [Error {code}]",
            "fr": "Un Master Key ne peut pas être fixé pour ce compte (PMA). Veuillez retourner sur votre compte principal pour fixer le Master Key. [Error {code}]",
            "it": "La Master Key non può essere impostata per questo account (PMA). Torna al tuo account principale per impostare la Master Key. [Error {code}]",
            "ja": "このアカウントにはマスターキーを設定できません (PMA)。メインアカウントに戻ってマスターキーを設定してください。[エラー{code}]",
            "ru": "Мастер-ключ не может быть установлен на этом аккаунте (PMA). Используйте Ваш основной аккаунт для получения мастер-ключа. [Error {code}]",
            "tr": "Bu hesap (PMA) için Ana Anahtar ayarlanamaz. Ana Anahtarı ayarlamak için lütfen ana hesabınıza dönün. [{code} hatası]",
            "uk": "Майстер-ключ не може бути встановлений на цьому акаунті (PMA). Використовуйте Ваш основний аккаунт для отримання майстер-ключа. [Error {code}]",
            "zh": "无法为此帐户（PMA）设置主密钥。请返回主帐户设置主密钥。 [Error {code}]"
        },
        "20705": {
            "en": "The characters you provided do not match the current Master Key. Last {0} characters of the Master Key are required to activate it. [Error {code}]",
            "fr": "Les caractères que vous avez fournis ne correspondent pas au Master Key actuel. Les {0} derniers caractères du Master Key sont requis pour l'activer. [Error {code}]",
            "it": "I caratteri forniti non corrispondono alla Master Key attuale. Gli ultimi {0} caratteri della Master Key sono necessari per attivarla. [Error {code}]",
            "ja": "指定した文字は、現在のマスターキーと一致しません。これを有効にするには、マスターキーの最後の{0}文字が必要です。[エラー{code}]",
            "ru": "Введенные символы не соответствуют Мастер-ключу, который вы пытаетесь активировать. Введите последние {0} символов для активации текущего ключа. При повторении ошибки начните процедуру заново. [Error {code}]",
            "tr": "Sağladığınız karakterler mevcut Ana Anahtarla eşleşmiyor. Ana Anahtarın son {0} karakterleri, bunu etkinleştirmek için gereklidir. [{code} hatası]",
            "uk": "Введені символи не відповідають Майстер-ключу, який ви намагаєтеся активувати. Введіть останні {0} символів для активації поточного ключа. При повторенні помилки почніть процедуру заново. [Error {code}]",
            "zh": "您提供的字符与当前主密钥不匹配。激活主密钥需要主密钥的最后{0}个字符。[Error {code}]"
        },
        "20801": {
            "en": "Wrong withdrawal address format. [Error {code}]",
            "fr": "Format d'adresse de retrait incorrect. [Error {code}]",
            "it": "Formato dell'indirizzo di prelievo errato. [Error {code}]",
            "ja": "間違った引き出しアドレス形式。 [Error {code}]",
            "ko": "인출 주소 형식이 잘못되었습니다. [Error {code}]",
            "ru": "Неправильный формат адреса для вывода средств. [Error {code}]",
            "tr": "Yanlış para çekme adresi biçimi. [{code} hatası]",
            "uk": "Неправильний формат адреси для виведення. [Error {code}]",
            "zh": "提款地址格式错误。[Error {code}]"
        },
        "20802": {
            "en": "You cannot use the other account's depositing address as EWA. [ERROR {code}]",
            "de": "Sie können die Einzahlungsadresse des anderen Kontos nicht als EWA verwenden. [ERROR {code}]",
            "fr": "Vous ne pouvez pas utiliser l'adresse de dépôt de l'autre compte comme EWA. [ERROR {code}]",
            "it": "Non è possibile utilizzare l'indirizzo di deposito dell'altro conto come EWA. [ERROR {code}]",
            "ja": "他の口座の入金先住所をEWAとして使用することはできません。 [ERROR {code}]",
            "ko": "다른 계정의 입금 주소를 EWA로 사용할 수 없습니다. [ERROR {code}]",
            "zh": "您不能将另一个帐户的存款地址用作EWA。 [ERROR {code}]",
            "tr": "Diğer hesabın para yatırma adresini EWA olarak kullanamazsınız. [ERROR {code}]",
            "uk": "Ви не можете використовувати адресу депонування іншого рахунку як EWA. [ERROR {code}]",
            "ru": "Вы не можете использовать адрес пополнения другого аккаунта в качестве EWA. [ERROR {code}]"
        },
        "20900": {
            "en": "Main 2FA OTP cannot be disabled. You may change the SEED Private key for your 2FA OTP. [Error {code}]",
            "fr": "Le 2FA OTP principal ne peut pas être désactivé. Vous pouvez changer la clé privée SEED pour votre 2FA OTP.  [Error {code}]",
            "it": "L'OPP 2FA principale non può essere disabilitato. È possibile modificare la chiave privata SEED per il proprio OTP 2FA. [Error {code}]",
            "ja": "Main 2FA OTPを無効にすることはできません。SEEDプライベートキーをあなたの2FA OTPに変更することができます [エラー{code}]",
            "ru": "Основной 2FA OTP нельзя отключить, но вы можете сменить приватный ключ к нему. [Error {code}]",
            "tr": "Ana 2FA OTP devre dışı bırakılamaz. 2FA OTP'niz için SEED Özel anahtarını değiştirebilirsiniz. [{code} hatası]",
            "uk": "Основний 2FA OTP не можна відключити, але ви можете змінити приватний ключ до нього. [Error {code}]",
            "zh": "无法禁用主2FA OTP。您可以更改2FA OTP的种子私钥。 [Error {code}]"
        },
        "21400": {
            "en": "External (blockchain) deposits are unavailable for your account type."
        },
        "21500": {
            "en": "External (blockchain) withdrawals are unavailable for your account type."
        },
        "21901": {
            "en": "Emergency Withdrawal Аddress for {0} has not been set yet."
        },
        "22000": {
            "en": "Mandatory parameter {0} is missing [Error {code}]. Please report to the service support.",
            "fr": "Paramètre obligatoire {0} est absent [Error {code}]. Veuillez contacter le service de soutien.",
            "it": "Manca il parametro obbligatorio {0} [Errore {code}]. Si prega di riferirsi al servizio di assistenza.",
            "ja": "入力必須のパラメーター {0} が存在しません [エラー {code}]。サービスサポートに報告してください。",
            "ko": "필요한 매개변수 '{0}'이(가) 없습니다 [Error {code}]",
            "ru": "Не передан обязательный параметр '{0}' [Error {code}]",
            "tr": "Zorunlu parametre {0} eksiktir [{code} hatası]. Lütfen hizmet desteğine bildirin.",
            "uk": "Не переданий обов'язковий параметр {0} [Error {code}]",
            "zh": "缺少必需参数{0}[Error {code}]。请向服务支持报告。"
        },
        "22001": {
            "en": "Unknown Parameter {0}",
            "fr": "Paramètre Inconnu {0}",
            "it": "Parametro sconosciuto {0}",
            "ja": "不明のパラメーター {0}",
            "tr": "Bilinmeyen Parametre {0}",
            "uk": "Невідомий параметр {0}",
            "zh": "未知参数 {0}"
        },
        "22004": {
            "en": "Value {0} has invalid TYPE. Expected {1}. [Error {code}]",
            "fr": "Le TYPE de la valeur {0} est invalide. Prévu {1}. [Error {code}]",
            "it": "Il valore {0} ha un TIPO non valido. Previsto {1}. [Error {code}]",
            "ja": "値 {0} に無効な種類が使用されています。予期されるのは {1} です。 [Error {code}]",
            "tr": "{0} değeri geçersiz TÜR'e sahiptir. Beklenen {1}'dir. [Error {code}]",
            "ru": "Значение {0} имеет неправильный тип. Нужно {1}. [Error {code}]",
            "uk": "Значення {0} має недійсний тип. Очікується {1}. [Error {code}]",
            "zh": "值{0}的类型无效。需要{1}。 [Error {code}]"
        },
        "22005": {
            "en": "Value {0} is out of range. {0} value {1} should be >= {2} and <={3}.",
            "fr": "La valeur {0} est hors de portée. {0} valeur {1} devrait être >= {2} et <={3}.",
            "it": "Il valore {0} non è compreso nell'intervallo. Il valore {0} {1} dovrebbe essere >={2} e <={3}.",
            "ja": "値 {0} は規定の範囲外です。{0} の値 {1} は >= {2} そして <={3}になる必要があります。",
            "ru": "Значение {0} вне допустимого диапазона. {0} значение {1} должно быть >= {2} и <={3}.",
            "tr": "{0} değeri aralık dışındadır. {0} değeri {1} >= {2} ve <={3} olmalıdır.",
            "uk": "Значення {0} поза межами допустимого діапазону. {0} значення {1} має бути >= {2} та <= {3}.",
            "zh": "值{0}超出范围。{0}值{1}应为>={2}和<={3}。"
        },
        "22006": {
            "en": "Value '{0}' is incorrect. '{0}' value {1} should be >= {2}.",
            "fr": "La valeur '{0}' est incorrecte. '{0}' valeur {1} devrait être >= {2}.",
            "it": "Il valore '{0}' non è corretto. Il valore '{0}' {1} dovrebbe essere >= {2}.",
            "ja": "値 '{0}' が正しくありません。'{0}' の値 {1} は >= {2}になる必要があります。",
            "tr": "'{0}' değeri yanlıştır. '{0}' değeri {1} >= {2} olmalıdır.",
            "uk": "Значення '{0}' невірне. '{0}' значення {1} має бути >= {2}.",
            "zh": "值'{0}'不正确。'{0}'值{1}应大于等于{2}。"
        },
        "22007": {
            "en": "Value '{0}' is incorrect. '{0}' value {1} should be <= {2}.",
            "fr": "La valeur '{0}' est incorrecte. '{0}' valeur {1} devrait être <= {2}.",
            "it": "Il valore '{0}' non è corretto. Il valore '{0}' {1} dovrebbe essere <= {2}.",
            "ja": "値 '{0}' が正しくありません。'{0}' の値 {1} は <= {2} である必要があります。",
            "tr": "'{0}' değeri yanlıştır. '{0}' değeri {1} <= {2} olmalıdır.",
            "uk": "Значення '{0}' невірно. '{0}' значення {1} має бути <= {2}.",
            "zh": "值'{0}'不正确。'{0}'值{1}应为<={2}。"
        },
        "22008": {
            "en": "Two or more parameters cannot be used simultaneously: {0} {1} {2} {3}. [Error {code}]",
            "fr": "Deux ou plusieurs paramètres ne peuvent pas être utilisés en même temps: {0} {1} {2} {3}. [Error {code}]",
            "it": "Non è possibile utilizzare contemporaneamente due o più parametri: {0} {1} {2} {3}. [Error {code}]",
            "ja": "2つ以上のパラメーターを同時に使うことができません： {0} {1} {2} {3}。[エラー {code}]",
            "tr": "İki veya daha fazla parametre aynı anda kullanılamaz: {0} {1} {2} {3}. [{code} hatası]",
            "uk": "Не можна використовувати два або більше параметрів одночасно: {0} {1} {2} {3}. [Error {code}]",
            "zh": "不能同时使用两个或多个参数：{0}{1}{2}{3}。[Error {code}]"
        },
        "22009": {
            "en": "Value {0} is incorrect. [Error {code}]",
            "fr": "La valeur {0} est incorrecte. [Error {code}]",
            "it": "Il valore {0} non è corretto. [Error {code}]",
            "ja": "値 {0} が正しくありません。 [エラー {code}]",
            "ru": "Значение {0} некорректно. [Error {code}]",
            "tr": "{0} değeri yanlıştır. [{code} hatası]",
            "uk": "Значення {0} некоректно. [Error {code}]",
            "zh": "值{0}不正确。 [Error {code}]"
        },
        "22010": {
            "en": "Parameter '{0}' requires parameter '{1}'[Error {code}]",
            "fr": "Le paramètre '{0}' nécessite le paramètre '{1}'[Error {code}]",
            "it": "Il parametro '{0}' richiede il parametro '{1}' [Error {code}]",
            "ja": "パラメーター「{0}」にはパラメーター「{1}」が必要です[エラー {code}]",
            "ru": "Параметр '{0}' не может быть установлен без '{1}' [Error {code}]",
            "tr": "'{0}' parametresi, '{1}' parametresini gerektirir [{code} hatası]",
            "uk": "Параметр '{0}' не може бути встановлено без '{1}' [Error {code}]",
            "zh": "参数{0}需要参数{1}[Error {code}]"
        },
        "22011": {
            "en": "Parameter '{0}' must be one of the following: '{1}'[Error {code}]",
            "ru": "Параметр '{0}' должен быть любым значением из: '{1}' [Error {code}]"
        },
        "22101": {
            "en": "You have unread messages with the lower ID. Read them first please. [Error {code}]",
            "ru": "У вас есть более старые непрочитанные сообщения. Пожалуйста, прочтите их. [Error {code}]"
        },
        "23100": {
			"en": "Minimal lot for {1} is {0} {1}. [Error {code}]",
			"fr": "Le nombre de transactions minimal pour {1} est de {0} {1}. [Error {code}]",
			"it": "Il lotto di trading minimo per {1} è di {0} {1}. [Error {code}]",
			"ja": "{1}の最小取引ロットは{0} {1}です。[エラー {code}]",
			"ru": "Mинимальный торговый лот для {1}: {0} {1}. [Error {code}]",
			"tr": "{1} için minimum işlem lotu {0} {1} öğesidir. [{code} hatası]",
			"uk": "Mінімальна кількість для {1}: {0} {1}. [Error {code}]",
			"zh": "{1}的最小交易量是{0} {1}. [Error {code}]"
        },
        "23309": {
            "en": "Error occurred while trying to change the order {0}. [Error {code}]",
            "fr": "Une erreur s'est produite lors de la tentative de modification de l'ordre {0}. [Error {code}]",
            "it": "Si è verificato un errore durante il tentativo di modificare l'ordine {0}. [Error {code}]",
            "ja": "注文 {0} の変更中にエラーが発生しました [エラー {code}]",
            "ru": "Ошибка при попытке изменения ордера {0}. [Error {code}]",
            "tr": "{0} komutu değiştirilmeye çalışılırken hata oluştu. [{code} hatası]",
            "uk": "Помилка при спробі зміни ордера {0}. [Error {code}]",
            "zh": "试图更改顺序{0}时出错。 [Error {code}]"
        },
        "23310": {
            "en": "Position cannot be created from the unfilled or fulfilled order, the order should be  partially filled. [Error {code}]",
            "fr": "La position ne peut pas être créée depuis une commande vide ou réalisée, la commande doit être partialement réalisée. [Error {code}]",
            "it": "La posizione non può essere creata dall'ordine non effettuato o completato, l'ordine dovrebbe essere parzialmente effettuato. [Error {code}]",
            "ja": "未決済、または完了した注文からポジションを作成することができません。注文は部分的に完了している必要があります。[エラー {code}]",
            "ru": "Нельзя конвертировать в позицию неисполненный или полностью исполненный ордер, только частично исполненный. [Error {code}]",
            "tr": "Gerçekleştirilmemiş veya gerçekleştirilmiş komuttan pozisyon oluşturulamaz, komut kısmen yerine getirilmelidir. [{code} hatası]",
            "uk": "Не можна конвертувати в позицію невиконаний або повністю виконаний ордер, тільки частково виконаний. [Error {code}]",
            "zh": "无法从未填写或已履行的订单创建职位，订单应部分填写。[Error {code}]"
        },
        "260000": {
			"en": "Your loan (id:{0}) for {1} {2} will expire within 24 hours. {2} tokens are not currently available for the borrowing with the refinance interest rate currently set in this loan. If you want to refinance this loan, you need to increase refinance interest rate for this loan on the LOANS page, otherwise it will be automatically canceled. [Message code: {code}]",
			"ru": "Ваш займ (id:{0}) на {1} {2} истекает через 24 часа. Сейчас {2} токены недоступны для заимствования по указанной вами ставке рефинансирования. Чтобы продлить займ, измените значение ставки рефинансирования для этого займа на странице 'Займы' или займ будет принудительно выкуплен и возвращен. [Код сообщения: {code}]"
        },
        "26050": {
			"en": "Loan service is currently unavailable. [code.tryLater] [Error {code}]",
			"ru": "Сервис займов временно недоступен. [code.tryLater] [Error {code}]"
        },
        "26051": {
			"en": "MARGIN CALL! Your account got a margin call and is currently in the process of margin normalisation. [code.tryLater] [Error {code}]",
			"ru": "МАРЖИН КОЛ! Ваш аккаунт потребовал снижения долговой нагрузки и сейчас идет нормализация показателей маржинального обеспечения [code.tryLater] [Error {code}]"
        },
        "26052": {
			"en": "Requested action with the order {0} is rejected as the new state will cause violation of the margin requirements. Projected margin level: {1}% [Error {code}]",
			"ru": "Запрошенное действие с ордером {0} отклонено, поскольку новое состояние приведет к нарушению маржинальных требований. Спрогнозированный уровень маржинального обеспечения {1}% [Error {code}]"
        },
        "26053": {
			"en": "Borrowing and lending are unavailable on current account. [code.useMain] [Error {code}]",
			"ru": "Заимствование и кредитование недоступны на текущем аккаунте. [code.useMain] [Error {code}]"
        },
        "26054": {
			"en": "Rejected. Use different accounts to borrow and to lend tokens.[Error {code}]",
			"ru": "Отклонено. Используйте разные аккаунты для заимствования и кредитования.[Error {code}]"
        },
        "26001": {
			"en": "The annual percent is too small, minimum annual percent for {0} is {1}. [Error {code}]",
			"ru": "Годовой процент слишком мал, минимальный годовой процент для {0} равен {1}. [Error {code}]"
        },
        "26002": {
			"en": "The annual percent is too big, maximum annual percent for {0} is {1}. [Error {code}]",
			"ru": "Годовой процент слишком велик, максимальный годовой процент для {0} равен {1}. [Error {code}]"
        },
        "26201": {
			"en": "This lending order will be canceled {date}. [Error {code}]",
			"ru": "Этот кредитный ордер будет отменен {date}. [Error {code}]"
        },
        "26300": {
			"en": "There are not enough own tokens (accepted as loan security) on your account to get a new loan. Your current margin coverage is {0}%, new loans are available for the accounts with margin coverage more than {1}%. [Error {code}]",
			"ru": "На вашем аккаунте недостаточно собственных токенов (принимаемых в обеспечение займа) для получения нового займа. Текущий уровень маржинального покрытия {0}%, новые займы доступны при уровне покрытия более {1}%. [Error {code}]"
        },
        "26305": {
			"en": "Selected amount with the given interest rate is currently unavailable for you. You can borrow no more than {0} {1}. [code.tryNow] [Error {code}]",
			"ru": "Выбранное количество по указанной ставке для вас недоступно. Вы можете занять не более {0} {1}. [code.tryNow] [Error {code}]"
        },
        "26400": {
			"en": "You need additional {0} {1} to be available to pay back the loan. [Error {code}]",
			"ru": "Вам нужно дополнительно {0} свободных токенов {1} чтобы вернуть займ. [Error {code}]"
        },
        "28100": {
			"en": "There are not enough own funds on your account to get a new loan. Your current margin coverage is {own_funds_percent}%, new loans are available for the accounts with margin coverage more than {new_loan_level}%.",
			"ru": "На вашем аккаунте недостаточно собственных средств для получения нового займа. Текущий уровень маржинального покрытия {own_funds_percent}%, новые займы доступны при уровне покрытия более {new_loan_level}%."
		},
        "28101": {
			"en": "Post-loan marginal coverage is not enough to maintain the loan. Your projected margin coverage after borrowing is {post_own_funds_percent}%, new loans are available for the accounts with post-loan margin coverage more than {margincall_level}%.",
			"ru": "Прогнозируемое маржинальное обеспечение после займа {post_own_funds_percent}% недостаточно для получения нового займа. Новые займы доступны при прогнозируемом уровне покрытия более {margincall_level}%."
		},
        "29901": {
            "en": "Wrong Master Key or login. No account found. [Error {code}]",
            "fr": "Master Key ou identifiant incorrect. Aucun compte trouvé. [Error {code}]",
            "it": "Master Key o login errato. Nessun account trovato. [Error {code}]",
            "ja": "マスターキーまたはログイン情報に誤りがあります。アカウントが見つかりませんでした。 [エラー {code}]",
            "ru": "Неверный Мастер-ключ или логин. Аккаунт не найден. Возможно, он уже был успешно удален, проверьте свои EWA. [Error {code}]",
            "tr": "Hatalı Ana Anahtar veya giriş. Hesap bulunamadı. [{code} hatası]",
            "uk": "Невірний Майстер-ключ або логін. Аккаунт не знайдено. Можливо, він уже був успішно видалений, перевірте свої EWA. [Error {code}]",
            "zh": "主密钥或登录错误。找不到帐户。[Error {code}]"
        },
        "29902": {
            "en": "Account {0} is already in the process of termination. [Error {code}]",
            "fr": "Compte {0} est déjà en cours de résiliation. [Error {code}]",
            "it": "L'account {0} è già in fase di chiusura. [Error {code}]",
            "ja": "アカウント {0} は既に削除プロセスにあります。[エラー {code}]",
            "ru": "Аккаунт {0} уже в процессе удаления. [Error {code}]",
            "tr": "{0} hesabı artık sonlandırılma aşamasındadır.  [{code} hatası]",
            "uk": "Аккаунт {0} вже в процесі видалення. [Error {code}]",
            "zh": "帐户{0}已在终止过程中。[Error {code}]"
        },
        "29903": {
            "en": "Account {0} is suspended and cannot be terminated right now. Please contact the support via email {domain.email} to solve this issue first. [Error {code}]",
            "fr": "Le compte {0} est suspendu et ne peut pas être résilié pour le moment. Veuillez contacter le support client par e-mail {domain.email} pour résoudre ce problème d'abord. [Error {code}]",
            "it": "L'account {0} è sospeso e non può essere chiuso in questo momento. Contatta l'assistenza via e-mail {domain.email} per risolvere prima questo problema. [Error {code}]",
            "ja": "アカウント {0} は停止され、今すぐ削除することはできません。メール {domain.email} からサポートまで連絡することで、この問題を先に解決してください。[エラー {code}]",
            "ru": "Аккаунт {0} заблокирован и не может быть удален прямо сейчас. Пожалуйста свяжитесь с техподдержкой {domain.email}. [Error {code}]",
            "tr": "{0} hesabı askıya alındı ve şu anda sonlandırılamaz. Lütfen öncelikle bu durumu çözmek için e-posta {domain.email} aracılığıyla destek ile iletişim kurunuz. [{code} hatası]",
            "uk": "Аккаунт {0} заблокований і не може бути видалений прямо зараз. Будь ласка, зв'яжіться з техпідтримкою {domain.email}. [Error {code}]",
            "zh": "帐户{0}已暂停使用，现在无法终止。请通过电子邮件{domain.email}与支持部门联系，以首先解决此问题。[Error {code}]"
        },
        "29904": {
            "en": "Internal Error: account termination service is currently unavailable. [Error {code}]",
            "fr": "Erreur Interne: le service de résiliation de compte est actuellement indisponible. [Error {code}]",
            "it": "Errore interno: il servizio di chiusura dell'account non è al momento disponibile. [Error {code}]",
            "ja": "内部エラー：アカウント削除サービスは現在利用できません。[エラー{code}]",
            "ru": "Ошибка сервера: Сервис удаления аккаунта в настоящий момент недоступен. [Error {code}]",
            "tr": "Dahili Hata: hesap sonlandırma hizmeti şu anda kullanılamıyor. [{code} hatası]",
            "uk": "Помилка сервера: Сервіс видалення аккаунта в даний момент недоступний. [Error {code}]",
            "zh": "内部错误：帐户终止服务当前不可用。 [Error {code}]"
        },
        "29905_DEPRECATED": {
            "en": "No Emergency Withdrawal Addresses(EWA) were set for your account. Unable to terminate the account. [Error {code}]",
            "fr": "Aucune Adresse de Prélèvement d'Urgence n'a été fixée pour votre compte. Impossible de fermer le compte. [Error {code}]",
            "it": "Non sono stati impostati indirizzi di prelievo di emergenza per il tuo account. Impossibile chiudere l'account. [Error {code}]",
            "ja": "このアカウントに緊急出金アドレスは設定されていません。アカウントを削除できませんでした。[エラー {code}]",
            "ru": "На указанном аккаунте не задан ни один Адрес Аварийного Вывода. Невозможно вывести токены и удалить аккаунт. [Error {code}]",
            "tr": "Hesabınız için Acil Durum Para Çekme Adresleri ayarlanmadı. Hesap sonlandırılamıyor. [{code} hatası]",
            "uk": "На зазначеному акаунті не задана жодна Адреса Аварійного Виведення. Неможливо вивести токени і видалити акаунт. [Error {code}]",
            "zh": "没有为您的帐户设置紧急取款地址。无法终止帐户。[Error {code}]"
        },
        "29905": {
            "en": "No Emergency Withdrawal Addresses(EWA) were set for your account. Unable to terminate the account. Log in to the system and set EWA first. If you do not have access to your account, please wait till {time} and use your Master Key again to start alternative account termination procedure. You will be able to set EWA using just your current Master Key [Error {code}]",
            "ru": "На указанном аккаунте не задан ни один Адрес Аварийного Вывода. Невозможно вывести токены и удалить аккаунт. Войдите в систему и установите EWA. Если вы потеряли доступ в ваш аккаунт, подождите до {time} и используйте Мастер-ключ снова. Вы попадете в процедуру альтернативного доступа и сможете задать адреса, на которые будут выведены токены с вашего аккаунта. [Error {code}]"
        },
        "29906": {
            "en": "To withdraw your tokens, you must provide ALL addresses for ALL blockchains used by the tokens on your account at once. We will send all tokens to the given addresses. Smart-contract addresses are not valid - please use only regular blockchain addresses. [Error {code}]"
        },
        "29907": {
            "en": "Login received. Master key is required to terminate this account.[Error {code}]"
        },
        "29909": {
            "en": "Unexpected error during account termination. Your account will be terminated by the administrator manually in 48 hours. [Error {code}]",
            "fr": "Erreur inattendue lors de la fermeture du compte. Votre compte sera résilié par l'administrateur manuellement dans les 48 heures. [Error {code}]",
            "it": "Errore imprevisto durante la chiusura dell'account. Il tuo account verrà chiuso manualmente dall'amministratore tra 48 ore. [Error {code}]",
            "ja": "アカウント削除中に、予期せぬエラーが発生しました。あなたのアカウントは、48時間以内に管理者により手動で削除されます。[エラー {code}]",
            "ru": "Возникла неизвестная ошибка при попытке удаления аккаунта. Ваш аккаунт будет удален в ручном режиме администратором сервиса в течение 48 часов.[Error {code}]",
            "tr": "Hesap sonlandırılması sırasında beklenmedik hata. Hesabınız yönetici tarafından 48 saat içinde manuel olarak sonlandırılacaktır. [{code} hatası]",
            "uk": "Виникла невідома помилка при спробі видалення аккаунта. Ваш аккаунт буде видалений в ручному режимі адміністратором сервісу протягом 48 годин. [Error {code}]",
            "zh": "帐户终止期间出现意外错误。管理员将在48小时内手动终止您的帐户。[Error {code}]"
        },
        "31001": {
            "en": "Please check your email for activation code. [Error {code}]",
            "fr": "Veuillez vérifier votre e-mail pour le chiffre d'activation. [Error {code}]",
            "it": "Controlla la tua e-mail per il cifrario di attivazione. [Error {code}]",
            "ja": "有効化暗号の記載されたメールが送信されました。[エラー{code}]",
            "ru": "Проверьте ваш email - вам отправлено письмо с кодом для активации аккаунта. [Error {code}]",
            "tr": "Lütfen etkinleştirme bağlantısı için e-postanızı kontrol edin. [{code} hatası]",
            "uk": "Перевірте ваш email - вам відправлено лист з посиланням на активацію аккаунта. [Error {code}]",
            "zh": "请检查您的电子邮件激活密码。 [Error {code}]"
        },
        "31002": {
            "en": "To deposit {0}, please send {0} to this {1} address. [Error {code}]",
            "fr": "Pour déposer {0}, veuillez envoyer {0} à cette {1} adresse. [Error {code}]",
            "it": "Per depositare {0}, invia {0} a questo {1} indirizzo. [Error {code}]",
            "ja": "{0}を入金するには、{0}をこの{1}アドレスに送信してください。[エラー {code}]",
            "ko": "{0}을(를) 입금하려면 {0}을(를) 이 {1} 주소로 보내십시오. [Error {code}]",
            "ru": "Для пополнения {0}, отправьте {0} на следующий {1} адрес. [Error {code}]",
            "tr": "{0}'ı yatırmak için lütfen bu {1} adresine {0}'ı gönderin. [{code} hatası]",
            "uk": "Для поповнення {0}, надішліть {0} на наступну {1} адресу. [Error {code}]",
            "zh": "若要存放{0}，请将{0}发送到此{1}地址。 [Error {code}]"
        },
        "31002tag": {
            "en": "using this TAG: '{3}' (WARNING! You must include this TAG in your transaction or your tokens will be lost!)",
            "fr": "en utilisant ce TAG: '{3}' (ATTENTION! Vous devez inclure ce TAG dans votre transaction ou vos jetons seront perdus!)",
            "it": "usando questo TAG: '{3}' (ATTENZIONE! Devi includere questo TAG nella tua transazione o i tuoi gettoni andranno persi!)",
            "ja": "使用すべきタグ：{3}（警告！このタグをトランザクションに含めてください。これを怠ると、トークンが失われてしまいます！）",
            "ko": "이 태그 사용: '{3}'(경고! 트랜잭션에 이 태그를 포함해야 합니다. 그러지 않으면 토큰을 잃게 됩니다!)",
            "ru": "обязательно указавайте TAG: '{3}' (ВАЖНО! Обязательно указывайте TAG в транзакции или токены будут потеряны!)",
            "tr": "bu ETİKET kullanılarak: '{3}' (UYARI! Bu ETİKETİ işleminize dahil etmelisiniz yoksa tokenleriniz kaybedilecektir!)",
            "uk": "обов'язково вказуйте TAG: '{3}' (ВАЖЛИВО! Обов'язково вказуйте TAG в транзакції або токени будуть втрачені!)",
            "zh": "使用此标记：'{3}'（警告！您必须在事务中包含此标记，否则您的标记将丢失！）"
        },
        "31003": {
            "en": "The new API KEY '{0}' was successfully created with API SECRET: '{1}'.",
            "fr": "La nouvelle API Key '{0}' a été créée avec succès avec API SECRET: '{1}'.",
            "it": "Il nuovo API KEY '{0}' è stato creato correttamente con API SECRET: '{1}'.",
            "ja": "新しいAPIキー「{0}」が作成されました--API SECRET：「{1}」",
            "ko": "새 API 키 '{0}'이(가) 성공적으로 만들어졌습니다. API SECRET: '{1}'.",
            "ru": "Новый ключ API '{0}' был успешно создан с API SECRET: '{1}'.",
            "tr": "Yeni '{0}' API ANAHTARI, API PAROLASI: '{1}' ile başarıyla oluşturuldu.",
            "uk": "Новий ключ API '{0}' був успішно створений з API SECRET: '{1}'.",
            "zh": "已成功使用API密钥“{1}”创建新的API密钥“{0}”。"
        },
        "33001": {
            "en": "Error: Login required [Error {code}]",
            "fr": "Connexion requise [Error {code}]",
            "it": "Login necessario [Error {code}]",
            "ja": "[エラー {code}]：ログインが必要です[エラー {code}]",
            "ko": "오류:로그인 필요함 [Error {code}]",
            "ru": "ОШИБКА: Требуется авторизация в системе [Error {code}]",
            "tr": "Hatası: Oturum açma gereklidir [{code} hatası]",
            "uk": "Необхідно авторизуватися в системі [Error {code}]",
            "zh": "需要登录[Error {code}]"
        },
        "33002": {
            "en": "POST request is required [Error {code}]",
            "fr": "Une demande POST est requise [Error {code}]",
            "it": "È necessaria la richiesta POST [Error {code}]",
            "ja": "POSTリクエスが必要です [エラー {code}]",
            "ko": "오류:POST 요청 필요 [Error {code}]",
            "ru": "Должен быть POST запрос [Error {code}]",
            "tr": "POST talebi gereklidir [{code} hatası]",
            "uk": "Повинен бути POST запит [Error {code}]",
            "zh": "需要POST请求[Error {code}]"
        },
        "33003": {
            "en": "Error placing Market order, please try again later! [Error {code}]",
            "fr": "Une erreur s'est produite lors de la commande au Marché, veuillez réessayer plus tard! [Error {code}]",
            "it": "Errore durante l'effettuazione dell'ordine del mercato, riprovare più tardi! [Error {code}]",
            "ja": "成り行き注文の実行中にエラーが発生しました。後でもう一度挑戦してください！[エラー {code}]",
            "ko": "시장가 주문을 거는 중 오류. 나중에 다시 시도하십시오! [Error {code}]",
            "ru": "Ошибка установки маркет-ордера, пожалуйста, попробуйте позже! [Error {code}]",
            "tr": "Piyasa komutu verilirken hata oluştu, lütfen daha sonra tekrar deneyin! [{code} hatası]",
            "uk": "Помилка встановлення маркет-ордера, будь ласка, спробуйте пізніше! [Error {code}]",
            "zh": "下单时出错，请稍后再试！[Error {code}]"
        },
        "33004": {
            "en": "Your reserved amount of {0} < 0, please email to {domain.email} ! [Error {code}]",
            "fr": "Votre montant réservé de {0} <0, veuillez envoyer un e-mail à {domain.email} ! [Error {code}]",
            "it": "Il vostro importo riservato è di {0} <0, invia un'email a {domain.email}! [Error {code}]",
            "ja": "あなたの予約した予約額は{0} < 0です。{domain.email}までメールをお送りください！[エラー {code}]",
            "ko": "예약금 {0} < 0입니다. {domain.email}에 이메일을 보내서 문의하십시오! [Error {code}]",
            "ru": "У вас зарезервированный баланс {0} < 0, пожалуйста, свяжитесь со службой поддержки по email {domain.email} ! [Error {code}]",
            "tr": "Ayrılmış {0} tutarınız < 0, lütfen {domain.email} adresine e-posta gönderin! [{code} hatası]",
            "uk": "У вас зарезервований баланс {0} < 0, будь ласка, зв'яжіться зі службою підтримки по email {domain.email}  ! [Error {code}]",
            "zh": "您的预订金额{0}<0，请发送电子邮件至{domain.email}！ [Error {code}]"
        },
        "33005": {
            "en": "Not enough available balance of {0} for placing this order, {1} {0} is needed, your available balance is {2} {0} [Error {code}]",
            "fr": "Solde disponible de {0} insuffisant pour passer cette commande, une solde de {1} {0} est nécessaire, votre solde disponible est de {2} {0} [Erreur {code}]",
            "it": "Saldo disponibile di {0} non sufficiente  per effettuare questo ordine, {1} {0} sono necessari, il saldo disponibile è di {2} {0} [Error {code}]",
            "ja": "注文実行に十分な{0}の残高がありません。 {1} {0}が必要です。あなたの現在の残高は{2} {0}です。[エラー {code}]",
            "ko": "이 주문에 필요한 금액({0})이 충분하지 않습니다. {1}{0}가 필요하며 귀하의 사용 가능한 금액은 {2}{0}입니다 [Error {code}]",
            "ru": "Недостаточно свободного баланса {0} для выставления этого ордера, требуется {1} {0}, ваш свободный баланс {2} {0}. [Error {code}]",
            "tr": "Bu komutu vermek için yeterli {0} bakiyesi bulunmuyor, {1} {0} gereklidir, mevcut bakiyeniz {2} {0}'dır [{code} hatası]",
            "uk": "Недостатньо вільного балансу {0} для виставлення цього ордера, потрібно {1} {0}, ваш вільний баланс {2} {0}. [Error {code}]",
            "zh": "{0}的可用余额不足，无法下单，需要{1}{0}，可用余额为{2}{0}[Error {code}]"
        },
		"33025": {
			"en": "Withdrawal to contract addresses is forbidden. [Error {code}]",
			"fr": "Le retrait aux adresses contractuelles est interdit. [Error {code}]",
			"it": "Il recesso agli indirizzi contrattuali è vietato. [Error {code}]",
			"ja": "コントラクトアドレスへの出金は禁止されています。[エラー {code}]",
			"ru": "Вывод на контракт запрещен.[Error 33025]",
			"tr": "Sözleşme adreslerine para çekme işlemi yasaklanmıştır.[{code} hatası]",
			"uk": "Виведення на контракт заборонено[Error {code}]",
			"zh": "禁止撤回合同地址[Error {code}]"
		},
        "33027": {
            "en": "Not enough available {0} balance for the requested action, {1} is needed, your available balance is {2} {0} [Error {code}]",
            "fr": "Le solde disponible de {0} ne suffit pas pour l'action demandée, {1} est nécessaire, votre solde disponible est de {2} {0} [Error {code}]",
            "it": "Saldo disponibile di {0} non sufficiente per l'azione richiesta, {1} è necessario, il saldo disponibile è di {2} {0} [Error {code}]",
            "ja": "リクエストされたアクションに十分な{0}残高がありません。{1}が必要です。現在利用できる残高は{2} {0}です。[エラー {code}]",
            "ko": "요청 된 조치에 사용 가능한 {0} 잔액이 충분하지 않습니다. {1}가 필요하며 귀하의 사용 가능한 금액은 {2}{0}입니다 [Error {code}]",
            "ru": "Недостаточно свободного баланса {0} для запрошенного действия, требуется {1}, в наличии свободно {2} {0} [Error {code}]",
            "tr": "İstenen işlem için yeterli {0} bakiye yok. {1} gereklidir, kullanılabilir bakiyeniz {2} {0}'dır [{code} hatası]",
            "uk": "Недостатньо вільного балансу {0}, потрібно {1}, в наявності вільно {2} {0} [Error {code}]",
            "zh": "可用余额{0}不足，需要{1}，可用余额为{2}{0}[Error {code}]"
        },
        "33028": {
            "en": "Withdrawal is disabled for this account [Error {code}]",
            "fr": "Les prélèvements sont déactivés pour ce compte. [Error {code}]",
            "it": "Il prelievi sono stati disabilitati per questo account [Error {code}]",
            "ja": "このアカウントの出金は無効になっています。[エラー {code}]",
            "ko": "이 계정에 대해 출금을 이용할 수 없습니다 [Error {code}]",
            "ru": "Вывод средств с этого аккаунта заблокирован. [Error {code}]",
            "tr": "Bu hesap için para çekme işlemi devre dışı bırakıldı [{code} hatası]",
            "uk": "Виведення коштів з цього аккаунта заблоковане. [Error {code}]",
            "zh": "此帐户已禁用提款 [Error {code}]"
        },
        "33030": {
            "en": "Fee has been changed. Old value = {0}, new value {1}. Please check the values in your request and resend it. [Error {code}]",
            "ru": "Комиссия изменилась. Старое значение = {0}, Новое значение = {1}. Проверьте значения в вашем запросе и отправьте его еще раз. [Error {code}]"
        },
        "34001": {
            "en": "Symbol {0} is unavailable now [Error {code}]",
            "fr": "Le symbole {0} n'est pas disponible en ce moment [Error {code}]",
            "it": "Il simbolo {0} non è al momento disponibile [Error {code}]",
            "ja": "シンボル{0}は現在利用できません。[エラー {code}]",
            "ko": "{0} 기호는 이제 사용할 수 없습니다 [Error {code}]",
            "ru": "Актив {0} в текущий момент недоступен для операций [Error {code}]",
            "tr": "{0} sembolü şu anda kullanılamıyor [{code} hatası]",
            "uk": "Актив {0} в поточний момент недоступний для операцій [Error {code}]",
            "zh": "符号{0}现在不可用[Error {code}]"
        },
        "34002": {
            "en": "Both pair symbols are the same [Error {code}]",
            "fr": "Les deux symboles de paire sont identiques [Error {code}]",
            "it": "Entrambi i simboli di coppia sono uguali [Error {code}]",
            "ja": "両方のペアシンボルが同じです。[エラー {code}]",
            "ko": "양쪽 거래 쌍 기호가 같습니다 [Error {code}]",
            "ru": "Обе части пары совпадают [Error {code}]",
            "tr": "Her iki çift sembol aynıdır [{code} hatası]",
            "uk": "Обидві частини пари збігаються [Error {code}]",
            "zh": "两对符号相同[Error {code}]"
        },
        "34003": {
            "en": "Incorrect trading pair. [Error {code}]",
            "fr": "Paire d’échange incorrect. [Error {code}]",
            "it": "Coppia di trading errata. [Error {code}]",
            "ja": "取引ペアに誤りがあります。[エラー {code}]",
            "ko": "잘못된 거래 쌍. [Error {code}]",
            "ru": "Неправильная торговая пара. [Error {code}]",
            "tr": "Yanlış işlem çifti. [{code} hatası]",
            "uk": "Неправильна торгова пара. [Error {code}]",
            "zh": "不正确的交易对。[Error {code}]"
        },
        "34004": {
            "en": "Trade with {0} is now disabled. [Error {code}]",
            "fr": "Les échanges avec {0} sont pour le moment déactivées. [Error {code}]",
            "it": "I negozi con {0} sono ora disabilitati. [Error {code}]",
            "ja": "{0}の取引は現在無効になっています。[エラー {code}]",
            "ko": "{0}(으)로 거래를 지금 사용할 수 없습니다 [Error {code}]",
            "ru": "Торговля {0} временно приостановлена [Error {code}]",
            "tr": "{0} ile alım satım işlemi şu anda devre dışıdır. [{code} hatası]",
            "uk": "Торгівля {0} тимчасово призупинена [Error {code}]",
            "zh": "与{0}的交易现在被禁用。[Error {code}]"
        },
        "35001": {
            "deprecated": "22000",
            "en": "Required parameter '{0}' is missing. [Error {code}]",
            "fr": "Le paramètre obligatoire '{0}' est absent. [Error {code}]",
            "it": "Manca il parametro richiesto '{0}'. [Error {code}]",
            "ja": "必須パラメーター「{0}」が存在しません。[エラー {code}]",
            "ko": "필요한 매개변수 '{0}'이(가) 없습니다 [Error {code}]",
            "ru": "Не передан обязательный параметр '{0} [Error {code}]'",
            "tr": "Gerekli '{0}' parametresi eksiktir. [{code} hatası]",
            "uk": "Не переданий обов'язковий параметр '{0}' [Error {code}]",
            "zh": "缺少必需的参数{0}。 [Error {code}]"
        },
        "35002": {
            "en": "parameter 'r' (rate) must be float [Error {code}]",
            "fr": "le paramètre 'r' (taux) doit être flottant [Error {code}]",
            "it": "il parametro 'r' (rate) deve essere float [Error {code}]",
            "ja": "パラメーター「'r」（レート）は浮動小数点数型にする必要があります。[エラー {code}]",
            "ko": "매개변수 'r'(환율)은 부동 소수점 수여야 합니다 [Error {code}]",
            "ru": "Параметр 'r' (цена) должен быть типа 'float' [Error {code}]",
            "tr": "'r' (oran) parametresi piyasaya çıkarılmış olmalıdır [{code} hatası]",
            "uk": "Параметр 'r' (ціна) повинен бути типу 'float' [Error {code}]",
            "zh": "参数'r'（rate）必须是float[Error {code}]"
        },
        "35003": {
            "en": "parameter 'v' (volume) must be float [Error {code}]",
            "fr": "le paramètre 'v' (volume) doit être flottant [Error {code}]",
            "it": "il parametro 'v' (volume) deve essere float [Error {code}]",
            "ja": "パラメーター「v」（ボリューム）は浮動小数点数型にする必要があります。[エラー {code}]",
            "ko": "매개변수 'v'(거래량)은 부동 소수점 수여야 합니다 [Error {code}]",
            "ru": "Параметр 'v' (количество) должен быть типа 'float' [Error {code}]",
            "tr": "'v' (işlem hacmi) parametresi piyasaya çıkarılmış olmalıdır [{code} hatası]",
            "uk": "Параметр 'v' (кількість) повинен бути типу 'float' [Error {code}]",
            "zh": "参数'v'（音量）'必须是浮动的[Error {code}]"
        },
        "35004": {
            "en": "parameter 'ot' (order type) can be one of these: 'l' (limit), 'm' (market), 'c' (conditional) [Error {code}]",
            "fr": "le paramètre «ot» (type d'ordre) peut être l'un de ces paramètres: «l» (limite), «m» (marché), «c» (conditionnel) [Error {code}]",
            "it": "il parametro 'ot' (tipo di ordine) può essere uno di questi: 'l' (limite), 'm' (mercato), 'c' (condizionale) [Error {code}]",
            "ja": "パラメーター「ot」（注文タイプ）は以下のいずれかにしてください：「l」（限定）、「m」（成り行き）、「c」（条件）[エラー {code}]",
            "ko": "매개변수 'ot'(주문 유형)은 다음 중 하나일 수 있습니다: 'l'(지정가), 'm'(시장가), 'c'(조건적) [Error {code}]",
            "ru": "Параметр 'ot' (тип ордера) может быть или: 'l' (лимитный), 'm' (маркет), 'c' (conditional) [Error {code}]",
            "tr": "'to' (komut türü) parametresi şunlardan biri olabilir: 'l' (limit), 'm' (piyasa), 'c' (şartlı) [{code} hatası]",
            "uk": "Параметр 'ot' (тип ордера) може бути або: 'l' (лімітний), 'm' (маркет), 'c' (conditional) [Error {code}]",
            "zh": "参数“ot”（订单类型）可以是以下类型之一：“l”（限制）、“m”（市场）、“c”（条件） [Error {code}]"
        },
        "35005": {
            "en": "This type of orders is currently disabled [Error {code}]",
            "fr": "Ce type de commande est actuellement désactivé [Error {code}]",
            "it": "Questo tipo di ordine è attualmente disabilitato [Error {code}]",
            "ja": "この注文タイプは現在無効になっています。[エラー {code}]",
            "ko": "이 주문 유형은 현재 사용할 수 없습니다 [Error {code}]",
            "ru": "Ордера этого типа временно недоступны [Error {code}]",
            "tr": "Bu tür komutlar şu anda devre dışıdır [{code} hatası]",
            "uk": "Ордери цього типу тимчасово недоступні [Error {code}]",
            "zh": "当前已禁用此类订单 [Error {code}]"
        },
        "35006": {
            "en": "parameter 'bs' (buy or sell) can be 'b' or 's' [Error {code}]",
            "fr": "le paramètre 'bs' (acheter ou vendre) peut être 'b' ou 's' [Error {code}]",
            "it": "il parametro 'bs' (compra o vendi) può essere 'b' o 's' [Error {code}]",
            "ja": "パラメーター「bs」（買いまたは売り）は「b」または「s」にしてください。[エラー {code}]",
            "ko": "매개변수 'bs'(매수 또는 매도)는 'b' 또는 's'일 수 있습니다 [Error {code}]",
            "ru": "Параметр 'bs' (покупка или продажа)может быть 'b' или 's' [Error {code}]",
            "tr": "'bs' (alma veya satma) parametresi 'b' veya 's' olabilir [{code} hatası]",
            "uk": "Параметр 'bs' (купівля або продаж) може бути 'b' або 's' [Error {code}]",
            "zh": "参数“b s”（买入或卖出）可以是“b”或“s” [Error {code}]"
        },
        "35007": {
            "en": "'lifetime' parameter must be int (the order will be cancelled after this number of seconds) [Error {code}]",
            "fr": "Le paramètre 'lifetime' doit être int (la commande sera annulée après ce nombre de secondes) [Error {code}]",
            "it": "il parametro 'lifetime' deve essere int (l'ordine verrà annullato dopo questo numero di secondi) [Error {code}]",
            "ja": "「期限」パラメーターは整数にしてください（この数秒経過後に注文がキャンセルされます）[エラー {code}]",
            "ko": "'lifetime' 매개변수는 정수여야 합니다(주문은 이 시간(초) 후 취소할 수 있습니다) [Error {code}]",
            "ru": "Параметр 'lifetime' должен быть целым числом (INT). Ордер будет отменен через указанное количество секунд. [Error {code}]",
            "tr": "'ömür' parametresi bulunmalıdır (komut bu saniye kadar süre sonra iptal edilecektir) [{code} hatası]",
            "uk": "Параметр 'lifetime' повинен бути цілим числом (INT). Ордер буде скасований через вказану кількість секунд. [Error {code}]",
            "zh": "“lifetime”参数必须为int（此秒数后将取消订单） [Error {code}]"
        },
        "35008": {
            "en": "You cannot place an order with the lifetime less than 10 seconds [Error {code}]",
            "fr": "Vous ne pouvez pas passer de commande avec une durée de vie inférieure à 10 secondes [Error {code}]",
            "it": "Non è possibile effettuare un ordine con una durata inferiore a 10 secondi [Error {code}]",
            "ja": "期限を10秒未満にして注文をすることができません。[エラー {code}]",
            "ko": "10초 미만의 시간으로는 주문을 걸 수 없습니다 [Error {code}]",
            "ru": "Запрещено выставлять ордер с 'lifetime' менее 10 секунд. [Error {code}]",
            "tr": "Ömrü 10 saniyeden az olan bir komut veremezsiniz [{code} hatası]",
            "uk": "Заборонено виставляти ордер з 'lifetime' менше 10 секунд. [Error {code}]",
            "zh": "您不能订购寿命少于10秒的产品[Error {code}]"
        },
        "35009": {
            "en": "'expire_time' parameter must be int unix timestamp [Error {code}]",
            "fr": "Le paramètre 'expire_time' doit être un horodatage int unix [Error {code}]",
            "it": "Il parametro 'expire_time' deve essere int unix timestamp [Error {code}]",
            "ja": "「期限」パラメーターは整数のUNIX時間て記載する必要があります。[エラー {code}]",
            "ko": "'expire_time' 매개변수는 정수 유닉스 타임스태프이어야 합니다 [Error {code}]",
            "ru": "'expire_time' параметр должен быть меткой времени UNIX [Error {code}]",
            "tr": "'sona erme_zamanı' parametresi int unix zaman damgası olmalıdır [{code} hatası]",
            "uk": "'expire_time' параметр повинен бути міткою часу UNIX [Error {code}]",
            "zh": "“expire_time”参数必须是int unix timestamp[Error {code}]"
        },
        "35010": {
            "en": "You cannot place an order with the expiration time less than the current timestamp (now {0}) [Error {code}]",
            "fr": "Vous ne pouvez pas passer une commande dont le délai d'expiration est inférieur à l'horodatage actuel (maintenant {0}) [Error {code}]",
            "it": "Non è possibile effettuare un ordine con il tempo di scadenza inferiore al timestamp corrente (ora {0}) [Error {code}]",
            "ja": "現在のタイムスタンプより前の時間を期限に指定して注文をすることはできません。（現在：{0}）[エラー {code}]",
            "ko": "현재 타임스탬프(지금 {0})보다 짧은 만료 시간으로는 주문을 걸 수 없습니다 [Error {code}]",
            "ru": "Невозможно выставить ордер со временем отмены ранее текущего времени ({0}) + 10 секунд. [Error {code}]",
            "tr": "Zaman aşımı tarihi geçerli zaman damgasından (şimdi {0}) daha az olan bir komut veremezsiniz [{code} hatası]",
            "uk": "Неможливо виставити ордер з часом скасування раніше поточного часу ({0}) + 10 секунд. [Error {code}]",
            "zh": "不能将过期时间小于当前时间戳的订单（现在{0}） [Error {code}]"
        },
        "35011": {
            "en": "You cannot place an order with the lifetime closer than 10 seconds to the current time (current timestamp is {0}) [Error {code}]",
            "fr": "Vous ne pouvez pas passer de commande dont la durée de vie est inférieure à 10 secondes à l'heure actuelle (l'horodatage actuel est {0}) [Error {code}]",
            "it": "Non è possibile effettuare un ordine con una durata inferiore a 10 secondi rispetto all'ora corrente (il timestamp corrente è {0}) [Error {code}]",
            "ja": "現在時刻からの誤差10秒未満に期限を設定して注文をすることはできません。（現代の時刻：{0}）[エラー {code}]",
            "ko": "현재 시간과 10초보다 짧은 만료 시간으로는 주문을 걸 수 없습니다(현재 타임스탬프는 {0}) [Error {code}]",
            "ru": "Невозможно выставить ордер со временем отмены ранее текущего времени (время сейчас: {0}) + 10 секунд. [Error {code}]",
            "tr": "Ömrü geçerli zamana (geçerli zaman damgası {0}) 10 saniyeden daha yakın olan bir komut veremezsiniz [{code} hatası]",
            "uk": "Неможливо виставити ордер з часом скасування раніше поточного часу (час зараз: {0}) + 10 секунд. [Error {code}]",
            "zh": "不能将生存期小于当前时间10秒的订单（当前时间戳为{0}） [Error {code}]"
        },
        "35012": {
            "en": "Rate and volume must be greater than 0.",
            "fr": "Le taux et le volume doivent être supérieurs à 0.",
            "it": "Il tasso e il volume devono essere superiori a 0.",
            "ja": "レートとボリュームは0を上回る必要があります。",
            "ko": "수량과 가격은 0보다 커야합니다.",
            "ru": "Количество и цена должны быть больше 0. ",
            "tr": "Oran ve işlem hacmi 0'dan büyük olmalıdır.",
            "uk": "Кількість і ціна повинні бути більше 0.",
            "zh": "速率和音量必须大于0。"
        },
        "35013": {
            "en": "Minimal trading volume for {0} should be more than {1} {0} [Error {code}]",
            "fr": "Le volume d'échanges minimal pour {0} doit être supérieur à {1} {0} [Error {code}]",
            "it": "Il volume di trading minimo per {0} dovrebbe essere superiore a {1} {0} [Error {code}]",
            "ja": "{0}の最低取引ボリュームは、{1} {0}を上回る必要があります。[エラー {code}]",
            "ko": "{0}의 최소 거래량은 {1}{0}보다 커야 합니다 [Error {code}]",
            "ru": "Минимальный объем в ордере {0} должен быть больше {1} {0} [Error {code}]",
            "tr": "{0} için minimum alım satım işlem hacmi {1} {0} 'dan fazla olmalıdır [{code} hatası]",
            "uk": "Мінімальний обсяг в ордері {0} повинен бути більше {1} {0} [Error {code}]",
            "zh": "{0}的最小交易量应大于{1}{0} [Error {code}]"
        },
        "35014": {
            "en": "'oid' (order ID) parameter is required [Error {code}]",
            "fr": "Le paramètre 'oid' (ID de commande) est requis [Error {code}]",
            "it": "È richiesto il parametro 'oid' (ID dell'ordine) [Error {code}]",
            "ja": "「oid」（注文ID）パラメーターが必要です。[エラー {code}]",
            "ko": "oid 필요(주문 ID 매개변수) [Error {code}]",
            "ru": "Нужен oid (ID ордера) [Error {code}]",
            "tr": "'oid' (komut kimliği) parametresi gerekldir [{code} hatası]",
            "uk": "Потрібен oid (ID ордера) [Error {code}]",
            "zh": "“oid”（order ID）参数是必需的[Error {code}]"
        },
        "35015": {
            "en": "Order {0} not found. [Error {code}]",
            "fr": "Ordre {0} introuvable. [Error {code}]",
            "it": "Ordine {0} non trovato. [Error {code}]",
            "ja": "注文{0}が見つかりませんでした。[Error {code}]",
            "ko": "주문 {0}을(를) 찾을 수 없습니다. [Error {code}]",
            "ru": "Ордер {0} не найден. [Error {code}]",
            "tr": "{0} komutu bulunamadı. [{code} hatası]",
            "uk": "Ордер {0} не знайдено. [Error {code}]",
            "zh": "未找到订单{0}。 [Error {code}]"
        },
        "35016": {
            "en": "Volume, rate and lifetime must be greater than 0 [Error {code}]",
            "fr": "Le volume, le taux et la durée de vie doivent être supérieurs à 0 [Error {code}]",
            "it": "Volume, tasso e durata devono essere superiori a 0 [Error {code}]",
            "ja": "ボリューム、レート、期限は0を上回る必要があります。[エラー {code}]",
            "ko": "거래량, 환율, 만료 시간은 0보다 커야 합니다 [Error {code}]",
            "ru": "Volume, rate и expire_time должны быть больше 0 [Error {code}]",
            "tr": "İşlem hacmi, oran ve ömür 0'dan büyük olmalıdır. [{code} hatası]",
            "uk": "Volume, rate та expire_time повинні бути більше 0 [Error {code}]",
            "zh": "容量、速率和生存期必须大于0[Error {code}]"
        },
        "35017": {
            "en": "You cannot change the lifetime of the order to a value less than the current timestamp {0} plus 6 seconds. [Error {code}]",
            "fr": "Vous ne pouvez pas modifier la durée de vie de la commande en une valeur inférieure à l'horodatage actuel {0} plus 6 secondes. [Error {code}]",
            "it": "Non è possibile modificare la durata dell'ordine in un valore inferiore al timestamp corrente {0} più 6 secondi. [Error {code}]",
            "ja": "注文の期限を現在の時刻{0}から6秒後未満に変更することはできません。[エラー{code}]",
            "ko": "주문 만료 시간을 현재 타임스탬프 {0} + 6초보다 작은 값으로는 변경할 수 없습니다. [Error {code}]",
            "ru": "Нельзя изменить время отмены ордера на значение менее текущего timestamp {0} плюс 6 секунд. [Error {code}]",
            "tr": "Komut ömrü geçerli zaman damgasını {0} artı 6 saniyeden daha az bir değere değiştiremezsiniz. [{code} hatası]",
            "uk": "Не можна змінити час скасування ордера на значення менше поточного timestamp {0} плюс 6 секунд. [Error {code}]",
            "zh": "不能将订单的生存期更改为小于当前时间戳{0}加6秒的值。 [Error {code}]"
        },
        "35018": {
            "en": "You cannot set the lifetime of the order less than +5 seconds from the current timestamp {0}) [Error {code}]",
            "fr": "Vous ne pouvez pas définir la durée de vie de la commande à moins de +5 secondes de l'horodatage actuel {0}) [Error {code}]",
            "it": "Non puoi impostare la durata dell'ordine a meno di +5 secondi dal timestamp corrente {0}) [Error {code}]",
            "ja": "注文の期限を現在の時刻{0}から5秒後未満に設定することはできません。[エラー {code}]",
            "ko": "현재 타임스탬프 {0}에서 +5초보다 짧은 주문 만료 시간은 설정할 수 없습니다 [Error {code}]",
            "ru": "Нельзя установить время отмены ордера на значение менее текущего timestamp {0} плюс 5 секунд. [Error {code}]",
            "tr": "Komut ömrünü geçerli zaman damgasıdan {0} +5 saniyeden daha az bir değere  ayarlayamazsınız [{code} hatası]",
            "uk": "Не можна встановити час скасування ордера на значення менше поточного timestamp {0} плюс 5 секунд. [Error {code}]",
            "zh": "不能将订单的生存期设置为距当前时间戳{0}小于+5秒）[Error {code}]"
        },
        "35019": {
            "en": "Amount and rate must be >= 0 [Error {code}]",
            "fr": "Le montant et le taux doivent être> = 0 [Error {code}]",
            "it": "L'importo e la tariffa devono essere >= 0 [Error {code}]",
            "ja": "数量とレートは>= 0である必要があります。[エラー {code}]",
            "ko": "금액과 환율은 0 이상이어야 합니다 [Error {code}]",
            "ru": "Amount и rate должны быть >= 0 [Error {code}]",
            "tr": "Tutar ve oran >= 0 olmalıdır [{code} hatası]",
            "uk": "Amount і rate повинні бути >= 0 [Error {code}]",
            "zh": "金额和费率必须大于等于0 [Error {code}]"
        },
        "35021": {
            "en": "Changing of MARKET order is impossible [Error {code}]",
            "fr": "La modification de l'ordre du MARCHÉ est impossible [Error {code}]",
            "it": "La modifica dell'ordine di MERCATO è impossibile [Error {code}]",
            "ja": "成り行き注文の変更はできません。[エラー {code}]",
            "ko": "시장가 주문 변경이 불가능합니다 [Error {code}]",
            "ru": "Изменение рыночных ордеров невозможно. Дождитесь завершения исполнения ордера. [Error {code}]",
            "tr": "PİYASA komutlarının değiştirilmesi mümkün değil [{code} hatası]",
            "uk": "Зміна ринкових ордерів неможлива. Дочекайтеся завершення виконання ордера. [Error {code}]",
            "zh": "改变市场秩序是不可能的[Error {code}]"
        },
        "35022": {
            "en": "Changes to this trade order are forbidden [Error {code}]",
            "fr": "Les modifications à cet ordre de marché sont interdites [Error {code}]",
            "it": "Modifiche a questo ordine commerciale sono vietate [Error {code}]",
            "ja": "この取引注文への変更は禁止されています。[エラー {code}]",
            "ko": "이 거래 주문 변경은 금지됩니다 [Error {code}]",
            "ru": "Изменение этого ордера запрещено. [Error {code}]",
            "tr": "Bu alım satım komutunda değişiklik yapılması yasaktır [{code} hatası]",
            "uk": "Зміна цього ордера заборонена. [Error {code}]",
            "zh": "禁止更改此交易订单[Error {code}]"
        },
        "35023": {
            "en": "This order is currently in changing queue, please wait. [Error {code}]",
            "fr": "Cette commande est actuellement en attente de modification. [Error {code}]",
            "it": "Questo ordine è attualmente nella lista d'attesa per essere cambiato, attendere prego. [Error {code}]",
            "ja": "この注文は現在変更の適用待ちです。少々お待ちください。[エラー {code}]",
            "ko": "이 주문은 현재 큐 변경 중입니다. 기다리십시오 [Error {code}]",
            "ru": "Ордер уже находится в очереди на изменение. Пожалуйста, подождите. [Error {code}]",
            "tr": "Bu komut şu anda değişen sıradadır, lütfen bekleyin. [{code} hatası]",
            "uk": "Ордер вже знаходиться в черзі на зміну. Будь ласка, зачекайте. [Error {code}]",
            "zh": "此订单当前正在更改队列中，请稍候。 [Error {code}]"
        },
        "35024": {
            "en": "New volume cannot be less than {0} {1} in this order [Error {code}]",
            "fr": "Le nouveau volume ne peut pas être inférieur à {0} {1} dans cette commande [Error {code}]",
            "it": "Il nuovo volume non può essere inferiore a {0} {1} in questo ordine [Error {code}]",
            "ja": "この注文での新しい数量は{0} {1}未満にすることはできません。[エラー {code}]",
            "ru": "Новое значение объема в этом ордере не может быть менее {0} {1}. [Error {code}]",
            "tr": "Yeni işlem hacmi bu komutta {0} {1}'dan az olamaz [{code} hatası]",
            "uk": "Нове значення обсягу в цьому ордері не може бути менше {0} {1}. [Error {code}]",
            "zh": "按此顺序，新的容量不能小于{0} {1}[Error {code}]"
        },
        "35025": {
            "en": "Your reserved amount of {0} < 0, please email to {domain.email} [Error {code}]",
            "fr": "Votre montant réservé de {0} <0, veuillez envoyer un courriel à {domain.email} [Error {code}]",
            "it": "Il vostro importo riservato di {0} <0, invia un'email a {domain.email} [Error {code}]",
            "ja": "あなたの予約額は{0} < 0です。{domain.email}にメールをお送りください。[エラー {code}]",
            "ko": "예약금 {0} < 0입니다. {domain.email}에 이메일을 보내서 문의하십시오 [Error {code}]",
            "ru": "Зарезервированный баланс {0} на вашем аккаунте меньше 0, свяжитесь с нами по email {domain.email} [Error {code}]",
            "tr": "Ayrılmış {0} tutarınız < 0, lütfen {domain.email} adresine e-posta gönderin [{code} hatası]",
            "uk": "Зарезервований баланс {0} на вашому аккаунті менше 0, зв'яжіться з нами по email {domain.email} [Error {code}]",
            "zh": "您的{0}<0保留金额，请发邮件至{domain.email} [Error {code}]"
        },
        "35026": {
            "en": "Not enough available balance of {0} for changing this order, {1} {0} is needed, your available balance is {2} {0}. [Error {code}]",
            "fr": "Solde disponible de {0} est insuffisant pour modifier cette commande, {1} {0} est nécessaire, votre solde disponible est de {2} {0}. [Error {code}]",
            "it": "Saldo disponibile di {0} non sufficiente per modificare questo ordine, {1} {0} sono necessari, il saldo disponibile è di {2} {0}. [Error {code}]",
            "ja": "この注文を変更するだけの十分な{0}の残高がありません。{1} {0}が必要です。あなたの現在の残高は{2} {0}です。[エラー {code}]",
            "ko": "이 주문의 변경을 위한 금액({0})이 충분하지 않습니다. {1}{0}가 필요하며 귀하의 사용 가능한 금액은 {2}{0}입니다. [Error {code}]",
            "ru": "Недостаточно свободного баланса {0} для изменения этого ордера, требуется {1} {0}, ваш свободный баланс {2} {0}. [Error {code}]",
            "tr": "Bu komutu değiştirmek için yeterli {0} bakiyesi bulunmuyor, {1} {0} gereklidir, mevcut bakiyeniz {2} {0}'dır. [{code} hatası]",
            "uk": "Недостатньо вільного балансу {0} для зміни цього ордера, потрібно {1} {0}, ваш вільний баланс {2} {0}. [Error {code}]",
            "zh": "{0}的可用余额不足，无法更改此顺序，需要{1}{0}，可用余额为{2}{0}。 [Error {code}]"
        },
        "35028": {
            "en": "Invalid value of 'oid' parameter [Error {code}]",
            "fr": "Valeur non valide du paramètre 'oid' [Error {code}]",
            "it": "Valore non valido del parametro 'oid' [Error {code}]",
            "ja": "「oid」パラメーターの値に誤りあります。[エラー {code}]",
            "ko": "올바르지 않은 'oid' 매개변수 값 [Error {code}]",
            "ru": "Невалидное значение параметра 'oid'. [Error {code}]",
            "tr": "Geçersiz 'oid' parametresi değeri [{code} hatası]",
            "uk": "Не валідне значення параметра 'oid'. [Error {code}]",
            "zh": "“oid”参数的值无效 [Error {code}]"
        },
        "35030": {
            "en": "Order {0} already fulfilled. [Error {code}]",
            "fr": "La commande {0} a déjà été réalisée. [Error {code}]",
            "it": "Ordine {0} già effettuato. [Error {code}]",
            "ja": "注文 {0}が自動で 確定しました。[エラー {code}]",
            "ko": "{0} 주문이 이미 완전히 체결되었습니다. [Error {code}]",
            "ru": "Ордер номер {0} уже полностью исполнен. [Error {code}]",
            "tr": "{0} komutu zaten yerine getirildi. [{code} hatası]",
            "uk": "Ордер номер {0} вже повністю виконаний. [Error {code}]",
            "zh": "订单{0}已完成。[Error {code}]"
        },
        "35031": {
            "en": "Order {0} is already in the cancelling queue. [Error {code}]",
            "fr": "La commande {0} est déjà dans la file d'attente pour l'annulation. [Error {code}]",
            "it": "L'ordine {0} è già nella lista d'attesa di annullamento. [Error {code}]",
            "ja": "注文{0}は既にキャンセル待ち状態です。[エラー {code}]",
            "ko": "{0} 주문이 이미 큐 취소 중입니다. [Error {code}]",
            "ru": "Ордер номер {0} уже в очереди на изменение, дождитесь завершения. [Error {code}]",
            "tr": "{0} komutu zaten iptal kuyruğunda. [{code} hatası]",
            "uk": "Ордер номер {0} вже в черзі на зміну, дочекайтеся завершення. [Error {code}]",
            "zh": "订单{0}已在取消队列中。 [Error {code}]"
        },
        "35032": {
            "en": "Order {0} already cancelled. [Error {code}]",
            "fr": "La commande {0} a déjà été annulée. [Error {code}]",
            "it": "Ordine {0} già annullato. [Error {code}]",
            "ja": "注文{0}は既にキャンセルされています。[エラー {code}]",
            "ko": "{0} 주문이 이미 취소되었습니다. [Error {code}]",
            "ru": "Ордер номер {0} уже отменен. [Error {code}]",
            "tr": "{0} komutu zaten iptal edildi. [{code} hatası]",
            "uk": "Ордер номер {0} вже скасований. [Error {code}]",
            "zh": "订单{0}已取消。[Error {code}]"
        },
        "35033": {
            "en": "Cannot cancel order {0} right now, please try later [Error {code}]",
            "fr": "Impossible d'annuler la commande {0} pour le moment, veuillez réessayer plus tard [Error {code}]",
            "it": "Impossibile annullare l'ordine {0} in questo momento, riprova più tardi [Error {code}]",
            "ja": "注文{0}を今すぐキャンセルすることはできません。後でもう一度挑戦してください。[エラー {code}]",
            "ko": "{0} 주문을 지금 바로 취소할 수 없습니다. 나중에 시도하십시오 [Error {code}]",
            "ru": "Невозможно сейчас изменить ордер номер {0}, пожалуйста, попробуйте позже. [Error {code}]",
            "tr": "{0} komutu şu anda iptal edilemiyor, lütfen daha sonra tekrar deneyin [{code} hatası]",
            "uk": "Неможливо зараз змінити ордер номер {0}, будь ласка, спробуйте пізніше. [Error {code}]",
            "zh": "现在无法取消订单{0}，请稍后再试[Error {code}]"
        },
        "35034": {
            "en": "Cannot cancel order with state {0}. [Error {code}]",
            "fr": "Impossible d'annuler la commande avec l'état {0}. [Error {code}]",
            "it": "Impossibile annullare l'ordine con lo stato {0}. [Error {code}]",
            "ja": "{0}の状態にある注文をキャンセルすることはできません。[エラー {code}]",
            "ko": "{0} 상태로 주문을 취소할 수 없습니다. [Error {code}]",
            "ru": "Невозможно изменить ордер со статусом {0}. [Error {code}]",
            "tr": "{0} durumu ile komut iptal edilemez. [{code} hatası]",
            "uk": "Неможливо змінити ордер зі статусом {0}. [Error {code}]",
            "zh": "无法取消状态为{0}的订单。 [Error {code}]"
        },
        "35035": {
            "en": "'oid' must be integer value [Error {code}]",
            "fr": "'oid' doit être une valeur entière [Error {code}]",
            "it": "'oid' deve essere un valore intero [Error {code}]",
            "ja": "「oid」は整数にしてください。[エラー {code}]",
            "ko": "'oid'는 정수값이어야 합니다 [Error {code}]",
            "ru": "'oid' должен быть типа 'integer' [Error {code}]",
            "tr": "'oid' tamsayı değeri olmalıdır [{code} hatası]",
            "uk": "'oid' повинен бути типу 'integer' [Error {code}]",
            "zh": "“oid”必须是整数值 [Error {code}]"
        },
        "35036": {
            "en": "parameter 'sym' is required [Error {code}]",
            "fr": "le paramètre 'sym' est requis [Error {code}]",
            "it": "il parametro 'sym' è necessario [Error {code}]",
            "ja": "パラメーター「sym」の入力が必須です。[エラー {code}]",
            "ko": "'sym' 매개변수가 필요합니다 [Error {code}]",
            "ru": "Необходим параметр 'sym'",
            "tr": "'sym' parametresi gereklidir [{code} hatası]",
            "uk": "Необхідний параметр 'sym' [Error {code}]",
            "zh": "参数'sym'是必需的[Error {code}]"
        },
        "35038": {
            "en": "State can be new, confirmed or done [Error {code}]",
            "fr": "L'état peut être nouveau, confirmé ou terminé [Error {code}]",
            "it": "Lo stato può essere nuovo, confermato o effettuato [Error {code}]",
            "ja": "状態は新規、確認済み、完了のいずれかになります。[エラー {code}]",
            "ko": "상태가 신규, 확인됨, 완료 중 하나일 수 있습니다 [Error {code}]",
            "ru": "State может быть 'new', 'confirmed' or 'done'",
            "tr": "Durum yenilenebilir, onaylanabilir veya yapılabilir [{code} hatası]",
            "uk": "State може бути 'new', 'confirmed' or 'done' [Error {code}]",
            "zh": "状态可以是新的、确认的或完成的 [Error {code}]"
        },
        "35039": {
            "en": "'{0}' parameter is required for withdrawal [Error {code}]",
            "fr": "Le paramètre '{0}' est requis pour effectuer un prélèvement [Error {code}]",
            "it": "Il parametro '{0}' è necessario per il prelevamento [Error {code}]",
            "ja": "出金のためには「{0}」パラメーターが必要です。[エラー {code}]",
            "ko": "출금에 '{0}' 필요 [Error {code}]",
            "ru": "Необходим параметр '{0}' для вывода [Error {code}]",
            "tr": "Para çekme için '{0}' parametresi gereklidir [{code} hatası]",
            "uk": "Необхідний '{0}' для виведення [Error {code}]",
            "zh": "提取时需要'{0}'参数[Error {code}]"
        },
        "35040": {
            "en": "Amount to be withdrawn is missing [Error {code}]",
            "fr": "Le montant à prélèver est absent [Error {code}]",
            "it": "Manca l'importo da prelevare [Error {code}]",
            "ja": "出金する額が入力されていません。[エラー {code}]",
            "ko": "출금액이 누락되었습니다 [Error {code}]",
            "ru": "Не указана сумма вывода [Error {code}]",
            "tr": "Çekilecek tutar eksik [{code} hatası]",
            "uk": "Не вказана сума вивведення [Error {code}]",
            "zh": "缺少要提取的金额 [Error {code}]"
        },
        "35041": {
            "en": "Withdrawal amount must be greater than 0 [Error {code}]",
            "fr": "Le montant à prélever doit être supérieur à 0 [Error {code}]",
            "it": "L'importo da prelevare deve essere superiore a 0 [Error {code}]",
            "ja": "出金額は0を上回る必要があります。[エラー {code}]",
            "ko": "출금액은 0보다 커야 합니다 [Error {code}]",
            "ru": "Сумма вывода должна быть больше нуля [Error {code}]",
            "tr": "Para çekme tutarı 0'dan büyük olmalıdır [{code} hatası]",
            "uk": "Сума виведення повинна бути більше нуля [Error {code}]",
            "zh": "支取金额必须大于0 [Error {code}]"
        },
        "35042": {
            "en": "Too small an amount for withdrawal, min withdrawal amount is {0} {1} [Error {code}]",
            "fr": "Montant de prélèvement trop bas, le montant minimal de prélèvement est de {0} {1} [Error {code}]",
            "it": "Un importo troppo basso per effettuare il prelevamento, l'importo minimo per un prelevamento è di {0} {1} [Error {code}]",
            "ja": "出金額が小さすぎます。最低出金額は{0} {1}です。[エラー {code}]",
            "ko": "소액 출금을 위한 최소 출금액은 {0}{1}입니다 [Error {code}]",
            "ru": "Вы пытаетесь отправить меньше минимально возможной суммы в {0} {1} [Error {code}]",
            "tr": "Para çekme işlemi için çok küçük bir tutar, minimum para çekme tutarı {0} {1}'dir [{code} hatası]",
            "uk": "Ви намагаєтеся відправити менше мінімально можливої суми в {0} {1} [Error {code}]",
            "zh": "支取金额太小，最小支取金额为{0}{1}[Error {code}]"
        },
        "35044": {
            "en": "Withdrawal address is missing [Error {code}]",
            "fr": "L'adresse de prélèvement est absente [Error {code}]",
            "it": "Indirizzo di prelevamento mancante [Error {code}]",
            "ja": "出金アドレスが入力されていません。[エラー {code}]",
            "ko": "출금 주소가 누락되었습니다 [Error {code}]",
            "ru": "Не указан адрес на который отправлять [Error {code}]",
            "tr": "Para çekme adresi eksik [{code} hatası]",
            "uk": "Не вказана адреса, на яку відправляти [Error {code}]",
            "zh": "取款地址丢失[Error {code}]"
        },
        "35045": {
            "en": "Withdrawal has been rejected, as the post-withdrawal account state do not match margin requirements (Margin Level must be > {0}% after the withdrawal). [Error {code}]",
            "ru": "Вывод был отклонен, так как состояние счета после вывода не соответствует маржинальным требованиям: после вывода уровень Margin Level должен превышать {0}%. [Error {code}]"
        },
        "35046": {
            "en": "Please enable 2FA first. [Error {code}]",
            "fr": "Veuillez d'abord activer le 2FA. [Error {code}]",
            "it": "Abilitare prima la 2FA. [Error {code}]",
            "ja": "先に2FAを有効にしてください。[Error {code}]",
            "ko": "OTP 인증을 먼저 활성화하십시오. [Error {code}]",
            "ru": "Сначала нужно ввести 2FA [Error {code}]",
            "tr": "Lütfen önce 2FA'yı etkinleştirin. [{code} hatası]",
            "uk": "Спочатку потрібно ввести 2FA [Error {code}]",
            "zh": "请先启用2FA。 [Error {code}]"
        },
        "35047": {
            "en": "Please enter 2FA code [Error {code}]",
            "fr": "Veuillez saisir le code 2FA [Error {code}]",
            "it": "Inserisci il codice 2FA [Error {code}]",
            "ja": "2FAコードを入力してください。[エラー {code}]",
            "ko": "OTP 인증 코드를 입력하십시오 [Error {code}]",
            "ru": "Пожалуйста, введите 2FA код [Error {code}]",
            "tr": "Lütfen 2FA kodunu girin [{code} hatası]",
            "uk": "Будь ласка, введіть 2FA код [Error {code}]",
            "zh": "请输入2FA代码[Error {code}]"
        },
        "35050": {
            "en": "'apikey' parameter is required [Error {code}]",
            "fr": "le paramètre 'apikey' est requis [Error {code}]",
            "it": "È necessario il parametro 'apikey' [Error {code}]",
            "ja": "「apikey」パラメーターを入力してください。[Error {code}]",
            "ko": "'apikey' 매개변수 필요 [Error {code}]",
            "ru": "Отсутствует параметр 'apikey' [Error {code}]",
            "tr": "'apikey' parametresi gereklidir [{code} hatası]",
            "uk": "Відсутній параметр 'apikey' [Error {code}]",
            "zh": "“apikey”参数是必需的 [Error {code}]"
        },
        "35051": {
            "en": "API key {0} not found! [Error {code}]",
            "fr": "Clé API {0} introuvable! [Error {code}]",
            "it": "Chiave API {0} non trovata! [Error {code}]",
            "ja": "APIキー{0}が見つかりませんでした！[エラー {code}]",
            "ko": "API 키 {0}을(를) 찾을 수 없습니다! [Error {code}]",
            "ru": "Ключ API {0} не найден! [Error {code}]",
            "tr": "{0} API anahtarı bulunamadı! [{code} hatası]",
            "uk": "Ключ API {0} не знайдено! [Error {code}]",
            "zh": "找不到API密钥{0}！ [Error {code}]"
        },
        "35054": {
            "en": "'settings' parameter is required to save settings [Error {code}]",
            "fr": "Le paramètre 'settings' est requis pour enregistrer les paramètres [Error {code}]",
            "it": "Il parametro 'settings' è necessario per salvare le impostazioni [Error {code}]",
            "ja": "設定を保存するには「settings」パラメーターが必要です。[エラー {code}]",
            "ko": "설정을 쓰기 위해 'settings' 매개변수 필요 [Error {code}]",
            "ru": "Отсутствует необходимое значение 'settings' для записи настроек [Error {code}]",
            "tr": "ayarları kaydetmek için 'ayarlar' parametresi gereklidir [{code} hatası]",
            "uk": "Відсутнє необхідне значення 'settings' для запису налаштувань [Error {code}]",
            "zh": "保存设置需要“settings”参数 [Error {code}]"
        },
        "35055": {
            "en": "Error while converting 'settings' value to JSON [Error {code}]",
            "fr": "Erreur lors de la conversion de la valeur des 'settings' en JSON [Error {code}]",
            "it": "Errore durante la conversione del valore di \"settings\" in JSON [Error {code}]",
            "ja": "「settings」の値をJSONに変換中にエラーが発生しました。[エラー {code}]",
            "ko": "'settings' 값을 JSON으로 변환하는 중 오류 [Error {code}]",
            "ru": "Ошибка конвертации значения 'settings' в JSON [Error {code}]",
            "tr": "'Ayarlar' değeri JSON'a dönüştürülürken hata oluştu [{code} hatası]",
            "uk": "Помилка конвертації значення 'settings' в JSON [Error {code}]",
            "zh": "将“settings”值转换为JSON时出错 [Error {code}]"
        },
        "35056": {
            "en": "Error while saving 'settings' value to JSON [Error {code}]",
            "fr": "Erreur lors de l'enregistrement de la valeur 'settings' en JSON [Error {code}]",
            "it": "Errore durante il salvataggio del valore 'settings' in JSON [Error {code}]",
            "ja": "「settings」の値をJSONに保存中にエラーが発生しました。[エラー {code}]",
            "ko": "'settings' 값을 JSON에 저장하는 중 오류 [Error {code}]",
            "ru": "Ошибка записи значения 'settings' в JSON [Error {code}]",
            "tr": "'Ayarlar' değeri JSON'a kaydedilirken hata oluştu [{code} hatası]",
            "uk": "Помилка запису значення 'settings' в JSON [Error {code}]",
            "zh": "将“settings”值保存到JSON时出错[Error {code}]"
        },
        "35058": {
            "en": "2FA is not enabled [Error {code}]",
            "fr": "2FA n'est pas activé [Error {code}]",
            "it": "2FA non è abilitato [Error {code}]",
            "ja": "2FAが有効になっていません。[エラー {code}]",
            "ko": "OTP 인증을 이용할 수 없습니다 [Error {code}]",
            "ru": "Не активирована двухфакторная авторизация (2FA) [Error {code}]",
            "tr": "2FA etkin değil [{code} hatası]",
            "uk": "Не активована двухфакторна авторизація (2FA) [Error {code}]",
            "zh": "2FA未启用[Error {code}]"
        },
        "35059": {
            "en": "Parameter 'settings' is too long, max length is {0} bytes [Error {code}]",
            "fr": "Le paramètre 'settings' est trop long, la longueur maximale est de {0} octets [Error {code}]",
            "it": "Il parametro 'settings' è troppo lungo, la lunghezza massima è di {0} byte [Error {code}]",
            "ja": "パラメーター「settings」が長すぎます。最大{0}バイトです。[エラー {code}]",
            "ru": "Параметр 'settings' слишком длинный, максимально возможная длина: {0} bytes [Error {code}]",
            "tr": "'Ayarlar' parametresi çok uzun, maksimum uzunluk {0} bayt'dır [{code} hatası]",
            "uk": "Параметр 'settings' занадто довгий, максимально можлива довжина: {0} bytes [Error {code}]",
            "zh": "参数“settings”太长，最大长度为{0}字节 [Error {code}]"
        },
        "35060": {
            "en": "'type' parameter is required [Error {code}]",
            "fr": "le paramètre 'type' est requis [Error {code}]",
            "it": "Il parametro 'type' è obbligatorio [Error {code}]",
            "ja": "「type」パラメーターを入力してください。[エラー {code}]",
            "ko": "'type' 매개변수 필요 [Error {code}]",
            "ru": "Отсутствует параметр 'type' [Error {code}]",
            "tr": "'tür' parametresi gereklidir [{code} hatası]",
            "uk": "Відсутній параметр 'type' [Error {code}]",
            "zh": "“type”参数是必需的[Error {code}]"
        },
        "35064": {
            "en": "Withdrawals of A2A(B) tokens are restricted. They may be used to pay commissions. [Error {code}]",
            "fr": "Les prélèvements de jetons A2A(B) sont limités. Ils peuvent être utilisés pour payer des commissions. [Error {code}]",
            "it": "I prelievi di gettoni A2A(B) sono limitati. Possono essere utilizzati per pagare commissioni. [Error {code}]",
            "ja": "A2A(B)トークンの出金は制限されています。これはコミッションの支払いに使用することができます。[エラー {code}]",
            "ko": "A2A(B) 토큰 출금은 제한됩니다. 이 토큰은 수수료 지불을 위해 사용될 수 있습니다. [Error {code}]",
            "ru": "Вывод A2A(H) запрещен. Их можно использовать только для оплаты комиссий. [Error {code}]",
            "tr": "A2A(B) tokenlerinin çekilmesi kısıtlanmıştır. Komisyon ödemek için kullanılabilirler. [{code} hatası]",
            "uk": "Виведення A2A(H) заборонено. Їх можна використовувати тільки для оплати комісій. [Error {code}]",
            "zh": "A2A（B）代币的提取受到限制。它们可以用来支付佣金。 [Error {code}]"
        },
        "35065": {
            "en": "Withdrawals of A2A(H) are unavailable [Error {code}]",
            "fr": "Les prélèvements de A2A(H) ne sont pas disponibles [Error {code}]",
            "it": "I prelievi di A2A(H) non sono disponibili [Error {code}]",
            "ja": "A2A(H)の出金はできません。[エラー {code}]",
            "ko": "A2A(H) 출금은 가능하지 않습니다 [Error {code}]",
            "ru": "Вывод A2A(H) заблокирован [Error {code}]",
            "tr": "A2A(H) çekme işlemleri kullanılamıyor [{code} hatası]",
            "uk": "Виведення A2A(H) заблоковано [Error {code}]",
            "zh": "无法提取A2A（H）[Error {code}]"
        },
        "37000": {
            "en": "Incorrect request [Error {code}]",
            "fr": "Demande incorrecte [Error {code}]",
            "it": "Richiesta errata [Error {code}]",
            "ja": "リクエストに誤りがあります。[エラー {code}]",
            "ko": "잘못된 요청 [Error {code}]",
            "ru": "Неправильный запрос [Error {code}]",
            "tr": "Hatalı talep [{code} hatası]",
            "uk": "Неправильний запит [Error {code}]",
            "zh": "不正确的请求[Error {code}]"
        },
        "37001": {
            "en": "Password must contain 6 or more symbols - upper case, lower case letters and numbers [Error {code}]",
            "fr": "Le mot de passe doit contenir 6 symboles ou plus - lettres majuscules, minuscules et chiffres  [Error {code}]",
            "it": "La password deve contenere 6 o più simboli: lettere maiuscole, lettere minuscole e numeri [Error {code}]",
            "ja": "パスワードは6桁以上にしてください。大文字、小文字、数字を使用する必要があります。[エラー {code}]",
            "ko": "암호는 6자 이상의 대문자, 소문자, 숫자를 포함해야 합니다 [Error {code}]",
            "ru": "Пароль должен содержать 6 или более символов - цифры, строчные и прописные буквы [Error {code}]",
            "tr": "Şifre 6 veya daha fazla sembol - büyük harf, küçük harf ve rakam içermelidir [{code} hatası]",
            "uk": "Пароль повинен містити 6 або більше символів - цифри, малі та великі літери [Error {code}]",
            "zh": "密码必须包含6个或更多符号-大写、小写字母和数字 [Error {code}]"
        },
        "37002": {
            "en": "POST query is needed [Error {code}]",
            "fr": "Une requête POST est nécessaire [Error {code}]",
            "it": "È necessaria una POST query [Error {code}]",
            "ja": "POSTクエリが必要です。[エラー {code}]",
            "ko": "POST 질의 요구됨 [Error {code}]",
            "ru": "Должен быть POST запрос [Error {code}]",
            "tr": "POST sorgusu gereklidir [{code} hatası]",
            "uk": "Повинен бути POST запит [Error {code}]",
            "zh": "需要后查询 [Error {code}]"
        },
        "37003": {
            "en": "Too many frequent queries - retry after 1 minute! [Error {code}]",
            "fr": "Trop de requêtes fréquentes - réessayez après 1 minute ! [Error {code}]",
            "it": "Troppe domande frequenti: riprovare dopo 1 minuto! [Error {code}]",
            "ja": "クエリが多すぎます。1分後にもう一度挑戦してください！[エラー {code}]",
            "ko": "너무 많은 빈번한 질의 - 1분 후에 다시 하세요! [Error {code}]",
            "ru": "Слишком много попыток войти с неправильными данными, пожалуйста, попробуйте еще раз через 1 минуту [Error {code}]",
            "tr": "Çok fazla sıklıkta sorgu - 1 dakika sonra tekrar deneyin! [{code} hatası]",
            "uk": "Занадто багато спроб увійти з неправильними даними, будь ласка, спробуйте ще раз через 1 хвилину [Error {code}]",
            "zh": "频繁查询过多-1分钟后重试！[Error {code}]"
        },
        "37004": {
            "en": "Empty email [Error {code}]",
            "fr": "E-mail vide [Error {code}]",
            "it": "Email vuota [Error {code}]",
            "ja": "メールアドレスが空欄になっています。[エラー {code}]",
            "ko": "이메일이 비어 있습니다 [Error {code}]",
            "ru": "Не указан email [Error {code}]",
            "tr": "Boş e-posta [{code} hatası]",
            "uk": "Не вказаний email [Error {code}]",
            "zh": "空电子邮件 [Error {code}]"
        },
        "37005": {
            "en": "Empty password [Error {code}]",
            "fr": "Mot de passe vide [Error {code}]",
            "it": "Password vuota [Error {code}]",
            "ja": "パスワードが空欄になっています。[エラー {code}]",
            "ko": "암호가 비어 있습니다 [Error {code}]",
            "ru": "Не указан пароль [Error {code}]",
            "tr": "Boş şifre [{code} hatası]",
            "uk": "Не вказаний пароль [Error {code}]",
            "zh": "空密码 [Error {code}]"
        },
        "37006": {
            "en": "Passwords do not match [Error {code}]",
            "fr": "Les mots de passe ne correspondent pas [Error {code}]",
            "it": "Le password non corrispondono [Error {code}]",
            "ja": "パスワードが一致しません。[エラー {code}]",
            "ko": "암호가 일치하지 않습니다 [Error {code}]",
            "ru": "Введенный пароль не совпадает в двух полях - вводите один и тот же [Error {code}]",
            "tr": "Şifreler eşleşmiyor [{code} hatası]",
            "uk": "Введений пароль не збігається в двох полях - вводьте один і той же [Error {code}]",
            "zh": "密码不匹配 [Error {code}]"
        },
        "37007": {
            "en": "Email is not valid [Error {code}]",
            "fr": "L'email n'est pas valide [Error {code}]",
            "it": "L'email non è valida [Error {code}]",
            "ja": "メールアドレスが有効ではありません。[エラー {code}]",
            "ko": "이메일이 올바르지 않습니다 [Error {code}]",
            "ru": "Некорректный email [Error {code}]",
            "tr": "E-posta geçerli değil [{code} hatası]",
            "uk": "Некоректний email [Error {code}]",
            "zh": "电子邮件无效[Error {code}]"
        },
        "37008": {
            "en": "User exists [Error {code}]",
            "fr": "L'utilisateur existe [Error {code}]",
            "it": "L'utente esiste già [Error {code}]",
            "ja": "ユーザーが既に存在します。[エラー {code}]",
            "ko": "사용자가 존재합니다 [Error {code}]",
            "ru": "Такой пользователь уже существует [Error {code}]",
            "tr": "Kullanıcı bulunuyor [{code} hatası]",
            "uk": "Такий користувач вже існує [Error {code}]",
            "zh": "用户存在[Error {code}]"
        },
        "37009": {
            "en": "Your account must be activated first using code that was sent to your email [Error {code}]",
            "fr": "Votre compte doit d'abord être activé à l'aide du code qui a été envoyé à votre adresse e-mail [Error {code}]",
            "it": "Il tuo account deve prima essere attivato utilizzando il codice che è stato inviato alla tua email [Error {code}]",
            "ja": "メールアドレスに送信されたコードを使用してアカウントの有効化を行ってください。[エラー {code}]",
            "ru": "Требуется активация аккаунта, код активации отправлен на ваш email. [Error {code}]",
            "tr": "Öncelikle hesabınızın e-postanıza gönderilen kod kullanılarak etkinleştirilmesi gereklidir [{code} hatası]",
            "uk": "Потрібна активація аккаунта, лист з кодом підтвердження відправлено на ваш email. [Error {code}]",
            "zh": "必须先使用发送到您电子邮件的代码激活您的帐户[Error {code}]"
        },
        "37010": {
            "en": "Too many frequent queries - retry after 2 minutes! [Error {code}]",
            "fr": "Trop de requêtes fréquentes - réessayez après 2 minutes! [Error {code}]",
            "it": "Troppe richieste frequenti: riprovare dopo 2 minuti! [Error {code}]",
            "ja": "クエリが多すぎます。2分後にもう一度挑戦してください！[エラー {code}]",
            "ko": "너무 많은 빈번한 질의 - 2분 후에 다시 하세요! [Error {code}]",
            "ru": "Слишком много попыток войти с неправильными данными, пожалуйста, попробуйте еще раз через 2 минуты [Error {code}]",
            "tr": "Çok fazla sıklıkta sorgu - 2 dakika sonra tekrar deneyin! [{code} hatası]",
            "uk": "Занадто багато спроб увійти з неправильними даними, будь ласка, спробуйте ще раз через 2 хвилини [Error {code}]",
            "zh": "频繁查询太多-2分钟后重试！[Error {code}]"
        },
        "37011": {
            "en": "Please try again in 30 minutes! [Error {code}]",
            "fr": "Veuillez réessayer dans 30 minutes! [Error {code}]",
            "it": "Riprova tra 30 minuti! [Error {code}]",
            "ja": "30分後にもう一度挑戦してください！[エラー {code}]",
            "ko": "30분 뒤에 다시 시도하세요! [Error {code}]",
            "ru": "Пожалуйста, попробуйте еще раз через 30 минут [Error {code}]",
            "tr": "Lütfen 30 dakika sonra tekrar deneyin! [{code} hatası]",
            "uk": "Будь ласка, спробуйте ще раз через 30 хвилин [Error {code}]",
            "zh": "请在30分钟后再试！ [Error {code}]"
        },
        "37012": {
            "en": "2FA OTP is required [Error {code}]",
            "fr": "2FA OTP est requis [Error {code}]",
            "it": "Il 2FA OTP è necessario [Error {code}]",
            "ja": "2FA OTPが必要です。[エラー {code}]",
            "ko": "OTP 인증 코드 필요 [Error {code}]",
            "ru": "Требуется код 2FA [Error {code}]",
            "tr": "2FA OTP gereklidir [{code} hatası]",
            "uk": "Потрібен код 2FA [Error {code}]",
            "zh": "需要2FA OTP[Error {code}]"
        },
        "37013": {
            "en": "Incorrect code! You should enter a 6-digit code from Google Authenticator app. Please note that this code is time based and you should synchronize your device's clock with internet time servers. [Error {code}]",
            "fr": "Code incorrect! Vous devez saisir un code à 6 chiffres depuis l'application Google Authenticator. Veuillez noter que ce code est basé sur l'heure et que vous devez synchroniser l'horloge de votre appareil avec les horaires des serveurs d'Internet. [Error {code}]",
            "it": "Codice non corretto! Devi inserire un codice di 6 cifre dall'app Google Authenticator. Si noti che questo codice è basato sul tempo e che è necessario sincronizzare l'orologio del dispositivo con gli orologi di Internet. [Error {code}]",
            "ja": "コードに誤りがあります。Google Authenticatorアプリの6桁のコードを入力してください。このコードは時間に基づいており、デバイスの時刻をインターネットタイムサーバーを使って同期する必要があります。[エラー {code}]",
            "ko": "잘못된 코드입니다! Google Authenticator 앱에서 6자리 코드를 입력해야 합니다. 이 코드는 시간에 따라 달라지므로 장치의 시계를 인터넷 시간 서버와 동기화해야 합니다. [Error {code}]",
            "ru": "Неправильный код 2FA. Вам нужно ввести 6ти значный код, который генерирует приложение Google Authenticator. Он действует 30 секунд, ваше устройство должно быть синхронизировано с серверами времени интернет и иметь правильный часовой пояс, иначе код будет неправильным. [Error {code}]",
            "tr": "Hatalı kod! Google Kimlik Denetleyicisi uygulamasından 6 haneli bir kod girmelisiniz. Bu kodun zamana dayalı olduğunu ve cihazınızın saatini internet saati sunucularıyla senkronize etmeniz gerektiğini lütfen unutmayın. [{code} hatası]",
            "uk": "Неправильний код 2FA. Вам потрібно ввести 6=ти значний код, який генерує додаток Google Authenticator. Він діє 30 секунд, ваш пристрій має бути синхронізованим з серверами часу інтернет і мати правильний часовий пояс, інакше код буде неправильним. [Error {code}]",
            "zh": "代码不正确！你应该输入一个来自Google Authenticator应用程序的6位代码。请注意，此代码是基于时间的，您应该将设备的时钟与网络时间服务器同步。[Error {code}]"
        },
        "37014": {
            "en": "Error while checking 2FA code, please try later [Error {code}]",
            "fr": "Erreur lors de la vérification du code 2FA, veuillez réessayer plus tard [Error {code}]",
            "it": "Errore durante il controllo del codice 2FA, riprova più tardi [Error {code}]",
            "ja": "2FAコードの確認中にエラーが発生しました。後でもう一度挑戦してください。[エラー {code}]",
            "ko": "OTP 인증 코드를 확인하는 중 오류. 나중에 다시 시도하세요 [Error {code}]",
            "ru": "Произошла ошибка во время проверки кода 2FA, попробуйте еще раз позднее [Error {code}]",
            "tr": "2FA kodu kontrol edilirken hata oluştu, lütfen daha sonra tekrar deneyin [{code} hatası]",
            "uk": "Сталася помилка під час перевірки коду 2FA, спробуйте ще раз пізніше [Error {code}]",
            "zh": "检查2FA代码时出错，请稍后再试 [Error {code}]"
        },
        "37015": {
            "en": "Wrong 2FA OTP [Error {code}]",
            "fr": "OTP 2FA Incorrect [Error {code}]",
            "it": "OTP 2FA errato [Error {code}]",
            "ja": "2FA OTPに誤りがあります。[Error {code}]",
            "ko": "잘못된 OTP 인증 코드 [Error {code}]",
            "ru": "Неправильный однократный код 2FA, попробуйте еще раз. Обратите внимание, код действителен только 30 секунд![Error {code}]",
            "tr": "Hatalı 2FA OTP [{code} hatası]",
            "uk": "Неправильний одноразовий код 2FA, спробуйте ще раз. Зверніть увагу, код дійсний тільки 30 секунд! [Error {code}]",
            "zh": "错误的2FA OTP [Error {code}]"
        },
        "37016": {
            "en": "Old password is required [Error {code}]",
            "fr": "Ancien mot de passe est requis [Error {code}]",
            "it": "La vecchia password è necessaria [Error {code}]",
            "ja": "以前のパスワードを入力してください。[エラー {code}]",
            "ko": "이전 암호 필요 [Error {code}]",
            "ru": "Нужен старый пароль [Error {code}]",
            "tr": "Eski şifre gereklidir [{code} hatası]",
            "uk": "Потрібен старий пароль [Error {code}]",
            "zh": "需要旧密码[Error {code}]"
        },
        "37017": {
            "en": "Wrong login or password [Error {code}]",
            "fr": "Identifiant ou mot de passe incorrect [Error {code}]",
            "it": "Nome utente o password errati [Error {code}]",
            "ja": "ログイン情報またはパスワードに誤りがあります。[エラー {code}]",
            "ko": "아이디 또는 비밀번호를 잘못 입력하였습니다. [Error {code}]",
            "ru": "Неправильные логин или пароль [Error {code}]",
            "tr": "Hatalı giriş veya şifre [{code} hatası]",
            "uk": "Неправильні логін або пароль [Error {code}]",
            "zh": "登录名或密码错误[Error {code}]"
        },
        "37018": {
            "en": "Invalid old password [Error {code}]",
            "fr": "Ancien mot de passe invalide [Error {code}]",
            "it": "Vecchia password non valida [Error {code}]",
            "ja": "以前のパスワードに誤りがあります。[エラー {code}]",
            "ko": "올바르지 않은 이전 암호 [Error {code}]",
            "ru": "Неправильный старый пароль [Error {code}]",
            "tr": "Geçersiz eski şifre [{code} hatası]",
            "uk": "Неправильний старий пароль [Error {code}]",
            "zh": "旧密码无效[Error {code}]"
        },
        "37019": {
            "en": "Old and new passwords are the same [Error {code}]",
            "fr": "Les anciens et les nouveaux mots de passe sont identiques [Error {code}]",
            "it": "La password vecchia e quella nuova sono uguali [Error {code}]",
            "ja": "以前のパスワードと新しいパスワードが同じです。[エラー {code}]",
            "ko": "이전 암호와 새 암호가 같습니다 [Error {code}]",
            "ru": "Страрый и новый пароли совпадают [Error {code}]",
            "tr": "Eski ve yeni şifreler aynı [{code} hatası]",
            "uk": "Старий і новий паролі збігаються [Error {code}]",
            "zh": "新旧密码相同 [Error {code}]"
        },
        "37020": {
            "en": "2FA is enabled on this account - OTP is required [Error {code}]",
            "fr": "2FA est activé sur ce compte - OTP est requis [Error {code}]",
            "it": "2FA è abilitato su questo account - OTP è necessario [Error {code}]",
            "ja": "このアカウントでは2FAが有効になっています。OTPが必須です。[エラー {code}]",
            "ko": "OTP 인증 활성화됨 - 인증 코드 필요 [Error {code}]",
            "ru": "У вас активирована 2FA - нужно ввести код 2FA [Error {code}]",
            "tr": "2FA bu hesapta etkin - OTP gereklidir [{code} hatası]",
            "uk": "У вас активована 2FA - потрібно ввести код 2FA [Error {code}]",
            "zh": "此帐户已启用2FA-需要OTP [Error {code}]"
        },
        "37021": {
            "en": "2FA OTP is invalid, please try again [Error {code}]",
            "fr": "Le 2FA OTP n'est pas valide, veuillez réessayer [Error {code}]",
            "it": "2FA OTP non è valido, riprovare [Error {code}]",
            "ja": "2FA OTPが無効です。もう一度挑戦してください。[エラー {code}]",
            "ko": "OTP 인증 코드가 올바르지 않습니다. 나중에 다시 시도하세요 [Error {code}]",
            "ru": "Введенный неправильный код 2FA, попробуйте еще раз. Обратите внимание, код действителен только 30 секунд! [Error {code}]",
            "tr": "2FA OTP geçersiz, lütfen tekrar deneyin [{code} hatası]",
            "uk": "Введений неправильний код 2FA, спробуйте ще раз. Зверніть увагу, код дійсний тільки 30 секунд! [Error {code}]",
            "zh": "2FA OTP无效，请重试[Error {code}]"
        },
        "37022": {
            "en": "Your email address has not been confirmed yet. Please find an email with the activation code in your inbox. Check the SPAM folder if it is not there. [Error {code}]",
            "fr": "Votre adresse e-mail n'a pas encore été confirmée. Veuillez trouver un e-mail avec le code d'activation dans votre boîte de réception. Vérifiez le dossier SPAM s'il n'y figure pas. [Error {code}]",
            "it": "Il tuo indirizzo email non è stato ancora confermato. Trova un'email con il codice di attivazione nella tua casella di posta. Controllare la cartella SPAM se non è presente. [Error {code}]",
            "ja": "あなたのメールアドレスはまだ確認できていません。受信したメッセージにある有効化コードを確認してください。スパムフォルダに分類されている可能性もあります。[エラー {code}]",
            "ko": "이메일을 아직 확인하지 않으셨습니다. 활성 코드가 있는 이메일을 받은메일함에서 찾으십시오. 거기에 없으면 스팸 폴더를 확인하십시오. [Error {code}]",
            "ru": "Ваш почтовый адрес пока не подтвержден (письмо с кодом подтверждения у вас в почте) [Error {code}]",
            "tr": "E-posta adresiniz henüz onaylanmadı. Lütfen gelen kutunuzda etkinleştirme kodunu içeren e-postayı bulunuz. Orada değilse, SPAM klasörünü kontrol edin. [{code} hatası]",
            "uk": "Ваша поштова адреса поки не підтверджена (лист з кодом підтвердження у вас в пошті) [Error {code}]",
            "zh": "您的电子邮件地址尚未确认。请在收件箱中找到带有激活码的电子邮件。如果垃圾邮件文件夹不存在，请检查它。[Error {code}]"
        },
        "37024": {
            "en": "The code from the email is needed to reset the password [Error {code}]",
            "fr": "Le code envoyé sur votre courriel est nécessaire pour réinitialiser le mot de passe [Error {code}]",
            "it": "Il codice inviato al vostro indirizzo email è necessario per reimpostare la password [Error {code}]",
            "ja": "パスワードをリセットするにはメールに記載されているコードが必要です。[エラー {code}]",
            "ko": "암호를 재설정하려면 이메일의 코드가 필요합니다 [Error {code}]",
            "ru": "Для смены пароля нужен код который был вам выслан по email [Error {code}]",
            "tr": "Şifreyi sıfırlamak için e-postadaki kod gereklidir [{code} hatası]",
            "uk": "Для зміни пароля потрібен код, який був вам висланий на email [Error {code}]",
            "zh": "重置密码需要电子邮件中的代码[Error {code}]"
        },
        "37025": {
            "en": "Please initiate password reset [Error {code}]",
            "fr": "Veuillez lancer la réinitialisation du mot de passe [Error {code}]",
            "it": "Si prega di avviare la reimpostazione della password [Error {code}]",
            "ja": "パスワードのリセットを実行してください。[エラー {code}]",
            "ko": "암호 재설정을 시작하십시오 [Error {code}]",
            "ru": "Пожалуйста, выполните процедуру смены пароля [Error {code}]",
            "tr": "Lütfen şifre sıfırlamayı başlatın [{code} hatası]",
            "uk": "Будь ласка, виконайте процедуру зміни пароля [Error {code}]",
            "zh": "请启动密码重置 [Error {code}]"
        },
        "37026": {
            "en": "Password reset code is wrong [Error {code}]",
            "fr": "Le code de réinitialisation du mot de passe est incorrect [Error {code}]",
            "it": "Il codice di reimpostazione della password è errato [Error {code}]",
            "ja": "パスワードのリセットコードが違います。[エラー {code}]",
            "ko": "암호 재설정 코드가 틀립니다 [Error {code}]",
            "ru": "Неправильный код сброса пароля [Error {code}]",
            "tr": "Şifre sıfırlama kodu hatalıdır [{code} hatası]",
            "uk": "Неправильний код скидання пароля [Error {code}]",
            "zh": "密码重置码错误[Error {code}]"
        },
        "37027": {
            "en": "Empty new password [Error {code}]",
            "fr": "Nouveau mot de passe est vide [Error {code}]",
            "it": "Svuota nuova password [Error {code}]",
            "ja": "新しいパスワードが空欄になっています。[エラー {code}]",
            "ko": "새 암호가 비어 있습니다 [Error {code}]",
            "ru": "Не указан новый пароль [Error {code}]",
            "tr": "Boş yeni şifre [{code} hatası]",
            "uk": "Не вказаний новий пароль [Error {code}]",
            "zh": "清空新密码 [Error {code}]"
        },
        "37029": {
            "en": "New email address is needed [Error {code}]",
            "fr": "Une nouvelle adresse e-mail est nécessaire [Error {code}]",
            "it": "È necessario un nuovo indirizzo e-mail [Error {code}]",
            "ja": "新しいメールアドレスが必要です。[エラー {code}]",
            "ko": "새 이메일 필요 [Error {code}]",
            "ru": "Требуется указать новый email [Error {code}]",
            "tr": "Yeni e-posta adresi gereklidir [{code} hatası]",
            "uk": "Потрібно вказати новий email [Error {code}]",
            "zh": "需要新的电子邮件地址[Error {code}]"
        },
        "37030": {
            "en": "Old and new emails are the same [Error {code}]",
            "fr": "L'ancien et le nouveau e-mail sont les mêmes [Error {code}]",
            "it": "La email vecchia e quella nuova sono uguali [Error {code}]",
            "ja": "以前のメールアドレスと新しいメールアドレスが一緒です。[エラー {code}]",
            "ko": "이전 이메일과 새 이메일이 같습니다 [Error {code}]",
            "ru": "Старый и новый e-mail совпадают [Error {code}]",
            "tr": "Eski ve yeni e-postalar aynı [{code} hatası]",
            "uk": "Старий і новий e-mail збігаються [Error {code}]",
            "zh": "新邮件和旧邮件是一样的 [Error {code}]"
        },
        "37031": {
            "en": "Email is not valid [Error {code}]",
            "fr": "L'email n'est pas valide [Error {code}]",
            "it": "L'email non è valida [Error {code}]",
            "ja": "メールアドレスが有効ではありません。[エラー {code}]",
            "ko": "이메일이 올바르지 않습니다 [Error {code}]",
            "ru": "Неправильный e-mail [Error {code}]",
            "tr": "E-posta geçerli değil [{code} hatası]",
            "uk": "Неправильний e-mail [Error {code}]",
            "zh": "电子邮件无效 [Error {code}]"
        },
        "37032": {
            "en": "User with this email already exists [Error {code}]",
            "fr": "Un utilisateur avec ce courriel existe déjà [Error {code}]",
            "it": "Esiste già un utente con questa email [Error {code}]",
            "ja": "このメールアドレスを使用するユーザーは既に存在します。[エラー {code}]",
            "ko": "이 이메일을 가진 사용자가 이미 존재합니다 [Error {code}]",
            "ru": "Уже есть пользователь с таким e-mail [Error {code}]",
            "tr": "Bu e-postaya sahip kullanıcı zaten bulunuyor [{code} hatası]",
            "uk": "Уже є користувач з таким e-mail [Error {code}]",
            "zh": "使用此电子邮件的用户已经存在[Error {code}]"
        },
        "37033": {
            "en": "Your account is suspended, please contact our support via email {domain.email} [Error {code}]",
            "fr": "Votre compte est suspendu, veuillez contacter notre support par e-mail {domain.email} [Error {code}]",
            "it": "Il tuo account è sospeso, ti preghiamo di contattare il nostro supporto via email {domain.email} [Error {code}]",
            "ja": "あなたのアカウントは停止されています。サポートまでメール{domain.email}にてお問い合わせください。[エラー {code}]",
            "ko": "계정이 보류 중입니다. {domain.email}에 이메일을 보내서 문의하십시오 [Error {code}]",
            "ru": "Ваш аккаунт временно заблокирован, свяжитесь с нами по email {domain.email} [Error {code}]",
            "tr": "Hesabınız askıya alındı, lütfen e-posta adresinden  {domain.email} destek ekibimizle iletişime geçin [{code} hatası]",
            "uk": "Ваш аккаунт тимчасово заблокований, зв'яжіться з нами по email {domain.email} [Error {code}]",
            "zh": "您的帐户已暂停使用，请通过电子邮件{domain.email}与我们的支持部门联系 [Error {code}]"
        },
        "37034": {
            "en": "Too many frequent queries - please retry later! [Error {code}]",
            "fr": "Trop de requêtes fréquentes - veuillez réessayer plus tard! [Error {code}]",
            "it": "Troppe richieste frequenti: riprovare più tardi! [Error {code}]",
            "ja": "クエリが多すぎます。後でもう一度挑戦してください！[エラー {code}]",
            "ko": "너무 많은 빈번한 질의 - 나중에 다시 하세요! [Error {code}]",
            "ru": "Слишком много попыток войти с неправильными данными, пожалуйста, попробуйте через некоторое время [Error {code}]",
            "tr": "Çok fazla sıklıkta sorgu - lütfen daha sonra tekrar deneyin! [{code} hatası]",
            "uk": "Занадто багато спроб увійти з неправильними даними, будь ласка, спробуйте через деякий час [Error {code}]",
            "zh": "频繁查询过多-请稍后重试！[Error {code}]"
        },
        "37035": {
            "en": "Your {0} balance is suspended, please email to {domain.email}",
            "fr": "Votre solde de {0} est suspendu, veuillez envoyer un e-mail à {domain.email}",
            "it": "l tuo saldo {0} è sospeso, invia un'email a {domain.email}",
            "ja": "あなたの{0}が凍結されました。{domain.email}までメールをお送りください。",
            "ko": "{0} 자산이 보류 중입니다. {domain.email}에 이메일을 보내서 문의하십시오",
            "ru": "Ваш баланс {0} временно заблокирован, свяжитесь с нами по email {domain.email}",
            "tr": "{0} bakiyeniz askıya alındı, lütfen {domain.email} adresine e-posta gönderin",
            "uk": "Ваш баланс {0} тимчасово заблокований, зв'яжіться з нами по email {domain.email}",
            "zh": "您的{0}余额已暂停，请发送电子邮件至{domain.email}"
        },
        "37036": {
            "en": "Cannot reserve new {0} address for {0} deposit, please try later. [Error {code}]",
            "fr": "Impossible de réserver une nouvelle adresse{0} pour le dépôt de {0}, veuillez réessayer plus tard. [Error {code}]",
            "it": "Impossibile prenotare il nuovo indirizzo {0} per il deposito {0}, riprova più tardi [Error {code}]",
            "ja": "新しい{0}アドレスを{0}の入金で予約することはできません。後でもう一度挑戦してください。[エラー {code}]",
            "ko": "{0} 입금을 위해 새 {0} 주소를 예약할 수 없습니다. 나중에 시도하십시오. [Error {code}]",
            "ru": "Системе не удалось зарезервировать адрес {0} для пополнения, пожалуйста, попробуйте позже. Админы получили уведомление, но исправление займет некоторое время. [Error {code}]",
            "tr": "{0} para yatırma için yeni {0} adresi ayıramaz, lütfen daha sonra tekrar deneyin. [{code} hatası]",
            "uk": "Системі не вдалося зарезервувати адресу {0} для поповнення {0}, будь ласка, спробуйте пізніше. Адміни отримали повідомлення, але виправлення займе якийсь час. [Error {code}]",
            "zh": "无法为{0}存款保留新的{0}地址，请稍后再试。[Error {code}]"
        },
        "37037": {
            "en": "Please wait 1 minute before your next withdrawal! [Error {code}]",
            "fr": "Veuillez patienter 1 minute avant votre prochain prélèvement! [Error {code}]",
            "it": "Ti preghiamo di attendere 1 minuto prima di proseguire con il prossimo prelievo! [Error {code}]",
            "ja": "次の出金まで、1分間お待ちください！[エラー {code}]",
            "ko": "다음 출금을 위해 1분만 기다리십시오! [Error {code}]",
            "ru": "Пожалуйста, подождите 1 минуту прежде чем отправлять следующую заявку на вывод! [Error {code}]",
            "tr": "Lütfen bir sonraki para çekme işleminizden önce 1 dakika bekleyin! [{code} hatası]",
            "uk": "Будь ласка, зачекайте 1 хвилину перш ніж відправляти наступну заявку на виведення! [Error {code}]",
            "zh": "请在下次取款前等一分钟！ [Error {code}]"
        },
        "37038": {
            "en": "Error code 1 while signing withdrawal [Error {code}]",
            "fr": "Code d'erreur 1 lors de la signature du prélèvement [Error {code}]",
            "it": "Codice errore 1 durante la firma del prelevamento [Error {code}]",
            "ja": "出金の署名中にエラーコード1のエラーが発生しました。[エラー {code}]",
            "ko": "출금 서명 중 오류 코드 1 [Error {code}]",
            "ru": "Ошибка (код 1) при отправке исходящей транзакции [Error {code}]",
            "tr": "Para çekme işlemi imzalanırken hata kodu 1 oluştu [{code} hatası]",
            "uk": "Помилка (код 1) при відправці вихідної транзакції [Error {code}]",
            "zh": "签署撤回时的错误代码1 [Error {code}]"
        },
        "37039": {
            "en": "Error code 2 while signing withdrawal [Error {code}]",
            "fr": "Code d'erreur 2 lors de la signature du prélèvement [Error {code}]",
            "it": "Codice errore 2 durante la firma del prelevamento [Error {code}]",
            "ja": "出金の署名中にエラーコード2のエラーが発生しました。[エラー {code}]",
            "ko": "출금 서명 중 오류 코드 2 [Error {code}]",
            "ru": "Ошибка (код 2) при отправке исходящей транзакции [Error {code}]",
            "tr": "Para çekme işlemi imzalanırken hata kodu 2 oluştu [{code} hatası]",
            "uk": "Помилка (код 2) при відправці вихідної транзакції [Error {code}]",
            "zh": "签署撤回时出现错误代码2 [Error {code}]"
        },
        "37040": {
            "en": "Wrong 2FA OTP was entered 3 times in a row for this account. You need to enter 3 different OTP generated one by one to log in.[Error {code}]",
            "fr": "Un OTP 2FA incorrect a été saisi 3 fois de suite pour ce compte. Vous devez saisir 3 OTP différents générés un par un pour vous connecter. [Error {code}]",
            "it": "Un OTP 2FA errato è stato inserito 3 volte di seguito per questo account. Per accedere devi inserire 3 diversi OTP generati uno per uno. [Error {code}]",
            "ja": "誤った2FA OTPがこのアカウントで3回連続入力されました。ログインするには、生成される3つのOTPを1つずつ入力する必要があります。[エラー {code}]",
            "ru": "Неверный OTP (однократный пароль) 2FA был введен 3 раза подряд на этом аккаунте. Вам нужно ввести 3 разных OTP последовательно сгенеренных Гугл Аутентификатором.[Error {code}]",
            "tr": "Bu hesap için arka arkaya 3 kez yanlış 2FA OTP girildi. Giriş yapmak için tek tek oluşturulmuş 3 farklı OTP girmeniz gerekmektedir. [{code} hatası]",
            "uk": "Невірний OTP (одноразовий пароль) 2FA був введений 3 рази поспіль на цьому акаунті. Вам потрібно ввести 3 різних OTP послідовно сгенерованих додатком Google Authenticator. [Error {code}]",
            "zh": "此帐户连续输入了3次错误的2FA OTP。您需要输入3个不同的OTP生成一个一个登录。[Error {code}]"
        },
        "37041": {
            "en": "One or more out of 3 OTP is wrong. Please try again.[Error {code}]",
            "fr": "Un ou plusieurs OTP sur 3 sont incorrects. Veuillez réessayer. [Error {code}]",
            "it": "Uno o più OTP su 3 sono errati. Per favore riprova.[Error {code}]",
            "ja": "3つのOTPの一部または全てに誤りがあります。もう一度挑戦してください。[エラー {code}]",
            "ru": "Один или более кодов OTP 2FA был введен неверно. Попробуйте еще раз. Вам нужно ввести 3 разных OTP последовательно сгенеренных Гугл Аутентификатором.[Error {code}]",
            "tr": "3 OTP'den biri veya daha fazlası hatalıdır. Lütfen tekrar deneyiniz. [{code} hatası]",
            "uk": "Один або більше кодів OTP 2FA був введений невірно. Спробуйте ще раз. Вам потрібно ввести 3 різних OTP послідовно сгенерованих додатком Google Authenticator. [Error {code}]",
            "zh": "三个OTP中有一个或多个是错误的。请再试一次。[Error {code}]"
        },
        "37057": {
            "en": "2FA OTP or 2FA private key are required [Error {code}]",
            "fr": "Un 2FA OTP ou une clé privée 2FA est requise [Error {code}]",
            "it": "Sono richiesti 2FA OTP o 2FA chiave privata [Error {code}]",
            "ja": "2FA OTPまたは2FAプライベートキーが必要です。[エラー {code}]",
            "ko": "OTP 인증 코드 또는 OTP 인증 키 필요 [Error {code}]",
            "ru": "Требуется однократный код 2FA или 2FA приватный ключ [Error {code}]",
            "tr": "2FA OTP veya 2FA özel anahtarı gereklidir [{code} hatası]",
            "uk": "Потрібен одноразовий код 2FA або 2FA приватний ключ [Error {code}]",
            "zh": "需要2FA OTP或2FA私钥 [Error {code}]"
        },
        "37061": {
            "en": "This OTP has already been used, please wait for a new OTP to be generated and try again.",
            "fr": "Cet OTP a déjà été utilisé, veuillez attendre qu'un nouvel OTP soit généré et réessayer.",
            "it": "Questo OTP è già stato utilizzato, attendere che venga generato un nuovo OTP e riprovare.",
            "ja": "このOTPは既に使用されています。新しいOTPが生成されるのを待ってから、もう一度挑戦してください。",
            "ko": "입력하신 2fa 코드는 이미 사용된 것입니다. 새로운 코드가 생성될때 까지 기다려주시고 다시 생성된 코드를 입력해 주세요. [Error {code}]",
            "ru": "Этот код 2fa уже был использован, пожалуйста дождитесь генерации нового OTP кода в приложениии попробуйте опять с новым кодом. [Error {code}]",
            "tr": "Bu OTP zaten kullanılmıştır, lütfen yeni bir OTP'nin oluşturulmasını bekleyin ve tekrar deneyin.",
            "uk": "Цей код 2FA вже був використаний, будь ласка дочекайтеся генерації нового OTP коду в додатку та спробуйте знову з новим кодом.",
            "zh": "此OTP已被使用，请等待生成新的OTP并重试。"
        },
        "37062": {
            "en": "Internal System Error: Your current 2FA SEED has not been activated yet.[Error {code}]",
            "fr": "Erreur Interne du Système: Votre SEED 2FA actuel n'a pas encore été activé. [Error {code}]",
            "it": "Errore di sistema interno: l'attuale SEED 2FA non è stato ancora attivato. [Error {code}]",
            "ja": "内部システムエラー：あなたのアカウントの2FA SEEDはまだ有効化されていません。[エラー {code}]",
            "ru": "Внутреннаяя Ошибка Системы: 2FA SEED не активировался [Error {code}]",
            "tr": "Dahili Sistem Hatası: Mevcut 2FA SEED'iniz henüz etkinleştirilmedi. [{code} hatası]",
            "uk": "Внутрішня Помилка Системи: 2FA SEED не активувався [Error {code}]",
            "zh": "内部系统错误：您当前的2FA种子尚未激活。[Error {code}]"
        },
        "37072": {
            "en": "Email confirmation code required [Error {code}]",
            "fr": "Code de confirmation par e-mail requis [Error {code}]",
            "it": "Codice di conferma email necessario [Error {code}]",
            "ja": "メールの確認コードが必要です。[エラー {code}]",
            "ko": "이메일 확인 코드 필요 [Error {code}]",
            "ru": "Требуется подтвердить email введя код подтверждения из отправленного вам письма. [Error {code}]",
            "tr": "E-posta onay kodu gereklidir [{code} hatası]",
            "uk": "Потрібно підтвердити email ввівши код підтвердження з відправленого вам листа. [Error {code}]",
            "zh": "需要电子邮件确认代码[Error {code}]"
        },
        "37073": {
            "en": "Incorrect email confirmation code [Error {code}]",
            "fr": "Code de confirmation e-mail incorrect [Error {code}]",
            "it": "Codice di conferma e-mail errato [Error {code}]",
            "ja": "メールの確認コードに誤りがあります。[エラー {code}]",
            "ko": "잘못된 이메일 확인 코드 [Error {code}]",
            "ru": "Неверный код подтверждения email [Error {code}]",
            "tr": "Hatalı e-posta onay kodu [{code} hatası]",
            "uk": "Невірний код підтвердження email [Error {code}]",
            "zh": "电子邮件确认码不正确[Error {code}]"
        },
        "37075": {
            "en": "To reset 2FA without login, you need to enter 2FA SEED key that you are supposed to store offline in a safe place. [Error {code}]",
            "fr": "Pour réinitialiser le 2FA sans vous connecter, vous devez saisir la clé 2FA SEED que vous êtes censé stocker hors ligne dans un endroit sûr. [Error {code}]",
            "it": "Per ripristinare il 2FA senza effettuare il login, è necessario immettere la chiave SEED 2FA che si suppone si debba archiviare offline in un luogo sicuro.  [Error {code}]",
            "ja": "2FAをログインせずにリセットするには、オフラインの安全な場所に保管している2FA SEEDキーを入力する必要があります。[エラー {code}]",
            "ru": "Для отключения 2FA без авторизации в системе нужно ввести ПРИВАТНЫЙ КЛЮЧ (2FA SEED key) который вы должны были записать на бумаге (при активации 2FA) и хранить в безопасном месте. [Error {code}]",
            "tr": "Giriş yapmadan 2FA'yı sıfırlamak için, çevrimdışı olarak güvenli bir yerde saklamanız gereken 2FA SEED anahtarını girmeniz gerekir. [{code} hatası]",
            "uk": "Для відключення 2FA без авторизації в системі потрібно ввести ПРИВАТНИЙ КЛЮЧ (2FA SEED key) який ви повинні були записати на папері (при активації 2FA) і зберігати в безпечному місці. [Error {code}]",
            "zh": "要在不登录的情况下重置2FA，您需要输入2FA种子密钥，该密钥应该脱机存储在安全的地方。 [Error {code}]"
        },
        "37076": {
            "en": "Unknown symbol of the asset: {0} [Error {code}]",
            "fr": "Symbole inconnu de l'actif: {0} [Error {code}]",
            "it": "Simbolo sconosciuto dell'asset: {0}  [Error {code}]",
            "ja": "アセットのシンボルが認識できません：{0} [エラー {code}]",
            "ru": "Неправильный тикер актива {0} [Error {code}]",
            "tr": "Varlığın bilinmeyen sembolü: {0} [{code} hatası]",
            "uk": "Неправильний тікер активу {0} [Error {code}]",
            "zh": "资产的未知符号：{0} [Error {code}]"
        },
        "37077": {
            "en": "Deposit of {0} is unavailable. [Error {code}]",
            "fr": "Dépôt de {0} n'est pas disponible. [Error {code}]",
            "it": "Il deposito di {0} non è disponibile. [Error {code}]",
            "ja": "{0}の入金は利用できません。[エラー {code}]",
            "ru": "Пополнение {0} в настоящий момент недоступно. [Error {code}]",
            "tr": "{0} yatırma işlemi kullanılamıyor. [{code} hatası]",
            "uk": "Поповнення {0} наразі недоступне. [Error {code}]",
            "zh": "{0}的存款不可用。[Error {code}]"
        },
        "37078": {
            "en": "Withdrawal of {0} is unavailable. [Error {code}]",
            "fr": "Le prélèvement de {0} n'est pas disponible. [Error {code}]",
            "it": "Il prelevamento di {0} non è disponibile. [Error {code}]",
            "ja": "{0}の出金は利用できません。[エラー {code}]",
            "ru": "Вывод {0} в настоящий момент недоступен. [Error {code}]",
            "tr": "{0} çekme işlemi kullanılamıyor. [{code} hatası]",
            "uk": "Виведення {0} в даний момент недоступне. [Error {code}]",
            "zh": "无法撤消{0}。[Error {code}]"
        },
        "37079": {
            "en": "You have reached the limit of {0} depositing addresses and cannot generate more. [Error {code}]",
            "fr": "Vous avez atteint la limite d'adresses de dépôt de {0} et vous ne pouvez plus en générer. [Error {code}]",
            "it": "Hai raggiunto il limite di deposito degli indirizzi per {0} e non puoi generarne altri.  [Error {code}]",
            "ja": "{0}の入金アドレス制限に到達しました。これ以上生成することはできません。[エラー {code}]",
            "ru": "Вы исчерпали лимит адресов пополнения {0}. Вы не можете сгенерировать больше {0} адресов. [Error {code}]",
            "tr": "{0} yatırma adresleri sınırına ulaştınız ve daha fazlasını oluşturamazsınız. [{code} hatası]",
            "uk": "Ви вичерпали ліміт адрес поповнення і не можете згенерувати більше {0} адрес. [Error {code}]",
            "zh": "您已达到{0}存放地址的限制，无法生成更多地址。 [Error {code}]"
        },
        "37080": {
            "en": "You do not have {0} depositing addresses on the account {1}. [Error {code}]",
            "ru": "У вас нет адреса пополнения {0} на аккаунте {1}. [Error {code}]"
        },
        "37090": {
            "en": "[tokens.{0}.title] ({0}) cannot be deposited using fiat gateway. [Error {code}]",
            "ru": "[tokens.{0}.title] ({0}) недоступен для пополнения через фиатный шлюз. [Error {code}]"
        },
        "37091": {
            "en": "Fiat gateway deposits should be more than {0} {2} and less than {1} {2}. [Error {code}]",
            "ru": "Пополнения через фиатный шлюз возможны на сумму от {0} {2} до {1} {2}. [Error {code}]"
        },
        "400": {
            "en": "Bad Request [Error {code}]",
            "fr": "Mauvaise Requête [Error {code}]",
            "it": "Richiesta non valida [Error {code}]",
            "ja": "不正なリクエスト [エラー {code}]",
            "ru": "Некорректный запрос [Error {code}]",
            "tr": "Geçersiz istek [{code} hatası]",
            "uk": "Некоректний запит [Error {code}]",
            "zh": "错误请求[错误{code}]"
        },
        "401": {
            "en": "Unauthorized. Log in to use this feature [Error {code}]",
            "fr": "Non autorisé. Connectez-vous pour utiliser cette fonctionnalité [Error {code}]",
            "it": "Non autorizzato. Fai il login per utilizzare questa funzione [Error {code}]",
            "ja": "認証されていません。この機能を使うにはログインしてください [エラー{code}]",
            "ru": "Вы не авторизованы. Войдите в систему для использования этой функции [Error {code}]",
            "tr": "Onaylanmadı. Bu özelliği kullanmak için giriş yapın [{code} hatası]",
            "uk": "Ви не авторизовані. Увійдіть в систему для використання цієї функції [Error {code}]",
            "zh": "未经授权。登录以使用此功能[错误{code}]"
        },
        "403": {
            "en": "Forbidden [Error {code}]",
            "fr": "Interdit [Error {code}]",
            "it": "Vietato [Error {code}]",
            "ja": "この操作は禁止されています [エラー{code}]",
            "ru": "Доступ запрещен [Error {code}]",
            "tr": "Yasaklanmış [{code} hatası]",
            "uk": "Доступ заборонено [Error {code}]",
            "zh": "禁止[错误{code}]"
        },
        "404": {
            "en": "Not Found [Error {code}]",
            "fr": "Introuvable [Error {code}]",
            "it": "Non Trovato [Error {code}]",
            "ja": "見つかりませんでした [エラー{code}]",
            "ru": "Не найдено [Error {code}]",
            "tr": "Bulunamadı [{code} hatası]",
            "uk": "Не знайдено [Error {code}]",
            "zh": "找不到[错误{code}]"
        },
        "405": {
            "en": "Method Not Allowed [Error {code}]",
            "fr": "Méthode Non Autorisée [Error {code}]",
            "it": "Operazione Non Permessa [Error {code}]",
            "ja": "この方法は許可されていません [エラー{code}]",
            "ru": "Неправильный метод вызова [Error {code}]",
            "tr": "İzin Verilmeyen Metod [{code} hatası]",
            "uk": "Неправильний метод виклику [Error {code}]",
            "zh": "不允许的方法[错误{code}]"
        },
        "43002": {
            "en": "Order {0} change error: Volume cannot be changed in SLTP orders. [Error {code}]",
            "fr": "Erreur de modification de la commande {0}: le volume ne peut pas être modifié dans les commandes SLTP. [Error {code}]",
            "it": "Errore di modifica ordine {0}: il volume non può essere modificato negli ordini SLTP. [Error {code}]",
            "ja": "注文{0}の変更エラーが発生しました。SLTP注文のボリュームが変更できません。[エラー {code}]",
            "ru": "Изменения ордера {0} отклонены: Объем не может быть изменен в SLTP ордерах. [Error {code}]",
            "tr": "{0} komutu değişikliği hatası: SLTP komutunda işlem hacmi değiştirilemez. [{code} hatası]",
            "uk": "Зміни ордера {0} відхилені: Обсяг не може бути змінений в SLTP ордерах. [Error {code}]",
            "zh": "订单{0}更改错误：无法在SLTP订单中更改容量。[Error {code}]"
        },
        "43003": {
            "en": "Order {0} changes rejected. Cannot change volume or rate in orders with state {1} [Error {code}]",
            "fr": "Les modifications de la commande {0} ont été rejetées. Impossible de modifier le volume ou le taux dans les commandes avec l'état {1} [Error {code}]",
            "it": "Modifiche per l'ordine {0} rifiutate. Impossibile modificare il volume o la tariffa negli ordini con stato {1} [Error {code}]",
            "ja": "注文{0}の変更が拒否されました。{1}の状態にある注文のボリュームやレートを変更できません。[エラー {code}]",
            "ru": "Изменения ордера {0} отклонены: Объем или цена не могут быть изменены в ордерах со статусом {1} [Error {code}]",
            "tr": "{0} komutu değişiklikleri reddedildi. {1} durumlu olan komutlarda işlem hacmi veya oran değiştirilemez [{code} hatası]",
            "uk": "Зміни ордера {0} відхилені: Обсяг або ціна не можуть бути змінені в ордерах зі статусом {1} [Error {code}]",
            "zh": "订单{0}更改被拒绝。无法更改状态为{1}的订单中的容量或速率 [Error {code}]"
        },
        "43004": {
            "en": "You cannot change filled or cancelled orders, only SLTP can be added [Error {code}]",
            "fr": "Vous ne pouvez pas modifier les commandes réalisées ou annulées, seul SLTP peuvent être ajoutés [Error {code}]",
            "it": "Non è possibile modificare gli ordini effettuati o annullati, è possibile aggiungere solo SLTP [Error {code}]",
            "ja": "確定した、または、キャンセルされた注文を変更することはできません。SLTPの追加のみが行えます。[エラー {code}]",
            "ru": "Нельзя менять исполненные или закрытые ордера, доступна только установка SLTP для них [Error {code}]",
            "tr": "Gerçekleştirilmiş veya iptal edilmiş komutları değiştiremezsiniz, yalnızca SLTP eklenebilir [{code} hatası]",
            "uk": "Не можна міняти виконані або закриті ордера, для них доступна тільки установка SLTP [Error {code}]",
            "zh": "您不能更改已填写或取消的订单，只能添加SLTP [Error {code}]"
        },
        "43005": {
            "en": "Cannot remove SLTP for order {0} [Error {code}]",
            "fr": "Impossible de supprimer SLTP pour la commande {0} [Error {code}]",
            "it": "Impossibile rimuovere SLTP per l'ordine {0}  [Error {code}]",
            "ja": "注文{0}のSLTPを削除することはできません。[エラー {code}]",
            "ru": "Не удалось удалить SLTP для ордера {0} [Error {code}]",
            "tr": "{0} komutu için SLTP kaldırılamıyor [{code} hatası]",
            "uk": "Не вдалося видалити SLTP для ордера {0} [Error {code}]",
            "zh": "无法删除订单{0}的SLTP [Error {code}]"
        },
        "43006": {
            "en": "Cannot set SLTP for the order {0} because it is an SLTP itself. [Error {code}]"
        },
        "500": {
            "en": "Internal Server Error [Error {code}]",
            "fr": "Erreur Interne du Serveur [Error {code}]",
            "it": "Errore Interno del Server [Error {code}]",
            "ja": "内部サーバーエラー [エラー{code}]",
            "ru": "Внутренняя ошибка сервера [Error {code}]",
            "tr": "Dahili Sunucu Hatası [{code} hatası]",
            "uk": "Внутрішня помилка сервера [Error {code}]",
            "zh": "内部服务器错误[Error{code}]"
        },
        "503": {
            "en": "Service Unavailable. Please, try again later [Error {code}]",
            "fr": "Service indisponible. Veuillez réessayer plus tard [Error {code}]",
            "it": "Servizio non disponibile. Per favore riprova più tardi [Error {code}]",
            "ja": "サービスが利用できません。あとでもう一度お試しください [エラー{code}]",
            "ru": "Сервис временно недоступен. Попробуйте перезвонить позднее. [Error {code}]",
            "tr": "Hizmet kullanılamıyor. Lütfen daha sonra tekrar deneyin [{code} hatası]",
            "uk": "Сервіс тимчасово недоступний. Будь-ласка, спробуйте пізніше. [Error {code}]",
            "zh": "服务不可用。请稍后再试[Error{code}]"
        },
        "70105": {
            "en": "This Master Key has been already used. [Error {code}]",
            "ru": "Этот Мастер-ключ уже был использован. [Error {code}]"
        },
        "90000": {
            "en": "Wrong PMA ID. No PMA was found with ID {0} [Error {code}]",
            "fr": "ID du PMA incorrect. Aucun PMA n'a été trouvé avec cet ID {0} [Error {code}]",
            "it": "ID PMA errato. Nessun PMA trovato con l'identificazione {0} [Error {code}]",
            "ja": "PMA IDに誤りがあります。IDが{0}のPMAが見つかりませんでした。[エラー {code}]",
            "ru": "Несуществующий PMA ID. Не найдено PMA с ID {0} [Error {code}]",
            "tr": "Hatalı PMA Kimliği. {0} kimliğine sahip PMA bulunamadı [{code} hatası]",
            "uk": "Неіснуючий PMA ID. Не знайдено PMA з ID {0} [Error {code}]",
            "zh": "错误的PMA ID。找不到ID为{0}的PMA[Error {code}]"
        },
        "90001": {
            "en": "Requested data is not available for PMA {0} yet. PMA should have longer trading history before metrics can be calculated. [Error {code}]",
            "fr": "Les données demandées ne sont pas encore disponibles pour le PMA {0}. Le PMA devrait avoir un historique de trading plus long avant de pouvoir en calculer les mesures. [Error {code}]",
            "it": "I dati richiesti non sono ancora disponibili per PMA {0}. Il PMA dovrebbe avere una cronologia di trading più lunga prima di poter calcolarne le metriche. [Error {code}]",
            "ja": "PMA{0}についてリクエストされたデータはまだ利用できません。データの計算を行うにはPMAにもある程度の取引履歴が必要です。[Error {code}]",
            "ru": "Запрошенные данные пока еще недоступны для PMA {0}. PMA должен иметь более длинную историю сделок для начала показа метрик. [Error {code}]",
            "tr": "Gerekli veriler henüz PMA {0} için mevcut değil. Metriklerin hesaplanabilmesi için PMA'nın daha uzun alım satım işlem geçmişe sahip olması gerekir. [{code} hatası]",
            "uk": "Запитані дані поки що недоступні для PMA {0}. PMA повинен мати довшу історію угод для початку показу метрик. [Error {code}]",
            "zh": "PMA{0}尚未获得请求的数据。在计算指标之前，PMA应该有更长的交易历史。 [Error {code}]"
        },
        "90003": {
            "en": "Rates server is not available now. Please try again later. [Error {code}]",
            "fr": "Le serveur des taux n'est pas disponible pour le moment. Veuillez réessayer plus tard. [Error {code}]",
            "it": "Il server delle tariffe non è al momento disponibile. Per favore riprova più tardi. [Error {code}]",
            "ja": "レートサーバーは現在利用できません。後でもう一度挑戦してください。[エラー {code}]",
            "ru": "Сервер котировок временно недоступен. Попробуйте позже. [Error {code}]",
            "tr": "Oranlar sunucusu şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyiniz. [{code} hatası]",
            "uk": "Сервер котирувань тимчасово недоступний. Спробуй пізніше. [Error {code}]",
            "zh": "Rates服务器现在不可用。请稍后再试。 [Error {code}]"
        },
        "90004": {
            "en": "Access denied. Incorrect account for the requested action.[Error {code}]",
            "fr": "Accès interdit. [Error {code}]",
            "it": "Accesso negato. [Error {code}]",
            "ja": "アクセスが拒否されました。[エラー {code}]",
            "ru": "Доступ запрещен. Неправильный аккаунт для запрошенного действия.[Error {code}]",
            "tr": "Erişim reddedildi. [{code} hatası]",
            "uk": "Доступ заборонено. [Error {code}]",
            "zh": "拒绝访问。 [Error {code}]"
        },
        "90005": {
            "en": "Error getting information about Root account. [Error {code}]",
            "fr": "Erreur lors de l'obtention d'informations sur le compte Root. [Error {code}]",
            "it": "Errore durante il recupero delle informazioni sull'account root. [Error {code}]",
            "ja": "ルートアカウント情報取得の最中にエラーが発生しました。[エラー {code}]",
            "ru": "Ошибка получения данных аккаунта менеджера. [Error {code}]",
            "tr": "Kök hesap hakkında bilgi alınırken hata oluştu. [{code} hatası]",
            "uk": "Помилка отримання даних аккаунта менеджера. [Error {code}]",
            "zh": "获取有关根帐户的信息时出错。[Error {code}]"
        },
        "90006": {
            "en": "API method {0} is currently unavailable. [Error {code}]",
            "fr": "La méthode API {0} est actuellement indisponible. [Error {code}]",
            "it": "Il metodo API {0} non è attualmente disponibile. [Error {code}]",
            "ja": "APIメソッド{0}は現在利用できません。[エラー {code}]",
            "ru": "API метод {0} сейчас недоступен. [Error {code}]",
            "tr": "{0} API yöntemi şu anda kullanılamıyor. [{code} hatası]",
            "uk": "API метод {0} зараз недоступний. [Error {code}]",
            "zh": "API方法{0}当前不可用。 [Error {code}]"
        },
        "90007": {
            "en": "You must agree with the TERMS by signing the PMA Agreement first. [Error {code}]",
            "fr": "Vous devez accepter les CONDITIONS en signant le PMA Contrat d'Utilisation d'abord. [Error {code}]",
            "it": "Devi accettare le CONDIZIONI firmando prima l'Accordo con l'Utilizzatore (PMA). [Error {code}]",
            "ja": "最初にユーザー契約に署名して、規約に同意する必要があります。 [エラー{code}]",
            "ru": "До начала работы вам необходимо согласиться с Правилами сервиса, подписав ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ PMA. [Error {code}]",
            "tr": "Öncelikle Kullanıcı Sözleşmesi'ni imzalayarak PMA KOŞULLARI kabul etmelisiniz. [{code} hatası]",
            "uk": "До початку роботи вам необхідно погодитися з Правилами сервісу, підписавши УГОДУ КОРИСТУВАЧА PMA. [Error {code}]",
            "zh": "您必须先签署用户协议，同意这些条款 (PMA)。[Error {code}]"
        },
        "90008": {
            "en": "PMA {pmaid} is suspended. [tryagain].[Error {code}]",
            "ru": "PMA {pmaid} сейчас приостановлен.[tryagain] [Error {code}]"
        },
        "90009": {
            "en": "This PMA {pmaid} is currently blocked. [Error {code}]",
            "fr": "Ce PMA {pmaid} est actuellement bloqué. [Error {code}]",
            "it": "Questo PMA {pmaid} è attualmente bloccato. [Error {code}]",
            "ja": "このPMA{pmaid}は現在ブロックされています。[エラー {code}]",
            "ru": "Этот PMA {pmaid} сейчас заблокирован. [Error {code}]",
            "tr": "Bu PMA {pmaid} şu anda engellendi. [{code} hatası]",
            "uk": "Цей PMA {pmaid} зараз заблокований. [Error {code}]",
            "zh": "此PMA{pmaid}当前被阻止。 [Error {code}]"
        },
        "90010": {
            "en": "Trading with {0} is not allowed for this PMA {1} because of the PMA setting [Error {code}]",
            "fr": "Les échanges avec {0} ne sont pas autorisées pour ce PMA {1} en raison du paramètre du PMA [Error {code}]",
            "it": "Il trading con {0} non è consentito per questo PMA {1} a causa dell'impostazione PMA [Error {code}]",
            "ja": "PMAの設定により、PMA{1}には{0}での取引が許可されていません。[エラー {code}]",
            "ru": "Торговля с {0} запрещена на данном PMA {1} правилами, установленными управляющим при открытии аккаунта. [Error {code}]",
            "tr": "PMA ayarı nedeniyle bu {1} PMA için {0} ile alım satım işlemi yapılmasına izin verilmiyor [{code} hatası]",
            "uk": "Торгівля з {0} заборонена на даному PMA {1} правилами, встановленими керуючим при відкритті аккаунта. [Error {code}]",
            "zh": "此PMA{1}不允许与{0}交易，因为PMA设置 [Error {code}]"
        },
        "90011": {
            "en": "Cross-trading is not allowed for this PMA {0} because of the PMA setting [Error {code}]",
            "fr": "Le cross-trading n'est pas autorisé pour ce PMA {0} en raison du paramètre PMA [Erreur {code}]",
            "it": "Il cross-trading non è consentito per questo PMA {0} a causa dell'impostazione PMA [Error {code}]",
            "ja": "PMAの設定により、PMA{0}には相対取引が許可されていません。[エラー {code}]",
            "ru": "Торговля напрямую между парами запрещена на данном PMA {0} правилами, установленными управляющим при открытии аккаунта. Можно торговать только в паре к базовой валюте.[Error {code}]",
            "tr": "PMA ayarı nedeniyle bu {0} PMA için çapraz alım satım işlemine izin verilmiyor [{code} hatası]",
            "uk": "Торгівля безпосередньо між парами заборонена на даному PMA {0} правилами, встановленими керуючим при відкритті аккаунта. Можна торгувати тільки в парі до базової валюті. [Error {code}]",
            "zh": "由于PMA设置，此PMA{0}不允许交叉交易 [Error {code}]"
        },
        "90012": {
            "en": "Your order does not fit the {0} PMA limit. PMA limit: {1}%, already used: {2}%, your order will add {3}%, estimated after execution: {4}% [Error {code}]",
            "fr": "Votre commande ne correspond pas à la limite de {0} PMA. Limite PMA: {1}%, déjà utilisée: {2}%, votre commande ajoutera {3}%, estimée après exécution: {4}%  [Error {code}]",
            "it": "Il tuo ordine non corrisponde al limite del PMA {0} . Limite PMA: {1}%, già utilizzato: {2}%, il tuo ordine aggiungerà {3}%, previsto dopo l'esecuzione: {4}% [Error {code}]",
            "ja": "あなたの注文はPMAの制限{0}に合致しません。PMA制限：{1}%、すでに使用したもの：{2}%、あなたの注文に追加されるもの：{3}%、実行後の予測：{4}% [エラー {code}]",
            "ru": "Ваш ордер превышает разрешенный в данном PMA лимит доли {0}. Установлен лимит: {1}%, текущее значение: {2}%, ваш ордер добавит {3}%, прогноз после исполнения ордера: {4}% [Error {code}]",
            "tr": "Komutunuz {0} PMA sınırına uymuyor. PMA limiti: % {1}, zaten kullanılmış: %{2}, komutunuz % {3}'e eklenecek, yürütüldükten sonra tahmin edilen: %{4} [{code} hatası]",
            "uk": "Ваш ордер перевищує дозволений в даному PMA ліміт частки {0}. Встановлено ліміт: {1}%, поточне значення: {2}%, ваш ордер додасть {3}%, прогноз після виконання ордера: {4}% [Error {code}]",
            "zh": "您的订单不符合{0}PMA限制。PMA限制：{1}%，已使用：{2}%，您的订单将添加{3}%，执行后估计：{4}% [Error {code}]"
        },
        "90013": {
            "en": "PMA {0} is not active now. The manager must make a deposit to the PMA first. [Error {code}]",
            "fr": "Le PMA {0} n'est pas actif maintenant. Le gestionnaire doit d'abord effectuer un dépôt dans le PMA. [Error {code}]",
            "it": "PMA {0} non è attivo ora. Il gestore deve prima effettuare un deposito sulla PMA. [Error {code}]",
            "ja": "PMA{0}は現在有効ではありません。マネジャーはまずPMAに入金を行う必要があります。[エラー {code}]",
            "ru": "PMA {0} сейчас не активен. Управляющий должен сначала сам сделать депозит на PMA. [Error {code}]",
            "tr": "PMA {0} şu anda etkin değil. Yönetici öncelikle PMA'ya para yatırmalıdır. [{code} hatası]",
            "uk": "PMA {0} зараз не активний. Керуючий повинен спочатку сам зробити депозит на PMA. [Error {code}]",
            "zh": "PMA{0}现在不激活。经理必须先向PMA存款。 [Error {code}]"
        },
        "90014": {
            "en": "PMA {0} is not currently listed. [Error {code}]",
            "fr": "Le PMA {0} n'est pas actuellement listé. [Error {code}]",
            "it": "PMA {0} non è attualmente elencato. [Error {code}]",
            "ja": "PMA{0}は現在掲載されていません。[エラー {code}]",
            "ru": "PMA {0} сейчас не в листинге. [Error {code}]",
            "tr": "PMA {0} şu anda listelenmiyor. [{code} hatası]",
            "uk": "PMA {0} зараз не в лістингу. [Error {code}]",
            "zh": "PMA{0}当前未列出。[Error {code}]"
        },
        "90015": {
            "en": "Market orders are restricted on the PMA. [Error {code}]",
            "ru": "На PMA запрещено использование рыночных ордеров. [Error {code}]"
        },
        "90016": {
            "en": "The price level of your order exceeded maximum spread {1}% allowed on this PMA. [Error {code}]",
            "ru": "Цена вашего ордера слишком далеко от лучшего предложения на рынке и превышает лимит рыночного спреда d {1}%, разрешенного для данного PMA. [Error {code}]"
        },
        "90020": {
            "en": "This PMA's current status does not allow requested action to be performed. Problem: {0} {1} {2} {3} [Error {code}]",
            "ru": "Текущий cтатус PMA не позволяет выполнить запрошенное действие. Проблема: {0} {1} {2} {3}[Error {code}]"
        },
        "90030": {
            "en": "This method should be called from the PMA. Front level error. [Error {code}]",
            "fr": "Cette méthode doit être appelée à partir du PMA. Erreur de niveau avant. [Error {code}]",
            "it": "Questo metodo dovrebbe essere effettuato dal PMA. Errore di livello frontale. [Error {code}]",
            "ja": "このメソッドはPMAから呼び出す必要があります。フロントレベルでのエラーが発生しました。[エラー {code}]",
            "ru": "Этот метод должен быть вызван с PMA. Ошибка фронт-разработчика. [Error {code}]",
            "tr": "Bu yöntem PMA'dan çağrılmalıdır. Ön seviye hatası. [{code} hatası]",
            "uk": "Цей метод повинен бути викликаний з PMA. Помилка фронт-розробника. [Error {code}]",
            "zh": "应该从PMA调用此方法。低级错误。[Error {code}]"
        },
        "91110": {
            "en": "Not enough A2A tokens to pay the PMA fee, please buy A2A tokens first. PMA opening fee is {0} A2A. Your current balance is {1} A2A [Error {code}]",
            "fr": "Pas assez de jetons A2A pour payer les frais du PMA, veuillez d'abord acheter des jetons A2A. Les frais d'ouverture du PMA sont de {0} A2A. Votre solde actuel est de {1} A2A [Error {code}]",
            "it": "I gettoni A2A disponibili non sufficienti per pagare la commissione PMA, si prega di acquistare prima gettoni A2A. La commissione di apertura di PMA è {0} A2A. Il tuo saldo attuale è {1} A2A [Error {code}]",
            "ja": "PMA費用を支払うだけの十分なA2Aトークンがありません。A2Aトークンを先に購入してください。PMA開設費用は{0} A2Aです。あなたの現在の残高は{1} A2Aです。[エラー {code}]",
            "ru": "Недостаточно токенов A2A для оплаты открытия PMA, сначала купите A2A токены на бирже. Цена открытия PMA = {0} A2A. Ваш баланс {1} A2A [Error {code}]",
            "tr": "PMA ücretini ödemek için yeterli A2A token yok, lütfen önce A2A token satın alın. PMA açılış ücreti {0} A2A'dır. Mevcut bakiyeniz {1} A2A'dir. [{code} hatası]",
            "uk": "Недостатньо токенів A2A для оплати відкриття PMA, спочатку купіть A2A токени на біржі. Ціна відкриття PMA = {0} A2A. Ваш баланс {1} A2A [Error {code}]",
            "zh": "没有足够的A2A代币支付PMA费用，请先购买A2A代币。PMA期初费用为{0}A2A。您当前余额为{1}A2A [Error {code}]"
        },
        "91202": {
            "en": "Requested PMA public name already exists, must be unique. [Error {code}]",
            "fr": "Le nom public demandé pour ce PMA existe déjà, il doit être unique. [Error {code}]",
            "it": "Il nome pubblico richiesto per il PMA esiste già, deve essere unico. [Error {code}]",
            "ja": "リクエストされたPMA公開名はすでに存在します。他にはない名前を選択してください。[エラー {code}]",
            "ru": "Запрошенное имя PMA уже используется, выберите другое уникальное имя. [Error {code}]",
            "tr": "Gereken PMA genel adı zaten bulunuyor, benzersiz olmalıdır. [{code} hatası]",
            "uk": "Таке ім'я PMA вже використовується, виберіть інше унікальне ім'я. [Error {code}]",
            "zh": "请求的PMA公共名称已经存在，必须是唯一的。[Error {code}]"
        },
        "91203": {
            "en": "PMA opening error, please contact support via email {domain.email} [Error {code}]",
            "fr": "Erreur d'ouverture du PMA, veuillez contacter le support par courriel {domain.email} [Error {code}]",
            "it": "Errore di apertura PMA, contattare l'assistenza via e-mail {domain.email} [Error {code}]",
            "ja": "PMA開設エラーが発生しました。サポートまでメールにて{domain.email}ご連絡ください。[エラー {code}]",
            "ru": "Ошибка открытия нового PMA, свяжитесь с техподдержкой по email {domain.email} [Error {code}]",
            "tr": "PMA açılış hatası, lütfen e-posta {domain.email} aracılığıyla destek ile iletişime geçin [{code} hatası]",
            "uk": "Помилка відкриття нового PMA, зв'яжіться з техпідтримкою по email {domain.email} [Error {code}]",
            "zh": "PMA打开错误，请通过电子邮件{domain.email}与支持部门联系 [Error {code}]"
        },
        "91204": {
            "en": "To create a new PMA please return to the Root account. [Error {code}]",
            "fr": "Pour créer un nouveau PMA, veuillez retourner au compte root. [Error {code}]",
            "it": "Per creare un nuovo PMA, torna all'account principale. [Error {code}]",
            "ja": "新しいPMAを作成するには、ルートアカウントに戻ってください。[エラー {code}]",
            "ru": "Для создания нового PMA переключитесь в свой основной аккаунт. [Error {code}]",
            "tr": "Yeni bir PMA oluşturmak için lütfen Kök hesabına dönün. [{code} hatası]",
            "uk": "Для створення нового PMA перейдіть в свій основний аккаунт. [Error {code}]",
            "zh": "若要创建新的PMA，请返回到根帐户。 [Error {code}]"
        },
        "91205": {
            "en": "The sum of the trading assets limits must be >= 200%. You set the total limit at {0}% [Error {code}]",
            "ru": "Сумма лимитов криптовалют должна быть >= 200%. Вы установили общий лимит в {0}% [Error {code}]"
        },
        "91210": {
            "en": "Cross-trading must be denied to restrict StopLoss usage. [Error {code}]",
            "fr": "Le cross-trading doit être refusé pour limiter l'utilisation de StopLoss. [Error {code}]",
            "it": "Il cross-trading deve essere negato per limitare l'utilizzo di StopLoss. [Error {code}]",
            "ja": "ストップロスを使用を制限するには、相対取引を拒否する必要があります。[エラー {code}]",
            "ru": "Для запрета Стоп-лосса кросс-трейдинг должен быть запрещен. [Error {code}]",
            "tr": "StopLoss (Zararı durdurma satışı) kullanımını kısıtlamak için çapraz alım satımın reddedilmesi gerekir. [{code} hatası]",
            "uk": "Для заборони Стоп-лосс крос-трейдинг повинен бути заборонений. [Error {code}]",
            "zh": "必须拒绝交叉交易以限制止损使用。 [Error {code}]"
        },
        "91211": {
            "en": "Guest level of disclosure was set higher than subscriber's. It is not logical. Please check the settings and try again. [Error {code}]",
            "fr": "Le niveau de divulgation de l'invité a été fixé à un niveau plus haut que celui de l'abonné. Celà n'est pas logique. Veuillez vérifier les paramètres et réessayer. [Error {code}]",
            "it": "Il livello di divulgazione degli ospiti è stato impostato superiore a quello degli abbonati. Non è logico. Controlla le impostazioni e riprova. [Error {code}]",
            "ja": "ゲストの公開レベルが購読者より高く設定されており、有効ではありません。設定を確認してもう一度挑戦してください。[エラー {code}]",
            "ru": "Уровень раскрытия информации для публики установлен выше чем для вкладчиков. Это нелогично. Проверьте настройки и попробуйте еще раз. [Error {code}]",
            "tr": "Konuk açıklama seviyesi aboneye göre daha yüksek olarak belirlendi. Bu uygun değil. Lütfen ayarları kontrol edip tekrar deneyin. [{code} hatası]",
            "uk": "Рівень розкриття інформації для публіки встановлений вище ніж для вкладників. Це не логічно. Перевірте настройки і спробуйте ще раз. [Error {code}]",
            "zh": "来宾级别的泄漏设置高于订阅服务器的级别。这不符合逻辑。请检查设置并重试。 [Error {code}]"
        },
        "91304": {
            "en": "Relogin error, please contact support via email  {domain.email}. [Error {code}]",
            "fr": "Erreur de reconnexion, veuillez contacter le support par courriel {domain.email}. [Error {code}]",
            "it": "Errore di relogin, contatta l'assistenza via e-mail {domain.email}. [Error {code}]",
            "ja": "再ログインエラーが発生しました。メールから{domain.email}サポートまで連絡してください。[エラー {code}]",
            "ru": "Ошибка переавторизации, свяжитесь с техподдержкой по email {domain.email}  [Error {code}]",
            "tr": "Yeniden oturum açma hatası, lütfen e-posta {domain.email} aracılığıyla destek ile iletişime geçin. [{code} hatası]",
            "uk": "Помилка переавторізаціі, зв'яжіться з техпідтримкою по email {domain.email}. [Error {code}]",
            "zh": "重新登录错误，请通过电子邮件{domain.email}与支持部门联系。 [Error {code}]"
        },
        "91600": {
            "en": "You do not have available {1} balance to deposit {0} {1}. [Error {code}]",
            "fr": "Vous n'avez pas de solde disponible de {1} pour déposer {0} {1}. [Error {code}]",
            "it": "Non hai a disposizione il saldo {1} da depositare {0} {1}.[Error {code}]",
            "ja": "{0} {1}の入金を実行するだけの十分な{1}の残高がありません。[エラー {code}]",
            "ru": "У вас нет свободных {1} на балансе для совершения депозита в размере {0} {1}. [Error {code}]",
            "tr": "{0} {1} yatırmak için uygun {1} bakiyeniz yok. [{code} hatası]",
            "uk": "У вас немає вільних {1} на балансі для здійснення депозиту в розмірі {0} {1}. [Error {code}]",
            "zh": "您没有可用的{1}余额来存放{0}{1}。 [Error {code}]"
        },
        "91601": {
            "en": "You have already opened a deposit with the same PMA less than 5 minutes ago. Make sure you do want to open more and try again after 5 minutes. [Error {code}]",
            "fr": "Vous avez déjà ouvert un dépôt avec le même PMA il y a moins de 5 minutes. Assurez-vous que vous souhaitez en ouvrir davantage et réessayez après 5 minutes. [Error {code}]",
            "it": "Hai già aperto un deposito con lo stesso PMA meno di 5 minuti fa. Assicurati di voler aprirne di più e riprovare dopo 5 minuti. [Error {code}]",
            "ja": "同じPMAで5分前以内に既に入金を開始しています。さらに実行する場合には、5分以上時間をあけてからもう一度挑戦してください。[エラー {code}]",
            "ru": "Вы уже сделали депозит в этот PMA менее чем 5 минут назад. Убедитесь, что вы правда хотите сделать еще один, и повторите отправку через 5 минут. [Error {code}]",
            "tr": "Aynı PMA ile 5 dakikadan daha kısa zaman önce bir mevduat zaten açtınız. Daha fazla açmak istediğinizden emin olun ve 5 dakika sonra tekrar deneyin. [{code} hatası]",
            "uk": "Ви вже зробили депозит в цей PMA менш ніж 5 хвилин тому. Переконайтеся, що ви правда хочете зробити ще один, і повторіть відправку через 5 хвилин. [Error {code}]",
            "zh": "不到5分钟前，您已经在同一PMA开立了存款。请确保确实要打开更多，并在5分钟后重试。 [Error {code}]"
        },
        "91602": {
            "en": "You are logged in the PMA different to the 'pma' parameter sent in the request. Please inform the support via email {domain.email}. [Error {code}]",
            "fr": "Vous êtes connecté dans un PMA différent du paramètre 'pma' envoyé dans la demande. Veuillez informer le support par courriel {domain.email}. [Error {code}]",
            "it": "Il PMA è stato registrato in modo diverso dal parametro 'pma' inviato nella richiesta. Informare l'assistenza via e-mail {domain.email}. [Error {code}]",
            "ja": "リクエストに対して送信された「pma」パラメーターとは別のPMAにログインしています。サポートまでメールにて{domain.email}連絡してください。[エラー {code}]",
            "ru": "PMA в котором вы сейчас авторизованы не совпадает с параметром 'pma' отправленным в запросе на сервер. Свяжитесь с техподдержкой по email {domain.email} для исправления. [Error {code}]",
            "tr": "PMA'da, talepte gönderilen 'pma' parametresinden farklı olarak oturum açtınız. Lütfen desteği e-posta {domain.email} ile bilgilendirin. [{code} hatası]",
            "uk": "PMA в якому ви зараз авторизовані не збігається з параметром 'pma' відправленим у запиті на сервер. Зв'яжіться з техпідтримкою по email {domain.email} для виправлення. [Error {code}]",
            "zh": "您登录的PMA与请求中发送的PMA参数不同。请通过电子邮件{domain.email}通知支持人员。[Error {code}]"
        },
        "91603": {
            "en": "Depositing to this PMA is unavailable right now. Please try again later. [Error {code}]",
            "fr": "Faire un versement sur ce PMA n'est pas disponible pour le moment. Veuillez réessayer plus tard. [Error {code}]",
            "it": "Fare depositi su questo PMA non è al momento disponibile. Per favore riprova più tardi. [Error {code}]",
            "ja": "現在PMAに入金を行うことはできません。後でもう一度挑戦してください。[エラー {code}]",
            "ru": "Выполнение депозита в данный PMA в настоящий момент невозможно. Попробуйте позже. [Error {code}]",
            "tr": "Bu PMA'ya para yatırma işlemi şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyiniz. [{code} hatası]",
            "uk": "Виконання депозиту в даний PMA зараз неможливо. Спробуйте пізніше. [Error {code}]",
            "zh": "目前无法存入此PMA。请稍后再试。 [Error {code}]"
        },
        "91605": {
            "en": "PMA depositing error, please contact support via email {domain.email} [Error {code}]",
            "fr": "Erreur de dépôt dans ce PMA, veuillez contacter l'assistance par courriel {domain.email} [Error {code}]",
            "it": "Errore di deposito sul PMA, contattare l'assistenza via e-mail {domain.email} [Error {code}]",
            "ja": "PMA入金エラーが発生しました。メールから{domain.email}サポートまでご連絡ください。[エラー {code}]",
            "ru": "Ошибка выполнение депозита в данный PMA, свяжитесь с техподдержкой по email {domain.email} [Error {code}]",
            "tr": "PMA para yatırma hatası, lütfen e-posta {domain.email} yoluyla destek ekibiyle iletişime geçin [{code} hatası]",
            "uk": "Помилка виконання депозиту в даний PMA, зв'яжіться з техпідтримкою по email {domain.email} [Error {code}]",
            "zh": "PMA存放错误，请通过电子邮件{domain.email}与支持部门联系 [Error {code}]"
        },
        "91700": {
            "en": "Invalid Deposit ID: {0}. No deposit found with this id. [Error {code}]",
            "fr": "ID de dépôt non valide: {0}. Aucun dépôt trouvé avec cet identifiant. [Error {code}]",
            "it": "ID del deposito non valido: {0}. Nessun deposito trovato con questo ID. [Error {code}]",
            "ja": "入金ID：{0}が有効ではりません。このIDに該当する入金が見つかりませんでした。[エラー {code}]",
            "ru": "Неправильный ID депозита в запросе к серверу: {0}. Депозит с таким ID не найден. [Error {code}]",
            "tr": "Geçersiz Mevduat Kimliği: {0}. Bu kimlikle mevduat bulunamadı. [{code} hatası]",
            "uk": "Неправильний ID депозиту в запиті до сервера: {0}. Депозит з таким ID не знайдено. [Error {code}]",
            "zh": "无效的存款ID:{0}。找不到此id的存款。 [Error {code}]"
        },
        "91701": {
            "en": "Deposit ID: {0} has been already closed. [Error {code}]",
            "fr": "ID de dépôt: {0} a déjà été fermé. [Error {code}]",
            "it": "ID deposito: {0} è già stato chiuso. [Error {code}]",
            "ja": "入金ID：{0}は既に終了しています。[エラー {code}]",
            "ru": "Депозит {0} уже закрыт. [Error {code}]",
            "tr": "Mevduat kimliği: {0} zaten kapatıldı. [{code} hatası]",
            "uk": "Депозит {0} вже закритий. [Error {code}]",
            "zh": "存款ID{0}已关闭。[Error {code}]"
        },
        "91702": {
            "en": "This deposit contains manager's undistributed reward and will be closed automatically during the next clearing if only {0} is on the PMA {1}. [Error {code}]",
            "fr": "Ce dépôt contient la récompense non distribuée du gestionnaire et sera clôturé automatiquement lors du prochain rapprochement si seulement {0} se trouvent sur le PMA {1}. [Error {code}]",
            "it": "Questo deposito contiene la ricompensa non distribuita del gestore e verrà chiuso automaticamente durante la successiva compensazione se sul PMA {1} è presente solo {0}. [Error {code}]",
            "ja": "この入金にはマネジャーの未分配の報酬が含まれており、{0}のみがPMA {1}にある場合、次回の決済の際に自動で終了します。[エラー {code}]",
            "ru": "Этот депозит содержит нерапределенную награду Управляющего,и будет автоматически закрыт при следующем клиринге если на балансе PMA {1} будет только Базовый Токен {0}. [Error {code}]",
            "tr": "Bu mevduat yöneticinin dağıtılmamış ödülünü içerir ve PMA {1}'da yalnızca {0} varsa, sonraki mahsup sırasında otomatik olarak kapatılacaktır. [{code} hatası]",
            "uk": "Цей депозит містить нерозподілену нагороду Керуючого, і буде автоматично закритий при наступному клірингу якщо на балансі PMA {1} буде тільки Базовий Токен {0}. [Error {code}]",
            "zh": "此存款包含经理的未分配奖励，如果PMA{1}上只有{0}，则下次结算时将自动关闭。[Error {code}]"
        },
        "91703": {
            "en": "The manager's deposits can be closed only during PMA termination. [Error {code}]",
            "fr": "Les dépôts du gestionnaire ne peuvent être fermés que pendant la résiliation du PMA. [Error {code}]",
            "it": "I depositi del gestore possono essere chiusi solo durante la risoluzione del PMA. [Error {code}]",
            "ja": "マネジャーの入金は PMA満了の際にのみ終了することができます。[エラー {code}]",
            "ru": "Депозит менеджера может быть закрыт только в процессе ликвидации PMA. [Error {code}]",
            "tr": "Yöneticinin mevduatları sadece PMA sonlandırılması sırasında kapatılabilir. [{code} hatası]",
            "uk": "Депозит менеджера може бути закритий тільки в процесі ліквідації PMA. [Error {code}]",
            "zh": "经理的存款只能在PMA终止期间结清。 [Error {code}]"
        },
        "91704": {
            "en": "Lock-up period for this deposit {0} is not over yet. Please try again after {0} days ({1} seconds). [Error {code}]",
            "fr": "La période de blocage pour ce dépôt {0} n'est pas encore terminée. Veuillez réessayer après {1} secondes. [Error {code}]",
            "it": "Il periodo di blocco per questo deposito {0} non è ancora scaduto. Riprova tra {1} secondi. [Error {code}]",
            "ja": "この入金{0}の固定期間はまだ終了していません。{1}秒後にもう一度挑戦してください。[エラー {code}]",
            "ru": "Период блокировки для данного депозита еще не закончился. Попробуйте снова через {0} дней ({deadline}). [Error {code}]",
            "tr": "Bu mevduat {0} için elde tutma süresi henüz bitmedi. Lütfen {1} saniye sonra tekrar deneyin. [{code} hatası]",
            "uk": "Період блокування для даного депозиту {0} ще не закінчився. Спробуйте знову через {1} секунд. [Error {code}]",
            "zh": "此存款{0}的锁定期尚未结束。请在{1}秒后重试。 [Error {code}]"
        },
        "91705": {
            "en": "This deposit {0} cannot be closed. [Error {code}]",
            "fr": "Ce dépôt {0} ne peut pas être fermé. [Error {code}]",
            "it": "Questo deposito {0} non può essere chiuso. [Error {code}]",
            "ja": "この入金{0}は締め切ることができません。[エラー {code}]",
            "ru": "Депозит {0} не может быть закрыт. [Error {code}]",
            "tr": "Bu mevduat {0} kapatılamaz. [{code} hatası]",
            "uk": "Депозит {0} не може бути закритий. [Error {code}]",
            "zh": "无法关闭此存款{0}。 [Error {code}]"
        },
        "91706": {
            "en": "Deposit withdrawals are temporarily unavailable in the PMA {pmaid}. [Error {code}]",
            "ru": "Выводы депозитов временно заблокированы на этом PMA. [Error {code}]"
        },
        "91801": {
            "en": "Successfully closed {0} deposits. Failed to close {1} deposits. Please try to close remaining deposits one by one to get the details. [Error {code}]",
            "de": "{0} Einzahlungen erfolgreich abgeschlossen. {1} Einzahlungen konnten nicht geschlossen werden. Bitte versuchen Sie, verbleibende Einzahlungen nacheinander zu schließen, um die Details zu erhalten. [Error {code}]",
            "fr": "{0} dépôts ont été clôturés avec succès. Échec de la clôture de {1} dépôts. Veuillez essayer de fermer les dépôts restants un par un pour obtenir les détails. [Error {code}]",
            "it": "{0} depositi chiusi con successo. Impossibile chiudere {1} depositi. Si prega di provare a chiudere i depositi rimanenti uno per uno per ottenere i dettagli. [Error {code}]",
            "ko": "{0} 입금을 성공적으로 마감했습니다. {1} 예금을 닫는 데 실패했습니다. 세부 사항을 확인하려면 남은 예금을 하나씩 닫으십시오. [Error {code}]",
            "ja": "{0}デポジットを正常にクローズしました。 {1}預金を閉じることができませんでした。詳細を確認するには、残りのデポジットを1つずつ閉じてみてください。 [エラー {code}]",
            "ru": "Успешно закрыто {0} депозитов. Не удалось закрыть {1} депозитов. Пожалуйста, попробуйте закрыть оставшиеся депозиты один за другим, чтобы получить подробную информацию. [Error {code}]",
            "tr": "{0} mevduat başarıyla kapatıldı. {1} mevduat kapatılamadı. Ayrıntıları almak için lütfen kalan mevduatları tek tek kapatmaya çalışın. [{code} hatası]",
            "uk": "Успішно закрито {0} депозитів. Не вдалося закрити {1} депозитів. Будь ласка, спробуйте закрити решту депозитів по одному, щоб отримати деталі. [Error {code}]",
            "zh": "已成功关闭 {0} 笔存款。未能关闭 {1} 个存款。请尝试一一关闭剩余存款以获取详细信息。 [Error {code}]"
        },
        "92502": {
            "en": "This PMA's current status does not allow this PMA to be closed. [Error {code}]",
            "fr": "Le statut actuel de ce PMA ne permet pas de fermer ce PMA. [Error {code}]",
            "it": "Lo stato corrente di questo PMA non consente la chiusura di questo PMA. [Error {code}]",
            "ja": "このPMAの現在の状態ではPMAを締め切ることはできません。[エラー {code}]",
            "ru": "Текущий cтатус PMA не позволяет закрыть аккаунт в настоящий момент. [Error {code}]",
            "tr": "Bu PMA'nın mevcut durumu, bu PMA'nın kapatılmasına izin vermez. [{code} hatası]",
            "uk": "Поточний Cтатус PMA не дозволяє закрити акаунт зараз. [Error {code}]",
            "zh": "此PMA的当前状态不允许关闭此PMA。 [Error {code}]"
        },
        "92602": {
            "en": "PMA closing request not found. [Error {code}]",
            "fr": "Demande de clôture PMA introuvable. [Error {code}]",
            "it": "Richiesta di chiusura del PMA non trovata. [Error {code}]",
            "ja": "PMA締め切りリクエストが見つかりませんでした。[エラー {code}]",
            "ru": "Запрос на закрытие PMA не найден. [Error {code}]",
            "tr": "PMA kapatma talebi bulunamadı. [{code} hatası]",
            "uk": "Запит на закриття PMA не знайдено. [Error {code}]",
            "zh": "找不到PMA关闭请求。 [Error {code}]"
        },
        "92702": {
            "en": "NLV is less than the last profit distribution level. Nothing to distribute. [Error {code}]",
            "fr": "Le NLV est inférieur au dernier niveau de distribution des bénéfices. Rien à distribuer. [Error {code}]",
            "it": "NLV è inferiore all'ultimo livello di distribuzione degli utili. Niente da distribuire. [Error {code}]",
            "ja": "NLVが最後の利益分配レベル未満になっています。分配できるものがありません。[エラー {code}]",
            "ru": "ЧЛС аккаунта ниже уровня прошлого распределения прибыли, нечего распределять. [Error {code}]",
            "tr": "NLV, son kar dağıtım seviyesinin altındadır. Dağıtacak bir şey yok. [{code} hatası]",
            "uk": "ЧЛС аккаунта нижче рівня минулого розподілу прибутку, нічого розподіляти. [Error {code}]",
            "zh": "NLV小于上一个利润分配级别。没什么好分发的。 [Error {code}]"
        },
        "92703": {
            "en": "Last profit distribution was carried out less than a week ago ({0} days ago). Please try again at least after 7 days from the last profit distribution date. [Error {code}]",
            "fr": "La dernière distribution des bénéfices a été effectuée il y a moins d'une semaine (il y a {0} jours). Veuillez réessayer au moins 7 jours après la dernière date de distribution des bénéfices. [Error {code}]",
            "it": "L'ultima distribuzione degli utili è stata effettuata meno di una settimana fa ({0} giorni fa). Riprova almeno dopo 7 giorni dall'ultima data di distribuzione degli utili. [Error {code}]",
            "ja": "最後の利益の分配は1週間以内（{0}日前）に実施されています。最後の分配から最低でも7日の間隔をあけてから、もう一度挑戦してください。[エラー {code}]",
            "ru": "Прошлое распределение прибыли было менее недели назад ({0} дней, если быть точным). Попробуйте через неделю после прошлого распределения. [Error {code}]",
            "tr": "Son kâr dağıtımı bir haftadan daha kısa bir süre önce ({0} gün önce) gerçekleştirildi. Lütfen son kâr dağıtım tarihinden en az 7 gün sonra tekrar deneyin. [{code} hatası]",
            "uk": "Минуле розподілення прибутку було менше тижня назад ({0} днів, якщо бути точним). Спробуйте через тиждень після минулого розподілу. [Error {code}]",
            "zh": "上一次利润分配是在不到一周前（即{0}天前）进行的。请至少在上次利润分配日期后7天内重试。 [Error {code}]"
        },
        "92704": {
            "en": "PMA status is not suitable for clearing. [Error {code}]",
            "fr": "Le statut du PMA ne convient pas pour la compensation. [Error {code}]",
            "it": "Lo stato del PMA non è adatto per la cancellazione. [Error {code}]",
            "ja": "PMAの状態が決済に適していません。[エラー {code}]",
            "ru": "Текущий cтатус PMA не позволяет запустить распределение прибыли. [Error {code}]",
            "tr": "PMA durumu mahsup için uygun değildir. [{code} hatası]",
            "uk": "Поточний Cтатус PMA не дозволяє запустити розподіл прибутку. [Error {code}]",
            "zh": "PMA状态不适合清算。 [Error {code}]"
        },
        "92705": {
            "en": "This PMA does not have enough available balance of {2} to run clearing. Requires {1} {2} available. Currently available {0} {2}. [Error {code}]",
            "de": "Dieser PMA verfügt nicht über genügend {2} verfügbares Guthaben, um das Clearing durchzuführen. Benötigt {1} {2} auf Lager. Derzeit verfügbar {0} {2}. [Error {code}]",
            "fr": "Ce PMA ne dispose pas d'un {2} solde disponible suffisant pour effectuer l'apurement. Nécessite {1} {2} en stock. Actuellement disponible {0} {2}. [Error {code}]",
            "it": "Questo PMA non ha {2} saldo disponibile sufficiente per eseguire la compensazione. Richiede {1} {2} in magazzino. Attualmente disponibile {0} {2}. [Error {code}]",
            "ja": "このPMAには、クリアを実行するのに十分な{2}使用可能な残高がありません。 {1} {2}の在庫が必要です。現在利用可能な{0} {2}。[エラー {code}]",
            "ko": "이 PMA에는 정산을 수행하기에 충분한 {2} 사용 가능한 잔액이 없습니다. {1} {2} 재고가 필요합니다. 현재 사용 가능 {0} {2}.[Error {code}]",
            "ru": "У этого PMA недостаточно доступного баланса {2} для выполнения клиринга. Требуется {1} {2} в наличии. В настоящее время доступно {0} {2}. [Error {code}]",
            "tr": "Bu PMA, takas gerçekleştirmek için yeterli {2} kullanılabilir bakiyeye sahip değil. Stokta {1} {2} gerektirir. Şu anda mevcut {0} {2}. [{code} hatası]",
            "uk": "Цей PMA не має достатнього {2} доступного залишку для здійснення клірингу. Потрібно {1} {2} на складі. Наразі доступно {0} {2}. [Error {code}]",
            "zh": "此 PMA 没有足够的 {2} 可用余额来执行清算。需要 {1} {2} 个库存。目前可用 {0} {2}。 [Error {code}]"
        },
        "623000": {
            "en": "You got a new loan: {0} {1}",
            "ru": "Вы получили новый займ: {0} {1}"
        },
        "900001": {
			"en":"Your PMA '{0}' ({1}) has been listed in the trading terminal's 'Available PMAs' section since {start}",
			"ru":"Ваш PMA '{0}' ({1}) добавлен в раздел 'Доступные ПМА' торгового терминала с {start}"
        },
        "900011": {
            "help": "{0}=pma_name, {1}=dep_id, {2}=sym_list",
            "en": "🇬🇧[EN] Your {0} PMA deposit {1} has been closed. Funds has been credited to your account in {2}.",
            "ru": "🇷🇺[RU] Ваш депозит {1} в PMA {0} закрыт. средства выведены и зачислены на ваш аккаунт в {2}."
        },
        "tryLater": {
			"en": "Please try again later.",
            "fr": "Veuillez réessayer plus tard.",
            "it": "Per favore riprova più tardi.",
            "ja": "後でもう一度やり直してください。",
            "ko": "나중에 다시 시도 해주십시오.",
			"ru": "Попробуйте еще раз попозже.",
            "tr": "Lütfen daha sonra tekrar deneyiniz.",
            "uk": "Будь-ласка спробуйте пізніше.",
            "zh": "请稍后再试。"
        },
        "tryNow": {
			"en": "Please check your internet connection, reload the page and try again now. If you get the same error over and over again, please contact our support.",
            "fr": "Veuillez vérifier votre connexion Internet, recharger la page et réessayer maintenant. Si vous obtenez la même erreur encore et encore, veuillez contacter notre support.",
            "it": "Controlla la tua connessione Internet, ricarica la pagina e riprova ora. Se ricevi lo stesso errore più e più volte, contatta il nostro supporto.",
            "ja": "インターネット接続を確認し、ページをリロードして、今すぐ再試行してください。同じエラーが何度も発生する場合は、サポートにお問い合わせください。",
            "ko": "인터넷 연결을 확인하고 페이지를 새로 고침 한 다음 지금 다시 시도하세요. 같은 오류가 계속해서 발생하면 지원팀에 문의하십시오.",
			"ru": "Проверьте подключение к Интернету, перезагрузите страницу и попробуйте еще раз. Если одна и та же ошибка возникает снова и снова, обратитесь в нашу службу поддержки.",
            "tr": "Lütfen internet bağlantınızı kontrol edin, sayfayı yeniden yükleyin ve şimdi tekrar deneyin. Aynı hatayı defalarca alırsanız, lütfen destek ekibimizle iletişime geçin.",
            "uk": "Перевірте підключення до Інтернету, перезавантажте сторінку та повторіть спробу зараз. Якщо ви постійно отримуєте ту саму помилку, зв’яжіться з нашою службою підтримки.",
            "zh": "请检查您的互联网连接，重新加载页面，然后重试。如果您一次又一次遇到相同的错误，请联系我们的支持。"
        },
        "useMain": {
			"en": "Requested features are only available on the ordinary main accounts.",
            "fr": "Les fonctionnalités demandées ne sont disponibles que sur les comptes principaux ordinaires.",
            "it": "Le funzionalità richieste sono disponibili solo sui conti principali ordinari.",
            "ja": "リクエストされた機能は、通常のメインアカウントでのみ利用できます。",
            "ko": "요청 된 기능은 일반 기본 계정에서만 사용할 수 있습니다.",
			"ru": "Запрошенные функции доступны только для обычных аккаунтов.",
            "tr": "İstenen özellikler yalnızca normal ana hesaplarda mevcuttur.",
            "uk": "Потрібні функції доступні лише на звичайних основних рахунках.",
            "zh": "所需功能仅在普通主帐户上可用。"
        },
        "addressValue": {
            "en": "Address: {2}",
            "fr": "Adresse: {2}",
            "it": "Indirizzo: {2}",
            "ja": "アドレス：{2}",
            "ko": "주소: {2}",
            "tr": "Adres: {2}",
            "uk": "Адреса: {2}",
            "zh": "地址：{2}"
        },
        "tagValue": {
            "en": "Tag ({tag_name}): {3}",
            "fr": "Tag ({tag_name}): {3}",
            "it": "Tag ({tag_name}): {3}",
            "ja": "タグ ({tag_name})：{3}",
            "ko": "태그 ({tag_name}): {3}",
            "tr": "Etiket ({tag_name}): {3}",
            "uk": "Тег ({tag_name}): {3}",
            "zh": "标签 ({tag_name})：{3}"
        }
	},
    "common": {
        
        "granted": {
            "en": "Granted",
            "ru": "Получено"
        },
        "denied": {
            "en": "Denied",
            "ru": "Отклонено"
        },
        "default": {
            "en": "default",
            "ru": "По умолчанию"
        },
        "browserPermissions": {
			"en": "Browser permission",
			"ru": "Резрешение браузера"
        },
        "hue": {
			"en": "Hue",
			"ru": "Тон"
        },
        "chroma": {
			"en": "Chroma",
			"ru": "Цветность"
        },
        "luminance": {
			"en": "Luminance",
			"ru": "Яркость"
        },
        "hideZeroBalance": {
			"en": "Hide zero balances",
			"ru": "Спрятать нулевые балансы"
        },
        "button_connectAccount": {
			"en": "Connect account",
			"ru": "Добавить аккаунт"
        },
		"pushNotification": {
			"en": "Push notifications",
			"ru": "Push уведомления"
		},
		"lastMonthProfit_TH": {
			"en": "Month",
			"ru": "Месяц"
		},
		"transferred": {
			"en": "Transferred",
			"fr": "Transféré",
			"de": "Übertragen",
			"it": "Trasferito",
			"ja": "転送",
			"ko": "이전됨",
			"ru": "Переведено",
			"tr": "Transfer edildi",
			"uk": "Передано",
			"zh": "传递"
		},
		"liquidityPools": {
			"en": "Liquidity pools",
			"fr": "Pools de liquidité",
			"de": "Liquiditätspools",
			"it": "Pool di liquidità",
			"ja": "流動性プール",
			"ko": "유동성 풀",
			"ru": "Пулы ликвидности",
			"tr": "Likidite havuzları",
			"uk": "Пули ліквідності",
			"zh": "流动资金池"
		},
		"pools": {
			"en": "Pools",
			"fr": "Pools",
			"de": "Pools",
			"it": "Pool",
			"ja": "プール",
			"ko": "수영장",
			"ru": "Пулы",
			"tr": "Havuzlar",
			"uk": "Пули",
			"zh": "流动资金池"
		},
		"button_cardDeposit": {
			"en": "Card deposit",
			"fr": "Dépôt par carte",
			"de": "Karteneinzahlung",
			"it": "Deposito con carta",
			"ja": "カード入金",
			"ru": "Пополнить с карты",
			"tr": "Kart ile Yatırma",
			"uk": "Депозит за допомогою картки"
		},
        "orderbook": {
            "en": "Orderbook",
            "ru": "Книга ордеров"
        },
        "buyNewAddress": {
            "en": "Buy New Deposit Address",
            "ru": "Купить новый адрес пополнения"
        },
        "buyNewAddress_description": {
            "en": "You can get a new depositing address to increase the anonymity of your transactions. Each change of address will be charged {fee} A2A tokens.",
            "de": "Sie können eine neue Einzahlungsadresse erhalten, um die Anonymität Ihrer Transaktionen zu erhöhen. Für jede Adressänderung werden {fee} A2A-Token berechnet.",
            "fr": "Vous pouvez obtenir une nouvelle adresse de dépôt pour augmenter l'anonymat de vos transactions. Chaque changement d'adresse sera facturé {fee} jetons A2A.",
            "it": "Puoi ottenere un nuovo indirizzo di deposito per aumentare l'anonimato delle tue transazioni. Ad ogni cambio di indirizzo verranno addebitati {fee} token A2A.",
            "ja": "新しい預金先住所を取得して、取引の匿名性を高めることができます。アドレスを変更するたびに、{fee}個のA2Aトークンが課金されます。",
            "ko": "거래의 익명성을 높이기 위해 새 입금 주소를 얻을 수 있습니다. 주소가 변경될 때마다 {fee} A2A 토큰이 청구됩니다.",
            "tr": "İşlemlerinizin gizliliğini artırmak için yeni bir para yatırma adresi alabilirsiniz. Her adres değişikliği için {fee} A2A jetonu tahsil edilecektir.",
            "uk": "Ви можете отримати нову адресу для депонування, щоб збільшити анонімність ваших транзакцій. За кожну зміну адреси стягується {fee} жетонів A2A.",
            "zh": "您可以获得一个新的充值地址以增加交易的匿名性。每次更改地址将收取 {fee} 个 A2A 代币",
            "ru": "Вы можете получить новый адрес пополнения чтобы повысить анонимность своих транзакций. За каждую смену адреса взимается плата в размере {fee} A2A"
        },
        "lessons": {
            "en": "How-to videos",
            "ru": "Видеоуроки"
        },
        "loanTerms": {
            "en": "Loan Terms",
            "ru": "Правила займа"
        },
        "lendingTerms": {
            "en": "Lending Terms",
            "ru": "Правила выдачи"
        },
        "coinsinfo": {
            "en": "Coinsinfo",
            "fr": "Coinsinfo",
            "it": "Coinsinfo",
            "ja": "コイン情報",
            "ru": "Справочник",
            "tr": "Coin bilgileri",
            "uk": "Довідник",
            "zh": "硬币信息"
        },
        "pmaOpen": {
            "en": "Open new PMA",
            "fr": "Ouvrir un nouveau PMA",
            "it": "Apri un nuovo PMA",
            "ja": "新しいPMAを開く",
            "ru": "Открыть новый PMA",
            "tr": "Yeni PMA aç",
            "uk": "Відкрити новий PMA",
            "zh": "打开新PMA"
        },
        "pmaagreements": {
            "en": "PMA user agreement",
            "fr": "Accord d'utilisation PMA",
            "it": "Contratto utente PMA",
            "ja": "PMAユーザー同意書",
            "ru": "Пользователькое соглашение PMA",
            "tr": "PMA kullanıcı sözleşmesi",
            "uk": "Користувацька угода PMA",
            "zh": "PMA用户协议"
        },
        "terminal": {
            "en": "Trade Terminal",
            "fr": "Terminal Commercial",
            "it": "Terminal commerciale",
            "ja": "取引終了",
            "ru": "Торговый терминал",
            "tr": "Alım Satım Terminali",
            "uk": "Торговий термінал",
            "zh": "交易终端机"
        },
        "terminateAccount": {
            "en": "Terminate Account",
            "fr": "Fermer le compte",
            "it": "Chiudi account",
            "ja": "アカウントの削除",
            "ru": "Удалить аккаунт",
            "tr": "Hesabı sonlandır",
            "uk": "Видалити аккаунт",
            "zh": "终止帐户"
        },
        "button_getCode": {
            "en": "Get registration code",
            "fr": "Obtenez le code d'enregistrement",
            "it": "Ottieni il codice di registrazione",
            "ja": "登録コードの取得",
            "ru": "Получить код регистрации",
            "tr": "Kayıt kodunu al",
            "uk": "Отримати код реєстрації",
            "zh": "获取注册代码"
        },
        "cachedAlert": {
            "en": "Your browser is had cache old version v.{old}, please remove your cache. Actiual version is v.{version}",
            "fr": "Votre navigateur a une ancienne version de cache v.{old}, veuillez supprimer votre cache. La version actuelle est v.{version}",
            "it": "Nel tuo browser è presente la versione cache precedente v.{old}, rimuovi il cache. La versione effettiva è v.{version}",
            "ja": "ブラウザに古いバージョンのキャッシュ v.{old}が保存されています。このキャッシュを削除してください。最新のバージョンは v.{version} です。",
            "ru": "Ваш браузер закешировал старую версию терминала v.{old}, пожалуйста очистите кэш. Актуальная версия v.{version}",
            "tr": "Tarayıcınızda eski sürüm v.{old} önbellek mevcuttur, lütfen önbelleğinizi kaldırın. Mevcut sürüm v.{version}'dir",
            "uk": "Ваш браузер запам'ятав стару версію терміналу v.{old}, будь ласка, очистіть кеш. Актуальна версія v.{version}",
            "zh": "您的浏览器已缓存旧版本 v.{old}，请删除缓存。活动版本是v.{version}"
        },
        "clearFilters_title": {
            "en": "Clear filters",
            "fr": "Effacer les filtres",
            "it": "Cancella filtri",
            "ja": "フィルタをクリア",
            "ru": "Сбросить фильтры",
            "tr": "Filtreleri temizleme",
            "uk": "Скинути фільтри",
            "zh": "清除筛选器"
        },
        "passwordForgot_description": {
            "en": "You can restore your password when you press the button [Forgot password]",
            "fr": "Vous pouvez restaurer votre mot de passe en appuyant sur le bouton [Mot de passe oublié]",
            "it": "È possibile ripristinare la password quando si preme il pulsante [Password dimenticata]",
            "ja": "[パスワードを忘れた場合]ボタンを押してパスワードのリセットを行うことができます。",
            "ru": "Вы можете восстановить свой пароль на почту к которой привязан аккаунт воспользовавшись функцией [Забыли пароль?].",
            "tr": "[Şifremi unuttum] düğmesine bastığınızda şifrenizi geri yükleyebilirsiniz",
            "uk": "Ви можете відновити свій пароль на пошту до якої прив'язаний аккаунт скориставшись функцією [Забули пароль?].",
            "zh": "您可以在按下[Forgot password]按钮时恢复密码"
        },
        "print": {
            "en": "Print",
            "fr": "Imprimer",
            "it": "Stampare",
            "ja": "印刷",
            "ru": "Печать",
            "tr": "Çıktı",
            "uk": "Друк",
            "zh": "打印"
        },
        "security": {
            "en": "Security",
            "fr": "Sécurité",
            "it": "Sicurezza",
            "ja": "セキュリティ",
            "ru": "Безопасность",
            "tr": "Güvenlik",
            "uk": "Безпека",
            "zh": "安全"
        },
        "step": {
            "en": "Step",
            "fr": "Étape",
            "it": "Passo",
            "ja": "ステップ",
            "ru": "Шаг",
            "tr": "Adım",
            "uk": "Крок",
            "zh": "台阶"
        },
        "steps": {
            "1": {
                "en": "Creating an account",
                "fr": "Créer un compte",
                "it": "Creare un account",
                "ja": "アカウントの新規作成",
                "ru": "Создание аккаунта",
                "tr": "Bir hesap oluşturma",
                "uk": "Створення аккаунта",
                "zh": "创建帐户"
            },
            "2": {
                "en": "Email confirmation",
                "fr": "Email de confirmation",
                "it": "Conferma via email",
                "ja": "メールの確認",
                "ru": "Подтверждение email",
                "tr": "E-posta onayı",
                "uk": "Підтвердження email",
                "zh": "电子邮件确认"
            },
            "3": {
                "en": "2FA activation",
                "fr": "Activer le 2FA",
                "it": "Attivazione 2FA",
                "ja": "2FAの有効化",
                "ru": "Активация двухфакторной авторизации",
                "tr": "2FA aktivasyonu",
                "uk": "Активація двухфакторної авторизації",
                "zh": "2FA激活"
            },
            "4": {
                "en": "User agreement",
                "fr": "Conditions d'Utilisation",
                "it": "Accordo per gli utenti",
                "ja": "ユーザーの同意",
                "ru": "Принятие пользовательского соглашения",
                "tr": "Kullanıcı sözleşmesi",
                "uk": "Погодження з користувальницькою угодою",
                "zh": "用户协议"
            },
            "5": {
                "en": "Master Key setup",
                "fr": "Configuration du Master Key",
                "it": "Impostazione della Master Key",
                "ja": "マスターキーのセットアップ",
                "ru": "Установка мастер-ключа",
                "tr": "Ana Anahtar kurulumu",
                "uk": "Встановлення майстер-ключа",
                "zh": "主密钥设置"
            }
        },
		"value_hours": {
				"en": "{value} hours", 
				"fr": "{value} heures", 
				"it": "{value} ore", 
				"ja": "{value} 時間", 
				"ru": "{value} часов", 
				"tr": "{value} saat", 
				"uk": "{value} годин", 
				"zh": "{value} 小时"
		}, 
        "basketPMA": {
            "en": "Basket PMA"
        },
        "sltp": {
            "en": "SLTP"
        },
        "settings": {
            "en": "Settings",
            "fr": "Réglages",
            "it": "Impostazioni",
            "ja": "設定",
            "ru": "Настройки",
            "tr": "Ayarlar",
            "uk": "Налаштування",
            "zh": "设置"
        },
        "pma": {
            "en": "PMA",
            "fr": "PMA",
            "it": "PMA",
            "ja": "PMA",
            "tr": "PMA",
            "uk": "PMA",
            "zh": "PMA公司"
        },
        "pmaDashboard": {
            "en": "PMA {pmaid} info",
            "fr": "Info sur le PMA {pmaid}",
            "it": "Informazioni sul PMA {pmaid}",
            "ja": "PMA {pmaid}情報",
            "ru": "PMA {pmaid} инфо",
            "tr": "PMA {pmaid} bilgileri",
            "uk": "PMA {pmaid} інфо",
            "zh": "PMA{pmaid}信息"
        },
        "pmaDepositList": {
            "en": "My PMA deposits",
            "fr": "Mes dépôts PMA",
            "it": "I miei depositi PMA",
            "ja": "自分のPMA入金",
            "ru": "Мои депозиты в PMA",
            "tr": "PMA mevduatlarım",
            "uk": "Мої депозити в PMA",
            "zh": "我的PMA存款"
        },
        "pmaList": {
            "en": "Active PMAs",
            "fr": "PMA actifs",
            "it": "PMA attivi",
            "ja": "有効なPMA",
            "ru": "Активные PMA",
            "tr": "Aktif PMA'lar",
            "uk": "Активні PMA",
            "zh": "活跃的PMAs"
        },
        "myPMA": {
            "en": "My PMA",
            "fr": "Mes PMA",
            "it": "I miei PMA",
            "ja": "自分のPMA",
            "ru": "Мои PMA",
            "tr": "PMA'm",
            "uk": "Мої PMA",
            "zh": "我的PMA"
        },
        "depositsList": {
            "en": "Deposits list",
            "fr": "Liste des dépôts",
            "it": "Elenco dei depositi",
            "ja": "入金リスト",
            "ru": "Список депозитов",
            "tr": "Mevduat listesi",
            "uk": "Список депозитів",
            "zh": "存款清单"
        },
        "chart": {
            "en": "Chart",
            "fr": "Graphique",
            "it": "Grafico",
            "ja": "チャート",
            "ru": "График",
            "tr": "Grafik",
            "uk": "Графік",
            "zh": "图表"
        },
        "actionType": {
            "en": "Action type",
            "fr": "Type d'action",
            "it": "Tipo di azione",
            "ja": "アクションタイプ",
            "ru": "Вид действия",
            "tr": "İşlem türü",
            "uk": "Вид дії",
            "zh": "操作类型"
        },
        "actionsLog": {
            "en": "Actions log",
            "fr": "Journal des actions",
            "it": "Registro delle azioni",
            "ja": "アクションログ",
            "ru": "Журнал",
            "tr": "İşlem günlüğü",
            "uk": "Журнал",
            "zh": "操作日志"
        },
		"convertDust_description": {
			"en": "All your {sym} tokens will be converted at the current market rates.",
			"fr": "Tous vos jetons {sym} seront convertis aux taux actuels du marché.",
			"it": "Tutti i tuoi token {sym} verranno convertiti agli attuali tassi di mercato.",
			"de": "Alle Ihre {sym} Token werden zu den aktuellen Marktpreisen konvertiert.",
			"ja": "すべての{sym}トークンは、現在の市場レートで変換されます。",
			"ko": "모든 {sym} 토큰은 현재 시장 요율로 변환됩니다.",
            "ru": "Конвертировать весь баланс {sym} в токены A2A",
            "tr": "Tüm {sym} jetonlarınız mevcut piyasa oranlarına göre dönüştürülecektir.",
            "ua": "Усі ваші символи {sym} будуть конвертовані за поточними ринковими курсами.",
            "zh": "您所有的{sym}代币都将按照当前的市场汇率转换。"
		},
		"order2Position_description": {
            "en": "Your order {oid} will become a position with the volume being equal to filled volume at the time of conversion. SLTP will be activated for the filled part.",
            "fr": "Votre commande {oid} deviendra une position dont le volume sera égal au volume rempli au moment de la conversion. SLTP sera activé pour la pièce remplie.",
            "it": "Il tuo ordine {oid} diventerà una posizione con il volume pari al volume riempito al momento della conversione. SLTP verrà attivato per la parte riempita.",
            "ja": "注文{oid}は、変換時の入力されたボリュームを伴うポジションになります。入力された部分に対してSLTPが有効になります。",
            "ru": "Ваш ордер {oid} превратится в Позицию с объемом, равным уже исполненному объему. Будет активирован SLTP ордер на исполненный объем.",
            "tr": "{oid} komutunuz, dönüşüm sırasında işlem hacmi ile, tamamlanmış işlem hacmine eşit olacak şekilde bir konum alacaktır. Tamamlanmış kısım için SLTP etkinleştirilecektir.",
            "uk": "Ваш ордер {oid} перетвориться в Позицію з об'ємом, рівним вже виконаному обсягу. Буде активовано SLTP ордер на виконаний обсяг.",
            "zh": "您的订单{oid}在转换时将变成一个容量等于填充容量的位置。填充部分将激活SLTP。"
        },
		"actionConfirmation": {
			"en": "Please confirm the following action:",
			"ru": "Подтвердите следующее действие:"
		},
        "newAddress" : {
            "en": "New address",
            "de": "Neue Adresse",
            "fr": "Nouvelle adresse",
            "it": "Nuovo indirizzo",
            "ja": "新しいアドレス",
            "ko": "새 주소",
            "ru": "Новый адрес",
            "tr": "Yeni adres",
            "uk": "Нова адреса",
            "zh": "新地址"
        },
        "addressBook" : {
            "en": "Address book",
            "de": "Adressbuch",
            "fr": "Carnet d'adresses",
            "it": "Rubrica",
            "ja": "住所録",
            "ko": "주소록",
            "ru": "Адресная книга",
            "tr": "Adres defteri",
            "uk": "Адресна книга",
            "zh": "地址簿"
        },
        "any2any" : {
            "en": "Any2Any"
        },
        "favorites": {
            "en": "Favorites",
            "fr": "Favoris",
            "it": "Favoriti",
            "ja": "お気に入り",
            "ko": "收藏夹",
            "ru": "Избранное",
            "tr": "Favoriler",
            "uk": "Обране",
            "zh": "收藏夹"
        },
        "tokenInfo": {
            "en": "Token contract info",
            "fr": "Informations sur le contrat de jeton",
            "it": "Informazioni sul contratto token",
            "ja": "トークンコントラクト情報",
            "ko": "代币合约信息",
            "ru": "Информация о токене",
            "tr": "Token sözleşme bilgisi",
            "uk": "Інформація про токен",
            "zh": "代币合同信息"
        },
        "button_addToFavorite": {
            "en": "Add to favorites",
            "fr": "Ajouter aux favoris",
            "it": "Aggiungi ai preferiti",
            "ja": "お気に入りに追加",
            "ru": "Добавить в избранное",
            "tr": "Favorilere ekle",
            "uk": "Додати в обране",
            "zh": "添加到收藏夹"
        },
        "button_closeAsFulfilled": {
            "en": "Close as fulfilled",
            "ru": "Закрыть как исполненный"
        },
        "rowsPerPage": {
            "en": "Rows per page",
            "ru": "Cтрок на странице"
        },
        "dateFrom": {
            "deprecated":"true",
            "en": "From",
            "ru": "С"
        },
        "dateTo": {
            "deprecated":"true",
            "en": "To",
            "ru": "До"
        },
        "compression": {
            "en": "Сompression",
            "de": "Kompression",
            "fr": "Compression",
            "it": "Compressione",
            "ja": "圧縮",
            "ko": "압축",
            "ru": "Сжатие",
            "tr": "Sıkıştırma",
            "uk": "Стиснення",
            "zh": "压缩"
        },
        "percentPrice": {
            "en": "Best rate diff(%)",
            "fr": "Meilleur taux de diff (%)",
            "it": "Miglior tariffa differenziale (%)",
            "ja": "最良価格差（%）",
            "ru": "До лучшей цены(%)",
            "tr": "En iyi oran farkı(%)",
            "uk": "До кращої ціни(%)",
            "zh": "最佳汇率差(%)"
        },
        "myOrders": {
            "en": "My orders",
            "fr": "Mes commandes",
            "it": "I miei ordini",
            "ja": "自分の注文",
            "ru": "Мои ордера",
            "tr": "Komutlarım",
            "uk": "Мої ордера",
            "zh": "我的 订单"
        },
        "orders": {
            "en": "Orders",
            "fr": "Commandes",
            "it": "Ordini",
            "ja": "注文",
            "ru": "Ордера",
            "tr": "Komutlar",
            "uk": "Ордера",
            "zh": "订单"
        },
        "button_cancelClosing": {
            "en": "Cancel PMA closing request",
            "fr": "Annuler la demande de clôture PMA",
            "it": "Annulla la richiesta di chiusura PMA",
            "ja": "PMA締め切りリクエストのキャンセル",
            "ru": "Отменить закрытие PMA",
            "tr": "PMA kapanışı talebini iptal et",
            "uk": "Відмінити закриття PMA",
            "zh": "取消PMA关闭请求"
        },
        "signupWarning": {
            "en": "Please deactivate the translation plugin in your browser and select the correct language from the list above. Using plugins can cause errors in the terminal and lead to loss of tokens.",
            "ru": "Пожалуйста, деактивируйте плагин перевода в своем браузере и выберите правильный язык из списка выше. Использование плагинов может вызвать ошибки в терминале и привести к потере токенов.",
            "fr": "Veuillez désactiver le plugin de traduction dans votre navigateur et sélectionner la bonne langue dans la liste ci-dessus. L'utilisation de plugins peut provoquer des erreurs dans le terminal et entraîner la perte de jetons.",
            "it": "Disattiva il plug-in di traduzione nel tuo browser e seleziona la lingua corretta dall'elenco sopra. L'utilizzo di plugin può causare errori nel terminale e portare alla perdita di token.",
            "ja": "ブラウザで翻訳プラグインを無効にして、上記のリストから正しい言語を選択してください。 プラグインを使用すると、端末でエラーが発生し、トークンが失われる可能性があります。",
            "ko": "브라우저에서 번역 플러그인을 비활성화하고 위 목록에서 올바른 언어를 선택하십시오. 플러그인을 사용하면 터미널에 오류가 발생하고 토큰이 손실 될 수 있습니다.",
            "tr": "Lütfen tarayıcınızdaki çeviri eklentisini devre dışı bırakın ve yukarıdaki listeden doğru dili seçin. Eklenti kullanmak, terminalde hatalara ve token kaybına neden olabilir.",
            "uk": "Будь ласка, деактивуйте плагін перекладу у своєму браузері та виберіть правильну мову зі списку вище. Використання плагінів може спричинити помилки в терміналі та призвести до втрати токенів.",
            "zh": "请停用浏览器中的翻译插件， 然后从上面的列表中选择正确的语言。 使用插件会导致终端错误并导致令牌丢失。"
        },
        "tradingView": {
            "en": "TradingView"
        },
        "bidAsk": {
            "en": "Bid/Ask"
        },
        "useInfinityOrder": {
            "en": "Repeat position",
            "ru": "Повторять позицию"
        },
        "infinityOrder_description": {
            "en": "Infinity Order: when takeprofit is executed, the original order will be placed again with exactly same price and volume. The cycle will continue until position cancellation or stoploss/trailing stop activation.",
            "ru": "Бесконечный ордер: После исполнения тейкпрофита будет перевыставлен исходный ордер с исходным объемом и ценой. Цикл будет повторяться до отмены ордера вручную или срабатывания тригера стоплосса / трейлингстопа."
        },
        "unrealizedPL": {
            "en": "Unrealized Profit/Loss",
            "fr": "Bénéfice / perte non réalisé",
            "it": "Guadagni non realizzati/Perdite",
            "ja": "未実現利益/損失",
            "ru": "Нереализованная прибыль/убыток",
            "tr": "Gerçekleşmemiş Kâr/Zarar",
            "uk": "Нереалізований прибуток/збиток",
            "zh": "未实现损益"
        },
        "unrealizedPL_TH": {
            "en": "Un.P/L"
        },
	    "crosschainWarning": {
	        "en" : "WARNING! You must send a {0} transaction on the  [blockchains.{1}] blockchain, or transferred amount will be lost!",
	        "ru" : "Внимание! Отправляйте {0} транзакцию только на блокчейне [blockchains.{1}], иначе посланные средства будут потеряны!"
        },
	    "never": {
	        "en" : "Never",
	        "ru" : "Никогда"
        },
	    "button_showRules": {
	        "en" : "Show rules",
	        "ru" : "Показать правила"
        },
	    "button_closeAllDeposits": {
	        "en" : "Close all deposits",
	        "ru" : "Закрыть все депозиты"
        },
	    "pmaCloseAllDeposits": {
	        "en" : "Withdraw all deposits from PMA {pmaid}",
	        "ru" : "Вывести все депозиты с PMA {pmaid}"
        },
	    "place": {
	        "en" : "Place",
	        "ru" : "Место"
        },
	    "contestRules": {
	        "en" : "Contest rules",
	        "ru" : "Правила конкурса"
        },
	    "qualification": {
	        "en" : "Qualification",
	        "ru" : "Квалификация"
        },
	    "minVol": {
	        "en" : "Minimum volume",
	        "ru" : "Минимальный объем"
        },
	    "minTrades": {
	        "en" : "Minimum number of trades",
	        "ru" : "Минимальное количество сделок"
        },
	    "myStats": {
	        "en" : "My statistic",
	        "ru" : "Моя статистика"
        },
        "amountOfDeals": {
            "en": "Amount of deals",
            "ru": "Количество сделок"
        },
        "averageProfitPercent": {
            "en": "Average profit",
            "ru": "Средняя прибыль"
        },
        "rating": {
            "en": "Rating",
            "ru": "Рейтинг"
        },
        "contestStates": {
        },
        "showOrders": {
            "en": "Show orders",
            "ru": "Показать ордера"
        },
        "logoutAll": {
            "en": "Logout from all",
            "fr": "Se déconnecter de tout",
            "it": "Esci da tutto",
            "ja": "全てからログアウト",
            "ru": "Выйти со всех устройств",
            "tr": "Tümünden çıkış yap",
            "uk": "Вийти з усіх пристроїв",
            "zh": "全部注销"
        },
        "logout": {
            "en": "Logout",
            "fr": "Se déconnecter",
            "it": "Disconnettersi",
            "ja": "ログアウト",
            "ko": "로그 아웃",
            "ru": "Выйти",
            "tr": "Çıkış yap",
            "uk": "Вийти",
            "zh": "退出登陆"
        },
        "button_cancelUnusedPart": {
            "en": "Cancel unused part",
            "ru": "Отменить неиспользуемую часть"
        },
        "multiplicatorDeposit": {
            "en": "ATTENTION! This token has a multiplier {multiplicator}, which means that your balance will be credited with {multiplicator} times less tokens than the original amount in blockchain transaction.",
            "ru": "ВНИМАНИЕ данный токен имеет мультипликатор = {multiplicator}, это означает что на баланс вам зачислится количество токенов / {multiplicator} от того, которое вы отправили по blockchain."
        },
        "multiplicatorWithdrawal": {
            "en": "ATTENTION! This token has a multiplier {multiplicator}, which means that you will transfer {multiplicator} times more tokens than specified in this form.",
            "ru": "ВНИМАНИЕ данный токен имеет мультипликатор = {multiplicator}, это означает что вы совершите перевод на указанное в данной форме количество * {multiplicator}"
        },
        "lend": {
            "en": "Lend",
            "ru": "Одолжить"
        },
        "lendingHistory_tab": {
            "en": "Lending history",
            "ru": "История займов"
        },
        "showHistory": {
            "en": "Show history",
            "ru": "Показать историю"
        },
        "hideHistory": {
            "en": "Hide history",
            "ru": "Спрятать историю"
        },
        "lendingOrderbook": {
            "en": "Lending orderbook ({sym})",
            "ru": "Ордербук займов {sym}"
        },
        "timePayBack": {
            "en": "Pay back time",
            "ru": "Дата возврата"
        },
        "availableForYou": {
            "en": "Available for you",
            "ru": "Доступно для вас"
        },
        "recommendedForYou": {
            "en": "Recommended for you",
            "ru": "Рекомендовано для вас"
        },
        "availableTotal": {
            "en": "Available total",
            "ru": "Доступно всего"
        },
        "dailyFee": {
            "en": "Daily fee",
            "ru": "Стоимость в день"
        },
        "loanFee": {
            "en": "Loan fee",
            "ru": "Ком. кредита"
        },
        "loanPayBack": {
            "en": "Loan repayment",
            "ru": "Возврат долга"
        },
        "loanStatus": {},
        "lendingStatus": {},

        "orderStatus": {},
        "marginLevel": {
            "en": "Margin Level",
            "ru": "Margin Level"
        },
        "marginLevel_description": {
            "en": "Margin Level - the trusted coin ({loanSecuritiesSymString}) percentage amount that is higher than the loan amount. If this value drops to 20% then 'Margin Call' will activate, forcing trades to pay back the loan.",
            "ru": "Margin Level - это насколько сумма ваших трастовых монет ({loanSecuritiesSymString}) на балансе превышает сумму займа, если значение упадет до 20%, то случится 'Margin Call' - принудительный выкуп и возврат заемных средств"
        },
        "feeReceived": {
            "en": "Received fees",
            "ru": "Получено комиссий"
        },
        "feeReceived_TH": {
            "en": "Profit",
            "ru": "Прибыль"
        },
        "lendingAvailable": {
            "en": "Available for lending",
            "ru": "Можно отдать в долг"
        },
        "loanMy": {
            "en": "My {sym} Loans",
            "ru": "Мои Займы {sym}"
        },
        "loanList": {
            "en": "Available loans",
            "ru": "Доступные займы"
        },
        "loanProvision": {
            "en": "Loan provision",
            "ru": "Предоставление займа"
        },
        "loanGet": {
            "en": "Get loan",
            "ru": "Взять средства в займ"
        },
        "loans": {
            "en": "Loans",
            "ru": "Займы"
        },
        "currentLoans": {
            "en": "Current loans",
            "ru": "Текущие займы"
        },
        "lendingCancellation": {
            "en": "Lending Cancellation",
            "ru": "Отмена лендинга токенов"
        },
        "button_lend": {
            "en": "Lend {sym}",
            "ru": "Одолжить {sym}"
        },
        "button_loanPayBack": {
            "en": "Pay back loan",
            "ru": "Вернуть долг"
        },
        "created": {
            "en": "Created",
            "ru": "Создан"
        },
        "registrationDate": {
            "en": "Registration date",
            "fr": "Date d'inscription",
            "it": "Data di registrazione",
            "ja": "登録日",
            "ru": "Дата создания",
            "tr": "Kayıt tarihi",
            "uk": "Дата створення",
            "zh": "注册日期"
        },
        "created_TH": {
            "en": "Created",
            "fr": "Créé",
            "it": "Creato",
            "ja": "作成",
            "ru": "Создан",
            "tr": "Oluşturuldu",
            "uk": "Створений",
            "zh": "创建"
        },
        "yieldAnnual": {
            "en": "Annual Yield(%)",
            "ru": "Доходность в год(%)"
        },
        "yieldMonthly": {
            "en": "Monthly Yield(%)",
            "ru": "Доходность в месяц(%)"
        },
        "yieldDaily": {
            "en": "Daily Yield(%)",
            "ru": "Доходность в день(%)"
        },
        "yieldHourly": {
            "en": "Hourly Yield(%)",
            "ru": "Доходность в час(%)"
        },
		"loanDailyInterest": {
			"en": "Loan daily interest",
			"ru": "Дневные проценты по займу"
		},
        "message": {
            "en": "Message",
            "ru": "Сообщение"
        },
        "messages": {
            "en": "Messages",
            "ru": "Сообщения"
        },
        "menu": {
            "en": "Menu",
            "ru": "Меню"
        },
        "need_confirmations": {
            "en": "Number of network confirmations needed for the depositing",
            "ru": "Число подтверждений сети, нужное для зачисления"
        },
        "walletTitle": {
            "en": "{title} {sym} wallet",
            "fr": "Portefeuille {title} ({sym})",
            "it": "{title} {sym} portafoglio",
            "ja": "{title} {sym}ウォレット",
            "ru": "{title} {sym} кошелек",
            "tr": "{title} {sym} cüzdanı",
            "uk": "{title} {sym} гаманець",
            "zh": "{title} {sym} 钱包"
        },
        "infoTitle": {
            "en": "{title} ({sym}) Information",
            "fr": "Information {title} ({sym})",
            "it": "{title} ({sym}) Info",
            "ja": "{title}({sym})情報",
            "ru": "Информация о {title} ({sym})",
            "zh": "{title} ({sym}) 信息"
        },
        "publicKey": {
            "en": "Public Key",
            "ru": "Публичный ключ"
        },
		"staking_base": {
			"en": "{sym} amount valid for Staking Reward",
			"ru": "Количество {sym} валидное для стейкинга:"
		},
        "button_showAllSymPairs": {
            "en": "Show all pairs with {sym}",
            "fr": "Afficher toutes les paires avec {sym}",
            "it": "Mostra tutte le coppie con {sym}",
            "ja": "{sym}の全てのペアを表示",
            "ru": "Показать все пары с {sym}",
            "tr": "{sym} öğesi ile tüm çiftleri göster",
            "uk": "Показати всі пари з {sym}",
            "zh": "显示所有配对{sym}"
        },
        "button_hideAllSymPairs": {
            "en": "Hide all pairs with {sym}",
            "fr": "Masquer toutes les paires avec {sym}",
            "it": "Nascondi tutte le coppie con {sym}",
            "ru": "Скрыть все пары с {sym}",
            "tr": "{sym} öğesi ile tüm çiftleri gizle"
        },

        "dailyFeeMax": {
            "en": "Daily fee, no more than",
            "ru": "Стоимость в день, не более"
        },
        "button_loanGet": {
            "en": "Get {sym} loan",
            "ru": "Занять {sym}"
        },
        "borrowed": {
            "en": "Borrowed",
            "ru": "Заемные"
        },
        "borrowedFunds": {
            "en": "Borrowed funds",
            "ru": "Заемные средства"
        },
        "lending": {
            "en": "Lending",
            "ru": "Лендинг"
        },
        "lent": {
            "en": "Lent",
            "ru": "Одолжено"
        },
        "lentFunds": {
            "en": "Lent funds",
            "ru": "Одолженные средства"
        },
        "own": {
            "en": "Own",
            "ru": "Собственные"
        },
        "ownFunds": {
            "en": "Own funds",
            "ru": "Собственные средства"
        },
		"wotp": {
			"en": "Withdrawal OTP (WOTP)",
			"fr": "OTP de retrait (WOTP)",
			"it": "Prelievo OTP (WOTP)",
			"ja": "出金OTP（WOTP）",
			"ru": "Дополнительный Код 2FA(WOTP)",
			"tr": "Para çekilen OTP (WOTP)",
			"uk": "Додатковий Код 2FA (WOTP)",
			"zh": "提取OTP（WOTP）"
		},
		"addNewWallet": {
			"en": "Add new wallet",
			"fr": "Ajouter un nouveau portefeuille",
			"it": "Aggiungi nuovo portafoglio",
			"ja": "新しいウォレットを追加",
			"ru": "Добавить новый кошелек",
			"tr": "Yeni cüzdan ekle",
			"uk": "Додати новий гаманець",
			"zh": "添加新钱包"
		},
		"removeWallet": {
			"en": "Remove wallet",
			"ru": "Удалить кошелек"
		},
		"button_activate": {
			"en": "Activate",
			"fr": "Activer",
			"it": "Attivare",
			"ja": "有効化する",
			"ru": "Активировать",
			"tr": "Etkinleştir",
			"uk": "Активувати",
			"zh": "激活"
		},
		"button_add": {
			"en": "Add",
			"fr": "Ajouter",
			"it": "Aggiungi",
			"ja": "追加",
			"ru": "Добавить",
			"tr": "Ekle",
			"uk": "Додати",
			"zh": "添加"
		},
		"button_clear": {
			"en": "Clear",
			"fr": "Effacer",
			"it": "Rimuovi",
			"ja": "クリア",
			"ru": "Очистить",
			"tr": "Temizle",
			"uk": "Очистити",
			"zh": "清除"
		},
		"button_info": {
			"en": "Info",
			"fr": "Information",
			"it": "Info",
			"ja": "情報",
			"ru": "Подробнее",
			"tr": "Bilgi",
			"uk": "Детальніше",
			"zh": "信息"
		},
		"button_cancelOrders": {
			"en": "Cancel all [bs.order.{bs}] {sym} orders",
			"fr": "Annuler toutes les commandes [bs.order.{bs}] {sym}",
			"it": "Annulla tutti gli ordini [bs.order.{bs}] {sym}",
			"ja": "全ての[bs.order.{bs}] {sym}の注文をキャンセル",
			"ko": "모든 [bs.order.{bs}] {sym} 주문 취소",
			"ru": "Отменить все {sym} ордера [bs.order.{bs}]",
			"tr": "Tüm [bs.order.{bs}] {sym} komutlarını iptal et",
			"uk": "Відмінити всі {sym} ордера [bs.order.{bs}]",
			"zh": "取消所有[bs.order.{bs}] {sym} 订单"
		},
		"createOrder": {
			"en": "Create order",
			"fr": "Créer une commande",
			"it": "Creare un ordine",
			"ja": "注文を作成",
			"ru": "Создать ордер",
			"tr": "Komut oluştur",
			"uk": "Створити ордер",
			"zh": "创建订单"
		},
		"coins_info": {
			"en": "Coins info",
			"fr": "Informations sur les monnaies",
			"it": "Informazioni sulle monete",
			"ja": "コインの情報",
			"ko": "동전 정보",
			"ru": "Информация о монетах",
			"tr": "Coin bilgileri",
			"uk": "Інформація про монети",
			"zh": "硬币信息"
		},
		"EWA_label": {
			"en": "{sym} Emergency Withdrawal Address (EWA)",
			"fr": "{sym} Adresse de retrait d'urgence (EWA)",
			"it": "{sym} Indirizzo per il ritiro di emergenza (EWA)",
			"ja": "{sym}の緊急出金アドレス(EWA)",
			"ru": "{sym} Адрес Аварийного Вывода (EWA)",
			"tr": "{sym} Acil Durum Para Çekme Adresi (EWA)",
			"uk": "{sym} Адреса Аварійного Виведення (EWA)",
			"zh": "{sym}紧急取款地址（EWA）"
		},
		"EWA_TH": {
			"en": "EWA"
		},
		"transaction": {
			"en": "Transaction",
			"fr": "Transaction",
			"it": "Transazione",
			"ja": "トランザクション",
			"ru": "Транзакция",
			"tr": "İşlem",
			"uk": "Транзакція",
			"zh": "交易"
		},
		"changePassword": {
			"en": "Change password",
			"fr": "Modifier le mot de passe",
			"it": "Cambia password",
			"ja": "パスワードを変更",
			"ru": "Сменить пароль",
			"tr": "Parolayı değiştir",
			"uk": "Змінити пароль",
			"zh": "更改密码"
		},
		"confirmationEmail": {
			"en": "Email confirmation",
			"fr": "Email de confirmation",
			"it": "Conferma via email",
			"ja": "メールの確認",
			"ru": "Подтверждение email",
			"tr": "E-posta onayı",
			"uk": "Підтвердження Email",
			"zh": "电子邮件确认"
		},
		"confirmEmail": {
			"en": "Confirm email",
			"fr": "Confirmez votre e-mail",
			"it": "Conferma email",
			"ja": "メールアドレスを確認",
			"ko": "전자메일 확인",
			"ru": "Подтвердите email",
			"tr": "E-postayı onaylayın",
			"uk": "Підтвердження email",
			"zh": "确认电子邮件"
		},
		"createApiKey": {
			"en": "Create API key",
			"fr": "Créer une clé API",
			"it": "Crea chiave API",
			"ja": "APIキーを作成",
			"ko": "API 키 생성",
			"ru": "Создать API ключ",
			"tr": "API anahtarını oluşturun",
			"uk": "Створити API ключ",
			"zh": "创建API密钥"
		},
		"deleteApiKey": {
			"en": "Delete API key",
			"fr": "Supprimer la clé API",
			"it": "Elimina chiave API",
			"ja": "APIキーを削除",
			"ru": "Удалить API ключ",
			"tr": "API anahtarını sil",
			"uk": "Видалити API ключ",
			"zh": "删除API密钥"
		},
		"depositInfo": {
			"en": "Deposit info",
			"fr": "Informations sur le dépôt",
			"it": "Informazioni sul deposito",
			"ja": "入金情報",
			"ru": "Пополнение счета",
			"tr": "Para yatırma bilgileri",
			"uk": "Поповнення рахунку",
			"zh": "存款信息"
		},
		"ipWhitelist": {
			"en": "IP whitelist",
			"fr": "Liste blanche IP",
			"it": "Lista bianca IP",
			"ja": "IPホワイトリスト",
			"ko": "IP 화이트리스트",
			"ru": "Белый список IP",
			"tr": "IP beyaz listesi",
			"uk": "Білий список IP",
			"zh": "IP白名单"
		},
		"editApiKey": {
			"en": "Edit API key",
			"fr": "Modifier la clé API",
			"it": "Modifica chiave API",
			"ja": "APIキーを編集",
			"ko": "API 키 수정",
			"ru": "Редактировать API ключ",
			"tr": "API anahtarını düzenle",
			"uk": "Редагувати API ключ",
			"zh": "编辑API密钥"
		},
		"getPasswordChangeCode": {
			"en": "Request a code to change the password",
			"fr": "Demander un code pour changer le mot de passe",
			"it": "Richiedi un codice per modificare la password",
			"ja": "パスワード変更のコードをリクエスト",
			"ko": "비밀번호 변경 코드 요청",
			"ru": "Запросить код на смену пароля",
			"tr": "Paraloyı değiştirmek için kod isteyin",
			"uk": "Запросити код на зміну пароля",
			"zh": "请求更改密码验证码"
		},
		"help_header": {
			"en": "HELP:",
			"fr": "AIDE:",
			"it": "AIUTO:",
			"ja": "ヘルプ：",
			"ru": "Справка: ",
			"tr": "YARDIM:",
			"uk": "Довідка:",
			"zh": "帮助："
		},
		"defaultSettings": {
			"en": "Default settings",
			"fr": "Paramètres par défaut",
			"it": "Impostazioni predefinite",
			"ja": "デフォルト設定",
			"ru": "Настройки по умолчанию",
			"tr": "Varsayılan ayarlar",
			"uk": "Налаштування за замовчуванням",
			"zh": "默认设置"
		},
		"cancelAllOrders": {
			"en": "Cancel all {type} [bs.order.{bs}] orders",
			"fr": "Annuler toutes les commandes de type {type} [bs.order.{bs}]",
			"it": "Annulla tutti gli ordini di {type} [bs.order.{bs}]",
			"ja": "全ての{type} [bs.order.{bs}]の注文をキャンセル",
			"ru": "Отмена всех {type} ордеров [bs.order.{bs}]",
			"tr": "Tüm {type} [bs.order.{bs}] komutlarını iptal edin",
			"uk": "Відміна всіх {type} ордерів [bs.order.{bs}]",
			"zh": "取消所有{type}[bs.order.{bs}]订单"
		},
		"button_confirmMassCancellation": {
		"deprecated": "deprecated",
			"en": "Yes, cancel all {type} [bs.order.{bs}] orders",
			"fr": "Oui, annulez toutes les commandes de type {type} [bs.order.{bs}]",
			"it": "Sì, annulla tutti gli ordini di {type} [bs.order.{bs}]",
			"ja": "はい、全ての{type}の[bs.order.{bs}]の注文をキャンセルします",
			"ru": "Да, отменить все {type} ордера [bs.order.{bs}]",
			"tr": "Evet, tüm {type} [bs.order.{bs}] komutlarını iptal et",
			"uk": "Так, відмінити всі {type} ордера [bs.order.{bs}]",
			"zh": "是，取消所有{type}[bs.order.{bs}]订单"
		},
		"button_nextStep": {
			"en": "Next step",
			"fr": "L'étape suivante",
			"it": "Passo successivo",
			"ja": "次のステップ",
			"ru": "Следующий шаг",
			"tr": "Sonraki adım",
			"uk": "Наступний крок",
			"zh": "下一步"
		},
		"orderEdit_header": {
			"en": "Edit {o_type} [bs.order.{bs}] order {o_id} ",
			"fr": "Modifier la commande {o_type} [bs.order.{bs}] {o_id}",
			"it": "Modificare {o_type} [bs.order.{bs}] ordine {o_id}",
			"ja": "{o_type} [bs.order.{bs}]注文{o_id}の編集",
			"ru": "Изменить {o_type} ордер [bs.order.{bs}] {o_id}",
			"tr": "{o_type} [bs.order.{bs}] komutunu {o_id} düzenleyin",
			"uk": "Змінити {o_type} ордер [bs.order.{bs}] {o_id}",
			"zh": "编辑{o_type}[bs.order.{bs}]订单{o_id}"
		},
		"otpChange": {
			"en": "Change 2FA OTP SEED Private Key",
			"fr": "Modifier la clé privée 2FA OTP SEED",
			"it": "Modifica chiave privata OFA SEED 2FA",
			"ja": "2FA OTPシード秘密鍵の変更",
			"ru": "Смена приватного ключа 2FA (Seed)",
			"tr": "2FA OTP SEED Özel Anahtarını Değiştir",
			"uk": "Зміна приватного ключа 2FA (Seed)",
			"zh": "更改2FA OTP SEED 私钥"
		},
		"otpDisable": {
			"en": "Disable 2FA",
			"fr": "Désactiver 2FA",
			"it": "Disabilita 2FA",
			"ja": "2FAを無効にする",
			"ko": "2FA 사용안함",
			"ru": "Отключение 2FA",
			"tr": "2FA'yı devre dışı bırak",
			"uk": "Відключення 2FA",
			"zh": "禁用2FA"
		},
		"otpEnable": {
			"en": "Enable 2FA OTP",
			"fr": "Activer 2FA OTP",
			"it": "Abilita OTP 2FA",
			"ja": "2FA OTPを有効にする",
			"ko": "2FA 사용",
			"ru": "Включение 2FA",
			"tr": "2FA OTP'yi etkinleştir",
			"uk": "Включення 2FA",
			"zh": "启用2FA OTP"
		},
		"button_depositPma": {
			"en": "Deposit to this PMA",
			"fr": "Déposer dans ce PMA",
			"it": "Deposito a questa PMA",
			"ja": "このPMAに入金する",
			"ru": "Сделать депозит в этот PMA",
			"tr": "Bu PMA'ya para yatırın",
			"uk": "Зробити депозит в цей PMA",
			"zh": "存入本PMA"
		},
		"profitRate": {
			"en": "Profit per 1 {sym}",
			"fr": "Bénéfice pour 1 {sym}",
			"it": "Guadagno per 1 {sym}",
			"ja": "1 {sym}あたりの利益",
			"ru": "Прибыль с 1 {sym}",
			"tr": "1 {sym} başına kâr",
			"uk": "Прибуток з 1 {sym}",
			"zh": "每1{sym}利润"
		},
		"totalBuyVol": {
			"en": "Total amount bought",
			"fr": "Montant total acheté",
			"it": "Importo totale acquistato",
			"ja": "購入した合計価格",
			"ru": "Общий объем покупок",
			"tr": "Toplam alınan miktar",
			"uk": "Загальний обсяг покупок",
			"zh": "购买总额"
		},
		"totalSellVol": {
			"en": "Total amount sold",
			"fr": "Montant total vendu",
			"it": "Importo totale venduto",
			"ja": "合計販売額",
			"ru": "Общий объем продаж",
			"tr": "Toplam satılan miktar",
			"uk": "Загальний обсяг продажів",
			"zh": "销售总额"
		},
		"averageBuyPrice": {
			"en": "Average purchase price",
			"fr": "Prix d'achat moyen",
			"it": "Prezzo medio d'acquisto",
			"ja": "平均購入価格",
			"ru": "Средняя цена покупки",
			"tr": "Ortalama satın alma fiyatı",
			"uk": "Середня ціна покупки",
			"zh": "平均购买价格"
		},
		"averageSellPrice": {
			"en": "Average sell price",
			"fr": "Prix de vente moyen",
			"it": "Prezzo medio di vendita",
			"ja": "平均販売価格",
			"ru": "Средняя цена продажи",
			"tr": "Ortalama satış fiyatı",
			"uk": "Середня ціна продажу",
			"zh": "平均售价"
		},
		"profitInSym": {
			"en": "Profit in {sym}",
			"fr": "Bénéfices en {sym}",
			"it": "Guadagni in {sym}",
			"ja": "{sym}での利益",
			"ru": "Прибыль в {sym}",
			"tr": "{sym} içinde kâr",
			"uk": "Прибуток в {sym}",
			"zh": "利润{sym}"
		},
		"emergencyWithdrawal": {
			"en": "Emergency Account Termination and Withdrawal",
			"fr": "Résiliation et retrait d'urgence d'un compte",
			"it": "Chiusura e prelievo del conto di emergenza",
			"ja": "緊急アカウント終了と出金",
			"ru": "Аварийное Закрытие Аккаунта и вывод токенов",
			"tr": "Acil Durum Hesabını Sonlandırma ve Para Çekme",
			"uk": "Аварійне Закриття Акаунта і виведення токенів",
			"zh": "紧急账户终止和撤销"
		},
		"havepromo": {
			"en": "Use promo code",
			"fr": "Utiliser un code promo",
			"it": "Usa il codice promozionale",
			"ja": "プロモコードを使用",
			"ko": "프로모션이 있습니다",
			"ru": "Использовать промокод",
			"tr": "Promosyon kodunu kullan",
			"uk": "Використати промокод",
			"zh": "使用促销代码"
		},
		"wd_delay": {
			"en": "Withdrawal delay",
			"fr": "Retard de retrait",
			"it": "Ritardo di prelievo",
			"ja": "出金遅延",
			"ru": "Задержка вывода токенов",
			"tr": "Para çekme işleminde erteleme",
			"uk": "Затримка виведення токенів",
			"zh": "取款延迟"
		},
		"withdrawalInfo": {
			"en": "Withdrawal info",
			"fr": "Informations de retrait",
			"it": "Informazioni sul prelievo",
			"ja": "出金情報",
			"ru": "Вывод средств",
			"tr": "Para çekme bilgileri",
			"uk": "Виведення коштів",
			"zh": "取款信息"
		},
		"withdrawalCancellation": {
			"en": "Withdrawal order cancellation",
			"fr": "Annulation de l'ordre de retrait",
			"it": "Annullamento dell'ordine di prelievo",
			"ja": "出金注文のキャンセル",
			"ru": "Отмена вывода токенов",
			"tr": "Para çekme komutunun iptali",
			"uk": "Відміна виведення токенів"
		},
        "withdrawalCancellation_description": {
            "en": "Your withdrawal order {oid} for {amount} {symbol} will be cancelled.",
            "fr": "Votre commande de retrait {oid} pour {amount} {symbol} sera annulée.",
            "it": "Il tuo ordine di prelievo {oid} per {amount} {symbol} verrà annullato.",
            "ja": "{vol} {symbol}の出金注文{oid}はキャンセルされます。",
            "ru": "Ваш ордер {oid} на вывод {amount} {symbol} будет отменен.",
            "tr": "{amount} {symbol} için para çekme komutunuz {oid} iptal edilecektir.",
            "uk": "Ваш ордер {oid} на виведення {amount} {symbol} буде відмінений.",
            "zh": "您的{amount}{symbol}提款单{oid}将被取消。"
		},
		"wotpDisable": {
			"en": "Disable WOTP",
			"fr": "Désactiver WOTP",
			"it": "Disattiva WOTP",
			"ja": "WOTPを無効にする",
			"ko": "WOTP 사용안함",
			"ru": "Отключение WOTP",
			"tr": "WOTP öğesini devre dışı bırakma",
			"uk": "Відключення WOTP",
			"zh": "禁用WOTP"
		},
		"wotpEnable": {
			"en": "Enable Withwrawal OTP (WOTP)",
			"fr": "Activer Withwrawal OTP (WOTP)",
			"it": "Attiva Prelievi OTP (WOTP)",
			"ja": "出金OTP (WOTP)を有効にする",
			"ko": "WOTP 사용",
			"ru": "Включение WOTP",
			"tr": "Para çekme OTP'sini (WOTP) etkinleştirme",
			"uk": "Включення WOTP",
			"zh": "启用Wrawal OTP（WOTP）"
		},
        "telegramDelete": {
            "en": "Disconnect Telegram User",
            "ru": "Отключить пользователя Telegram"
        },
        "telegramNotification": {
            "en": "Telegram messenger user notification",
            "ru": "Уведомления пользователю в Telegram"
        },
        "telegramNotificationList": {
            "en": "Connected Telegram users",
            "ru": "Присоединенные Telegram аккаунты"
        },
        "telegramNotificationList_description": {
            "en": "The Security Pack is provided free of charge for your MAIN Telegram account only. You may subscribe to the Security Pack on the additional accounts at a regular charge.",
            "ru": "Пакет Безопасности предоставляется бесплатно для ГЛАВНОГО аккаунта. Вы можете также подписаться на Пакет Безопасности для дополнительных аккаунтов на платной основе."
        },
        "notifyFor": {
            "en": "Notify for the following:",
            "ru": "Уведомлять о следующем:"
        },
        "enterManually": {
            "en": "Please enter manually",
            "ru": "Введите вручную"
        },
        "2fakey": {
            "en": "Secret 2FA SEED KEY",
            "fr": "2FA SEED KEY secret",
            "it": "2FA SEED KEY segreta",
            "ja": "シークレット2FAシードキー",
            "ru": "Секретный ключ 2FA",
            "tr": "Gizli 2FA SEED ANAHTARI",
            "uk": "Секретний ключ 2FA",
            "zh": "秘密2FA SEE 钥匙"
        },
        "2faotp": {
            "en": "2FA OTP",
            "fr": "2FA OTP",
            "it": "2FA OTP",
            "ja": "2FA OTP",
            "ru": "2FA пароль",
            "tr": "2FA OTP",
            "uk": "2FA пароль",
            "zh": "2FA OTP"
        },
        "2faotp_placeholder": {
            "en": "Enter 2FA 6-digit OTP",
            "fr": "Saisir l'OTP de 6 chiffres du 2FA",
            "it": "Inserire OTP a 6 cifre del 2FA",
            "ja": "2FAの6桁のOTPを入力",
            "ru": "Введите однократный пароль 2FA (6 цифр)",
            "tr": "2FA 6 haneli OTP'yi girin",
            "uk": "Введіть одноразовий пароль 2FA (6 цифр)",
            "zh": "输入2FA 6位OTP"
        },
        "OCOgroup": {
            "en": "OCO Group",
            "fr": "Groupe OCO",
            "it": "Gruppo OCO",
            "ja": "OCOグループ",
            "ru": "Группа OCO",
            "tr": "OCO Grubu",
            "uk": "Група OCO",
            "zh": "OCO集团"
        },
        "OCOgroup_description": {
            "en": "OCO ORDERS (OneCancelOthers) are the group of ORDERS where any full or partial execution of any ORDER in this group will cause a cancellation of all other ORDERS in this group.",
            "fr": "Les COMMANDES OCO (OneCancelOthers) sont le groupe de COMMANDES où toute exécution complète ou partielle de toute COMMANDE de ce groupe entraînera l'annulation de toutes les autres COMMANDES de ce groupe.",
            "it": "ORDINI OCO (OneCancelOthers) sono il gruppo di ORDINI in cui qualsiasi esecuzione completa o parziale di qualsiasi ORDINE in questo gruppo provocherà la cancellazione di tutti gli altri ORDINI in questo gruppo.",
            "ja": "OCO（OneCancelOthers）は注文の一種であり、そのグループ内で、ある注文の全体または一部が実行された場合には、残りの注文は全てキャンセルされます。",
            "tr": "OCO KOMUTLARI (OneCancelOthers (DiğerleriniİptalEden)), bu gruptaki herhangi bir KOMUT'un tam veya kısmi yürütülmesinin, bu gruptaki diğer KOMUTLARIN iptaline neden olacağı KOMUTLAR grubudur.",
            "uk": "OCO ORDERS (OneCancelOthers) - це група ОРДЕРІВ, де будь-яке повне або часткове виконання будь-якого ОРДЕРА в цій групі призведе до скасування всіх інших ОРДЕРІВ у цій групі.",
            "zh": "OCO订单(onecancelothers)是一组订单，其中任何全部或部分执行该组中的任何订单都将导致取消该组中的所有其他订单。"
        },
        "account_name": {
            "en": "Account name",
            "fr": "Nom du compte",
            "it": "Nome dell'account",
            "ja": "アカウント名",
            "ru": "Название аккаунта",
            "tr": "Hesap adı",
            "uk": "Назва аккаунта",
            "zh": "帐户名"
        },
        "activate2FA4Withdraw_description": {
            "en": "Please enable 2-factor authentication for withdrawal",
            "fr": "Veuillez activer l'authentification à 2 facteurs pour les prélèvements",
            "it": "Vogliate abilitare l'autenticazione a 2 fattori per i prelevamenti",
            "ja": "出金の二段階認証を有効にしてください。",
            "ko": "출금하려면 OTP 인증을 활성화하십시오",
            "nn": "Ver venleg og aktiver 2-faktor-autentisering for uttak",
            "no": "Vennligst aktiver 2-faktor-autentisering for uttak",
            "ru": "Перед выводом средств, активируйте Двухфакторную авторизацию",
            "tr": "Lütfen para çekme işlemi için 2 faktörlü kimlik doğrulamayı etkinleştirin",
            "uk": "Перед виведенням коштів, активуйте двухфакторну авторизацію",
            "zh": "请启用2代身份验证以退出"
        },
        "all_tab": {
            "en": "All",
            "fr": "Tout",
            "it": "Tutto",
            "ja": "全て",
            "ko": "모두",
            "ru": "Все",
            "tr": "Tümü",
            "uk": "Всі",
            "zh": "全部"
        },
        "total": {
            "en": "Total",
            "fr": "Total",
            "it": "Totale",
            "ja": "合計",
            "ko": "총액",
            "ru": "Всего",
            "tr": "Toplam",
            "uk": "Всього",
            "zh": "总计"
        },
        "apikey": {
            "en": "API key",
            "fr": "Clé API",
            "it": "Chiave API",
            "ja": "APIキー",
            "ko": "API 키",
            "ru": "API-ключ",
            "tr": "API anahtarı",
            "uk": "API-ключ",
            "zh": "API密钥"
        },
        "apikeys": {
            "en": "API keys",
            "fr": "Clés API",
            "it": "Chiavi API",
            "ja": "APIキー",
            "ko": "API 키",
            "ru": "API-ключи",
            "tr": "API anahtarları",
            "uk": "API-ключі",
            "zh": "API密钥们"
        },
        "at": {
            "en": "at",
            "fr": "chez",
            "it": "a",
            "ja": "--",
            "ru": "по",
            "tr": "konumunda",
            "uk": "по",
            "zh": "在"
        },
        "attention": {
            "en": "Attention!",
            "fr": "Attention!",
            "it": "Attenzione!",
            "ja": "注意！",
            "ko": "주의!",
            "ru": "Внимание!",
            "tr": "Dikkat!",
            "uk": "Увага!",
            "zh": "注意！"
        },
        "autoConvert": {
            "en": "Withdraw as Base Token",
            "fr": "Prélever en Jeton de Base",
            "it": "Preleva come gettone di base",
            "ja": "ベーストークンとして出金",
            "ru": "Вывести все в Базовом Токене",
            "tr": "Baz Token Olarak Çek",
            "uk": "Вивести все в Базовому токені",
            "zh": "作为基础代币撤回"
        },
        "autoConvert_description": {
            "en": "Your share in all tokens in the PMA will be automatically converted to Base Token",
            "fr": "Votre part dans tous les jetons du PMA sera automatiquement convertie en Jeton de Base",
            "it": "La tua quota in tutti i gettoni nel PMA verrà automaticamente convertita in gettoni di base",
            "ja": "PMAのすべてのトークンの持ち分は、ベーストークンに自動的に変換されます。",
            "ru": "Ваши доли от всех средств на PMA будут конвертированы по рыночному курсу в Базовый Токен",
            "tr": "PMA'da bulunan tüm tokenlerdeki payınız otomatik olarak Baz Tokene dönüştürülecektir",
            "uk": "Ваші частки від всіх коштів на PMA будуть конвертовані за ринковим курсом в Базовий Токен",
            "zh": "您在PMA中所有代币中的份额将自动转换为基本代币"
        },
        "available_title": {
            "en": "Available balance: {available}",
            "fr": "Solde disponible: {available}",
            "it": "Saldo disponibile: {available}",
            "ja": "利用可能な残高：{available}",
            "ru": "Доступный баланс: {available}",
            "tr": "Kullanılabilir bakiye: {available}",
            "uk": "Доступний баланс: {available}",
            "zh": "可用余额： {available}"
        },
        "basesym": {
            "en": "Base coin",
            "fr": "Monnaie de base",
            "it": "Gettone di base",
            "ja": "ベースコイン",
            "ru": "Базовая монета",
            "tr": "Baz coin",
            "uk": "Базова монета",
            "zh": "假币"
        },
        "brightness": {
            "en": "Brightness",
            "fr": "Luminosité",
            "it": "Luminosità",
            "ja": "明るさ",
            "ru": "Яркость",
            "tr": "Parlaklık",
            "uk": "Яскравість",
            "zh": "亮度"
        },
        "bsType": {
            "en": "Type of transaction",
            "fr": "Type de transaction",
            "it": "Tipo di transazione",
            "ja": "取引の種類",
            "ko": "거래 유형",
            "ru": "Вид сделки",
            "tr": "İşlem türü",
            "uk": "Вид угоди",
            "zh": "交易类型"
        },
        "button_EWAchange": {
            "en": "Change {sym} EWA",
            "fr": "Modifier {sym} EWA",
            "it": "Cambia {sym} EWA",
            "ja": "{sym} EWAを変更",
            "ru": "Изменить {sym} EWA",
            "tr": "{sym} EWA'yı değiştirin",
            "uk": "Змінити {sym} EWA",
            "zh": "更改{sym}EWA"
        },
        "button_EWAset": {
            "en": "Set {sym} EWA",
            "fr": "Définir {sym} EWA",
            "it": "Configura {sym} EWA",
            "ja": "{sym} EWAを設定",
            "ru": "Задать {sym} EWA",
            "tr": "{sym} EWA'yı ayarlayın",
            "uk": "Задати {sym} EWA",
            "zh": "设置{sym}EWA"
        },
        "button_EWAshow": {
            "en": "Show {sym} EWA",
            "fr": "Montrer {sym} EWA",
            "it": "Mostra {sym} EWA",
            "ja": "{sym} EWAを表示",
            "ru": "Показать {sym} EWA",
            "tr": "{sym} EWA'yı göster",
            "uk": "Показати {sym} EWA",
            "zh": "显示{sym}EWA"
        },
        "button_EnterConfirmationCode": {
            "en": "Confirm email",
            "fr": "Confirmation du courriel",
            "it": "Conferma email",
            "ja": "メールアドレスを確認",
            "ru": "Подтвердить email",
            "tr": "E-postayı onaylayın",
            "uk": "Підтвердити email",
            "zh": "确认电子邮件"
        },
        "button_addMore": {
            "en": "Add more",
            "fr": "Ajouter plus",
            "it": "Aggiungi altro",
            "ja": "もっと追加",
            "ru": "Добавить ещё",
            "tr": "Daha fazla ekle",
            "uk": "Додати ще",
            "zh": "添加更多"
        },
        "button_agreeTerms": {
            "en": "I agree with the terms",
            "fr": "Je suis d'accord avec les conditions",
            "it": "Sono d'accordo con le condizioni",
            "ja": "規約に同意する",
            "ru": "Я согласен с правилами",
            "tr": "Şartlara katılıyorum",
            "uk": "Я згоден з правилами",
            "zh": "我同意这些条款"
        },
        "button_buy": {
            "en": "Buy {sym1}",
            "fr": "Acheter {sym1}",
            "it": "Acquista {sym1}",
            "ja": "{sym1}を購入",
            "ko": "매수하다 {sym1}",
            "ru": "Купить {sym1}",
            "tr": "Satın al {sym1}",
            "uk": "Купити {sym1}",
            "zh": "购买{sym1}"
        },
        "button_cancelTransaction": {
            "en": "Cancel this transaction",
            "fr": "Annuler cette transaction",
            "it": "Annulla questa transazione",
            "ja": "この取引をキャンセルする",
            "ru": "Отменить эту транзакцию",
            "tr": "Bu işlemi iptal et",
            "uk": "Відмінити цю транзакцію",
            "zh": "取消此交易"
        },
        "button_copyPosition": {
            "en": "Copy position",
            "fr": "Copier la position",
            "it": "Copia posizione",
            "ja": "ポジションをコピー",
            "ru": "Копировать позицию",
            "tr": "Kopyalama konumu",
            "uk": "Копіювати позицію",
            "zh": "复制位置"
        },
        "button_deleteOrder": {
            "en": "Close this order",
            "fr": "Fermer cette commande",
            "it": "Chiudi questo ordine",
            "ja": "この注文を終える",
            "ru": "Закрыть этот ордер",
            "tr": "Bu komutu kapat",
            "uk": "Закрити цей ордер",
            "zh": "关闭此订单"
        },
        "button_deposit": {
            "en": "Deposit",
            "fr": "Déposer",
            "it": "Depositare",
            "ja": "入金",
            "ru": "Депозит",
            "tr": "Mevduat",
            "uk": "Депозит",
            "zh": "存款"
        },
        "button_disable": {
            "en": "Disable",
            "fr": "Désactiver",
            "it": "Disabilitare",
            "ja": "無効にする",
            "ko": "사용 안함",
            "ru": "Отключить",
            "tr": "Devre dışı bırak",
            "uk": "Відключити",
            "zh": "禁用"
        },
        "button_disagree": {
            "en": "I disagree",
            "fr": "Je ne suis pas d'accord",
            "it": "Non sono d'accordo",
            "ja": "同意しない",
            "ru": "Я не согласен",
            "tr": "Kabul etmiyorum",
            "uk": "Я не згоден",
            "zh": "我不同意"
        },
        "button_edit": {
            "en": "Edit",
            "fr": "Modifier",
            "it": "Modifica",
            "ja": "編集",
            "ru": "Изменить",
            "tr": "Düzenle",
            "uk": "Змінити",
            "zh": "编辑"
        },
        "button_enable": {
            "en": "Enable",
            "fr": "Permettre",
            "it": "Permettere",
            "ja": "有効化",
            "ko": "사용",
            "ru": "Включить",
            "tr": "Etkinleştir",
            "uk": "Увімкнути",
            "zh": "启用"
        },
        "button_fillSLTP": {
            "en": "Fill SLTP",
            "fr": "Remplier SLTP",
            "it": "Esegui SLTP",
            "ja": "SLTPを入力",
            "ru": "Заполнить SLTP",
            "tr": "SLTP'yi gerçekleştir",
            "uk": "Заповнити SLTP",
            "zh": "填充SLTP"
        },
        "button_findPmaById": {
            "en": "Find PMA by ID",
            "fr": "Trouver PMA par ID",
            "it": "Trova PMA per ID",
            "ja": "PMAをIDで探す",
            "ru": "Найти PMA по ID",
            "tr": "PMA'yı kimlikle bulun",
            "uk": "Знайти PMA по ID",
            "zh": "按ID查找PMA"
        },
        "button_join": {
            "en": "Join",
            "fr": "Rejoindre",
            "it": "Iscriviti",
            "ja": "参加",
            "ru": "Присоединиться",
            "tr": "Katıl",
            "uk": "Приєднатися",
            "zh": "加入"
        },
        "button_makePosition": {
            "en": "Close & make position",
            "fr": "Fermer et faire une position",
            "it": "Chiudi e posiziona",
            "ja": "ポジションの終了と作成",
            "ru": "Закрыть и сделать позицией",
            "tr": "Kapat ve konumlandır",
            "uk": "Закрити і зробити позицією",
            "zh": "闭合位置"
        },
        "button_manage": {
            "en": "Manage",
            "fr": "Gérer",
            "it": "Gestire",
            "ja": "管理",
            "ru": "Управлять",
            "tr": "Yönet",
            "uk": "Керувати",
            "zh": "管理"
        },
        "button_noCancel": {
            "en": "No",
            "fr": "Non",
            "it": "No",
            "ja": "いいえ",
            "ko": "아니오",
            "ru": "Нет",
            "tr": "Hayır",
            "uk": "Ні",
            "zh": "不"
        },
        "button_passwordForgot": {
            "en": "Forgot password?",
            "fr": "Mot de passe oublié?",
            "it": "Hai dimenticato la password?",
            "ja": "パスワードを忘れた場合",
            "ko": "비밀번호를 분실하셨습니까?",
            "ru": "Забыли пароль?",
            "tr": "Parolanızı mı unuttunuz?",
            "uk": "Забули пароль?",
            "zh": "忘记密码？"
        },
        "button_requestCode": {
            "en": "Request code",
            "fr": "Code de requête",
            "it": "Richiedi codice",
            "ja": "コードをリクエスト",
            "ko": "요청 코드",
            "ru": "Запросить код",
            "tr": "Talep kodu",
            "uk": "Запросити код",
            "zh": "请求代码"
        },
        "button_reset2fa": {
            "en": "Set new 2FA KEY",
            "fr": "Définir une nouvelle clé 2FA",
            "it": "Imposta nuovo 2FA KEY",
            "ja": "新しい2FAキーを設定",
            "ru": "Сменить ключ 2FA",
            "tr": "Yeni 2FA ANAHTARI ayarla",
            "uk": "Змінити ключ 2FA",
            "zh": "设置新的2FA密钥"
        },
        "button_returnToMainAccount": {
            "en": "Return To Main Account",
            "fr": "Retour au Compte Principal",
            "it": "Ritorna all'Account Principale",
            "ja": "メインアカウントに戻る",
            "ru": "Вернуться в основной аккаунт",
            "tr": "Ana Hesaba Dön",
            "uk": "Повернутися в основний аккаунт",
            "zh": "返回主帐户"
        },
        "button_sell": {
            "en": "Sell {sym1}",
            "fr": "Vendre {sym1}",
            "it": "Vendi {sym1}",
            "ja": "{sym1}を売却",
            "ko": "매도하다 {sym1}",
            "ru": "Продать {sym1}",
            "tr": "Sat {sym1}",
            "uk": "Продати {sym1}",
            "zh": "出售{sym1}"
        },
        "button_set2fa": {
            "en": "Enable 2FA",
            "fr": "Activer 2FA",
            "it": "Abilita 2FA",
            "ja": "2FAを有効にする",
            "ko": "2FA 활성화",
            "ru": "Активировать 2FA",
            "tr": "2FA'yı etkinleştir",
            "uk": "Активувати 2FA",
            "zh": "启用2FA"
        },
        "button_terminateAccount": {
            "en": "Yes, terminate my account",
            "fr": "Oui, fermez mon compte",
            "it": "Sì, chiudi il mio account",
            "ja": "はい、アカウントを削除します。",
            "ru": "Да, удалить мой аккаунт",
            "tr": "Evet, hesabımı sonlandır",
            "uk": "Так, видалити мій акаунт",
            "zh": "是的，终止我的帐户"
        },
        "button_yesDelete": {
            "en": "Yes, delete",
            "fr": "Oui, supprimer",
            "it": "Sì, chiudi",
            "ja": "はい、削除します。",
            "ko": "예, 주문을",
            "ru": "Да, удалить",
            "tr": "Evet, sil",
            "uk": "Так, видалити",
            "zh": "是，删除"
        },
        "cancel": {
            "en": "Cancel",
            "fr": "Annuler",
            "it": "Annulla",
            "ja": "キャンセル",
            "ko": "취소",
            "ru": "Отменить",
            "tr": "İptal et",
            "uk": "Відмінити",
            "zh": "取消"
        },
		"canceling": {
			"en": "Canceling",
			"fr": "En cours d'annulation",
			"it": "In corso di cancellazione",
			"ja": "キャンセル中",
			"ko": "취소 중",
			"ru": "Отмена",
			"tr": "İptal",
			"uk": "Відміна",
			"zh": "取消"
		},
        "cancelOrder": {
            "en": "Cancel order",
            "fr": "Annuler la commande",
            "it": "Annulla ordine",
            "ja": "注文をキャンセルする",
            "ko": "주문 취소",
            "ru": "Отменить ордер",
            "tr": "Komutu iptal et",
            "uk": "Відмінити ордер",
            "zh": "取消订单"
        },
        "cancelTime": {
            "en": "Cancellation time",
            "fr": "Délai d'annulation",
            "it": "Tempo di annullamento",
            "ja": "キャンセル時間",
            "ko": "취소 시간",
            "ru": "Время отмены",
            "tr": "İptal süresi",
            "uk": "Час відміни",
            "zh": "取消时间"
        },
        "changeSym": {
            "en": "Change {sym}",
            "fr": "Modifier {sym}",
            "it": "Cambia {sym}",
            "ja": "{sym}を変更",
            "ru": "Изменение {sym}",
            "tr": "{sym}'i değiştir",
            "uk": "Зміна {sym}",
            "zh": "更改{sym}"
        },
        "checkbox_confirmTerms": {
            "en": "I have read, understood and accepted Terms and Conditions published at {link}",
            "fr": "J'ai lu, compris et accepté les conditions générales publiées sur {link}",
            "it": "Ho letto, compreso e accettato i Termini e condizioni pubblicati su {link}",
            "ja": "{link}にある利用規約を読み、その内容に同意しました。",
            "ru": "Я прочел, понял и согласился с правилами и условиями работы опубликованными на {link}",
            "tr": "{link} adresinde yayınlanan Şartlar ve Koşulları okudum, anladım ve kabul ediyorum",
            "uk": "Я прочитав, зрозумів і погодився з правилами і умовами роботи опублікованими на {link}",
            "zh": "我已阅读、明白及接受在{link}发表的条款及细则"
        },
        "checkbox_confirmTermsPMA": {
            "en": "I have read, understood and accepted terms and conditions of the PMA published at {link}",
            "fr": "J'ai lu, compris et accepté les conditions générales de la PMA publiées sur {link}",
            "it": "Ho letto, compreso e accettato i termini e le condizioni della PMA pubblicati su {link}",
            "ja": "{link}にあるPMAの利用規約を読み、その内容に同意しました。",
            "ru": "Я прочел, понял и согласился с правилами и условиями работы PMA опубликованными на {link}",
            "tr": "{link} adresinde yayınlanan PMA'nın şartlar ve koşullarını okudum, anladım ve kabul ediyorum",
            "uk": "Я прочитав, зрозумів і погодився з правилами і умовами роботи PMA опублікованими на {link}",
            "zh": "本人已阅读、明白及接受在{link}发表的《永久性维修协议》的条款及细则"
        },
        "childFilled": {
            "en": "SLTP filled for",
            "fr": "SLTP rempli pour",
            "it": "SLTP eseguito per",
            "ja": "入力済みのSLTP",
            "ru": "Исполнено в SLTP",
            "tr": "SLTP gerçekleştirilmesi",
            "uk": "Виконано в SLTP",
            "zh": "SLTP填写"
        },
        "child_label": {
            "en": "Child order",
            "fr": "Commande subordonnée",
            "it": "Ordine subordinato",
            "ja": "チャイルドオーダー",
            "ru": "Дочерний закрывающий ордер",
            "tr": "Bağımlı komut",
            "uk": "Дочірній закриваючий ордер",
            "zh": "子订单"
        },
        "closeTime": {
            "en": "Closing time",
            "fr": "Heure de fermeture",
            "it": "Tempo di chiusura",
            "ja": "締め切り時間",
            "ko": "시간 종료",
            "ru": "Время закрытия",
            "tr": "Kapanış zamanı",
            "uk": "Час закриття",
            "zh": "关闭时间"
        },
        "closed_tab": {
            "en": "Closed",
            "fr": "Fermé",
            "it": "Chiuso",
            "ja": "終了",
            "ko": "닫힘",
            "ru": "Закрытые",
            "tr": "Kapalı",
            "uk": "Закриті",
            "zh": "关闭的"
        },
        "color": {
            "en": "Color",
            "fr": "Couleur",
            "it": "Colore",
            "ja": "色",
            "ru": "Цвет",
            "tr": "Renk",
            "uk": "Колір",
            "zh": "颜色"
        },
        "commission": {
            "en": "Commission",
            "fr": "Commission",
            "it": "Commissione",
            "ja": "コミッション",
            "ko": "수수료",
            "ru": "Комиссия",
            "tr": "Komisyon",
            "uk": "Комісія",
            "zh": "佣金"
        },
        "conditional": {
            "en": "Conditional",
            "fr": "Conditionnel",
            "it": "Condizionale",
            "ja": "条件付き",
            "ru": "Условные",
            "tr": "Koşullu",
            "uk": "Умовні",
            "zh": "有条件的"
        },
        "conditional_description": {
            "en": "CONDITIONAL ORDER means that the order will be inactive until the specified activation conditions have been detected by the EXCHANGE. All conditions values related to the market conditions (like liquidity, best prices, trading volume, change ratio over the period, etc.) are taken from the EXCHANGE and may be different from any other markets with no limitations.",
            "fr": "COMMANDE CONDITIONNELLE signifie que la commande sera inactive jusqu'à ce que les conditions d'activation spécifiées aient été détectées par EXCHANGE. Toutes les valeurs des conditions liées aux conditions du marché (comme la liquidité, les meilleurs prix, le volume des transactions, le taux de variation sur la période, etc.) sont tirées de l'EXCHANGE et peuvent être différentes de tout autre marché sans aucune limitation.",
            "it": "ORDINE CONDIZIONALE significa che l'ordine sarà inattivo fino a quando le condizioni di attivazione specificate non saranno state rilevate dall'EXCHANGE. Tutti i valori delle condizioni relativi alle condizioni di mercato (come liquidità, prezzi migliori, volume degli scambi, rapporto di variazione nel periodo, ecc.) Sono presi dall'EXCHANGE e possono essere diversi da qualsiasi altro mercato senza limitazioni.",
            "ja": "条件付き注文においては、指定された有効化の条件が取引所で検出されるまで、注文は無効状態のままになります。市場の状態に関連するすべての条件（流動性、最良価格、取引量、期間中の変化率など）は取引所から取得され、制限のない他の市場とは異なる場合があります。",
            "tr": "KOŞULLU KOMUT, belirtilen aktivasyon koşulları EXCHANGE tarafından tespit edilinceye kadar komutun aktif olmayacağı anlamına gelir. Piyasa koşullarına ilişkin tüm koşullar (likidite, en iyi fiyatlar, işlem hacmi, dönem içindeki değişim oranı vb.) EXCHANGE'den alınır ve sınırlama olmaksızın diğer piyasalardan farklı olabilir.",
            "uk": "УМОВНИЙ ОРДЕР означає, що ордер буде неактивним, поки ОБМІН не виявить зазначені умови активації. Усі значення умов, пов'язані з ринковими умовами (як ліквідність, найкращі ціни, обсяг торгів, коефіцієнт змін за період тощо), беруться з ОБМІНУ та можуть відрізнятися від будь-яких інших ринків без обмежень.",
            "zh": "条件订单是指在交易所检测到指定的激活条件之前，订单将处于非活动状态。所有与市场状况相关的条件值（如流动性、最佳价格、交易量、期间变化率等）均取自交易所，可能与任何其他没有限制的市场不同。"
        },
        "confirmations": {
            "en": "Confirmations",
            "fr": "Confirmations",
            "it": "Conferme",
            "ja": "確認",
            "ru": "Подтверждений",
            "tr": "Onaylama işlemleri",
            "uk": "Підтверджень",
            "zh": "确认书"
        },
        "copiedFromID": {
            "en": "Copied from ID {oid}",
            "fr": "Copié à partir de l'ID {oid}",
            "it": "Copiato dall'ID {oid}",
            "ja": "ID {oid}からコピーしました",
            "ru": "Скопировано из ID {oid}",
            "tr": "Kimlikten kopyalandı {oid}",
            "uk": "Скопійовано з ID {oid}",
            "zh": "从ID{oid}复制"
        },
        "copiedToID": {
            "en": "Copied to ID:{copied_to}",
            "fr": "Copié dans l'ID: {copied_to}",
            "it": "Copiato nell'ID: {copied_to}",
            "ja": "ID:{copied_to}にコピーしました",
            "ru": "Скопировано в ордер {copied_to}",
            "tr": "Kimliğe kopyalandı:{copied_to}",
            "uk": "Скопійовано в ордер {copied_to}",
            "zh": "复制到ID:{copied_to}"
        },
        "copy": {
            "en": "Copy",
            "fr": "Copier",
            "it": "Copia",
            "ja": "コピー",
            "ko": "복사",
            "ru": "Копировать",
            "tr": "Kopyala",
            "uk": "Копіювати",
            "zh": "复制"
        },
        "countLimitsIn_label": {
            "en": "Count all limits in",
            "fr": "Comptez toutes les limites dans",
            "it": "Conta tutti i limiti in",
            "ja": "以下における全ての制限を数える--",
            "ko": "한도 설정 기준 통화:",
            "nn": "Områ alle grenser i",
            "no": "Overvei alle grenser i",
            "ru": "Учитывать все лимиты в",
            "tr": "İçindeki tüm sınırları say",
            "uk": "Враховувати всі ліміти в",
            "zh": "计算所有限制"
        },
        "create": {
            "en": "Create",
            "fr": "Créer",
            "it": "Creare",
            "ja": "新規作成",
            "ko": "생성",
            "ru": "Создать",
            "tr": "Oluştur",
            "uk": "Створити",
            "zh": "创建"
        },
        "create_order": {
            "en": "Create order",
            "fr": "Créer une commande",
            "it": "Creare un ordine",
            "ja": "注文を作成",
            "ko": "주문 작성",
            "ru": "Создать ордер",
            "tr": "Komut oluştur",
            "uk": "Створити ордер",
            "zh": "创建订单"
        },
        "dashboard": {
            "en": "Dashboard",
            "fr": "Tableau de bord",
            "it": "Dashboard",
            "ja": "ダッシュボード",
            "ru": "Инфопанель",
            "tr": "Gösterge tablosu",
            "uk": "Інфопанель",
            "zh": "仪表板"
        },
        "days": {
            "en": "{days} d.",
            "fr": "{days} d.",
            "it": "{days} g.",
            "ja": "{days}日",
            "ru": "{days} дн.",
            "tr": "{days} g.",
            "uk": "{days} дн.",
            "zh": "{days} 天。"
        },
        "decimalBlockchain_label": {
            "en": "Decimals on blockchain transactions",
            "fr": "Décimales sur les transactions blockchain",
            "it": "Decimali sulle transazioni blockchain",
            "ja": "ブロックチェーン取引の小数点",
            "ru": "Десятичных знаков в транзакциях",
            "tr": "Blok zinciri işlemlerinde ondalık sayılar",
            "uk": "Десяткових знаків в транзакціях",
            "zh": "区块链交易中的小数"
        },
        "decimalObPrice_label": {
            "en": "Price decimals in the orderbook",
            "fr": "Décimales de prix dans le carnet de commandes",
            "it": "Decimali di prezzo nel Portafoglio ordini",
            "ja": "オーダーブックにおける価格の小数点",
            "ru": "Десятичных знаков в цене ордербука",
            "tr": "Komut defterindeki fiyat ondalıkları",
            "uk": "Десяткових знаків в ціні ордербука",
            "zh": "订单中的价格小数"
        },
        "decimalObVol_label": {
            "en": "Volume decimals in the orderbook",
            "fr": "Décimales de volume dans le carnet de commandes",
            "it": "Decimali di volume nel Portafoglio ordini.",
            "ja": "オーダーブックにおける数量の小数点",
            "ru": "Десятичных знаков в объеме ордербука",
            "tr": "Komut defterindeki işlem hacim ondalıkları",
            "uk": "Десяткових знаків в обсязі ордербука",
            "zh": "容量中的小数位数"
        },
        "delete": {
            "en": "Remove",
            "fr": "Supprimer",
            "it": "Rimuovere",
            "ja": "削除",
            "ko": "삭제",
            "ru": "Удалить",
            "tr": "Kaldırma",
            "uk": "Видалити",
            "zh": "删除"
        },
        "depositTokens": {
            "en": "Deposit tokens",
            "fr": "Jetons de dépôt",
            "it": "Token di deposito",
            "ja": "トークンの入金",
            "ru": "Пополнить счет",
            "tr": "Mevduat tokenleri",
            "uk": "Поповнити рахунок",
            "zh": "存款代币"
        },
        "depositNoun": {
            "en": "Deposit",
            "fr": "Dépôt",
            "it": "Deposito",
            "ja": "入金",
            "ru": "Пополнение",
            "tr": "Mevduat",
            "uk": "Поповнення",
            "zh": "存款"
        },
        "depositVerb": {
            "en": "Deposit",
            "fr": "Déposer",
            "it": "Depositare",
            "ja": "入金",
            "ru": "Пополнить",
            "tr": "Para yatırma",
            "uk": "Поповнити",
            "zh": "存款"
        },
        "description": {
            "en": "Description",
            "fr": "Description",
            "it": "Descrizione",
            "ja": "説明",
            "ko": "기술",
            "ru": "Описание",
            "tr": "Tanımlama",
            "uk": "Опис",
            "zh": "说明"
        },
        "editOrder": {
            "en": "Edit order",
            "fr": "Modifier la commande",
            "it": "Modifica l'ordine",
            "ja": "注文を編集",
            "ko": "주문 수정",
            "ru": "Изменить ордер",
            "tr": "Komutu düzenle",
            "uk": "Змінити ордер",
            "zh": "修改订单"
        },
        "editSLTP": {
            "en": "Edit SLTP",
            "fr": "Modifier SLTP",
            "it": "Modifica SLTP",
            "ja": "SLTPを編集",
            "ko": "SLTP 수정",
            "ru": "Изменить SLTP",
            "tr": "SLTP'yi düzenle",
            "uk": "Змінити SLTP",
            "zh": "编辑SLTP"
        },
        "email": {
            "en": "Email",
            "fr": "Email",
            "it": "Email",
            "ja": "メールアドレス",
            "ru": "Email",
            "tr": "E-posta",
            "uk": "Email",
            "zh": "电子邮件"
        },
        "emailCode": {
            "en": "Code from email",
            "fr": "Code envoyé dans votre courriel",
            "it": "Codice inviato all'email",
            "ja": "メールに記載されたコード",
            "ko": "이메일로 받은 코드",
            "nn": "Kode frå epost",
            "no": "Kode fra epost",
            "ru": "Код из e-mail",
            "tr": "E-postadaki kod",
            "uk": "Код з e-mail",
            "zh": "电子邮件中的代码"
        },
        "emailCode_description": {
            "en": "Enter the code sent to your email",
            "fr": "Saisir le code envoyé à votre courriel",
            "it": "Inserisci il codice inviato alla tua email",
            "ja": "メールアドレスに送信されたコードを入力してください。",
            "ko": "전자 메일로 보낸 코드를 입력하십시오",
            "ru": "Введите код, отправленный на ваш email",
            "tr": "E-postanıza gönderilen kodu girin",
            "uk": "Введіть код, відправлений на ваш email",
            "zh": "输入发送到您电子邮件的代码"
        },
        "enabled": {
            "false": {
                "en": "Disabled",
                "fr": "Désactivé",
                "it": "Disattivato",
                "ja": "無効",
                "ru": "Отключен",
                "tr": "Seçilemez kılınmış",
                "uk": "Відключений",
                "zh": "残疾人"
            },
            "true": {
                "en": "Enabled",
                "fr": "Activé",
                "it": "Attivato",
                "ja": "有効",
                "ru": "Включен",
                "tr": "Seçilir kılınmış",
                "uk": "Включений",
                "zh": "启用"
            }
        },
        "enterConfirmationCode_description": {
            "en": "If you already signed up and need to confirm your email by entering the code, please click [common.button_EnterConfirmationCode] button",
            "fr": "Si vous êtes déjà inscrit et devez confirmer votre adresse courriel en saisissant votre code, veuillez cliquer sur le bouton [common.button_EnterConfirmationCode]",
            "it": "Se ti sei già registrato e devi confermare la tua email inserendo il codice, fai clic sul pulsante [common.button_EnterConfirmationCode]",
            "ja": "すでにサインアップしており、コードを入力してメールを確認する必要がある場合は、[common.button_EnterConfirmationCode]ボタンをクリックしてください",
            "ru": "Если вы уже зарегистрировали аккаунт и хотите подтвердить ваш e-mail, введя код из письма, нажмите кнопку [common.button_EnterConfirmationCode]",
            "tr": "Zaten giriş yaptıysanız ve kodu girerek e-postanızı onaylamanız gerekiyorsa, lütfen [common.button_EnterConfirmationCode] düğmesine tıklayın",
            "uk": "Якщо ви вже зареєстрували акаунт і хочете підтвердити ваш e-mail, ввівши код з листа, натисніть кнопку",
            "zh": "如果您已经注册并需要输入代码来确认您的电子邮件，请单击[常用.按钮输入确认代码]按钮"
        },
        "error": {
            "en": "Error!",
            "fr": "Erreur!",
            "it": "Errore!",
            "ja": "エラー！",
            "ru": "Ошибка!",
            "tr": "Hata!",
            "uk": "Помилка!",
            "zh": "错误！"
        },
        "estimate_balance": {
            "en": "Estimated Balance",
            "fr": "Solde estimatif",
            "it": "Saldo stimato",
            "ja": "予測される残高",
            "ko": "예상 잔액",
            "ru": "Балансов на",
            "tr": "Tahmini Bakiye",
            "uk": "Балансів на",
            "zh": "预计余额"
        },
        "event": {
            "en": "Event",
            "fr": "Événement",
            "it": "Evento",
            "ja": "イベント",
            "ru": "Событие",
            "tr": "Etkinlik",
            "uk": "Подія",
            "zh": "事件"
        },
        "feeDescription": {
            "pmaSetup": {
                "en": "each new PMA setup",
                "fr": "configuration de chaque nouvelle PMA",
                "it": "Configurazione di ogni nuovo PMA",
                "ja": "全ての新規PMAセットアップ",
                "ru": "каждое открытие нового PMA",
                "tr": "her yeni PMA kurulumu",
                "uk": "кожне відкриття нового PMA",
                "zh": "每个新的PMA设置"
            }
        },
        "fill": {
            "en": "Fill",
            "fr": "Remplir",
            "it": "Esegui",
            "ja": "入力",
            "ko": "채워짐",
            "ru": "Исполнение",
            "tr": "Doldur",
            "uk": "Виконання",
            "zh": "填充"
        },
        "filled": {
            "en": "Filled",
            "fr": "Rempli",
            "it": "Eseguito",
            "ja": "入力済み",
            "ru": "Исполнено",
            "tr": "Doldurulmuş",
            "uk": "Виконано",
            "zh": "已填充"
        },
        "filter": {
            "en": "Filter",
            "fr": "Filtre",
            "it": "Filtro",
            "ja": "フィルター",
            "ru": "Фильтр",
            "tr": "Filtre",
            "uk": "Фільтр",
            "zh": "过滤器"
        },
        "filterOFF": {
            "en": "Filter :",
            "fr": "Filtre :",
            "it": "Filtro:",
            "ja": "フィルター：",
            "ru": "Показать :",
            "tr": "Filtre :",
            "uk": "Показати :",
            "zh": "过滤"
        },
        "filterON": {
            "en": "SELECTED :",
            "fr": "SÉLECTIONNÉ :",
            "it": "SELEZIONATO:",
            "ja": "選択済み：",
            "ru": "Показаны только:",
            "tr": "SEÇİLİ :",
            "uk": "Показані тільки:",
            "zh": "挑选出来的："
        },
        "for1": {
            "en": "{sym2} for 1 {sym1}",
            "fr": "{sym2} pour 1 {sym1}",
            "it": "{sym2} per 1 {sym1}",
            "ja": "1 {sym1}--{sym2}",
            "ko": "{sym2} / 1{sym1}",
            "ru": "{sym2} за 1 {sym1}",
            "tr": "1 {sym1} için {sym2}",
            "uk": "{sym2} за 1 {sym1}",
            "zh": "{sym2} for 1 {sym1}"
        },
        "getMasterKey": {
            "en": "Get Master Key",
            "fr": "Obtenez le Master Key",
            "it": "Ricevi Master Key",
            "ja": "マスターキーを取得",
            "ru": "Получить Мастер-ключ",
            "tr": "Ana Anahtarı Al",
            "uk": "Отримати Майстер-ключ",
            "zh": "获取主密钥"
        },
        "hideHelp": {
            "en": "Hide HELP buttons",
            "fr": "Masquer les boutons d'AIDE",
            "it": "Nascondi i pulsanti AIUTO",
            "ja": "ヘルプボタンを隠す",
            "ru": "Скрыть вызов СПРАВКИ",
            "tr": "YARDIM düğmelerini gizle",
            "uk": "Приховати виклик ДОВІДКИ",
            "zh": "隐藏帮助按钮"
        },
        "history": {
            "en": "History",
            "fr": "Historique",
            "it": "Storia",
            "ja": "履歴",
            "ko": "거래 기록",
            "ru": "История",
            "tr": "Geçmiş",
            "uk": "Історія",
            "zh": "历史"
        },
        "inProgress": {
            "en": "in progress...",
            "fr": "en cours...",
            "it": "in corso...",
            "ja": "進行中です…",
            "ru": "выполняется...",
            "tr": "devam ediyor...",
            "uk": "виконується...",
            "zh": "正在进行。。。"
        },
        "informer": {
            "en": "{domain} - the world's first Any to Any cryptocurrency trading platform ({version}) email: {email}. Telegram support: <a href='https://t.me/help_50x' target='new'>@help_50x</a>",
            "fr": "{domain} - la première plateforme de trading de tout crypto-monnaie à tout autre crypto-monnaie au monde ({version}): {email}. <a href='https://t.me/help_50x_official' target='new'>@help_50x_official</a>",
            "it": "{domain} - la prima piattaforma di trading per qualsiasi criptovaluta ({version}) al mondo: {email}.",
            "ja": "{domain} - 世界初の全ての仮想通貨間取引プラットフォーム({version}) メールアドレス：{email}",
            "ko": "{domain} - 어떤 암호화폐도 상호 교환할 수 있는 세계 최초의 거래 플랫폼({version}) 이메일: {email}. 텔레그램: @help_50x_korea.",
            "nn": "Denne utgjevinga er versjon {version}. E-mail: {email}.",
            "no": "Denne utgivelsen er versjon {version}. E-mail: {email}.",
            "ru": "{domain} - Криптовалютная биржа | торговый терминал версии {version} E-mail: {email}. Telegram: <a href='https://t.me/help_50x_russian' target='new'>@help_50x_russian</a>",
            "tr": "{domain} - dünyanın ilk Any to Any (Herhangi Birinden Herhangi Birine) kripto para birimi ticaret platformu ({version}) e-postası: {email}.",
            "uk": "{domain} - Криптовалютна біржа | торговий термінал версії {version} E-mail: {email}.",
            "zh": "{domain}-世界上第一个任何到任何加密货币交易平台（{version}）的电子邮件：{email}。"
        },
        "informerBeta": {
            "en": "Warning! This is β.{version} version. It is fully functional but is still under testing. Use at your own risk with small amounts. Email: {email}. Telegram support: <a href='https://t.me/help_50x' target='new'>@help_50x</a>",
            "fr": "Avertissement! Celle-ci est la version β.{version}. Elle est entièrement fonctionnelle mais est toujours en test. Vous pouvez l'utiliser à vos risques et périls avec de petites quantités. Courriel: {email}.",
            "it": "Avvertimento! Questa è la versione β.{version}. È perfettamente funzionante ma è ancora in fase di test. Utilizzare a proprio rischio in modo limitato. Email: {email}.",
            "ja": "警告！β.{version}バージョンです。機能は完全ですが現在テスト段階にあります。少量から、リスクを考慮した上でお使いください。メールアドレス：{email}",
            "ko": "경고!  이것은 β.{version} 버전입니다.  완전하게 작동하지만 여전히 테스트 중입니다. 위험 요소가 있으므로 소액으로 거래하세요. E-mail: {email}.",
            "nn": "Advarsel! Denne utgjevinga er versjon β.{version}. Den er fullt ut funksjonell men framleis under testing. Bruk på eige ansvar i små mengder. E-mail: {email}",
            "no": "Advarsel! Denne utgivelsen er versjon β.{version}. Den er fullt ut funksjonell men fremdeles under testing. Bruk på eget ansvar i små mengder. E-mail: {email}",
            "ru": "Внимание! Это релиз β.{version} - полностью функционирующий, но на стадии тестирования и доработки. Используйте на свой риск небольшими суммами.  E-mail: {email}. Telegram: <a href='https://t.me/help_50x_russian' target='new'>@help_50x_russian</a>",
            "tr": "Uyarı! Bu β.{version} sürümüdür. Tamamen işlevsel ama hala test aşamasındadır. Kendi sorumluluğunuzda olacak şekilde küçük tutarlarla kullanın. E-posta: {email}.",
            "uk": "Увага! Це реліз β. {version} - повністю функціонуючий, але на стадії тестування і доопрацювання. Використовуйте на свій ризик невеликими сумами. Email: {email}.",
            "zh": "警告！这是β.{version}版本。它功能齐全，但仍在测试中。少量使用，风险自负。电子邮件：{email}。"
        },
        "input_error": {
            "en": "Error in this field",
            "fr": "Erreur dans ce champ",
            "it": "Errore in questo campo",
            "ja": "このフィールドにエラーがあります。",
            "ru": "Неверно заполнено поле",
            "tr": "Bu alandaki hata",
            "uk": "Невірно заповнене поле",
            "zh": "此字段中的错误"
        },
        "input_find": {
            "en": "Find coin",
            "fr": "Trouver la monnaie",
            "it": "Trova una moneta",
            "ja": "アイコンを探す",
            "ru": "Найти монету",
            "tr": "Coin bul",
            "uk": "Знайти монету",
            "zh": "找到硬币"
        },
        "input_passwordsNotSame_title": {
            "en": "Passwords do not match",
            "fr": "Les mots de passe ne correspondent pas",
            "it": "Le password non corrispondono",
            "ja": "パスワードが一致しません。",
            "ru": "Пароли не совпадают",
            "tr": "Parolalar uyuşmuyor",
            "uk": "Паролі не співпадають",
            "zh": "密码不匹配"
        },
        "input_required_title": {
            "en": "Please fill in this field",
            "fr": "Veuillez remplir ce champ",
            "it": "Si prega di compilare questo campo",
            "ja": "このフィールドを入力してください。",
            "ru": "Пожалуйста заполните это поле",
            "tr": "Lütfen bu alanı doldurun",
            "uk": "Будь ласка, заповніть це поле",
            "zh": "请填写此字段"
        },
        
        "ip": {
            "en": "IP address",
            "fr": "Adresse IP",
            "it": "Indirizzo IP",
            "ja": "IPアドレス",
            "ru": "IP адрес",
            "tr": "IP adresi",
            "uk": "IP адреса",
            "zh": "IP地址"
        },
        "key": {
            "en": "Key",
            "fr": "Clé",
            "it": "Chiave",
            "ja": "キー",
            "ko": "키",
            "ru": "Ключ",
            "tr": "Anahtar",
            "uk": "Ключ",
            "zh": "钥匙"
        },
        "lang": {
            "en": "Lang",
            "fr": "Lang",
            "it": "Lang",
            "ja": "言語",
            "ko": "언어",
            "ru": "Язык",
            "tr": "Dil",
            "uk": "Мова",
            "zh": "冗长的"
        },
        "lastChanges": {
            "en": "Last changes",
            "fr": "Dernières modifications",
            "it": "Ultime modifiche",
            "ja": "最後のチャンス",
            "ko": "최근 변경 사항",
            "ru": "Последние изменения",
            "tr": "Son değişiklikler",
            "uk": "Останні зміни",
            "zh": "上次更改"
        },
        "lastip": {
            "en": "Last IP",
            "fr": "Dernier IP",
            "it": "Ultimo IP",
            "ja": "前回のIP",
            "ko": "마지막 IP",
            "ru": "Последний IP",
            "tr": "Son IP",
            "uk": "Останній IP",
            "zh": "最后一个IP"
        },
        "lasttimeFill": {
            "en": "Last filling time",
            "fr": "Dernière heure de remplissage",
            "it": "Ultimo tempo di esecuzione",
            "ja": "最後の確定時間",
            "ko": "마지막 완료시간",
            "ru": "Время последнего заполнения",
            "tr": "Son doldurma zamanı",
            "uk": "Час останнього заповнення",
            "zh": "上次填写时间"
        },
        "limit": {
            "en": "Limit",
            "fr": "Limite",
            "it": "Limite",
            "ja": "制限",
            "ko": "한도",
            "ru": "Лимитный",
            "tr": "Limit",
            "uk": "Лімітний",
            "zh": "限制"
        },
        "loginEmail": {
            "en": "Login (Email)",
            "fr": "Connexion (Email)",
            "it": "Accedi (Email)",
            "ja": "ログイン（メールアドレス）",
            "ru": "Логин (Email)",
            "tr": "Giriş (E-posta)",
            "uk": "Логін (Email)",
            "zh": "登录（电子邮件）"
        },
        "loginEmail_description": {
            "en": "Enter login of the account you want to terminate. Login is the same as your email address used during registration.",
            "fr": "Entrez l'identifiant du compte que vous souhaitez résilier. L'identifiant est la même que votre adresse e-mail utilisée lors de l'inscription.",
            "it": "Inserire il login dell'account che si desidera chiudere. Il login è uguale al indirizzo email utilizzato durante la registrazione.",
            "ja": "削除したいアカウントのログイン情報を入力してください。ログイン情報は、登録時に使用したメールアドレスです。",
            "ru": "Введите логин аккаунта который вы хотите закрыть (в качестве логина используется Email который вы указали при регистрации.)",
            "tr": "Sonlandırmak istediğiniz hesabın giriş bilgilerini girin. Giriş, kayıt sırasında kullanılan e-posta adresinizle aynıdır.",
            "uk": "Введіть логін аккаунта який ви хочете закрити (в якості логіна використовується Email який ви вказали при реєстрації.)",
            "zh": "输入要终止的帐户的登录名。登录名与注册时使用的电子邮件地址相同。"
        },
        "market": {
            "en": "Market",
            "fr": "Marché",
            "it": "Mercato",
            "ja": "市場",
            "ko": "시장",
            "ru": "Маркет",
            "tr": "Piyasa",
            "uk": "Маркет",
            "zh": "市场"
        },
        "masterKey_description": {
            "en": "Master Key is a one-time access tool to activate emergency tokens withdrawals from your account to your Emergency Withdrawal Addresses. Master Key is the only way to recover your tokens in case regular authentication method with password and OTP is lost or not working for any reason. Master Key must be stored securely offline in the same way as private keys from your blockchain addresses.",
            "fr": "Le Master Key (la clé principale) est un outil d'accès unique pour activer les prélèvements urgents de jetons de votre compte vers vos adresses de prélèvement d'urgence. La clé principale est le seul moyen de récupérer vos jetons dans le cas où la méthode d'authentification régulière avec mot de passe et OTP est perdue ou ne fonctionne pas pour une raison quelconque. La clé principale doit être stockée en toute sécurité hors ligne de la même manière que les clés privées de vos adresses blockchain.",
            "it": "Il Master Key è uno strumento di accesso unico per attivare i prelievi di emergenza di gettoni dal tuo account agli indirizzi di prelievo di emergenza. La Master Key è l'unico modo per recuperare i gettoni nel caso in cui il metodo di autenticazione regolare con password e OTP venga perso o non funzioni per qualsiasi motivo. La Master Key deve essere archiviata in modo sicuro offline come le chiavi private dei tuoi indirizzi blockchain.",
            "ja": "マスターキーは、アカウントから緊急出金アドレスへのトークンの出金を有効にするワンタイムアクセスツールです。マスターキーは、パスワードとOTPを使用した通常の認証方法が使えない場合、または何らかの理由で機能しなくなった場合に、トークンを回復する唯一の方法です。マスターキーは、ブロックチェーンアドレスの秘密キーと同じ方法でオフラインで安全に保存する必要があります。",
            "ru": "Мастер-ключ является ЕДИНСТВЕННЫМ методом аварийного вывода токенов с вашего аккаунта на ваши Адреса Аварийного Вывода (EWA), и абсолютно необходим в случае если вы потеряли возможность ввести правильный пароль с корректным однократным кодом Двухфакторной Аутентификации и не можете войти в свой аккаунт. Вы должны хранить Мастер-ключ к вашему аккаунту оффлайн в безопасном месте так же, как вы храните приватные ключи к своим блокчейн-адресам.",
            "tr": "Ana Anahtar, hesabınızdan Acil Durum Para Çekme Adreslerinize acil durum tokenlerinin çekilmesini etkinleştirmek için tek seferlik bir erişim aracıdır. Ana Anahtar, parola ve OTP ile düzenli kimlik doğrulama yönteminin kaybolması veya herhangi bir nedenle çalışmaması durumunda tokenlerinizi kurtarmanın tek yoludur. Ana Anahtar, blok zinciri adreslerinizdeki özel anahtarlarla aynı şekilde çevrimdışı olarak güvenli bir şekilde saklanmalıdır.",
            "uk": "Майстер-ключ є ЄДИНИМ методом аварійного виведення токенів з вашого аккаунта на ваші Адреси Аварійного Виведення (EWA), і абсолютно необхідний в разі якщо ви втратили можливість ввести правильний пароль з коректним одноразовим кодом двофакторної аутентифікації і не можете увійти в свій аккаунт. Ви повинні зберігати Майстер-ключ до вашого аккаунту оффлайн в безпечному місці так само, як ви зберігаєте приватні ключі до своїх блокчейн-адрес.",
            "zh": "主密钥是一个一次性访问工具，用于激活从您的帐户到您的紧急取款地址的紧急代币取款。主密钥是恢复令牌的唯一方法，以防带有密码和OTP的常规身份验证方法丢失或因任何原因不起作用。主密钥必须以与来自区块链地址的私钥相同的方式安全地脱机存储。"
        },
        "masterKey": {
            "en": "Master Key",
            "fr": "Master Key",
            "it": "Master Key",
            "ja": "マスターキー",
            "ru": "Мастер-ключ",
            "tr": "Ana Anahtar",
            "uk": "Майстер-ключ",
            "zh": "主密钥"
        },
        "maxOrderVolume": {
            "en": "Maximum volume for one order",
            "fr": "Volume maximal pour une commande",
            "it": "Volume massimo per un ordine",
            "ja": "一度の注文に対する最大数量",
            "ko": "주문 최대 금액",
            "nn": "Maks storleik på ein bestilling",
            "no": "Maks størrelse på en bestilling",
            "ru": "Максимальный размер одного ордера",
            "tr": "Bir komut için maksimum işlem hacmi",
            "uk": "Максимальний розмір одного ордера",
            "zh": "一个订单的最大容量"
        },
        "meanPrice": {
            "en": "Mean price",
            "fr": "Prix moyen",
            "it": "Prezzo medio",
            "ja": "平均価格",
            "ko": "평균 가격",
            "ru": "Средняя цена",
            "tr": "Ortalama fiyat",
            "uk": "Середня ціна",
            "zh": "平均价格"
        },
        "memo": {
            "en": "Order note",
            "fr": "Note pour la commande",
            "it": "Nota d'ordine",
            "ja": "注文メモ",
            "ko": "주문 노트",
            "ru": "Примечание",
            "tr": "Komut notu",
            "uk": "Примітка",
            "zh": "订货单"
        },
        "memo_description": {
            "en": "You can add a note for any order to remind you of the transaction's circumstances.",
            "fr": "Vous pouvez ajouter une note pour toute commande afin de vous rappeler les circonstances de la transaction.",
            "it": "È possibile aggiungere una nota per qualsiasi ordine per ricordare le circostanze della transazione.",
            "ja": "注文にメモを追加して、取引の状況を記録することができます。",
            "ru": "Вы можете добавить примечание к ордеру чтобы отслеживать развитие событий и зафиксировать исходную аналитику",
            "tr": "İşlemin koşullarını hatırlamak üzere herhangi bir komut için not ekleyebilirsiniz.",
            "uk": "Ви можете додати примітку до ордера щоб відстежувати розвиток подій і зафіксувати початкову аналітику",
            "zh": "您可以为任何订单添加注释，以提醒您交易的情况。"
        },
        "minTradeVol": {
            "en": "Minimal trading volume",
            "fr": "Volume d'échange minimal",
            "it": "Volume di trading minimo",
            "ja": "最小取引量",
            "ru": "Минимальный торговый лот",
            "tr": "Minimal ticari işlem hacmi",
            "uk": "Мінімальний торгiвельний лот",
            "zh": "最小交易量"
        },
        "newOrder": {
            "en": "New Order",
            "fr": "Nouvelle commande",
            "it": "Nuovo ordine",
            "ja": "新規注文",
            "ru": "Новый Ордер",
            "tr": "Yeni Komut",
            "uk": "Новий Ордер",
            "zh": "新订单"
        },
        "newSettingsUpdateTime_label": {
            "en": "New withdrawal delay will be activated from {dateTime}",
            "fr": "Le nouveau délai de prélèvement sera activé à partir du {dateTime}",
            "it": "Il nuovo ritardo per prelievo verrà attivato da {dateTime}",
            "ja": "新しい出金遅延は{dateTime}から有効になります。",
            "ru": "Новая задержка вывода средств будет действовать с {dateTime}",
            "tr": "Yeni para çekme gecikmesi {dateTime} tarihinden itibaren etkinleştirilecektir",
            "uk": "Нова затримка виведення коштів буде діяти з {dateTime}",
            "zh": "新的取款延迟将从{dateTime}激活"
        },
        "no": {
            "en": "No",
            "fr": "Non",
            "it": "No",
            "ja": "いいえ",
            "ko": "아니오",
            "ru": "Нет",
            "tr": "Hayır",
            "uk": "Ні",
            "zh": "不"
        },
        "nodata": {
            "en": "No data to display.",
            "fr": "Aucune donnée à afficher.",
            "it": "Nessun dato da visualizzare.",
            "ja": "表示するデータがありません。",
            "ru": "Нет данных для отображения.",
            "tr": "Gösterilecek bilgi yok.",
            "uk": "Немає даних для відображення.",
            "zh": "没有要显示的数据。"
        },
        "nodata_TH": {
            "en": "No data",
            "fr": "Pas de données",
            "it": "Nessun dato",
            "ja": "データがありません。",
            "ru": "Нет данных",
            "tr": "Veri yok",
            "uk": "Немає даних",
            "zh": "没有数据。"
        },
        "nodata_description": {
            "en": "No data to display on your account.",
            "fr": "Aucune donnée à afficher sur votre compte.",
            "it": "Nessun dato da visualizzare sul tuo account.",
            "ja": "あなたのアカウントには表示するデータがありません。",
            "ru": "Нет данных для отображения на вашем аккаунте.",
            "tr": "Hesabınızda görüntülenecek veri yok.",
            "uk": "Немає даних для відображення на вашому аккаунті.",
            "zh": "没有数据显示在您的帐户上。"
        },
        "oid": {
            "en": "Order ID",
            "fr": "Numéro de commande",
            "it": "ID ordine",
            "ja": "注文ID",
            "ru": "ID ордера",
            "tr": "Komut kimliği",
            "uk": "ID ордера",
            "zh": "Order ID"
        },
        "ok": {
            "en": "Ok",
            "fr": "Ok",
            "it": "Ok",
            "ja": "了解",
            "ru": "Понятно",
            "tr": "Tamam",
            "uk": "Зрозуміло",
            "zh": "好的"
        },
        "open_tab": {
            "en": "Open",
            "fr": "Ouvrir",
            "it": "Aperto",
            "ja": "開く",
            "ko": "미체결 주문",
            "ru": "Открытые",
            "tr": "Açık",
            "uk": "Відкриті",
            "zh": "打开"
        },
        "order": {
            "en": "Order",
            "fr": "Commande",
            "it": "Ordine",
            "ja": "注文",
            "ko": "주문",
            "ru": "Ордер",
            "tr": "Komut",
            "uk": "Ордер",
            "zh": "订单"
        },
        "orderDetails_title": {
            "en": "[bs.order.{bs}] order N:{oid} - {o_vol} {sym1} at {o_rate}",
            "fr": "[bs.order.{bs}] commande N:{oid} - {o_vol} {sym1} au {o_rate}",
            "it": "[bs.order.{bs}] ordine N:{oid} - {o_vol} {sym1} a {o_rate}",
            "ja": "[bs.order.{bs}] 注文N:{oid} - {o_vol} {sym1}--{o_rate}",
            "ru": "Ордер [bs.order.{bs}] №{oid} - {o_vol} {sym1} по {o_rate}",
            "tr": "{o_rate} öğesindeki [bs.order.{bs}] komutu N:{oid} - {o_vol} {sym1}",
            "uk": "Ордер [bs.order.{bs}] №{oid} - {o_vol} {sym1} по {o_rate}",
            "zh": "[bs.order.{bs}] 订单 N:{oid} - {o_vol} {sym1} 在{o_rate}"
        },
        "orderInfo": {
            "en": "Order info",
            "fr": "Info sur la commande",
            "it": "Informazioni sull'ordine",
            "ja": "注文情報",
            "ko": "주문 정보",
            "ru": "Информация об ордере",
            "tr": "Komut bilgisi",
            "uk": "Інформація про ордер",
            "zh": "订单信息"
        },

        "orderType": {
            "en": "Order type",
            "fr": "Type de commande",
            "it": "Tipo d'ordine",
            "ja": "注文タイプ",
            "ko": "주문 유형",
            "ru": "Тип ордера",
            "tr": "Komut türü",
            "uk": "Тип ордера",
            "zh": "订单类型"
        },
        "order_TH": {
            "en": "Order",
            "fr": "Commande",
            "it": "Ordine",
            "ja": "注文",
            "ko": "주문",
            "ru": "Ордер",
            "tr": "Komut",
            "uk": "Ордер",
            "zh": "订单"
        },
        "ordersToBeCanceled": {
            "en": "Orders to be canceled",
            "fr": "Commandes à effacer",
            "it": "Ordini da cancellare",
            "ja": "キャンセルする注文",
            "ru": "Отменяемые ордера",
            "tr": "İptal edilecek komutlar",
            "uk": "Ордера що скасовуються",
            "zh": "取消订单"
        },
        "otp": {
            "en": "2FA OTP",
            "fr": "2FA OTP",
            "it": "2FA OTP",
            "ja": "2FA OTP",
            "ko": "2FA 코드",
            "ru": "Код 2FA",
            "tr": "2FA OTP",
            "uk": "Код 2FA",
            "zh": "2FA OTP"
        },
        "otp_description": {
            "en": "Enter 6-digit OTP from Authenticator app",
            "fr": "Entrez OTP à 6 chiffres à partir de l'application d'authentification",
            "it": "Inserisci un OTP da 6 cifre dall'app Authenticator",
            "ja": "認証アプリから6桁のOTPを入力",
            "ru": "Введите 6-значный однократный пароль 2FA из приложения Authenticator",
            "tr": "Kimlik Denetleyicisi uygulamasından 6 haneli OTP kodunu girin",
            "uk": "Введіть 6-значний одноразовий пароль 2FA з додатку Authenticator",
            "zh": "从Authenticator app输入6位OTP"
        },
        "otp_placeholder": {
            "en": "If you don't have 2FA, leave blank",
            "fr": "Si vous n'avez pas de 2FA, laissez-le vide",
            "it": "Se non si dispone di 2FA, lasciare vuoto",
            "ja": "2FAがない場合には、空欄にしてください。",
            "ko": "2FA가 없으면 비워 두세요",
            "ru": "Оставьте пустым если у вас нет 2FA",
            "tr": "2FA'nız yoksa boş bırakın",
            "uk": "Залиште порожнім якщо у вас немає 2FA",
            "zh": "如果没有2FA，请留空"
        },
        "pair": {
            "en": "Pair",
            "fr": "Paire",
            "it": "Coppia",
            "ja": "ペア",
            "ko": "코인",
            "ru": "Пара",
            "tr": "Çift",
            "uk": "Пара",
            "zh": "一对"
        },
        "parent_label": {
            "en": "Parent order",
            "fr": "Commande Parent",
            "it": "Ordine parente",
            "ja": "ペアレントオーダー",
            "ru": "Родительский ордер",
            "tr": "Ana komut",
            "uk": "Батьківський ордер",
            "zh": "父订单"
        },
        "password": {
            "en": "Password",
            "fr": "Mot de passe",
            "it": "Password",
            "ja": "パスワード",
            "ko": "비밀번호",
            "nn": "Passord",
            "no": "Passord",
            "ru": "Пароль",
            "tr": "Parola",
            "uk": "Пароль",
            "zh": "密码"
        },
        "passwordNew": {
            "en": "New password",
            "fr": "Nouveau mot de passe",
            "it": "Nuova password",
            "ja": "新しいパスワード",
            "ko": "새 암호",
            "nn": "Nytt passord",
            "no": "Nytt passord",
            "ru": "Новый пароль",
            "tr": "Yeni şifre",
            "uk": "Новий пароль",
            "zh": "新密码"
        },
        "passwordNew_description": {
            "en": "Set a new password",
            "fr": "Définissez un nouveau mot de passe",
            "it": "Imposta una nuova password",
            "ja": "新しいパスワードを設定",
            "ko": "새 암호 설정",
            "nn": "Skriv inn nytt passord",
            "no": "Skriv inn nytt passord",
            "ru": "Установите новый пароль",
            "tr": "Yeni bir şifre belirleyin",
            "uk": "Встановіть новий пароль",
            "zh": "设置新密码"
        },
        "password_description": {
            "en": "The password must be not less than 6 characters with CAPITAL and lower case letters.",
            "fr": "Le mot de passe ne doit pas être inférieur à 6 caractères avec des chiffres majuscules et des minuscules.",
            "it": "La password non deve essere inferiore a 6 caratteri con lettere MAIUSCOLE e lettere minuscole.",
            "ja": "パスワードは6文字以上で、大文字と小文字を使用する必要があります。",
            "ko": "암호는 대문자 및 소문자로 6 자 이상이어야합니다",
            "ru": "Пароль должен быть не менее 6 символов с ЗАГЛАВНЫМИ и строчными буквами.",
            "tr": "Parola, BÜYÜK HARF ve küçük harflerden oluşmalı ve 6 karakterden az olmamalıdır.",
            "uk": "Пароль повинен бути не менше 6 символів з ВЕЛИКИМИ і малими літерами.",
            "zh": "密码必须不少于6个字符（大写和小写）。"
        },
        "period": {
            "en": "Period",
            "fr": "Période",
            "it": "Periodo",
            "ja": "期間",
            "ru": "Период",
            "tr": "Dönem",
            "uk": "Період",
            "zh": "期间"
        },
        "pmaDepositState": {
            "1": {
                "en": "Open",
                "fr": "Ouvrir",
                "it": "Aperto",
                "ja": "開く",
                "ko": "오픈",
                "ru": "Открыт",
                "tr": "Açık",
                "uk": "Відкритий",
                "zh": "打开"
            },
            "4": {
                "en": "Clearing",
                "fr": "Rapprochement",
                "it": "Liquidazione",
                "ja": "決済中",
                "ko": "청산 중",
                "ru": "Клиринг",
                "tr": "Mahsup",
                "uk": "Кліринг",
                "zh": "清理"
            },
            "6": {
                "en": "Suspended",
                "fr": "Suspendu",
                "it": "Sospeso",
                "ja": "保留",
                "ko": "일시중단",
                "ru": "Заморожен",
                "tr": "Askıya alınmış",
                "uk": "Заморожений",
                "zh": "暂停的"
            },
            "8": {
                "en": "Closing...",
                "fr": "En cours de résiliation...",
                "it": "In corso di chiusura...",
                "ja": "閉じています…",
                "ko": "닫는 중",
                "ru": "Закрывается",
                "tr": "Kapanıyor...",
                "uk": "Закривається",
                "zh": "正在关闭。。。"
            },
            "9": {
                "en": "Closed",
                "fr": "Fermé",
                "it": "Chiuso",
                "ja": "終了",
                "ko": "닫힘",
                "ru": "Закрыт",
                "tr": "Kapalı",
                "uk": "Закритий",
                "zh": "关闭"
            }
        },
        "pmaState": {
            "0": {
                "en": "Active",
                "fr": "Actif",
                "it": "Attivo",
                "ja": "有効",
                "ko": "활성화됨",
                "ru": "Работает",
                "tr": "Aktif",
                "uk": "Працює",
                "zh": "激活"
            },
            "1": {
                "en": "Suspended for recalculation",
                "fr": "Suspendu pour recalcul",
                "it": "Sospeso per il ricalcolo",
                "ja": "再計算のための保留中",
                "ko": "재계산을 위해 중단됨",
                "ru": "Заблокирован на время пересчета",
                "tr": "Yeniden hesaplama için askıya alındı",
                "uk": "Заблокований на час перерахунку",
                "zh": "暂停重新计算"
            },
            "2": {
                "en": "Suspended for clearing",
                "fr": "Suspendu pour rapprochement",
                "it": "Sospeso per la liquidazione",
                "ja": "決済のために保留中",
                "ko": "청산을 위해 중단됨",
                "ru": "Заблокирован для клиринга",
                "tr": "Mahsup için askıya alındı",
                "uk": "Заблокований для клірингу",
                "zh": "暂停清算"
            },
            "3": {
                "en": "Suspended by the Exchange",
                "fr": "Suspendu par l'Exchange",
                "it": "Sospeso dall'Exchange",
                "ja": "取引所により保留中",
                "ko": "거래소에 의해 중단됨",
                "ru": "Заблокирован администрацией",
                "tr": "Exchange tarafından askıya alındı",
                "uk": "Заблокований адміністрацією",
                "zh": "被交易所停牌"
            }
        },
        "pmaStateShort": {
            "0": {
                "en": "Active",
                "fr": "Actif",
                "it": "Attivo",
                "ja": "有効",
                "ko": "활성화됨",
                "ru": "Работает",
                "tr": "Aktif",
                "uk": "Працює",
                "zh": "激活"
            },
            "1": {
                "en": "Recalculation",
                "fr": "Recalcul",
                "it": "Ricalcolo",
                "ja": "再計算",
                "ko": "재계산 중",
                "ru": "Пересчет...",
                "tr": "Yeniden hesaplama",
                "uk": "Перерахунок...",
                "zh": "重新计算"
            },
            "2": {
                "en": "Clearing",
                "fr": "Rapprochement",
                "it": "In corso di liquidazione",
                "ja": "決済中",
                "ko": "청산 중",
                "ru": "Клиринг",
                "tr": "Mahsup",
                "uk": "Кліринг",
                "zh": "清理"
            },
            "3": {
                "en": "Suspended",
                "fr": "Suspendu",
                "it": "Sospeso",
                "ja": "保留中",
                "ko": "일시중단",
                "ru": "Заморожен",
                "tr": "Askıya alınmış",
                "uk": "Заморожений",
                "zh": "暂停的"
            }
        },
        "pmaStatus": {
            "0": {
                "en": "In the process of opening",
                "fr": "En cours d'ouverture",
                "it": "In fase di apertura",
                "ja": "開設中",
                "ko": "오픈하는 과정에 있음",
                "ru": "В процессе открытия",
                "tr": "Açılış sürecinde",
                "uk": "У процесі відкриття",
                "zh": "在开业过程中"
            },
            "1": {
                "en": "Empty (waiting for manager’s deposit)",
                "fr": "Vide (en attente du dépôt du gestionnaire)",
                "it": "Vuoto (in attesa del deposito del gestore)",
                "ja": "空欄（マネジャーの入金を待機中）",
                "ko": "비어있음(매니저의 입금을 기다리는 중)",
                "ru": "Пустой (ожидает депозита менеджера)",
                "tr": "Boş (yöneticinin para yatırması bekleniyor)",
                "uk": "Порожній (очікує депозиту менеджера)",
                "zh": "空的（等待经理的存款）"
            },
            "2": {
                "en": "Active",
                "fr": "Actif",
                "it": "Attivo",
                "ja": "有効",
                "ko": "활성화됨",
                "ru": "Работает",
                "tr": "Aktif",
                "uk": "Працює",
                "zh": "活跃的"
            },
            "7": {
                "en": "Waiting to be closed (closing request can be canceled by the manager)",
                "fr": "En attente de fermeture (la demande de fermeture peut être annulée par le gestionnaire)",
                "it": "In attesa di chiusura (la richiesta di chiusura può essere annullata dal gestore)",
                "ja": "確定を待っています（確定リクエスはマネジャーによりキャンセルできます）",
                "ko": "닫기 위해 기다리는 중(어떠한 액션도 불가능함)",
                "ru": "Ожидание закрытия (действия запрещены)",
                "tr": "Kapatılması bekleniyor (kapanış talebi yönetici tarafından iptal edilebilir)",
                "uk": "Очікування закриття (дії заборонені, запит на закриття може бути скасований менеджером)",
                "zh": "正在等待关闭（经理可以取消关闭请求）"
            },
            "8": {
                "en": "Waiting to be closed (no actions possible)",
                "fr": "En attente de fermeture (aucune action possible)",
                "it": "In attesa di chiusura (nessuna azione possibile)",
                "ja": "確定を待っています（アクションができません）",
                "ko": "닫기 위해 기다리는 중(어떠한 액션도 불가능함)",
                "ru": "Ожидание закрытия (действия запрещены)",
                "tr": "Kapatılması bekleniyor (eylem mümkün değil)",
                "uk": "Очікування закриття (дії заборонені)",
                "zh": "等待关闭（不可能执行任何操作）"
            },
            "9": {
                "en": "Closed. No open deposits",
                "fr": "Fermé. Pas de dépôts ouverts",
                "it": "Chiuso. Nessun deposito aperto",
                "ja": "締め切られています。受付中の入金はありません。",
                "ko": "닫힘. 입금할 수 없음.",
                "ru": "Закрыт. Открытых депозитов нет.",
                "tr": "Kapalı. Açık mevduat yok",
                "uk": "Закритий. Відкритих депозитів немає.",
                "zh": "关闭。无公开存款"
            },
            "listed": {
                "en": "PMA is listed",
                "fr": "PMA est listé",
                "it": "PMA è elencato",
                "ja": "PMAが掲載されています。",
                "ko": "PMA가 명단에 리스팅 됨.",
                "ru": "PMA рекламируется",
                "tr": "PMA listelenir",
                "uk": "PMA рекламується",
                "zh": "PMA已列出"
            },
            "notlisted": {
                "en": "PMA is not listed yet",
                "fr": "PMA n'est pas encore listé",
                "it": "PMA non è ancora elencato",
                "ja": "PMAはまだ掲載されていません。",
                "ko": "PMA가 아직 명단에 리스트 되지 않음.",
                "ru": "PMA пока не рекламируется",
                "tr": "PMA henüz listelenmez",
                "uk": "PMA поки не рекламується",
                "zh": "PMA尚未上市"
            },
            "overload": {
                "en": "PMA is full",
                "fr": "PMA est plein",
                "it": "PMA è pieno",
                "ja": "PMAが満杯になっています。",
                "ko": "PMA가 꽉 참",
                "ru": "Нет мест в PMA",
                "tr": "PMA dolu",
                "uk": "Немає місць в PMA",
                "zh": "PMA已满"
            }
        },
        "pmaStatusShort": {
            "0": {
                "en": "Opening",
                "fr": "En cours d'ouverture",
                "it": "In corso d'apertura",
                "ja": "受付中",
                "ko": "오픈되어있음",
                "ru": "Открывается",
                "tr": "Açılış",
                "uk": "Відкривається",
                "zh": "打开"
            },
            "1": {
                "en": "Empty",
                "fr": "Vide",
                "it": "Vuoto",
                "ja": "空欄",
                "ko": "비어있음",
                "ru": "Пустой",
                "tr": "Boş",
                "uk": "Пустий",
                "zh": "空的"
            },
            "2": {
                "en": "Active",
                "fr": "Actif",
                "it": "Attivo",
                "ja": "有効",
                "ko": "활성화됨",
                "ru": "Работает",
                "tr": "Aktif",
                "uk": "Працює",
                "zh": "活跃的"
            },
            "7": {
                "en": "Closing queue",
                "fr": "File d'attente de la fermeture",
                "it": "Fila d'attesa per la chiusura",
                "ja": "キューを締め切っています。",
                "ko": "닫는 중",
                "ru": "Закрывается",
                "tr": "Kapanış kuyruğu",
                "uk": "Закривається",
                "zh": "关闭队列"
            },
            "8": {
                "en": "Closing...",
                "fr": "En cours de fermeture...",
                "it": "In corso di chiusura...",
                "ja": "締め切っている最中です…",
                "ko": "닫는 중",
                "ru": "Закрывается",
                "tr": "Kapanış...",
                "uk": "Закривається",
                "zh": "正在关闭。。。"
            },
            "9": {
                "en": "Closed",
                "fr": "Fermé",
                "it": "Chiuso",
                "ja": "締め切り",
                "ko": "닫힘",
                "ru": "Закрыт",
                "tr": "Kapalı",
                "uk": "Закритий",
                "zh": "关闭"
            },
            "listed": {
                "en": "Listed",
                "fr": "Listé",
                "it": "Elencato",
                "ja": "掲載済み",
                "ko": "리스팅 됨",
                "ru": "Рекламируется",
                "tr": "Listelenmiş",
                "uk": "Рекламується",
                "zh": "上市的"
            },
            "overload": {
                "en": "Full",
                "fr": "Plein",
                "it": "Pieno",
                "ja": "満杯",
                "ko": "가득 참",
                "ru": "Заполнен",
                "tr": "Tam",
                "uk": "Заповнений",
                "zh": "满的"
            }
        },
        "pmaid": {
            "en": "PMA id",
            "fr": "Identifiant du PMA",
            "it": "ID del PMA",
            "ja": "PMA ID",
            "ko": "PMA 아이디",
            "ru": "Идентификатор PMA",
            "tr": "PMA kimliği",
            "uk": "Ідентифікатор PMA",
            "zh": "PMA编号"
        },
        "positions": {
            "en": "Positions",
            "fr": "Positions",
            "it": "Posizioni",
            "ja": "ポジション",
            "ko": "포지션",
            "ru": "Позиции",
            "tr": "Konumlar",
            "uk": "Позиції",
            "zh": "位置"
        },
        "profitPair": {
            "en": "Profit by pair {pair}",
            "fr": "Revenu par paire {pair}",
            "it": "Guadagni per coppia {pair}",
            "ja": "ペア{pair}の利益",
            "ru": "Прибыль по паре {pair}",
            "tr": "Çift {pair} öğesine göre kâr",
            "uk": "Прибуток по парі {pair}",
            "zh": "逐对获利{pair}"
        },
        "realprice": {
            "en": "Real price",
            "fr": "Prix réel",
            "it": "Prezzo reale",
            "ja": "実質価格",
            "ko": "실제가격",
            "ru": "Реальная цена",
            "tr": "Gerçek fiyat",
            "uk": "Реальна ціна",
            "zh": "实际价格"
        },
        "removed": {
            "en": "Removed",
            "fr": "Supprimé",
            "it": "Rimosso",
            "ja": "削除済み",
            "ko": "제거됨",
            "ru": "Удален",
            "tr": "Kaldırılmış",
            "uk": "Видалений",
            "zh": "移开的"
        },
        "repassword": {
            "en": "Repeat password",
            "fr": "Répéter le mot de passe",
            "it": "Ripeti la password",
            "ja": "パスワードの再入力",
            "ko": "암호 다시 입력",
            "nn": "Gjenta passord",
            "no": "Gjenta passord",
            "ru": "Повторите пароль",
            "tr": "Şifreyi tekrar girin",
            "uk": "Повторіть пароль",
            "zh": "重复密码"
        },
        "reserved": {
            "en": "Reserved",
            "fr": "Réservé",
            "it": "Riservato",
            "ja": "予約済み",
            "ko": "예약됨",
            "ru": "В ордерах",
            "tr": "Ayrılmış",
            "uk": "В ордерах",
            "zh": "保留"
        },
        "s_orderType": {
            "l": {
                "en": "Limit",
                "fr": "Limite",
                "it": "Limite",
                "ja": "制限",
                "ko": "한도가",
                "ru": "Лимитный",
                "tr": "Limit",
                "uk": "Лімітний",
                "zh": "限制"
            },
            "m": {
                "en": "Market",
                "fr": "Marché",
                "it": "Mercato",
                "ja": "市場",
                "ko": "시장가",
                "ru": "Рыночный",
                "tr": "Piyasa",
                "uk": "Ринковий",
                "zh": "市场"
            },
            "s": {
                "en": "SYSTEM",
                "ru": "CИСТЕМА"
            }
        },
        "saturation": {
            "en": "Saturation",
            "fr": "Saturation",
            "it": "Saturazione",
            "ja": "飽和",
            "ko": "포화도",
            "ru": "Насыщенность",
            "tr": "Doygunluk",
            "uk": "Насиченість",
            "zh": "饱和"
        },
        "secretkey": {
            "en": "Secret key",
            "fr": "Clef secrète",
            "it": "Chiave segreta",
            "ja": "シークレットキー",
            "ko": "비밀 키",
            "ru": "Секретный ключ",
            "tr": "Gizli anahtar",
            "uk": "Секретний ключ",
            "zh": "密钥"
        },
        "showTag_label": {
            "en": "Tag ({tag_name}) support in transactions",
            "fr": "Marquez ({tag_name}) le support dans les transactions",
            "it": "Tag ({tag_name}) il supporto nelle transazioni",
            "ja": "トランザクションのタグサポート({tag_name})",
            "ru": "Поддержка Тэгов ({tag_name}) в транзакциях",
            "tr": "İşlemlerde etiket desteği ({tag_name})",
            "uk": "Підтримка тегів ({tag_name}) в транзакціях",
            "zh": "事务中的标记支持 ({tag_name})"
        },
        "sltp_description": {
            "en": "Stoploss/takeprofit order (SLTP) is a conditional order activated upon fulfillment of a parent order. Takeprofit will be set immediately upon fulfillment if you have enough funds on your account and order Volume will be reserved for the SLTP order on your balance. Upon reaching STOPLOSS TRIGGER PRICE, the TAKEPROFIT becomes STOPLOSS with the STOPLOSS PRICE.",
            "fr": "La commande Stoploss / takeprofit (SLTP) est une commande conditionnelle activée lors de l'exécution d'une commande parent. Takeprofit sera fixé immédiatement après exécution si vous avez suffisamment de fonds sur votre compte et le volume de la commande sera réservé pour la commande SLTP sur votre solde. En atteignant le prix de déclenchement STOPLOSS, le TAKEPROFIT devient STOPLOSS avec le prix STOPLOSS.",
            "it": "L'ordine Stoploss/Takeprofit (SLTP) è un ordine condizionale attivato al momento dell'esecuzione di un ordine parent. Takeprofit verrà impostato immediatamente dopo l'esecuzione se si dispone di fondi sufficienti sul proprio account e il volume dell'ordine verrà riservato per l'ordine SLTP sul proprio saldo. Al raggiungimento del PREZZO DI ATTIVAZIONE STOPLOSS, TAKEPROFIT diventa STOPLOSS con il PREZZO STOPLOSS.",
            "ja": "ストップロス/テイクプロフィットオーダー（SLTP）は、ペアレントオーダー確定時に有効化される条件付きの注文です。アカウントに十分な資金があり、残高のSLTPに対して注文のボリュームが予約されている場合、テイクプロフィットは確定時にすぐに設定されます。ストップロストリガー価格に達すると、テイクプロフィットはストップロス価格でストップロスとなります。",
            "ru": "Стоплосс/тейкпрофит (SLTP) это условный ордер активирующийся в момент полного исполнения материнского ордера. Тейкпрофит будет выставлен немедленно после исполнения, если на вашем балансе достаточно средств и ОБЪЕМ ордера будет зарезервирован на вашем балансе. По достижении ТРИГГЕРА СТОПЛОССА, Тейкпрофит превратится в Стоплосс с ценой ЦЕНА СТОПЛОССА.",
            "tr": "Zararı durdurma satışı/kazanç sağlama komutu (SLTP) bir üst siparişin yerine getirilmesiyle etkinleştirilen koşullu bir komuttur. Hesabınızda yeterli fon varsa, komut İşlem Hacmi bakiyenizdeki SLTP siparişi için ayrılacaktır ve gerçekleştirilmek üzere hemen ödeme yapılacaktır. ZARARI DURDURMA SATIŞI TETİK FİYATI'na ulaşıldığında, KAZANÇ SAĞLAMA, ZARARI DURDURMA SATIŞI FİYATI ile ZARARI DURDURMA SATIŞI'na dönüşür.",
            "uk": "Стоплосс/тейкпрофіт (SLTP) це умовний ордер що активується в момент повного виконання материнського ордера. Тейкпрофіт буде виставлений негайно після виконання, якщо на вашому балансі достатньо коштів і ОБСЯГ ордера буде зарезервований на вашому балансі. Після досягнення тригерів СТОПЛОССА, Тейкпрофіт перетвориться в Стоплосс з ціною ЦІНА СТОПЛОССА.",
            "zh": "Stoploss/takeprofit订单（SLTP）是在完成父订单时激活的条件订单。如果您的帐户上有足够的资金，完成后将立即设置Takeprofit，您的余额将为SLTP订单保留订单量。当达到止损触发价格时，TAKEPROFIT随止损价格变为止损。"
        },
        "sltp_header": {
            "en": "Stoploss/Takeprofit {child_id}",
            "fr": "Stoploss/Takeprofit {child_id}",
            "it": "Stoploss/Takeprofit {child_id}",
            "ja": "ストップロス/テイクプロフィット{child_id}",
            "ru": "Стоплосс/Тейкпрофит {child_id}",
            "tr": "Zararı durdurma satışı/Kazanç sağlama {child_id}",
            "uk": "Стоплосс/Тейкпрофіт {child_id}",
            "zh": "止损/获利 {child_id}"
        },
        "spread": {
            "en": "Spread",
            "fr": "Propager",
            "it": "Diffusione",
            "ja": "スプレッド",
            "ko": "스프레드",
            "ru": "Спред",
            "tr": "Alım-satım marjı",
            "uk": "Спред",
            "zh": "传播"
        },
        "status": {
            "en": "Status",
            "fr": "Statut",
            "it": "Stato",
            "ja": "ステータス",
            "ko": "상태",
            "ru": "Статус",
            "tr": "Durum",
            "uk": "Статус",
            "zh": "地位"
        },
        "timeConfirm": {
            "en": "Confirmation time",
            "fr": "Heure de confirmation",
            "it": "Tempo di conferma",
            "ja": "確定時間",
            "ko": "확인시간",
            "ru": "Время подтверждения",
            "tr": "Onay zamanı",
            "uk": "Час підтвердження",
            "zh": "确认时间"
        },
        "timeCreated": {
            "en": "Creation time",
            "fr": "Temps de creation",
            "it": "Tempo di creazione",
            "ja": "作成時間",
            "ko": "생성된 시간",
            "ru": "Время создания",
            "tr": "Oluşturma zamanı",
            "uk": "Час створення",
            "zh": "创作时间"
        },
        "timePayoutAfter_label": {
            "en": "Will be executed after",
            "fr": "Sera exécuté après",
            "it": "Verrà eseguito dopo",
            "ja": "実行までの時間--",
            "ru": "Будет выполнен после",
            "tr": "Sonra gerçekleştirilecek",
            "uk": "Буде виконаний після",
            "zh": "将在之后执行"
        },
        "trade": {
            "en": "Trade",
            "fr": "Échange",
            "it": "Trade",
            "ja": "取引",
            "ko": "거래",
            "ru": "Торговля",
            "tr": "Alım satım işlemi",
            "uk": "Торгівля",
            "zh": "贸易"
        },
        "tradeCom": {
            "en": "Trading commission",
            "fr": "Commission d'échange",
            "it": "Commissione di trading",
            "ja": "取引コミッション",
            "ru": "Торговая комиссия",
            "tr": "Alım satım işlem komisyonu",
            "uk": "Торгова комісія",
            "zh": "交易手续费佣金"
        },
        "tradeCom_description": {
            "en": "In any trading pair, the commission equals the biggest value among separate coin commission levels. You can find the exact commission for any trading pair at <a target = '_blank' href = '{domain.feesurl}'>{domain.feesurl}</a>. If you have enough A2A tokens on your account (during 24 hours before the trade) the commission will be taken in the A2A tokens with a 50% discount.",
            "fr": "Dans toute paire de trading, la commission est égale à la plus grande valeur parmi les niveaux de commission de pièces séparés. Vous pouvez trouver la commission exacte pour toute paire de trading sur <a target = '_blank' href = '{domain.feesurl}'>{domain.feesurl}</a>. Si vous avez suffisamment de jetons A2A sur votre compte (pendant 24 heures avant le commerce), la commission sera prélevée sur les jetons A2A avec une remise de 50%.",
            "it": "In qualsiasi coppia di trading, la commissione equivale al valore più alto tra livelli di commissione monetarie separati. Puoi trovare la commissione esatta per qualsiasi coppia di trading su <a target = '_blank' href = '{domain.feesurl}'>{domain.feesurl}</a>. Se hai abbastanza gettoni A2A sul tuo account (nelle 24 ore prima dello scambio) la commissione verrà presa in gettoni A2A con uno sconto del 50%.",
            "ja": "どの取引ペアでも、コミッションは個別のコインコミッションレベルの中で最大の値に等しくなります。取引ペアの正確な手数料は、<a target = '_blank' href = '{domain.feesurl}'>{domain.feesurl}</a>で確認できます。アカウントに十分なA2Aトークンがある場合（取引の24時間前）、手数料は50％割引でA2Aトークンに加算されます。",
            "ru": "Торговая комиссия в торговой паре равна большему из значений комиссий монет, составивших пару. Вы можете найти комиссию по конкретной торговой паре на <a target = '_blank' href = '{domain.feesurl}'>{domain.feesurl}</a>. Если у вас на счете есть токены A2A, купленные более 24 часов назад, автоматически списывается комиссия в них со скидкой 50%",
            "tr": "Herhangi bir işlem çiftinde, komisyon ayrı coin komisyon seviyeleri arasında en büyük değere eşittir. Herhangi bir işlem çifti için tam komisyonu <a target = '_blank' href = '{domain.feesurl}'>{domain.feesurl}</a> adresinde bulabilirsiniz. Hesabınızda (işlemden önceki 24 saat boyunca) yeterli miktarda A2A token varsa komisyon, % 50 indirim ile A2A tokenlerinden alınacaktır.",
            "uk": "Торгова комісія в торговій парі дорівнює більшому із значень комісій монет, що склали пару. Ви можете знайти комісію по конкретній торговій парі на <a target = '_blank' href = '{domain.feesurl}'>{domain.feesurl}</a>. Якщо у вас на рахунку є токени A2A, куплені більше 24 годин тому, автоматично списується комісія в них зі знижкою 50%",
            "zh": "在任何一对交易中，佣金在不同的硬币佣金水平中都是最大的。您可以在<a target = '_blank' href = '{domain.feesurl}'>{domain.feesurl}</a>找到任何交易对的确切佣金。如果您的账户上有足够的A2A代币（在交易前24小时内），A2A代币将获得50%的折扣。"
        },
        "tradelogTypes": {
            "c": {
                "en": "Closed",
                "fr": "Fermé",
                "it": "Chiuso",
                "ja": "確定済み",
                "ko": "닫기",
                "ru": "Закрытие",
                "tr": "Kapalı",
                "uk": "Закриття",
                "zh": "关闭"
            },
            "p": {
                "en": "Placed",
                "fr": "Passé",
                "it": "Effettuato",
                "ja": "注文済み",
                "ko": "개시",
                "ru": "Открытие",
                "tr": "Yerleştirilmiş",
                "uk": "Відкриття",
                "zh": "放置"
            },
            "t": {
                "en": "Trade",
                "fr": "Échange",
                "it": "Trade",
                "ja": "取引",
                "ko": "거래",
                "ru": "Торговля",
                "tr": "Alım satım işlemi",
                "uk": "Торгівля",
                "zh": "贸易"
            }
        },
        "trustLevel": {
            "en": "Trust Level",
            "fr": "Niveau de confiance",
            "it": "Livello di fiducia",
            "ja": "信頼レベル",
            "ko": "신뢰도",
            "ru": "Доверие",
            "tr": "Güven Düzeyi",
            "uk": "Довіра",
            "zh": "信任级别"
        },
        "trustLevel_description": {
            "en": "Trust Level is an opinion of the EXCHANGE about security, reliability, stability etc of tokens or accounts. Restrictions may be applied based on this value.",
            "fr": "Le niveau de confiance est une opinion de EXCHANGE sur la sécurité, la fiabilité, la stabilité, etc. des jetons ou des comptes. Des restrictions peuvent être appliquées en fonction de cette valeur.",
            "it": "Il livello di fiducia è un'opinione dell'EXCHANGE sulla sicurezza, affidabilità, stabilità ecc. di gettoni o account. Certe restrizioni possono essere applicate in base a questo valore.",
            "ja": "信頼レベルは、トークンまたはアカウントのセキュリティ、信頼性、安定性などに関する取引所の見方です。この値に基づいて制限が適用される場合があります。",
            "ko": "신뢰도는 토큰이나 계정의 보안, 신뢰성, 안정성 등에 대한 거래소의 의견입니다. 이러한 평가에 기초해서 제약조건을 적용할 수 있습니다.",
            "ru": "Показатель доверия - оценка биржей безопасности, стабильности и т.д. для токенов или аккаунтов. Может использоваться для установки лимитов или ограничений.",
            "tr": "Güven Düzeyi, EXCHANGE'in tokenler veya hesapların güvenliği, güvenilirliği, istikrarı vb. hakkındaki görüşüdür. Bu değere bağlı olarak kısıtlamalar uygulanabilir.",
            "uk": "Показник довіри - оцінка біржею безпеки, стабільності і т.д. для токенів або акаунтів. Може використовуватися для встановлення лімітів або обмежень.",
            "zh": "信任度是指交易所对代币或账户的安全性、可靠性、稳定性等的评价。可以基于此值应用限制。"
        },
        "turn_off": {
            "en": "Disable",
            "fr": "Désactiver",
            "it": "Disattivare",
            "ja": "無効",
            "ko": "사용안함",
            "ru": "Выключить",
            "tr": "Devre dışı",
            "uk": "Вимкнути",
            "zh": "禁用"
        },
        "turn_on": {
            "en": "Enable",
            "fr": "Activer",
            "it": "Attivare",
            "ja": "有効",
            "ko": "사용",
            "ru": "Включить",
            "tr": "Etkinleştir",
            "uk": "Увімкнути",
            "zh": "启用"
        },
        "undefined": {
            "en": "Has not been set yet",
            "fr": "N'a pas encore été défini",
            "it": "Non è stato ancora impostato",
            "ja": "まだ設定されていません",
            "ru": "Не установлено",
            "tr": "Henüz ayarlanmadı",
            "uk": "Не встановлено",
            "zh": "尚未设置"
        },
        "url": {
            "en": "URL",
            "fr": "URL",
            "it": "URL",
            "ja": "URL",
            "ru": "Ссылка",
            "tr": "URL",
            "uk": "Посилання",
            "zh": "网址"
        },
        "value": {
            "en": "Value",
            "fr": "Valeur",
            "it": "Valore",
            "ja": "値",
            "ru": "Значение",
            "tr": "Değer",
            "uk": "Значення",
            "zh": "价值"
        },
        "value_days": {
            "en": "{value} days",
            "fr": "{value} jours",
            "it": "{value} giorni",
            "ja": "{value}日",
            "ru": "{value} суток",
            "tr": "{value} gün",
            "uk": "{value} діб",
            "zh": "{value} 天"
        },
        "value_percent": {
            "en": "{value}%",
            "fr": "{value}%",
            "it": "{value}%",
            "ja": "{value}%",
            "ru": "{value}%",
            "tr": "% {value}",
            "uk": "{value}%",
            "zh": "{value}%"
        },
        "value_sym": {
            "en": "{value} {sym}",
            "fr": "{value} {sym}",
            "it": "{value} {sym}",
            "ja": "{value} {sym}",
            "ru": "{value} {sym}",
            "tr": "{value} {sym}",
            "uk": "{value} {sym}",
            "zh": "{value} {sym}"
        },
        "vol": {
            "en": "Vol",
            "fr": "Vol",
            "it": "Vol",
            "ja": "ボリューム",
            "ko": "수량",
            "ru": "Кол-во",
            "tr": "İşlem hacmi",
            "uk": "К-сть",
            "zh": "音量"
        },
        "warnMeIf": {
            "en": "Warn me if the limit is exceeded",
            "fr": "M'avertir si la limite est dépassée",
            "it": "Avvisami se il limite viene superato",
            "ja": "制限を超えたら警告する",
            "ru": "Предупредить меня, если превышен лимит",
            "tr": "Limit aşılırsa beni uyar",
            "uk": "Попередити мене, якщо перевищено ліміт",
            "zh": "超过限制时警告我"
        },
        "was_changed": {
            "en": "Was changed",
            "fr": "A été changé",
            "it": "È stato cambiato",
            "ja": "変更されています",
            "ko": "변경되었습니다",
            "ru": "Был изменен",
            "tr": "Değiştirildi",
            "uk": "Був змінений",
            "zh": "已更改"
        },
        "wdCom": {
            "en": "Withdrawal Commission",
            "fr": "Commission de prélèvement",
            "it": "Commissione di prelievo",
            "ja": "出金コミッション",
            "ko": "철수위원회",
            "ru": "Комиссия на вывод",
            "tr": "Para Çekme Komisyonu",
            "uk": "Комісія на виведення",
            "zh": "退出委员会"
        },
        "withdraw": {
            "en": "Withdraw",
            "fr": "Prélever",
            "it": "Prelevare",
            "ja": "出金",
            "ko": "출금",
            "ru": "Вывести",
            "tr": "Para çekme",
            "uk": "Вивести",
            "zh": "撤回"
        },
        "withdrawal24hLimit_label": {
            "en": "Maximum 24H withdrawal amount",
            "fr": "Montant de prélèvement maximum dans les 24H",
            "it": "Importo massimo di prelievo per 24 ore",
            "ja": "最大24時間の出金額",
            "ko": "24시간 출금 최대 금액",
            "nn": "Maks uttaksmengde på 24-timar",
            "no": "Maks uttaksmengde på 24 timar",
            "ru": "Максимальный лимит на вывод в сутки",
            "tr": "24 saat maksimum para çekme miktarı",
            "uk": "Максимальний ліміт на виведення в добу",
            "zh": "最大24小时提取量"
        },
        "wotp_description": {
            "en": "Separate Withdrawal OTP was set for withdrawals and changes of the EWA on your account. Use it instead of the main 2FA OTP.",
            "fr": "Un retrait OTP distinct a été défini pour les retraits et les modifications de l'EWA sur votre compte. Utilisez-le à la place du principal 2TP OTP.",
            "it": "Un OTP distinto per i prelievi è stato impostato per i prelievi e le modifiche dell'EWA sul tuo account. Usalo al posto del 2FA OTP principale.",
            "ja": "アカウントのEWAの引き出しと変更のために、個別の出金OTPが設定されました。メインの2FA OTPの代わりに使用してください。",
            "ru": "У вас активирован WOTP - дополнительный код 2FA для вывода токенов. Введите его вместо 2FA, с которым вы входите в аккаунт.",
            "tr": "Hesabınızdaki EWA'nın çekilmesi ve değiştirilmesi için ayrı Para Çekilen OTP ayarlandı. Bunu, ana 2FA OTP yerine kullanın.",
            "uk": "У вас активований WOTP - додатковий код 2FA для виведення токенів. Введіть його замість 2FA, з яким ви входите в аккаунт.",
            "zh": "为您账户上的取款和EWA变更设置了单独的取款OTP。用它代替主2FA OTP。"
        },
        "yes": {
            "en": "Yes",
            "fr": "Oui",
            "it": "Sì",
            "ja": "はい",
            "ko": "예",
            "ru": "Да",
            "tr": "Evet",
            "uk": "Так",
            "zh": "是的"
        },
        "youbuy": {
            "en": "You buy",
            "fr": "Vous achetez",
            "it": "Comprate",
            "ja": "購入--",
            "ko": "매수하다",
            "ru": "Купите",
            "tr": "Satın alırsınız",
            "uk": "Купите",
            "zh": "你买"
        },
        "youget": {
            "en": "You get",
            "fr": "Vous recevez",
            "it": "Ricevete",
            "ja": "入手--",
            "ko": "얻을",
            "ru": "Получите",
            "tr": "Alırsınız",
            "uk": "Отримаєте",
            "zh": "你得到"
        },
        "youhave": {
            "en": "You have",
            "fr": "Vous avez",
            "it": "Avete",
            "ja": "所持--",
            "ko": "가지다",
            "ru": "У вас",
            "tr": "Sizde var",
            "uk": "У вас",
            "zh": "你有"
        },
        "yousell": {
            "en": "You sell",
            "fr": "Vous vendez",
            "it": "Vendete",
            "ja": "売却--",
            "ko": "매도하다",
            "ru": "Продадите",
            "tr": "Satarsınız",
            "uk": "Продасте",
            "zh": "你卖了"
        },
        "youspend": {
            "en": "You spend",
            "fr": "Vous dépensez",
            "it": "Spendete",
            "ja": "消費--",
            "ko": "지출하다",
            "ru": "Потратите",
            "tr": "Harcarsınız",
            "uk": "Витратите",
            "zh": "你花钱"
        }

    },
    
    "common3": {
        "modal_indicators": {
            "_header": {
                "en": "Indicators",
                "fr": "Indicateurs",
                "it": "Indicatori",
                "ja": "指標",
                "ru": "Индикаторы",
                "tr": "Göstergeler",
                "uk": "Індикатори",
                "zh": "指标"
            },
            "add": {
                "en": "Add indicator",
                "fr": "Ajouter un indicateur",
                "it": "Aggiungi indicatore",
                "ja": "指標を追加する",
                "ru": "Добавить индикатор",
                "tr": "Gösterge ekle",
                "uk": "Додати індикатор",
                "zh": "添加指示器"
            },
            "installed": {
                "en": "Installed indicators",
                "fr": "Indicateurs installés",
                "it": "Indicatori installati",
                "ja": "インストール済みの指標",
                "ru": "Установленные индикаторы",
                "tr": "Yüklü göstergeler",
                "uk": "Встановлені індикатори",
                "zh": "安装的指示器"
            }
        }
    },
    "createOrder": {
        "errorMax": {
            "en": "You have only {vol} {sym} available",
            "fr": "Vous avez seulement {vol} {sym} disponible",
            "it": "Hai solo {vol} {sym} disponibili",
            "ja": "利用できる残高は{vol} {sym}のみです。",
            "ru": "У вас свободно только {vol} {sym}",
            "tr": "Sadece mevcut {vol} {sym} öğesine sahipsiniz",
            "uk": "У вас вільно лише {vol} {sym}",
            "zh": "只有 {vol} {sym} 可用"
        },
        "errorMin": {
            "buy": {
                "en": "Minimal trading lot for {sym2} is {minvol2} {sym2}",
                "fr": "Le nombre de transactions minimal pour {sym2} est de {minvol2} {sym2}",
                "it": "Il lotto di trading minimo per {sym2} è di {minvol2} {sym2}",
                "ja": "{sym2}の最小取引ロットは{minvol2} {sym2}です。",
                "ru": "Mинимальное количество для покупки за {sym2}: {minvol2} {sym2}",
                "tr": "{sym2} için minimum işlem lotu {minvol2} {sym2} öğesidir",
                "uk": "Mінімальна кількість для покупки за {sym2}: {minvol2} {sym2}",
                "zh": "{sym2}的最小交易量是{minvol2} {sym2}"
            },
            "sell": {
                "en": "Minimal {sym1} trading lot is {minvol1} {sym1}",
                "fr": "Le lot de négociation minimal {sym1} est {minvol1} {sym1}",
                "it": "Il lotto di trading minimo per {sym1} è di {minvol1} {sym1}",
                "ja": "{sym1}の最小取引ロットは{minvol1} {sym1}です。",
                "ru": "Mинимальное количество для продажи {sym1}: {minvol1} {sym1}",
                "tr": "Minimum {sym1} işlem lotu {minvol1} {sym1} öğesidir",
                "uk": "Mінімальна кількість для продажу {sym1}: {minvol1} {sym1}",
                "zh": "最小{sym1}交易地段是{minvol1}{sym1}"
            }
        },
        "text1": {
            "en": "You can set SLTP (stoploss and takeprofit) for the market order after it has been filled by editing it on the 'HISTORY' tab.",
            "fr": "Vous pouvez définir SLTP (stoploss et takeprofit) pour l'ordre du marché après qu'il a été rempli en le modifiant dans l'onglet 'HISTORY'.",
            "it": "È possibile impostare SLTP (stoploss e takeprofit) per l'ordine di mercato dopo che è stato eseguito modificandolo nella scheda \"STORIA\".",
            "ja": "「履歴」タブで編集することにより、成約後の成行注文にSLTP（ストップロスおよびテイクプロフィット）を設定できます。",
            "ru": "Вы можете выставить SLTP (стоплосс и тейкпрофит) к маркет ордеру изменив его параметры на вкладке 'История' после его исполнения.",
            "tr": "Piyasa komutu için SLTP'yi (zararı durdurma satışı ve kazanç sağlama), gerçekleştirildikten sonra 'GEÇMİŞ' sekmesinde düzenleyerek ayarlayabilirsiniz.",
            "uk": "Ви можете виставити SLTP (стоплосс і тейкпрофіт) до маркет ордеру змінивши його параметри на вкладці 'Історія' після його виконання.",
            "zh": "通过在“历史记录”选项卡上编辑市场订单，您可以为市场订单设置SLTP（止损和获利）。"
        },
        "text2": {
            "en": ""
        },
        "text3": {
            "en": ""
        }
    },
    "currenciesInfo": {
        "coin_description": {
            "50X": {
                "en": "50Х tokens provide the same rights and functionality as STE tokens: net profit of 50x.com per quarter is distributed among 50X token holders. Please read the Whitepaper for details.",
                "fr": "Les jetons 50Х offrent les mêmes droits et fonctionnalités que les jetons STE: le bénéfice net de 50x.com par trimestre est réparti entre les détenteurs de pièces 50X. Veuillez lire le livre blanc pour plus de détails.",
                "it": "I token da 50Х forniscono gli stessi diritti e funzionalità dei token STE: l'utile netto di 50x.com per trimestre è distribuito tra i possessori di monete 50X. Si prega di leggere il Libro bianco per i dettagli.",
                "ja": "50Хトークンは、STEトークンと同じ権利と機能を提供します。四半期ごとの50x.comの純利益は、50Xコイン所有者に分配されます。詳細については、ホワイトペーパーをお読みください。",
                "ko": "50Х 토큰은 STE 토큰과 동일한 권한과 기능을 제공합니다. 분기당 50x.com의 순이익은 50X 코인 보유자에게 분배됩니다. 자세한 내용은 백서를 읽으십시오.",
                "ru": "Токены 50Х предоставляют те же права и функциональность, что и токены STE: чистая прибыль 50x.com за квартал распределяется между держателями монет 50X. Пожалуйста, прочтите White Paper для получения подробной информации.",
                "tr": "50Х jetonları, STE jetonlarıyla aynı hakları ve işlevselliği sağlar: çeyrek başına 50x.com net kar, 50X jeton sahipleri arasında dağıtılır. Ayrıntılar için lütfen Teknik Dokümanı okuyun.",
                "uk": "Токени 50Х забезпечують ті самі права та функціональність, що і токени STE: чистий прибуток 50x.com на квартал розподіляється між власниками монет 50X. Будь ласка, прочитайте Білу книгу для деталей.",
                "zh": "50Х代币提供与STE代币相同的权利和功能：每季度50x.com的净利润分配给50X代币持有者。请阅读白皮书以获取详细信息。"
            },
            "50X100": {
                "en": "50X100 tokens provide the same rights and functionality as 50X tokens, plus the benefits described in the whitepaper. Any movement of 50X100 tokens between addresses results in their conversion to 50X tokens in accordance with the original issuance rules.",
                "fr": "Les jetons 50X100 offrent les mêmes droits et fonctionnalités que les jetons 50X, ainsi que les avantages décrits dans le livre blanc. Tout mouvement de jetons 50X100 entre les adresses entraîne leur conversion en jetons 50X conformément aux règles d'émission d'origine.",
                "it": "I token 50X100 forniscono gli stessi diritti e funzionalità dei token 50X, oltre ai vantaggi descritti nel white paper. Qualsiasi spostamento di token 50X100 tra indirizzi comporta la loro conversione in token 50X in conformità con le regole di emissione originali.",
                "ja": "50X100トークンは、50Xトークンと同じ権利と機能に加えて、ホワイトペーパーに記載されている利点を提供します。アドレス間で50X100トークンを移動すると、元の発行ルールに従って50Xトークンに変換されます。",
                "ko": "50X100 토큰은 50X 토큰과 동일한 권한 및 기능과 백서에 설명 된 이점을 제공합니다. 주소간에 50X100 토큰을 이동하면 원래 발행 규칙에 따라 50X 토큰으로 변환됩니다.",
                "ru": "Токены 50X100 предоставляют те же права и функциональность, что и токены 50X, а также преимущества, описанные в Белой Бумаге. Любое перемещение токенов 50X100 между адресами приводит к их преобразованию в токены 50X в соответствии с исходными правилами выпуска.",
                "tr": "50X100 jetonları, 50X jetonlarıyla aynı hakları ve işlevselliği, ayrıca teknik incelemede açıklanan avantajları sağlar. Adresler arasında herhangi bir 50X100 jeton hareketi, orijinal düzenleme kurallarına uygun olarak 50X jetona dönüştürülmelerine neden olur.",
                "uk": "Токени 50X100 забезпечують ті самі права та функціональність, що і маркери 50X, плюс переваги, описані в доповіді. Будь-яке переміщення токенів 50X100 між адресами призводить до їх перетворення на маркери 50X відповідно до вихідних правил видачі.",
                "zh": "50X100令牌提供与50X令牌相同的权限和功能，此外还有白皮书中所述的优点。地址之间50X100令牌的任何移动都会导致其根据原始发行规则转换为50X令牌。"
            },
            "A2A": {
                "en": "A2A Tokens allow you to pay trade commissions on 50x.com with discount. You should hold available A2A tokens for at least 24 hours before the trade - and trading fees will be taken in a2a tokens automatically.",
                "fr": "Les jetons A2A vous permettent de payer des commissions commerciales sur 50x.com avec une réduction. Vous devez conserver les jetons A2A disponibles pendant au moins 24 heures avant l'échange - et les frais de négociation seront automatiquement prélevés sur les jetons A2A.",
                "it": "I token A2A ti consentono di pagare commissioni commerciali su 50x.com con uno sconto. Dovresti tenere i token A2A disponibili per almeno 24 ore prima della negoziazione e le commissioni di negoziazione verranno applicate automaticamente nei token a2a.",
                "ja": "A2Aトークンを使用すると、50x.comで取引手数料を割引価格で支払うことができます。取引前に少なくとも24時間は利用可能なA2Aトークンを保持する必要があります。取引手数料はa2aトークンに自動的に取り込まれます。",
                "ko": "A2A 토큰을 사용하면 50x.com에서 할인 된 가격으로 거래 수수료를 지불 할 수 있습니다. 거래 전 최소 24 시간 동안 사용 가능한 A2A 토큰을 보유해야하며 거래 수수료는 자동으로 a2a 토큰으로 청구됩니다.",
                "ru": "Токены A2A позволяют оплачивать торговые комиссии на 50x.com со скидкой. Вы должны держать доступные токены A2A как минимум за 24 часа до торговли - и торговые комиссии будут автоматически списаны в токенах a2a.",
                "tr": "A2A Token, 50x.com'da indirimli ticaret komisyonları ödemenizi sağlar. İşlemden en az 24 saat önce mevcut A2A jetonlarını tutmalısınız - ve işlem ücretleri otomatik olarak a2a jetonlarına alınacaktır.",
                "uk": "окени A2A дозволяють сплачувати торгові комісії на 50x.com зі знижкою. Ви повинні тримати доступні токени A2A принаймні за 24 години до торгів - і торгові збори будуть братися автоматично в токенах a2a.",
                "zh": "A2A代币允许您以折扣价在50x.com上支付交易佣金。您应该在交易前至少24小时持有可用的A2A令牌-交易费用将自动计入a2a令牌中。"
            },
            "A2AB": {
                "en": "Bonus A2A tokens (can be used only for trade commissions).",
                "fr": "Jetons A2A bonus (ne peuvent être utilisés que pour les commissions commerciales).",
                "it": "Gettoni bonus A2A (possono essere utilizzati solo per commissioni commerciali).",
                "ja": "ボーナスA2Aトークン（取引手数料にのみ使用できます）",
                "ko": "보너스 A2A 토큰 (무역 수수료 전용).",
                "ru": "Бонусные A2A токены (могут быть использованы только для торговой комиссии).",
                "tr": "Bonus A2A tokenleri (yalnızca alım satım işlemi komisyonları için kullanılabilir).",
                "uk": "Бонусні A2A токени (можуть бути використані тільки для торгової комісії).",
                "zh": "奖励A2A代币（只能用于交易佣金）。"
            },
            "A2AH": {
                "en": "A2A ICO bonus tokens. Locked A2A until April 2019",
                "fr": "Jetons bonus A2A ICO. A2A verrouillé jusqu'en avril 2019",
                "it": "Gettoni bonus ICO A2A. A2A bloccati fino ad aprile 2019",
                "ja": "A2A ICOボーナストークン（2019年4月までA2Aをロック）",
                "ko": "A2A ICO 보너스 토큰. 2019 년 4 월까지 A2A 잠김",
                "ru": "A2A ICO бонусные токены. Заблокированы до апреля 2019",
                "tr": "A2A ICO bonus tokenleri. A2A, Nisan 2019'a kadar kilitlenmiştir",
                "uk": "A2A ICO бонусні токени. Заблоковані до квітня 2019",
                "zh": "A2A ICO奖励代币。2019年4月之前锁定A2A"
            },
            "BAEX": {
                "en": "BAEX DeFi token is issued on the ETHEREUM blockchain as ERC-20 token, and unique since its price in USDT grows with each transaction on the token's smart contract, and the liquidity is 100% secured by the collateral stored on the smart contract (USDT & DAI). In other words, all existing BAEX tokens can be sold back to a smart contract at any time, while, unlike other tokens, the price will increase when selling since the amount of stablecoins collateral per token is always growing, no matter whether tokens are issued or burned. BAEX token is used to provide liquidity on the trading platform <A href='https://baex.com/baex/20720'>BAEX.COM</A>",
                "ru": "BAEX DeFi токен выпущен на блокчейне ETHEREUM по стандарту ERC-20 и уникален тем, что его цена в USDT растет с каждой транзакцией на смарт-контракте токена, а ликвидность на 100% обеспечена хранящимся на смарт-контракте обеспечением (USDT & DAI). Иными словами, все существующие токены BAEX в любой момент можно продать обратно на смарт-контракт, при этом, в отличие от других токенов, по мере продаж цена будет только возрастать, так как в расчете на один токен количество стейбл-коинов обеспечения всегда растет, не важно выпускаются токены или сжигаются. Токен BAEX служит для предоставления ликвидности на торговой платформе <A href='https://baex.com/baex/20720'>BAEX.COM</A>"
            },
            "BCH": {
                "en": "Bitcoin Cash is a hard fork of Bitcoin, took effect on 1 August 2017.",
                "fr": "Bitcoin Cash est un hard fork de Bitcoin, entré en vigueur le 1er août 2017.",
                "it": "Bitcoin Cash è un hard fork di Bitcoin, entrato in vigore il primo agosto 2017.",
                "ja": "ビットコインキャッシュはビットコインのハードフォークであり、2017年8月1日に発効されました。",
                "ko": "Bitcoin Cash는 cryptocurrency입니다. 2017 년 중반, 비트 코인의 블록 크기 제한을 늘려야하는 개발자 그룹이 코드 변경을 준비했습니다. 하드 포크라고하는 변경은 2017 년 8 월 1 일에 발효되었습니다. 결과적으로 비트 코 원장은 블록 체인 및 암호 해독 성을 2로 나누었습니다. 포크 시절에 비트 코인을 소유 한 사람도 같은 수의 비트 코 현금 단위를 소지하고있었습니다. 2018 년 11 월 15 일 Bitcoin Cash는 두 개의 cryptocurrencies로 분할되었습니다.\n            비트 코인 네트워크에 대한 비용 인상은 블록 크기를 늘리기 위해 하드 포크를 만드는 커뮤니티의 일부가 추진하는 데 기여했습니다. Roger Ver를 포함하여 Bitcoin 커뮤니티의 일부 구성원이 Bitcoin을 트랜잭션 통화가 아닌 디지털 투자로 취급하려는 사람을 선호하여 블록 크기 제한을 늘리지 않고 BIP 91을 채택하면 2017 년 7 월에 시작되었습니다. 블록 크기를 늘리기 위해 일부를 밀어 붙이는 것은 저항에 부합했습니다. Bitcoin 사용자는 2017 년 7 월에 설립 된 이래로 cryptocurrency에 대한 공통 규칙을 유지 관리했습니다. 결국, 비트 코인 활동가, 투자자, 기업가, 개발자 및 주로 중국에 기반을 둔 광부 그룹은 Bitcoin이 제안한 SegWit 개선 계획에 만족하지 않았고 용량을 늘리려했으며 Bitcoin Cash를 만든 분할 계획을 추진했습니다. 제안 된 분할에는 블록 크기 제한을 8MB로 늘려서 원장이 처리 할 수있는 트랜잭션 수를 늘릴 계획이 포함되었습니다.",
                "ru": "Форк биткойна, отделившийся от него. Разветвление произошло 1 августа 2017 года. Размер блока в блокчейне Биткойна ограничен в 1 мегабайт. Когда транзакций было не слишком много, такое ограничение почти ни на что не влияло, но существенно ограничивало возможности DDoS-атаки. С ростом популярности Биткойна, число транзакций увеличилось, но из-за ограничения максимального размера блоков не все транзакции «помещались» сразу, периодически возникала очередь. В мае 2017 года ситуация сильно ухудшилась. Некоторые пользователи жаловались, что им приходится ждать подтверждения несколько дней[4]. Для ускорения обработки пользователь может назначить повышенную комиссию. Но это делает использование биткойнов достаточно дорогим, особенно для небольших платежей — исчезает смысл использовать их, например, в кафе и барах.",
                "tr": "Bitcoin Cash, 1 Ağustos 2017'de yürürlüğe giren Bitcoin'in bir hard fork (mecburi çatallaşma) öğesidir.",
                "uk": "Форк біткоїна, що відокремився від нього. Розгалуження сталося 1 серпня 2017 року. Розмір блоку в блокчейнф Біткоїна обмежений в 1 мегабайт. Коли транзакцій було не надто багато, таке обмеження майже ні на що не впливало, але істотно обмежувало можливості DDoS-атаки. З ростом популярності Біткоїна, кількість транзакцій збільшилася, але через обмеження максимального розміру блоків не всі транзакції «вміщувалися» відразу, періодично виникала черга. В травні 2017 року ситуація сильно погіршилася. Деякі користувачі скаржилися, що їм доводиться чекати підтвердження кілька днів[4]. Для прискорення обробки користувач може призначити підвищену комісію. Але це робить використання біткоїнів досить дорогим, особливо для невеликих платежів - зникає сенс використовувати їх, наприклад, в кафе і барах.",
                "zh": "比特币现金是比特币的硬叉，于2017年8月1日生效。"
            },
            "BNB": {
                "en": "BNB is a token issued on the Binance SmartChain by the Binance cryptocurrency exchange.",
                "fr": "BNB est un jeton émis sur Binance SmartChain par l'échange de crypto-monnaie Binance.",
                "it": "BNB è un gettone emesso su Binance SmartChain dalla borsa di criptovalute Binance.",
                "ja": "BNBは、Binance仮想通貨取引所によってBinance SmartChainで発行されたトークンです。",
                "ko": "BNB 는 널리 알려진 cryptocurrency exchange Binance. 이 cryptocurrency를 사용하면 Exchange의 트랜잭션에 대한 비용을 지불 할 수 있습니다. 그렇게하기로 결정하면 추가 할인을 받게됩니다. 첫해에는 할인율 50 %, 두 번째 25 %, 세 번째 12.5 %, 네 번째 6.75 %의 할인을받을 수 있습니다. 토큰은 총 공급량 2 억 개로 설립되었습니다. 백서에 따르면, Binance는 BNB 총 공급 (1 억)의 50 %가 타 버릴 때까지 매 분기 수익의 20 %를 구매하여 BNB를 연소 할 계획입니다.\n\nBNB 토큰을 사용하면 Binance 플랫폼의 서비스에 대한 할인 혜택을받을 수 있습니다. cryptocurrency exchange는 차후에 블록 체인 자산의 분산 된 교환이 될 것입니다. 또한 BNB는 사용자에게 새로운 분산 형 교환기에서 사용할 고급 기능에 대한 액세스를 제공합니다.",
                "ru": "BNB - это криптовалюта Binance SmartChain выпущенная криптовалютной биржей Binance. При помощи монет BNB пользователи биржи могут оплачивать комиссии за транзакции и получать за это дополнительные скидки. Эмиссия выпуска криптовалюты Binance Coin составляет 200 млн. токенов, однако, в White paper проекта описываются планы Binance по использованию 20% квартальной прибыли на обратный выкуп и сжигание BNB токенов пока 50% эмиссии (100 млн. монет) не будет сожжено.",
                "tr": "BNB, Binance kripto para birimi borsası tarafından Binance SmartChain'de piyasaya çıkarılan bir tokendir.",
                "uk": "BNB - це криптовалюта Binance SmartChain випущена відомою криптовалютною біржею Binance. За допомогою монет BNB користувачі біржі можуть оплачувати комісії за транзакції і отримувати за це додаткові знижки. У перший рік - 50%, у другий - 25%, в третій - 12.5%, в четвертий - 6.75%.\n\nЕмісія випуску криптовалюти Binance Coin становить 200 млн. токенів, однак, в White paper проекту описуються плани Binance по використанню 20% квартального прибутку на зворотний викуп і спалювання BNB токенів поки 50% емісії (100 млн. монет) не буде спалено.",
                "zh": "BNB是Binance加密货币交换在Binance Smart链上发行的令牌。"
            },
            "BSV": {
                "en": "BCH Fork Bitcoin Satoshi Vision (Bitcoin SV)",
                "fr": "BCH Fork Bitcoin Satoshi Vision (Bitcoin SV)",
                "it": "BCH Fork Bitcoin Satoshi Vision (Bitcoin SV)",
                "ja": "BCHフォークビットコインサトシビジョン（ビットコインSV）",
                "ko": "BCH 포크 Bitcoin Satoshi Vision (Bitcoin SV)",
                "ru": "BCH форк Bitcoin Satoshi Vision (Bitcoin SV)",
                "tr": "BCH Fork Bitcoin Satoshi Vision (Bitcoin SV)",
                "uk": "BCH форк Bitcoin Satoshi Vision (Bitcoin SV)",
                "zh": "BCH Fork比特币Satoshi Vision（比特币SV）"
            },
            "BTC": {
                "en": "Original Bitcoin",
                "fr": "Bitcoin Originel",
                "it": "Original Bitcoin",
                "ja": "オリジナルビットコイン",
                "ko": "원래 Bitcoin",
                "ru": "Оригинальный биткойн",
                "tr": "Orijinal Bitcoin",
                "uk": "Оригінальний біткоїн",
                "zh": "原始比特币"
            },
            "BTG": {
                "en": "Bitcoin Gold is a hard fork of Bitcoin.",
                "fr": "Bitcoin Gold est un hard fork de Bitcoin.",
                "it": "Bitcoin Gold è un hard fork di Bitcoin.",
                "ja": "ビットコインゴールドはビットコインのハードフォークです。",
                "ko": "Bitcoin Gold는 분산 된 디지털 통화입니다. Bitcoin의 하드 포크, 오픈 소스 cryptocurrency입니다. 하드 포크의 명시된 목적은 Bitcoin을 채굴하는 데 사용되는 특수 ASIC (사용자 정의 칩셋)을 사용한 마이닝 대신 일반 GPU (Graphics Processing Units)로 마이닝 기능을 복원하는 것입니다.",
                "ru": "Bitcoin Gold - это распределенная цифровая валюта. Это хард форк Биткойн, криптовалюты с открытым исходным кодом. Заявленная цель хард-форка состоит в том, чтобы восстановить функциональность майнинга с помощью обычных графических процессоров (GPU) вместо майнинга со специализированной ASIC (специализированные чипсеты), используемой для майнинга биткойнов.",
                "tr": "Bitcoin Gold, Bitcoin'in bir hard fork (mecburi çatallaşma) öğesidir.",
                "uk": "Bitcoin Gold - це розподілена цифрова валюта. Це хард форк Біткоїна, криптовалюти з відкритим вихідним кодом. Заявлена мета хард-форку полягає в тому, щоб відновити функціональність майнінга за допомогою звичайних графічних процесорів (GPU) замість майнінга зі спеціалізованою ASIC (спеціалізовані чіпсети), використовуваної для майнінга біткоїнів.",
                "zh": "比特币黄金是比特币的硬叉。"
            },
            "BTT": {
                "en": "BitTorrent (BTT) is a TRC-10 utility token based on the TRON blockchain.",
                "fr": "BitTorrent (BTT) est un jeton utilitaire TRC-10 basé sur la blockchain TRON.",
                "it": "BitTorrent (BTT) è un gettone di utilità TRC-10 basato sulla blockchain TRON.",
                "ja": "ビットトレント（BTT）は、トロンブロックチェーンに基づくTRC-10ユーティリティトークンです。",
                "ru": "Токен BTT стандарта TRON TRC-10 выполняет роль механизма транзакций между клиентами BitTorrent и любыми другими заказчиками и поставщиками услуг. Токен BTT создан для расширения возможностей сети BitTorrent.",
                "tr": "BitTorrent (BTT), TRON blok zincirine dayanan bir TRC-10 yardımcı tokendir.",
                "uk": "Токен BTT стандарту TRON TRC-10 виконує роль механізму транзакцій між клієнтами BitTorrent і будь-якими іншими замовниками та постачальниками послуг. Токен BTT створений для розширення можливостей мережі BitTorrent.",
                "zh": "BitTorrent（BTT）是一种基于TRON区块链的TRC-10实用代币。"
            },
            "DASH": {
                "en": "Dash is an open source cryptocurrency.",
                "fr": "Dash est une crypto-monnaie open source.",
                "it": "Dash è una criptovaluta open source.",
                "ja": "ダッシュはオープンソースの仮想通貨です。",
                "ko": "Dash는 공개 소스 cryptocurrency이며 \"masternodes\"라고하는 사용자의 하위 집합에 의해 실행되는 분산 형 자율 조직 (DAO)의 한 형태입니다. 그것은 Bitcoin 프로토콜에서 분기 된 altcoin입니다. 통화는 추적 할 수없는 빠른 거래를 허용합니다. 채광 된 동전의 45 %는 광부에, 45 %는 마스터 국가에, 그리고 10 %는 DAO가 투자하는 기금에 사용됩니다.",
                "ru": "Dash (ранее известная как Darkcoin и XCoin) — открытая децентрализованная платёжная система в форме криптовалюты на базе блокчейна, использующая механизм анонимных транзакций.\n\nКак и большинство криптовалют, у DASH нет централизованного управления — эмиссия происходит при майнинге. Из полученного майнерами вознаграждения 90 % распределяются между майнерами и операторами мастернод. Остальные 10 % направляются на финансирование одобренных проектов.\n\nПо состоянию на конец 2017 года Dash по капитализации входит в десятку популярных криптовалют. ",
                "tr": "Dash açık kaynaklı bir kripto para birimidir.",
                "uk": "Dash (раніше відома як Darkcoin і XCoin) - децентралізована платіжна система в формі криптовалюти на базі блокчейна, що використовує механізм анонімних транзакцій.\n\nЯк і більшість криптовалют, у DASH немає централізованого управління - емісія відбувається при майнінгу. З отриманої майнерами винагороди 90% розподіляються між майнерами і операторами мастернод. Решта 10% спрямовується на фінансування схвалених проектів.\n\nСтаном на кінець 2017 року Dash за капіталізацією входить в десятку популярних криптовалют.",
                "zh": "Dash是一种开源的加密货币。"
            },
            "DEEX": {
                "en": "DEEX is a token of the DEEX decentralized exchange.",
                "fr": "DEEX est un gage de l'échange décentralisé DEEX.",
                "it": "DEEX è un gettone della borsa decentralizzata DEEX.",
                "ja": "DEEXは、DEEX分散型取引所のトークンです。",
                "ko": "Deex는 분산 형 교환 BitShares 2.0을 만들기위한 가장 진보 된 플랫폼을 기반으로합니다. 이 엔진을 사용하면 초당 최대 100 000 개의 트랜잭션을 처리 할 수 있습니다. BitShares 블록 체인의 최대 트랜잭션 수는 920 000에 도달합니다. 동시에 BitShares로 전환하는 비용은 Bitcoin 블록 체인보다 훨씬 저렴합니다. 첫 번째 단계에서 Deex는 BitShares 엔진을 사용할 계획입니다. 앞으로는 신생 기업이 자체 엔진을 만들어야합니다.",
                "ru": "Deex основан на платформе для создания децентрализованной биржи BitShares 2.0. В будущем стартап должен создать собственный движок.",
                "tr": "DEEX, DEEX merkezi olmayan borsanın bir tokenidir.",
                "uk": "DEEX заснований на платформі для створення децентралізованої біржі BitShares 2.0. В майбутньому стартап повинен створити власний рушій.",
                "zh": "DEEX是DEEX分散交换的一种象征。"
            },
            "DGB": {
                "en": "DigiByte (DGB) is a global blockchain focused on cybersecurity for digital payments.",
                "fr": "DigiByte (DGB) est une chaîne de blocs mondiale axée sur la cybersécurité pour les paiements numériques.",
                "it": "DigiByte (DGB) è una blockchain globale focalizzata sulla sicurezza informatica per i pagamenti digitali.",
                "ja": "デジバイト（DGB）は、デジタル決済のサイバーセキュリティに焦点を当てたグローバルブロックチェーンです。",
                "ru": "Блокчейн, ориентированный на кибербезопасность децентрализованных приложений и цифровых платежей. ",
                "tr": "DigiByte (DGB), dijital ödemeler için siber güvenlik odaklı küresel bir blok zinciridir.",
                "uk": "Блокчейн, орієнтований на кібербезпеку децентралізованих додатків і цифрових платежів.",
                "zh": "DigiByte（DGB）是一个专注于数字支付网络安全的全球区块链。"
            },
            "DOGE": {
                "en": "Dogecoin is a cryptocurrency based on Litecoin. Named after the internet meme Doge.",
                "fr": "Dogecoin est une crypto-monnaie basée sur Litecoin. Nommé d'après le mème Internet Doge.",
                "it": "Dogecoin è una criptovaluta basata su Litecoin. Prende il nome dal meme Internet Doge.",
                "ja": "ドージコインは、ライトコインを基礎とした仮想通貨です。インターネットミーム「ドージ」にちなんで名付けられました。",
                "ko": "Dogecoin은 Litecoin을 기반으로하는 cryptocurrency입니다. 인터넷 meme Doge로 지명되었습니다. 2013 년 12 월 8 일에 발표되었습니다. 다른 cryptocurrencies와는 다른, Dogecoin에는 초기 광업의 상당히 빠른 기간이 있습니다. 2014 년 말에는 980 억 동전이 유통되었습니다. 추가 광업 도기인에 대한 전망은 변경 될 수 있습니다. 2017 년 9 월 30 일 현재, 1 억 2,600 만 달러의 자본으로 1110 억 개의 동전이 유통되었습니다.",
                "ru": "Dogecoin — криптовалюта, основанная на Litecoin. Названа в честь интернет-мема Doge. Была представлена 8 декабря 2013 года. В отличие от других криптовалют Dogecoin имеет достаточно быстрый период изначального майнинга. На конец 2014 года в обороте находилось 98 млрд монет. Перспективы дальнейшего майнинга Dogecoin могут изменяться. По состоянию на 30 сентября 2017 года в обороте находится 111 млрд монет, капитализация которых составляет 126 миллионов долларов. ",
                "tr": "Dogecoin, Litecoin'e dayanan bir kripto para birimidir. İnternet memesinden sonra Doge adını almıştır.",
                "uk": "Dogecoin - криптовалюта, заснована на Litecoin. Названа на честь інтернет-мема Doge. Була представлена 8 грудня 2013 року. На відміну від інших криптовалют Dogecoin має досить швидкий період початкового майнінга. На кінець 2014 року в обігу перебувало 98 млрд монет. Перспективи подальшого майнінга Dogecoin можуть змінюватися. Станом на 30 вересня 2017 року обороті знаходиться 111 млрд монет, капіталізація яких становить 126 мільйонів доларів.",
                "zh": "Dogecoin是一种基于Litecoin的加密货币。以互联网上的模因狗命名。"
            },
            "ETC": {
                "en": "Ethereum Classic is an open-source, public, blockchain-based distributed computing platform featuring smart contract (scripting) functionality. Ethereum was hard-forked from the Ethereum Classic blockchain.",
                "fr": "Ethereum Classic est une plate-forme informatique distribuée open source, basée sur la blockchain et dotée d'une fonctionnalité de contrat intelligent (script). Ethereum était issu de la blockchain Ethereum Classic.",
                "it": "Ethereum Classic è una piattaforma di elaborazione distribuita pubblica e open source basata su blockchain con funzionalità di contratto intelligente (scripting). Ethereum e stato fortemente biforcuto dalla blockchain di Ethereum Classic.",
                "ja": "イーサリアムクラシックは、スマートコントラクト（スクリプト）機能を備えた、オープンソース、パブリックブロックチェーンベースの分散コンピューティングプラットフォームです。イーサリアムは、イーサリアムクラシックブロックチェーンからハードフォークにより作成されました。",
                "ko": "Ethereum Classic은 스마트 계약 (스크립팅) 기능을 특징으로하는 공개 소스, 공개, 블록 체인 기반 분산 컴퓨팅 플랫폼입니다. 분산 된 Turing-complete 가상 시스템 인 Ethereum Virtual Machine (EVM)을 제공합니다.이 EVM은 국제 노드 공용 네트워크를 사용하여 스크립트를 실행할 수 있습니다. Ethereum Classic 및 Ethereum에는 \"에테르\"라는 값 토큰이 있습니다.이 토큰은 참여자간에 전송되고 cryptocurrency wallet에 저장되며 Ethereum 플랫폼에서 수행되는 계산을 위해 참여 노드를 보완하는 데 사용됩니다. 고전적인 에테르 토큰은 티코 심볼 ETC 아래의 암호 해독 교환 (cryptocurrency exchanges)에서 거래된다. 내부 거래 가격 결정 메커니즘 인 Gas는 네트워크의 스팸을 방지하고 요청에 의해 제공되는 인센티브에 비례하여 자원을 할당하는 데 사용됩니다.",
                "ru": "Ethereum Classic (ETC) — блокчейн-криптоплатформа разработки децентрализованных приложений на базе смарт-контрактов с открытым исходным кодом. Представляет из себя децентрализованную Тьюринг-полную виртуальную машину, Виртуальную Машину Эфириума (EVM), которая может исполнять программы на публичных узлах сети. Ethereum Classic предоставляет валюту «Эфир» (Классический Эфир, Classic Ether, ETC), который может передаваться от одного участника сети другому и используется для оплаты вычислений, производимых публичными узлами сети, а также возможность создавать собственные цифровые активы (токены) на блокчейне Ethereum Classic. Эфир, оплаченный за произведенные вычисления, называется «Газ» (Gas). Газ служит не только для оплаты за произведённые вычисления, но и предотвращает DDOS-атаки на сеть. ",
                "tr": "Ethereum Classic, akıllı sözleşme (komut dosyası oluşturma) işlevselliğine sahip açık kaynaklı, halka açık, blockchain tabanlı dağıtılmış bir bilgi işlem platformudur. Ethereum, Ethereum Classic blok zincirinden hard forka uğramıştır (mecburi çatallaşmıştır).",
                "uk": "Ethereum Classic (ETC) - блокчейн-криптоплатформа розробки децентралізованих додатків на базі смарт-контрактів з відкритим вихідним кодом. Являє собою децентралізовану Тьюринг-повну віртуальну машину, Віртуальну Машину Ефіріума (EVM), яка може виконувати програми на публічних вузлах мережі. Ethereum Classic надає валюту «Ефір» (Класичний Ефір, Classic Ether, ETC), який може передаватися від одного учасника мережі іншому і використовується для оплати обчислень, вироблених публічними вузлами мережі, а також можливість створювати власні цифрові активи (токени) на блокчейні Ethereum Classic. Ефір, оплачений за вироблені обчислення, називається «Газ» (Gas). Газ служить не тільки для оплати за зроблені обчислення, а й запобігає DDOS-атакам на мережу.",
                "zh": "以太坊经典是一个开源、公共、基于区块链的分布式计算平台，具有智能合约（脚本）功能。以太坊是以太坊经典区块链的硬分叉。"
            },
            "ETH": {
                "en": "Ethereum is an open-source, public, blockchain-based distributed computing platform and operating system featuring smart contract (scripting) functionality. It supports a modified version of Nakamoto consensus via transaction-based state transitions.",
                "fr": "Ethereum est une plate-forme informatique distribuée open source, basée sur la blockchain et un système d'exploitation doté d'une fonctionnalité de contrat intelligent (script). Il prend en charge une version modifiée du consensus Nakamoto via des transitions d'état basées sur les transactions.",
                "it": "Ethereum è una piattaforma di elaborazione distribuita e open source, pubblica, basata su blockchain e dotata di funzionalità di contratto intelligente (scripting).  Supporta una versione modificata del consenso di Nakamoto tramite transizioni di stato basate su transazioni.",
                "ja": "イーサリアムは、スマートコントラクト（スクリプティング）機能を備えたオープンソース、パブリックブロックチェーンベースの分散コンピューティングプラットフォームおよびベンチマークシステムです。トランザクションベースの状態遷移を介したナカモトコンセンサスの修正版をサポートしています。",
                "ko": "Ethereum은 스마트 계약 (스크립팅) 기능을 갖춘 오픈 소스, 공용, 블록 체인 기반 분산 컴퓨팅 플랫폼 및 운영 체제입니다. 트랜잭션 기반 상태 전이를 통해 수정 된 나카 모토 합의 버전을 지원합니다.",
                "ru": "Ethereum — платформа для создания децентрализованных онлайн-сервисов на базе блокчейна (Đapps, Decentralized applications, децентрализованных приложений), работающих на базе умных контрактов. Реализована как единая децентрализованная виртуальная машина. Был предложен основателем журнала Bitcoin Magazine Виталиком Бутериным в конце 2013 года, сеть была запущена 30 июля 2015 года. ",
                "tr": "Ethereum, akıllı sözleşme (komut dosyası oluşturma) işlevselliğine sahip açık kaynaklı, halka açık, blockchain tabanlı dağıtılmış bir bilgi işlem platformu ve işletim sistemidir. İşleme dayalı durum geçişleri yoluyla Nakamoto konsensüsünün değiştirilmiş bir versiyonunu destekler.",
                "uk": "Ethereum - платформа для створення децентралізованих онлайн-сервісів на базі блокчейна (Đapps, Decentralized applications, децентралізованих додатків), що працюють на базі розумних контрактів. Реалізована як єдина децентралізована віртуальна машина. Був запропонований засновником журналу Bitcoin Magazine Віталіком Бутеріним в кінці 2013 року, мережа була запущена 30 липня 2015 року.",
                "zh": "以太坊是一个开源的、公共的、基于区块链的分布式计算平台和操作系统，具有智能合约（脚本）功能。通过基于事务的状态转换，它支持Nakamoto Consension的修改版本。"
            },
            "GSXC": {
                "en": "Online store with the ability to pay with internal tokens.",
                "fr": "Boutique en ligne avec la possibilité de payer avec des jetons internes.",
                "it": "Negozio digitale con la possibilità di pagare con gettoni interni.",
                "ja": "内部トークンで支払うことができるオンラインストアです。",
                "ko": "내부 토큰으로 지불 할 수있는 온라인 상점.",
                "ru": "Интернет-магазин с возможностью оплаты внутренними токенами.",
                "tr": "Dahili tokenlerle ödeme yapılabilen çevrimiçi mağaza.",
                "uk": "Інтернет-магазин з можливістю оплати внутрішніми токенами.",
                "zh": "能够使用内部代币支付的在线商店。"
            },
            "LTC": {
                "en": "Second cryptocurrency. Litecoin enables instant, near-zero cost payments.",
                "fr": "Deuxième crypto-monnaie. Litecoin permet des paiements instantanés à coût quasi nul.",
                "it": "Seconda criptovaluta. Litecoin consente pagamenti istantanei, con un costo di quasi zero.",
                "ja": "第二の仮想通貨です。ライトコインは、ほぼゼロコストでの即時支払いを可能にします。",
                "ko": "Litecoin은 P2P 인터넷 통화로 전 세계 어느 누구에게나 비용을 거의 지불 할 수 없습니다. Litecoin은 중앙 기관없이 완전히 분산 된 오픈 소스, 글로벌 지불 네트워크입니다. 수학은 네트워크를 보호하고 개인이 자신의 재정을 통제 할 수 있도록합니다.",
                "ru": "Litecoin - это одноранговая интернет-валюта, которая обеспечивает мгновенные, практически нулевые платежи для всех в мире. Litecoin - это глобальная платежная сеть с открытым исходным кодом, которая полностью децентрализована без каких-либо центральных органов власти. Математика защищает сеть и дает людям возможность контролировать свои финансы.",
                "tr": "İkinci kripto para birimi. Litecoin anında, sıfıra yakın maliyetli ödemeleri sağlar.",
                "uk": "Litecoin - це однорангова інтернет-валюта, яка забезпечує миттєві, практично нульові платежі для всіх в світі. Litecoin - це глобальна платіжна мережа з відкритим вихідним кодом, яка повністю децентралізована без будь-яких центральних органів влади. Математика захищає мережу і дає людям можливість контролювати свої фінанси.",
                "zh": "第二种加密货币。Litecoin支持即时、几乎零成本的支付。"
            },
            "OMG": {
                "en": "OmiseGO enables financial inclusion and interoperability through the public, decentralized OMG network.",
                "fr": "OmiseGO permet l'inclusion financière et l'interopérabilité via le réseau OMG public et décentralisé.",
                "it": "OmiseGO consente l'inclusione finanziaria e l'interoperabilità attraverso la rete OMG pubblica e decentralizzata.",
                "ja": "OmiseGOは、公開、分散型OMGネットワークを介し、幅広い人々に向けたファイナンシャルニーズの提供と相互運用性を実現します。",
                "ko": "OmiseGO는 공공적이고 분산 된 OMG 네트워크를 통해 재무 적 포함 및 상호 운용성을 지원합니다.",
                "ru": "OmiseGO обеспечивает финансовую доступность и совместимость через общедоступную децентрализованную сеть OMG.",
                "tr": "OmiseGO, halka açık merkezi olmayan OMG ağı aracılığıyla finansal içerme ve birlikte çalışabilirlik sağlar.",
                "uk": "OmiseGO забезпечує фінансову доступність і сумісність через загальнодоступну децентралізовану мережу OMG.",
                "zh": "OmiseGO通过公共的、分散的OMG网络实现了金融包容性和互操作性。"
            },
            "PYN": {
                "en": "Paycent Cards enable users to convert digital assets into local currencies for use or withdraw from automated teller machines (ATMs) with real time accessibility and convenience, while adhering to the highest level of security standards in the industry.",
                "fr": "Les cartes Paycent permettent aux utilisateurs de convertir des actifs numériques en devises locales pour les utiliser ou les retirer des distributeurs automatiques de billets (GAB) avec une accessibilité et une commodité en temps réel, tout en respectant les normes de sécurité les plus élevées du secteur.",
                "it": "Le Paycent Cards consentono agli utenti di convertire le risorse digitali in valute locali per l'uso o il prelievo da sportelli automatici (ATM) con accessibilità e praticità in tempo reale, aderendo al più alto livello di standard di sicurezza del settore.",
                "ja": "Paycent Cardを使用すると、ユーザーはデジタル資産を現地通貨に変換して、業界最高レベルのセキュリティ標準を順守しながら、リアルタイムでATMから引き出すことができます。",
                "ko": "Paycent Card를 사용하면 디지털 자산을 현지 통화로 변환하여 실시간 액세스 및 편의성을 갖춘 ATM (현금 자동 지급기)에서 사용 또는 철회 할 수 있으며 업계 최고 수준의 보안 표준을 준수 할 수 있습니다.",
                "ru": "Карты Paycent позволяют пользователям конвертировать цифровые активы в местную валюту для использования или снятия с банкоматов (ATM) с доступом в реальном времени и удобством, придерживаясь при этом самого высокого уровня стандартов безопасности в отрасли.",
                "tr": "Paycent Cards, sektördeki en yüksek güvenlik standartlarına bağlı kalarak, kullanıcıların gerçek zamanlı erişilebilirlik ve rahatlıkla dijital varlıklarını bankamatiklerden (ATM'ler) para para çekme veya kullanım için, yerel para birimlerine dönüştürmelerini sağlar.",
                "uk": "Карти Paycent дозволяють користувачам конвертувати цифрові активи в місцеву валюту для використання або зняття з банкоматів (ATM) з доступом в реальному часі і зручністю, дотримуючись при цьому найвищого рівня стандартів безпеки в галузі.",
                "zh": "Paycent卡使用户能够将数字资产转换为当地货币，以便使用或从自动取款机（ATM）取款，具有实时可访问性和方便性，同时遵守行业最高的安全标准。"
            },
            "PZM": {
                "en": "PRIZM coins provide staking reward called paramining, distributed on your {domain.name} accounts on a daily basis. On {domain.name} PRIZM settlement date is T+2, so PZM coins become available for the withdrawal after 48 hours after trade or deposit transaction. However, for the paramining accounting purposes, settlement date is T+1, so you will receive first paramining at the end of the the next day after the transaction. You can get current PRIZM paramining info from <a href='https://t.me/Prizm50xInfoBot' target='new'>@Prizm50xInfoBot</a> telegram bot.",
                "ru": "На монеты ПРИЗМ начисляется стейкинг - награда за количество (в экосистеме ПРИЗМ известный как парамайнинг) прямо на ваши аккаунты на {domain.name}. Поставка PRIZM на бирже {domain.name} осуществляется в режиме T+2, т.е. монеты PZM становятся доступны для вывода через 48 часов с момента транзакции обмена или пополнения баланса. Однако для целей начисления парамайнинга дата поставки учитывается как T+1, вы получите парамайнинг уже за следующий (за проведенной транзакцией) день. Вы можете получить статистику начисления парамайнинга на биржевые аккаунты {domain.name} отправив любое сообщение телеграм боту <a href='https://t.me/Prizm50xInfoBot' target='new'>@Prizm50xInfoBot</a>"
            },
            "QTUM": {
                "en": "A decentralized and open-source smart contracts platform and value transfer protocol.",
                "fr": "Une plateforme de contrats intelligents décentralisée et open source et un protocole de transfert de valeur.",
                "it": "Una piattaforma di contratti intelligenti decentralizzata e open source e protocollo di trasferimento del valore.",
                "ja": "分散型、オープンソースのスマートコントラクトプラットフォームと価値転送プロトコルです。",
                "ko": "분산 형 및 오픈 소스 스마트 계약 플랫폼 및 가치 전송 프로토콜.",
                "ru": "Децентрализованная платформа смарт-контрактов с открытым исходным кодом и протокол передачи стоимости.",
                "tr": "Merkezi olmayan ve açık kaynaklı bir akıllı sözleşme platformu ve değer aktarım protokolü.",
                "uk": "Децентралізована платформа смарт-контрактів з відкритим вихідним кодом і протокол передачі вартості.",
                "zh": "一个分散的、开源的智能合约平台和价值转移协议。"
            },
            "T2T": {
                "en": "50x.com test ERC-20 token on Ethereum blockchain.",
                "fr": "50x.com teste le jeton ERC-20 sur la blockchain Ethereum.",
                "it": "50x.com prova il token ERC-20 sulla blockchain di Ethereum.",
                "ja": "50x.comは、イーサリアムブロックチェーンでERC-20トークンをテストします。",
                "ru": "Тестовый токен 50x.com, используется в технических целях для тестирования терминала.",
                "tr": "50x.com, Ethereum blok zincirinde ERC-20 tokenini test eder.",
                "uk": "Тестовий токен 50x.com, використовується в технічних цілях для тестування терміналу.",
                "zh": "50x.com测试以太坊区块链上的ERC-20代币。"
            },
            "TAU": {
                "en": "Lamden is a suite of developer tools that speed up the process of creating new and custom blockchains and apps.",
                "fr": "Lamden est une suite d'outils de développement qui accélèrent le processus de création de chaînes de blocs et d'applications nouvelles et personnalisées.",
                "it": "Lamden è una suite di strumenti per sviluppatori che accelerano il processo di creazione di blockchain e app nuove e personalizzate.",
                "ja": "Lamdenは、新規、カスタムブロックチェーンとアプリの作成プロセスを高速化する開発者向けツールです。",
                "ko": "Lamden은 소프트웨어 개발 도구 제품군입니다.",
                "ru": "Lamden - это набор инструментов для разработчиков, которые ускоряют процесс создания новых, пользовательских блокчейнов и приложений.",
                "tr": "Lamden, yeni ve özel blok zincirler ve uygulamalar oluşturma sürecini hızlandıran bir geliştirici araçları paketidir.",
                "uk": "Lamden - це набір інструментів для розробників, які прискорюють процес створення нових, призначених для користувача блокчейнів і додатків.",
                "zh": "Lamden是一套开发工具，可加快创建新的和自定义区块链和应用程序的过程。"
            },
            "TRX": {
                "en": "TRON is one of the largest blockchain-based operating systems in the world.",
                "fr": "TRON est l'un des plus grands systèmes d'exploitation basés sur la blockchain au monde.",
                "it": "TRON è uno dei più grandi sistemi operativi basati su blockchain al mondo.",
                "ja": "TRONは、世界最大のブロックチェーンベースのオペレーティングシステムの1つです。",
                "ko": "TRON은 세계에서 가장 큰 블록 체인 기반 운영 체제 중 하나입니다.",
                "ru": "TRON - одна из крупнейших в мире операционных систем на основе блокчейнов.",
                "tr": "TRON, dünyadaki en büyük blok zinciri tabanlı işletim sistemlerinden biridir.",
                "uk": "TRON - одна з найбільших в світі операційних систем на основі блокчейнів.",
                "zh": "TRON是世界上最大的基于区块链的操作系统之一。"
            },
            "TUSD": {
                "en": "TrueUSD (TUSD) is a cryptocurrency tied to the US dollar rate. TrueUSD belongs to the class of so-called stable coins, which are pegged to real assets and do not imply high volatility.",
                "fr": "TrueUSD (TUSD) est une crypto-monnaie liée au taux du dollar américain. TrueUSD appartient à la classe des pièces dites stables, qui sont rattachées à des actifs réels et n'impliquent pas une volatilité élevée.",
                "it": "TrueUSD (TUSD) è una criptovaluta legata al tasso del dollaro USA. TrueUSD appartiene alla classe delle cosiddette monete stabili, che sono ancorate a beni reali e non implicano un'elevata volatilità.",
                "ja": "TrueUSD（TUSD）は、米ドルレートに紐づけられた仮想通貨です。TrueUSDは、いわゆるステーブルコインに属します。これは、実際の資産に固定されており、高いボラティリティを意味しません。",
                "ko": "TrueUSD (TUSD)는 미국 달러 환율과 연동된 암호화폐입니다.  TrueUSD는 소위 스테이블코인에 속하며 달러라는 실물자산 가치에 고정되어 있어 높은 변동성은 없습니다. 이 TrueUSD(TUSD)는  US 달러와 연동된 Tether에 반하여 나온 첫번째 스테이블 코인입니다.  Tether를 발행하는 회사는 단일 공개 감사를 통과하지 못했습니다.  그리고 2017 년 9 월에 실시 된 감사에서는 많은 의문점이 제기되었습니다. 이러한 의문점들과 관련하여 더 나은 대안으로 나온 것이 TrueUSD(TUSD)입니다.",
                "ru": "TrueUSD (TUSD) это криптовалюта, привязанная к курсу американского доллара. TrueUSD относится к классу так называемых stable coins — монет, курс которых привязан к реальным активам и не предполагает высокой волатильности. Это может стать первым шагом на пути к отказу от Tether, чьи токены также привязаны к курсу американского доллара. ",
                "tr": "TrueUSD (TUSD), ABD doları oranına bağlı olan bir kripto para birimidir. TrueUSD, gerçek varlıklara sabitlenmiş ve yüksek volatilite içermeyen sözde istikrarlı paralar sınıfına aittir.",
                "uk": "TrueUSD (TUSD) це криптовалюта, прив'язана до курсу американського долара. TrueUSD відноситься до класу так званих stable coins - монет, курс яких прив'язаний до реальних активів і не передбачає високої волатильності. Це може стати першим кроком на шляху до відмови від Tether, чиї маркери також прив'язані до курсу американського долара.",
                "zh": "TrueUSD（TUSD）是一种与美元汇率挂钩的加密货币。TrueUSD属于所谓的稳定货币，与实物资产挂钩，并不意味着高波动性。"
            },
            "USDC": {
                "en": "The USDC project is a joint development from Coinbase and Circle (Circle Internet Financial) on the Ethereum platform. USDC tokens are ERC-20 standard tokens. This cryptocurrency is the digital equivalent of the dollar.",
                "fr": "Le projet USDC est un développement conjoint de Coinbase et Circle (Circle Internet Financial) sur la plate-forme Ethereum. Les jetons USDC sont des jetons standard ERC-20. Cette crypto-monnaie est l'équivalent numérique du dollar.",
                "it": "Il progetto USDC è uno sviluppo congiunto di Coinbase e Circle (Circle Internet Financial) sulla piattaforma Ethereum. I token USDC sono token standard ERC-20. Questa criptovaluta è l'equivalente digitale del dollaro.",
                "ja": "USDCプロジェクトは、イーサリアムプラットフォームでCoinbaseとCircle（Circle Internet Financial）により共同開発されました。USDCトークンは、ERC-20標準トークンです。 この仮想通貨は、ドルに相当するデジタル資産です。",
                "ru": "Проект USDC — это совместная разработка от Coinbase и Circle (Circle Internet Financial). При этом самой разработкой занималось их совместное объединение, Centre Consortium.\n Как и у других стейбл-коинов, в качестве основы для криптовалюты USD Coin была взята платформа Ethereum. А токены USDC — это токены стандарта ERC-20. Авторы проекта утверждают, что USDC отличается от классических стейблкоинов. По их словам, эта криптовалюта является цифровым аналогом доллара. И поэтому ее нельзя покупать и продавать за USD для получения прибыли. Доступна лишь прямая конфертация в пропорции 1 к 1.",
                "tr": "USDC projesi, Ethereum platformunda Coinbase ve Circle'dan (Circle Internet Financial) ortak bir oluşumdur. USDC tokenleri ERC-20 standart tokenleridir. Bu kripto para birimi, doların dijital eşdeğeridir.",
                "uk": "Проект USDC - це спільна розробка від Coinbase і Circle (Circle Internet Financial). При цьому самою розробкою займалося їх спільне об'єднання, Centre Consortium.\n  Як і у інших стейбл-коїнів, в якості основи для криптовалюти USD Coin була взята платформа Ethereum. А токени USDC - це маркери стандарту ERC-20. Автори проекту стверджують, що USDC відрізняється від класичних стейблкоїнів. За їхніми словами, ця криптовалюта є цифровим аналогом долара. І тому її не можна купувати і продавати за USD для отримання прибутку. Доступна лише пряма конфертація в пропорції 1 до 1.",
                "zh": "USDC项目是由Coinbase和Circle（Circle Internet Financial）在以太坊平台上联合开发的。USDC代币是ERC-20标准代币。这种加密货币在数字上相当于美元。"
            },
            "USDT": {
                "en": "Tether is a controversial cryptocurrency with tokens issued by Tether Limited on the Ethereum blockchain. It formerly claimed that each token was backed by one United States dollar, but on March 14, 2019 changed the backing to include loans to affiliate companies. Tether was called a stablecoin because it was originally designed to always be worth $1.00, maintaining $1.00 in reserves for each tether issued. On April 30, 2019 Tether Limited's lawyer claimed that each tether was backed by only $0.74 in cash and cash equivalents.",
                "fr": "Tether est une crypto-monnaie controversée avec des jetons émis par Tether Limited. Il affirmait auparavant que chaque jeton était soutenu par un dollar américain, mais le 14 mars 2019, le support a été modifié pour inclure des prêts aux sociétés affiliées. Tether a été appelé un stablecoin parce qu'il était à l'origine conçu pour toujours valoir 1,00 $, en conservant 1,00 $ en réserves pour chaque tether émis. Le 30 avril 2019, l'avocat de Tether Limited a affirmé que chaque attache n'était soutenue que par 0,74 $ en espèces et quasi-espèces.",
                "it": "Tether è una controversa criptovaluta con token emessi da Tether Limited. In precedenza sosteneva che ogni token era sostenuto da un dollaro degli Stati Uniti, ma il 14 marzo 2019 ha cambiato il supporto per includere i prestiti alle società affiliate. Tether è stato chiamato stablecoin perché originariamente progettato per valere sempre $ 1,00, mantenendo $ 1,00 di riserve per ciascun tether emesso. Il 30 aprile 2019, l'avvocato di Tether Limited ha sostenuto che ciascun tether era sostenuto da $ 0,74 in contanti e equivalenti.",
                "ja": "テザーは、テザーリミテッドによって発行されたトークンを使用した物議を醸す仮想通貨です。以前は、各トークンは1米ドルに裏付けられると主張していましたが、2019年3月14日に関係会社へのローンを含めるよう変更しました。テザーは、元々は常に$1.00に相当するように設計され、発行されたテザーごとに$1.00の準備金を維持するため、ステーブルコインと呼ばれていました。2019年4月30日に、テザーリミテッドの弁護士は、各テザーに紐づけられているのは、わずか0.74ドルの現金および現金同等物だと主張しています。",
                "ru": "Tether  — криптовалютный токен, выпущенный компанией Tether Limited на блокчейне Ethereum. Компания утверждает, что его стоимость обеспечивается запасами долларов США, хранящимися на её банковских счетах. Основная идея разработчиков данного токена состоит в предоставлении участникам криптовалютного рынка возможности пользоваться стабильным цифровым активом («стейблкоином»), курс которого привязан к курсу доллара США и не испытывает столь сильных колебаний, как курсы других криптовалют. Tether выпущен на платформе ETHEREUM как токен ERC-20.",
                "tr": "Tether, Tether Limited tarafından verilen tokenlerle ihtilaflı bir kripto para birimidir. Daha önce, her tokenin bir ABD doları tarafından desteklendiği iddia edildi, ancak 14 Mart 2019 tarihinde, bağlı şirketlerine kredi eklemek için desteği değiştirdi. Tether, başlangıçta her zaman 1.00 $ değerinde olacak şekilde tasarlanmıştı ve verilen her bir tether için rezervlerde 1.00 $'ı koruyarak stabilcoin olarak adlandırıldı. 30 Nisan 2019 tarihinde Tether Limited'in avukatı, her tetherin sadece 0,74 $ nakit ve nakit eşdeğeri ile desteklendiğini iddia etti.",
                "uk": "Tether - криптовалютний токен, випущений компанією Tether Limited, яка стверджує, що його вартість забезпечується запасами доларів США, що зберігаються на її банківських рахунках. Основна ідея розробників даного токена полягає в наданні учасникам криптовалютного ринку можливості користуватися стабільним цифровим активом («стейблкоїном»), курс якого прив'язаний до курсу долара США і не відчуває таких сильних коливань, як курси інших криптовалют. Tether випущений на платформі ETHEREUM як токен ERC-20.",
                "zh": "Tether是一种有争议的加密货币，由Tether有限公司发行。它以前声称每一个代币都有一美元作为担保，但在2019年3月14日，它改变了担保方式，将贷款纳入附属公司。系绳之所以被称为马厩，是因为它最初的设计总是价值1.00美元，为每一个发行的系绳维持1.00美元的储备。2019年4月30日，Tether有限公司的律师声称，每个Tether的现金和现金等价物只有0.74美元。"
            },
            "WAVES": {
                "en": "Open blockchain platform and development toolset for Web 3.0 applications and decentralized solutions.",
                "fr": "Plateforme blockchain ouverte et ensemble d'outils de développement pour les applications Web 3.0 et les solutions décentralisées.",
                "it": "Piattaforma blockchain aperta e set di strumenti di sviluppo per applicazioni Web 3.0 e soluzioni decentralizzate.",
                "ja": "ウェブ3.0アプリケーションおよび分散ソリューション向けのオープンブロックチェーンプラットフォーム、そして、開発ツールセットです。",
                "ko": "이 플랫폼은 LPoS 컨센서스를 기반으로 운영되며, Proof-of-stake 합의를 수정합니다. LPoS의 특징은 사용자가 광업으로 인한 이익의 일부와 교환하여 자신의 대차 대조표를 전체 노드로 대여 할 수 있다는 것입니다 (소위 Account Leasing).\n\n임대인은 언제든지 양도 된 자금을 반환 할 권리가 있습니다. 블록 생성에 관여하는 사용자는 Waves 토큰 잔액에 의해 선택됩니다. 전체 노드 만 플랫폼 내에서 마이닝 권한을가집니다. 일반 사용자는 자신의 대차 대조표 만 전송할 수 있으며 채광 프로세스에 참여하지 않습니다.\n\n토큰으로 작업 기반을 구성하는 블록 체인의 불변성을 보장하기 위해 Bitcoin 시스템에서 사용되는 것과 유사한 암호화가 사용됩니다. 즉, 클래식 공개 키 암호화가 사용되며 토큰 소유자는 개인 키가 외부인에게 알려질 때까지 잔액을 제어합니다. 토큰은 다른 프로젝트의 토큰뿐만 아니라 피아트 또는 암호 해독으로 변환 될 수 있습니다.",
                "ru": "Платформа функционирует на основе консенсуса LPoS, модификации консенсуса Proof-of-stake. Особенностью LPoS является возможность для пользователей передавать собственные балансы полным узлам на правах аренды в обмен на часть прибыли от майнинга (так называемый Account leasing).\n\nУ арендодателей остается право вернуть переданные средства в любой момент. Пользователи, занятые генерацией блоков, отбираются по балансу токена Waves. Право майнинга в рамках платформы есть только у полных нод. Рядовые пользователи могут лишь передавать им свои балансы в аренду и в процессе майнинга не участвуют.\n\nДля обеспечения неизменности цепочки блоков, составляющих базу операций с токенами, используется криптография, аналогичная используемой в системе Биткойн. То есть применяется классическое шифрование с открытым ключом, а держатель токенов сохраняет контроль над своим балансом до тех пор, пока его закрытый ключ не оказывается известен посторонним. Токены могут быть конвертированы как в фиатную, так и в криптовалюту, а также в токены других проектов. ",
                "tr": "Web 3.0 uygulamaları ve merkezi olmayan çözümler için açık blok zinciri platformu ve geliştirme araç seti.",
                "uk": "Платформа функціонує на основі консенсусу LPoS, модифікації консенсусу Proof-of-stake. Особливістю LPoS є можливість для користувачів передавати власні баланси повним вузлам на правах оренди в обмін на частину прибутку від майнінга (так званий Account leasing).\n\nУ орендодавців залишається право повернути передані кошти в будь-який момент. Користувачі, зайняті генерацією блоків, відбираються по балансу токена Waves. Право майнінга в рамках платформи є тільки у повних нод. Рядові користувачі можуть лише передавати їм свої баланси в оренду і в процесі майнінга не беруть участь.\n\nДля забезпечення незмінності ланцюжка блоків, що є основою операцій з токенами, використовується криптографія, аналогічна використовуваної в системі біткоїнів. Тобто застосовується класичне шифрування з відкритим ключем, а утримувач токенів зберігає контроль над своїм балансом до тих пір, поки його закритий ключ не виявляється відомий стороннім. Токени можуть бути конвертовані як в фіат, так і в криптовалюту, а також в токени інших проектів.",
                "zh": "用于Web3.0应用程序和分散式解决方案的开放区块链平台和开发工具集。"
            },
            "XLM": {
                "en": "Stellar Lumen (XLM), powers the Stellar payment network.",
                "fr": "Stellar Lumen (XLM), alimente le réseau de paiement Stellar.",
                "it": "Stellar Lumen (XLM), alimenta la rete di pagamento Stellar.",
                "ja": "Stellar Lumen（XLM）は、Stellar支払いネットワークを強化します。",
                "tr": "Stellar Lumen (XLM), Stellar ödeme ağına güç sağlar.",
                "uk": "Stellar Lumen (XLM), працює на платіжній мережі Stellar.",
                "zh": "恒星流明（XLM），为恒星支付网络提供动力。"
            },
            "XRP": {
                "en": "Ripple (XRP) is an independent digital asset that is native to the Ripple Consensus Ledger.",
                "fr": "Ripple (XRP) est un actif numérique indépendant natif du Ripple Consensus Ledger.",
                "it": "Ripple (XRP) è una risorsa digitale indipendente originaria del libro mastro del consenso di Ripple.",
                "ja": "リップル（XRP）は、リップルコンセンサスレッジャーに固有の独立したデジタル資産です。",
                "tr": "Ripple (XRP), Ripple Consensus Ledger'e özgü bağımsız bir dijital varlıktır.",
                "uk": "Ripple (XRP) - незалежний цифровий актив, який є власником Ripple Consensus Ledger.",
                "zh": "Ripple（XRP）是Ripple共识分类账固有的独立数字资产。"
            },
            "ZRX": {
                "en": "Powering decentralized exchange",
                "fr": "Alimenter les échanges décentralisés",
                "it": "Alimentare lo scambio decentralizzato",
                "ja": "分散型取引所の強化",
                "ko": "분산 된 전원 공급",
                "ru": "Токены децентрализованной биржи.",
                "tr": "Merkezi olmayan değişimin güçlendirilmesi",
                "uk": "Токени децентралізованої біржі.",
                "zh": "为分散交换供电"
            }
        }
    },
    "lastTrades": {
        "_header": {
            "pair": {
                "en": "Last trades {pair}",
                "fr": "Dernières transactions {pair}",
                "it": "Ultimi scambi {pair}",
                "ja": "最後の取引{pair}",
                "ko": "최근 {pair} 거래내역",
                "ru": "Последние сделки {pair}",
                "tr": "Son alım satım işlemleri {pair}",
                "uk": "Останні угоди {pair}",
                "zh": "最后一笔交易{pair}"
            },
            "sym": {
                "en": "Last trades {sym}",
                "fr": "Dernières échanges {sym}",
                "it": "Ultimi scambi {sym}",
                "ja": "最後の取引{sym}",
                "ko": "최근 {sym} 거래내역",
                "ru": "Последние сделки {sym}",
                "tr": "Son alım satım işlemleri {sym}",
                "uk": "Останні угоди {sym}",
                "zh": "最后一笔交易{sym}"
            }
        }
    },
    "market": {
        "_header": {
            "en": "Market {sym}",
            "fr": "Marché {sym}",
            "it": "Mercato {sym}",
            "ja": "市場の{sym}",
            "ko": "시장 {sym}",
            "ru": "Маркет {sym}",
            "tr": "Piyasa {sym}",
            "uk": "Маркет {sym}",
            "zh": "市场 {sym}"
        },
        "_description": {
            "en": "(yesterday)",
            "fr": "(hier)",
            "it": "(ieri)",
            "ja": "（昨日）",
            "ru": "(вчера)",
            "tr": "(dün)",
            "uk": "(вчора)",
            "zh": "（昨天）"
        },
        "_description2": {
            "en": "(last 24H)",
            "fr": "(dernières 24H)",
            "it": "(ultime 24 ore)",
            "de": "(letzte 24H)",
            "ja": "（過去24時間）",
            "ru": "(за сутки)",
            "tr": "(son 24S)",
            "uk": "(за добу)",
            "zh": "（最后24小时）"
        }
    },
	"modal_convertDust": {
		"_header": {
			"en": "Convert total {sym} balance into A2A tokens",
            "fr": "Convertir le solde total de {sym} en jetons A2A",
            "it": "Converti il   saldo {sym} totale in token A2A",
            "de": "Konvertieren Sie das gesamte {sym} Guthaben in A2A-Token",
            "ja": "{sym}の合計残高をA2Aトークンに変換します",
            "ru": "Конвертировать весь баланс {sym} в токены A2A",
            "tr": "Toplam {sym} bakiyesini A2A jetonlarına dönüştürün",
            "uk": "Перетворити загальний баланс {sym} на маркери A2A",
            "zh": "将{sym}余额总计转换为A2A令牌"
		},
		"text1": {
			"en": "You may convert {sym} available balance into A2A tokens if your total {sym} balance is lower than Minimal Trading Volume for {sym}.",
			"fr": "Vous pouvez convertir {sym} solde disponible en jetons A2A si votre solde total {sym} est inférieur au volume de trading minimal pour {sym}",
			"it": "Puoi convertire il saldo disponibile di {sym} in token A2A se il tuo saldo {sym} totale è inferiore al volume di scambio minimo per {sym}",
			"de": "Sie können das verfügbare Guthaben von {sym} in A2A-Token umwandeln, wenn Ihr gesamtes Guthaben von {sym} niedriger ist als das minimale Handelsvolumen für {sym}",
			"ja": "{sym}の合計残高が{sym}の最小取引量よりも少ない場合は、{sym}の利用可能な残高をA2Aトークンに変換できます。",
			"ko": "총 {sym} 잔액이 {sym}의 최소 거래량보다 낮 으면 사용 가능한 {sym} 잔액을 A2A 토큰으로 전환 할 수 있습니다.",
            "ru": "Вы можете конвертировать доступный баланс {sym} в токены A2A, если ваш общий баланс {sym} меньше минимального торгового объема для {sym}",
            "tr": "Toplam {sym} bakiyeniz {sym} için Minimum İşlem Hacminden düşükse, {sym} kullanılabilir bakiyeyi A2A jetonlarına dönüştürebilirsiniz.",
            "ua": "Ви можете перетворити {sym} наявний баланс у токени A2A, якщо ваш загальний баланс {sym} нижчий за мінімальний обсяг торгів для {sym}",
            "zh": "如果您的总{sym}余额低于{sym}的最低交易量，则可以将{sym}可用余额转换为A2A代币"
		},
		"text3": {
			"en": "All your {sym} tokens will be converted at the current market rates.",
			"fr": "Tous vos jetons {sym} seront convertis aux taux actuels du marché.",
			"it": "Tutti i tuoi token {sym} verranno convertiti agli attuali tassi di mercato.",
			"de": "Alle Ihre {sym} Token werden zu den aktuellen Marktpreisen konvertiert.",
			"ja": "すべての{sym}トークンは、現在の市場レートで変換されます。",
			"ko": "모든 {sym} 토큰은 현재 시장 요율로 변환됩니다.",
            "ru": "Конвертировать весь баланс {sym} в токены A2A",
            "tr": "Tüm {sym} jetonlarınız mevcut piyasa oranlarına göre dönüştürülecektir.",
            "ua": "Усі ваші символи {sym} будуть конвертовані за поточними ринковими курсами.",
            "zh": "您所有的{sym}代币都将按照当前的市场汇率转换。"
		}
	},
    "modal_EWAset": {
        "_header": {
            "en": "Setting new {blockchain} Emergency Withdrawal Address (EWA)",
            "fr": "Définition d'une nouvelle {blockchain} adresse de retrait d'urgence (EWA)",
            "it": "Impostazione di un nuovo {blockchain} indirizzo per il ritiro di emergenza (EWA)",
            "ja": "新しい{blockchain}の緊急出金アドレス(EWA)の設定",
            "ru": "Сохранение нового Адреса Аварийного Вывода {blockchain} (EWA)",
            "tr": "Yeni {blockchain} Acil Durum Para Çekme Adresinin (EWA) ayarlanması",
            "uk": "Збереження нової Адреси Аварійного Виведення {blockchain} (EWA)",
            "zh": "设置新的{blockchain}紧急取款地址（EWA）"
        },
        "text": {
            "en": "{blockchain} Emergency Withdrawal Address (EWA) is the address where {sym} tokens will be sent automatically if you activate Emergency Account Termination. We recommend to use your own cold wallet address for this purpose. Smart Contract addresses are not supported.",
            "fr": "{blockchain} Adresse de retrait d'urgence (EWA) est l'adresse à laquelle les jetons {sym} seront envoyés automatiquement si vous activez la résiliation d'urgence du compte. Nous vous recommandons d'utiliser votre propre adresse de portefeuille froid à cette fin. Les adresses Smart Contract ne sont pas prises en charge.",
            "it": "{blockchain} Indirizzo di prelievo di emergenza (EWA) è l'indirizzo a cui {sym} token verranno inviati automaticamente se si attiva la chiusura del conto di emergenza. A tal fine, ti consigliamo di utilizzare il tuo indirizzo di portafoglio freddo. Gli indirizzi Smart Contract non sono supportati.",
            "ja": "{blockchain}の緊急出金アドレス（EWA）は、緊急アカウント終了を有効にした場合に{sym}トークンが自動的に送信されるアドレスです。このために、独自のコールドウォレットアドレスを使用することをお勧めします。スマートコントラクトのアドレスはサポートされていません。",
            "ru": "Адрес Аварийного Вывода (EWA) {blockchain} - это адрес в блокчейне {blockchain}, на который будут автоматически выведены токены {sym} с вашего аккаунта, если вы активируете процедуру Аварийного Закрытия Аккаунта. Вывод на адреса смарт-контрактов не поддерживается.",
            "tr": "{blockchain} Acil Durum Para Çekme Adresi (EWA), Acil Durum Hesap Sonlandırmayı etkinleştirmeniz durumunda {sym} tokenlerinin otomatik olarak gönderileceği adrestir. Bu amaçla kendi soğuk cüzdan adresinizi kullanmanızı öneririz. Akıllı Sözleşme adresleri desteklenmemektedir.",
            "uk": "Адреса Аварійного Виведення (EWA) {blockchain} - це адреса, на яку будуть автоматично виведені токени {sym} з вашого аккаунта, якщо ви активуєте процедуру Аварійного Закриття Акаунта. Виведення на адреси смарт-контрактів не підтримується.",
            "zh": "{blockchain}紧急取款地址（EWA）是在激活紧急帐户终止时自动发送{sym}令牌的地址。为此，我们建议您使用自己的冷钱包地址。不支持智能合约地址。"
        }
    },
    "modal_EWAshow": {
    },
    "modal_EWAwarning": {
        "_header": {
            "en": "WARNING! Your account does not have EWA!",
            "fr": "AVERTISSEMENT! Votre compte n'a pas EWA!",
            "it": "AVVERTIMENTO! Il tuo account non ha EWA!",
            "ja": "警告！アカウントにEWAがありません！",
            "ru": "ВНИМАНИЕ! У вас не заданы EWA!",
            "tr": "UYARI! Hesabınızda EWA bulunmuyor!",
            "uk": "УВАГА! У вас не задані EWA!",
            "zh": "警告！你的帐户没有EWA！"
        },
        "text1": {
            "en": "No Emergency Withdrawal Addresses (EWA) have been set for your account. You will not be able to use your Master Key until you set at least one EWA.",
            "fr": "Aucune adresse de retrait d'urgence (EWA) n'a été définie pour votre compte. Vous ne pourrez pas utiliser votre clé principale tant que vous n'aurez pas défini au moins un EWA.",
            "it": "Non sono stati impostati indirizzi di prelievo di emergenza (EWA) per il tuo account. Non sarai in grado di utilizzare la tua chiave master fino a quando non imposti almeno un EWA.",
            "ja": "アカウントに緊急出金アドレス（EWA）が設定されていません。少なくとも1つのEWAを設定するまで、マスターキーを使用することはできません。",
            "ru": "На вашем аккаунте не задан ни один Кошелек Аварийного Вывода (EWA). Вы не сможете использовать Мастер-ключ в случае утраты доступа к сайту пока не будет указан хотя бы один Адрес Аварийного Вывода (EWA).",
            "tr": "Hesabınız için hiçbir Acil Durum Para Çekme Adresi (EWA) ayarlanmadı. En az bir EWA ayarlayana kadar Ana Anahtarınızı kullanamazsınız.",
            "uk": "На вашому аккаунті не заданий жоден Гаманець Аварійного Виведення (EWA). Ви не зможете використати Майстер-ключ в разі втрати доступу до сайту поки не буде вказана принаймні одна Адреса Аварійного Виведення (EWA).",
            "zh": "没有为您的帐户设置紧急取款地址（EWA）。在至少设置一个EWA之前，您将无法使用主密钥。"
        },
        "text2": {
            "en": "You will not be able to recover your tokens in case you lose your 2FA device and 2FA SEED key because no Emergency Withdrawal Address (EWA) has been set.<br><b>Please take this issue seriously. There is no other way to recover your tokens in case of access problems!</b>",
            "fr": "Vous ne pourrez pas récupérer vos jetons au cas où vous perdriez votre appareil 2FA et votre clé 2FA SEED car aucune adresse de retrait d'urgence (EWA) n'a été définie. <br> <b> Veuillez prendre ce problème au sérieux. Il n'y a pas d'autre moyen de récupérer vos tokens en cas de problème d'accès! </b>",
            "it": "Non sarai in grado di recuperare i token nel caso in cui perdessi il dispositivo 2FA e la chiave SEED 2FA perché non è stato impostato alcun indirizzo di prelievo di emergenza (EWA). <br> <b> Prendi sul serio questo problema. Non esiste altro modo per recuperare i token in caso di problemi di accesso! </b>",
            "ja": "緊急出金アドレス（EWA）が設定されていないため、2FAデバイスと2FAシードキーを紛失した場合、トークンを回復することはできません。<br><b>この問題を真剣に受け止めてください。アクセスの問題が発生した場合にトークンを回復する他の方法はありません！</b>",
            "ru": "Вы не сможете получить свои токены используя Мастер-ключ в случае утраты доступа к сайту, потому что не задали ни одного Адреса Аварийного Вывода (EWA)<br><b>Отнеситесь к этому серьезно! Без заданного Адреса Аварийного Вывода (EWA) у вас нет возможности вывести токены с биржи, если по каким-то причинам вы потеряете доступ и не сможете его восстановить штатными средствами.</b>",
            "tr": "Acil Durum Para Çekme Adresi (EWA) ayarlanmadığı için 2FA cihazınızı ve 2FA SEED anahtarınızı kaybetmeniz durumunda tokenlerinizi kurtaramazsınız.<br><b>Lütfen bu sorunu ciddiye alın. Erişim sorunları olması durumunda tokenlerinizi kurtarmanın başka bir yolu bulunmamaktadır!</b>",
            "uk": "Ви не зможете отримати свої токени використовуючи Майстер-ключ в разі втрати доступу до сайту, тому що не задали жодної Адреси Аварійного Виведення (EWA)<br><b>Поставтеся до цього серйозно! Без заданої Адреси Аварійного Виведення (EWA) у вас немає можливості вивести токени з біржі, якщо з якихось причин ви втратите доступ і не зможете його відновити штатними засобами.</b>",
            "zh": "如果您丢失了2FA设备和2FA种子密钥，您将无法恢复代币，因为未设置紧急取款地址（EWA）。<br><b>请认真对待此问题。如果出现访问问题，没有其他方法可以恢复代币！</b>"
        },
        "text3": {
            "en": "You must set one of the MAIN EWA first. If there is no EWA for some tokens on your account upon termination, such tokens will be converted with the market order and sent to the first found EWA in the following order: BTC, ETH, LTC.",
            "fr": "Vous devez d'abord définir l'un des MAIN EWA. S'il n'y a pas d'EWA pour certains jetons sur votre compte lors de la résiliation, ces jetons seront convertis avec l'ordre du marché et envoyés au premier EWA trouvé dans l'ordre suivant: BTC, ETH, LTC.",
            "it": "È necessario impostare prima uno dei EWA PRINCIPALI. Se non è disponibile alcun EWA per alcuni token sul proprio account al momento della risoluzione, tali token verranno convertiti con l'ordine di mercato e inviati al primo EWA trovato nel seguente ordine: BTC, ETH, LTC.",
            "ja": "最初にMAIN EWAのいずれかを設定する必要があります。終了時にアカウントの一部のトークンにEWAがない場合、そのトークンは成行注文で変換され、BTC、ETH、LTCの順序で最初に見つかったEWAに送信されます。",
            "ru": "Для начала, нужно задать любой из трех основных EWA, чтобы на них были отправлены средства от продажи тех токенов, для которых вы не задали EWA блокчейна, на котором они выпущены, в первый из найденных EWA в порядке: BTC, ETH, LTC. После установки одного их основных вы можете добавлять/менять EWA для любого токена в разделе КОШЕЛЬКИ -> ИНФО.",
            "tr": "Öncelikle ANA EWA'dan birini ayarlamanız gereklidir. Sonlandırıldıktan sonra hesabınızda bazı tokenler için EWA bulunmuyorsa, bu tokenler piyasa komutuna dönüştürülür ve ilk bulunan EWA'ya şu sırayla gönderilir: BTC, ETH, LTC.",
            "uk": "Для початку, потрібно задати будь-яку з трьох основних EWA, щоб на них були відправлені кошти від продажу тих токенов, для яких ви не задали EWA блокчейна, на якому вони випущені, в перший зі знайдених EWA в порядку: BTC, ETH, LTC. Після установки одного з основних ви можете додавати/змінювати EWA для будь-якого токена в розділі ГАМАНЦІ -> ІНФО.",
            "zh": "你必须先设置一个主EWA。如果您的账户在终止时没有某些代币的EWA，则此类代币将根据市场订单进行转换，并按以下顺序发送给第一个找到的EWA:BTC、ETH、LTC。"
        }
    },
    "modal_blotter": {},
    "modal_browserWarning": {
        "_header": {
            "en": "Browser ERROR!",
            "fr": "Erreur de navigateur!",
            "it": "Errore del navigatore",
            "ja": "ブラウザエラー！",
            "ru": "Ошибка Браузера!",
            "tr": "Tarayıcı HATASI!",
            "uk": "Помилка Браузера!",
            "zh": "浏览器错误！"
        },
        "text1": {
            "en": "Your browser settings or version are not compatible with JS web application. Please use latest browser like Chrome or Firefox or correct settings in your browser to let JS web app work properly. Brave and some other browsers are known for such issues.",
            "fr": "Les paramètres ou la version de votre navigateur ne sont pas compatibles avec l'application Web JS. Veuillez utiliser le dernier navigateur comme Chrome ou Firefox ou les paramètres corrects de votre navigateur pour permettre à l'application Web JS de fonctionner correctement. Brave et certains autres navigateurs sont connus pour ces problèmes.",
            "it": "Le impostazioni o la versione del browser non sono compatibili con l'applicazione Web JS. Utilizzare il browser più recente come Chrome o Firefox o le impostazioni corrette nel browser per far funzionare correttamente l'app Web JS. Brave e alcuni altri browser sono noti per tali problemi.",
            "ja": "ブラウザの設定またはバージョンは、JS Webアプリケーションと互換性がありません。JSウェブアプリが正常に動作するように、ChromeやFirefoxなどの最新のブラウザを使用するか、ブラウザの設定を修正してください。Braveなどのブラウザでは問題の発生が報告されています。",
            "ru": "Версия или настройки вашего браузера не позволяют корректно работать веб-приложению JS. Если вы давно не обновляли браузер, установите и используйте последнюю версию Chrome или Firefox и отключите в них плагины и расширения. Если вы используете Brave или аналогичные альтернативные сборки браузеров, настройте их для корректной работы веб-приложений JS.",
            "tr": "Tarayıcı ayarlarınız veya sürümünüz JS web uygulamasıyla uyumlu değil. JS web uygulamasının düzgün çalışmasını sağlamak için lütfen Chrome veya Firefox gibi en son sürüm tarayıcıyı kullanın veya tarayıcınızda ayarları düzeltin. Brave ve diğer bazı tarayıcılar bu tür sorunlarla tanınır.",
            "uk": "Версія або налаштування вашого браузера не дозволяють коректно працювати веб-додатку JS. Якщо ви давно не оновлювали браузер, встановіть і використовуйте останню версію Chrome або Firefox і відключіть в них плагіни і розширення. Якщо ви використовуєте Brave або аналогічні альтернативні збірки браузерів, налаштуйте їх для коректної роботи веб-додатків JS.",
            "zh": "您的浏览器设置或版本与JS web应用程序不兼容。请使用最新的浏览器，如Chrome或Firefox，或在浏览器中使用正确的设置，以使JS web应用正常工作。Brave和其他一些浏览器以此类问题而闻名。"
        }
    },
    "modal_changePassword": {
        "_description": {
            "en": "Please check your mailbox and find a password reset code in the e-mail with the subject \"Reset password code for 50x.com\"",
            "fr": "Veuillez vérifier votre boîte aux lettres et trouver un code de réinitialisation de mot de passe dans l'e-mail avec le sujet \"Réinitialiser le code de mot de passe pour 50x.com\"",
            "it": "Controlla la tua casella di posta e trova un codice di reimpostazione della password nell'e-mail con l'oggetto \"Reimposta codice password per 50x.com\"",
            "ja": "受信箱を確認してください。「50x.comのパスワードコードリセット」という旨の件名が記載されたメールにパスワードリセットコードが含まれています。",
            "ko": "메일함을 확인하고 제목이 \"Reset password code for 50x.com\"인 이메일에서 암호 재설정 코드를 찾으십시오.",
            "nn": "Ver venleg og sjekk mailboksen din og finn kode for tilbakestilling av passport i epost med emnet \"Reset password code for 50x.com\"",
            "no": "Vennligst sjekk mailboksen din og finn kode for tilbakestilling av passord i e-posten med emnet \"Reset password code for 50x.com\"",
            "ru": "Проверьте вашу почту, код для обнуления пароля выслан в письме с темой: \"Reset password code for 50x.com\"",
            "tr": "Lütfen posta kutunuzu kontrol edin ve \"50x.com için parola kodunu sıfırla\" konulu e-postada bir parola sıfırlama kodu bulun",
            "uk": "Перевірте вашу пошту, код для обнулення пароля висланий в листі з темою: \"Reset password code for 50x.com\"",
            "zh": "请检查您的邮箱，并在主题为“重置50x.com的密码”的电子邮件中找到密码重置代码"
        }
    },
    "modal_confirmEmail": {
        "confirm_desription": {
            "en": "After your email has been confirmed, you will need to activate Two-Factor Authorization (2FA) for more security.",
            "fr": "Une fois votre e-mail confirmé, vous devrez activer l'autorisation à deux facteurs (2FA) pour plus de sécurité.",
            "it": "Dopo che la tua e-mail è stata confermata, dovrai attivare l'autorizzazione a due fattori (2FA) per maggiore sicurezza.",
            "ja": "メールアドレスの確認後、セキュリティを強化するために二要素認証（2FA）を有効にする必要があります。",
            "ko": "귀하의 전자메일이 확인 된 후 더 많은 보안을 위해 2 단계 인증 (2FA)을 활성화해야합니다",
            "ru": "После того как ваш e-mail будет подтверждён, вам нужно будет активировать двухфакторную Авторизацию (2FA) для большей безопасности.",
            "tr": "E-postanız onaylandıktan sonra, daha fazla güvenlik için İki Faktörlü Yetkilendirmeyi (2FA) etkinleştirmeniz gereklidir.",
            "uk": "Після того як ваш e-mail буде підтверджений, вам потрібно буде активувати двухфакторную Авторизацію (2FA) для більшої безпеки.",
            "zh": "确认您的电子邮件后，您将需要激活双因素授权（2FA）以提高安全性。"
        }
    },
    "modal_createApikey": {},
    "modal_createOrderError": {
        "_header": {
            "en": "Order placement error",
            "fr": "Erreur de placement de commande",
            "it": "Errore nel posizionamento dell'ordine",
            "ja": "注文送信エラー",
            "ru": "Ошибка создания ордера",
            "tr": "Komut yerleşim hatası",
            "uk": "Помилка створення ордера",
            "zh": "订单放置错误"
        }
    },
    "modal_createOrderMarketAlert": {
        "_header": {
            "en": "Market Orders Risk Disclosure",
            "fr": "Divulgation des risques liés aux ordres du marché",
            "it": "Divulgazione del rischio degli ordini di mercato",
            "ja": "成り行き注文のリスク開示",
            "ko": "시장가 주문 위험 알림",
            "nn": "Marknadordrar Risikoopplysning",
            "no": "Markedsordrer Risikoopplysning",
            "ru": "Уведомление о риске Маркет-ордеров",
            "tr": "Piyasa Komutları Risk Açıklaması",
            "uk": "Повідомлення про ризик Маркет-ордерів",
            "zh": "市场指令风险披露"
        },
        "button_accept": {
            "en": "I understood the risk, execute anyway",
            "fr": "J'ai compris le risque, exécutez quand même",
            "it": "Ho capito il rischio, eseguire comunque",
            "ja": "リスクを理解した上で操作を実行する",
            "ko": "위험이 있음을 이해했습니다.",
            "nn": "Eg forsto risikoen, utfør likevel",
            "no": "Jeg forstod risikoen, utfør allikevel",
            "ru": "Я понимаю риск, выставить ордер",
            "tr": "Riski anladım, yine de uygula",
            "uk": "Я розумію ризик, виставити ордер",
            "zh": "我明白风险，无论如何都要执行"
        },
        "first_description": {
            "en": "With a Market order you are guaranteed to get your order transacted, but unlike the Limit order, a Market order provides no price protection and may get a price inferior to what you were after.",
            "fr": "Avec un ordre de marché, vous êtes assuré de faire traiter votre ordre, mais contrairement à l'ordre à cours limité, un ordre de marché n'offre aucune protection de prix et peut obtenir un prix inférieur à ce que vous recherchiez.",
            "it": "Con un ordine di mercato ti viene garantito che il tuo ordine verrà effettuato, ma a differenza dell'ordine di limite, un ordine di mercato non fornisce alcuna protezione del prezzo e può ottenere un prezzo inferiore a quello che stavi cercando.",
            "ja": "成行注文では、注文を処理することが保証されていますが、指値注文とは異なり、成行注文は価格保護がなく、あなたの希望よりも価格が低くなる場合があります。",
            "ko": "시장가 주문을 이용하면 주문이 확실하게 체결되지만, 지정가 주문과 달리 시장가 주문은 가격 보호를 제공하지 않으며 더 낮은 가격으로 체결될 수도 있습니다.",
            "nn": "Med ein marknadordre er du garantert å få bestillinga di gjennomført, men i motsetning til Grenseordre så gjer ein marknadsordre ingen prisbeskyttelse og kan dermed føra til ein pris dårlegare enn kva du var ute etter.",
            "no": "Med en markedsordre er du garantert å få bestillingen din gjennomført, men i motsetning til Grenseordre så gir en markedsordre ingen prisbeskyttelse og kan dermed føre til en pris dårligere enn hva du var etter.",
            "ru": "С рыночным ордером вы гарантированно получите свой заказ, но в отличие от лимитного ордера, рыночный ордер не предусматривает никакой ценовой защиты и может получить цену, хуже, чем вы готовы были принять.",
            "tr": "Bir Piyasa komutuyla, komutunuzu işleme koymanız garanti edilir, ancak Limit komutundan farklı olarak, bir Piyasa komutu fiyat koruması sağlamaz ve daha sonra daha düşük bir fiyat alabilirsiniz.",
            "uk": "З ринковим ордером ви гарантовано отримаєте своє замовлення, але на відміну від лімітного ордера, ринковий ордер не передбачає ніякого цінового захисту і може отримати ціну, гірше, ніж ви були готові прийняти.",
            "zh": "有了市场订单，你就可以保证你的订单成交，但与限价订单不同，市场订单不提供价格保护，可能会得到低于你所追求的价格。"
        },
        "fourth_description": {
            "en": "Warning! The execution price of the Market orders is unpredictable by its nature.",
            "fr": "Avertissement! Le prix d'exécution des ordres de marché est imprévisible par sa nature.",
            "it": "Avvertimento! Il prezzo di esecuzione degli ordini di mercato è imprevedibile per sua natura.",
            "ja": "警告！成行注文の約定価格は、その性質上予測不能です。",
            "ko": "경고! 시장가 주문의 실행 가격은 예측할 수 없습니다.",
            "nn": "Åtvaring! Utføringsprisen på marknadssordrane er uføreseieleg av natur.",
            "no": "Advarsel! Utførelsesprisen på markedsordrene er uforutsigbar av natur.",
            "ru": "Предупреждение! Цена исполнения маркет-ордера непредсказуема из-за типа ордера.",
            "tr": "Uyarı! Piyasa komutlarının uygulama fiyatı, doğası gereği tahmin edilemez.",
            "uk": "Попередження! Ціна виконання маркет-ордера непередбачувана через тип ордера.",
            "zh": "警告！从本质上讲，市场指令的执行价格是不可预测的。"
        },
        "second_description": {
            "en": "On illiquid markets that are not traded frequently, there are people who would put a limit order at unrealistic prices, just to make quick money from people who blindly put market trades. We do not recommend using market orders, as neither you nor 50x.com system can predict the exact execution price for such orders.",
            "fr": "Sur les marchés non liquides qui ne sont pas échangés fréquemment, il y a des gens qui placeraient un ordre à cours limité à des prix irréalistes, juste pour gagner rapidement de l'argent avec des gens qui mettent aveuglément des échanges sur le marché. Nous ne recommandons pas d'utiliser des ordres de marché, car ni vous ni le système 50x.com ne pouvez prédire le prix d'exécution exact de ces ordres.",
            "it": "Sui mercati illiquidi che non sono scambiati frequentemente, ci sono persone che metterebbero un ordine limite a prezzi non realistici, solo per guadagnare velocemente da persone che fanno ciecamente scambi commerciali. Non è consigliabile utilizzare gli ordini di mercato, poiché né tu né il sistema 50x.com potete prevedere l'esatto prezzo di esecuzione di tali ordini.",
            "ja": "頻繁に取引されない非流動的な市場では、成行注文を盲目的に行う人から素早くお金を稼ぐためだけに、非現実的な価格で指値注文を行う人がいます。あなたも50x.comシステムもそのような注文の正確な価格を予測できないため、成行注文の使用はお勧めしません。",
            "ko": "유동성이 낮고 거래가 자주 일어나지 않는 시장에서 비현실적인 가격에 지정가 주문을 넣는 사람들이 있습니다. 무턱대고 시장가 거래를 하는 사람들로부터 돈을 재빨리 얻으려는 것입니다. 스텍스 시스템이나 사용자가 시장가 주문의 정확한 실행 가격을 예상할 수 없으므로, 시장가 주문 이용은 권장하지 않습니다.",
            "nn": "På illikvide marknadar som ikkje handlast ofte, er det folk som vil settje ein grenseordre til urealistiske prisar, berre for å tjena raske pengar på dei som blindt går for marknadshandel. Vi anbefaler dermed ikkje å bruka marknadsordrar, då korkje du eller 50x.com-systemet kan føreseia den nøyaktige eksekveringsprisen for slike bestillingar.",
            "no": "På illikvide markeder som ikke handles ofte, er det folk som vil sette en grenseordre til urealistiske priser, bare for å tjene raske penger på de som blindt går for markedshandel. Vi anbefaler dermed ikke å bruke markedsordrer, da verken du eller 50x.com-systemet kan forutsi den nøyaktige eksekveringsprisen for slike bestillinger.",
            "ru": "На неликвидных рынках, которые часто не торгуются, есть люди, которые поставили бы лимитный ордер по нереалистичным ценам, просто чтобы быстро заработать деньги у людей, которые слепо поставили рыночные сделки. Мы не рекомендуем использовать рыночные ордера, так как ни вы, ни система 50x.com не могут предсказать точную цену исполнения для таких сделок.",
            "tr": "Sıklıkla işlem görmeyen likit olmayan piyasalarda, sadece körlemesine piyasa alım satım işlemleri yapan kişilerden hızlı para kazanmak için, gerçekçi olmayan fiyatlara bir limit komutu verecek kişiler vardır. Ne siz ne de 50x.com sistemi tarafından bu tür komutların tam yürütme fiyatı tahmin edemeyeceği için, piyasa komutlarını kullanmanızı önermeyiz.",
            "uk": "На неліквідних ринках, які часто не торгуються, є люди, які поставили б лімітний ордер з нереалістичним цінами, просто щоб швидко заробити гроші у людей, які сліпо поставили ринкові угоди. Ми не рекомендуємо використовувати ринкові ордера, так як ні ви, ні система 50x.com не можуть передбачити точну ціну виконання для таких угод.",
            "zh": "在不经常交易的非流动性市场上，有些人会以不切实际的价格下达限价令，只是为了从盲目进行市场交易的人那里快速赚钱。我们不建议使用市场订单，因为您和50x.com系统都无法预测此类订单的确切执行价格。"
        },
        "third_description": {
            "en": "It is advisable to use Limit Order with the worst price you can afford for your trade. It will be executed at the best prices, just like Market Order, but not worse than your entered limit.",
            "fr": "Il est conseillé d'utiliser l'Ordre à cours limité avec le pire prix que vous pouvez vous permettre pour votre métier. Il sera exécuté au meilleur prix, tout comme l'Ordre de Marché, mais pas pire que votre limite entrée.",
            "it": "Si consiglia di utilizzare Limit Order con il prezzo peggiore che ci si può permettere per il proprio trade. Verrà eseguito ai prezzi migliori, proprio come per l'ordine di mercato, ma non peggio del limite inserito.",
            "ja": "余裕のある、最悪の場合でもリスクに対応できる価格で指値注文を使用することをお勧めします。成行注文と同じように最善の価格で実行され、入力した制限よりも悪くはなりません。",
            "ko": "거래를 위해 감당할 수 있는 최악의 가격으로 지정가 주문을 이용하는 것이 좋습니다. 거래는 시장가 주문과 같지만 입력한 지정가보다 나쁘지 않은 최상의 가격에서 실행됩니다.",
            "nn": "Det er tilrådeleg å bruka Grenseordre med den verste prisen du har råd til i handelen din. Den vil bli utført til dei beste prisane, akkurat som Marknadsordre, men ikkje verre enn di angitte grense.",
            "no": "Det er tilrådelig å bruke Grenseordre med den verste prisen du har råd til i handelen din. Den vil bli utført til de beste prisene, akkurat som Markedsordre, men ikke verre enn din angitte grense.",
            "ru": "Целесообразно использовать Limit Order с наихудшей ценой, которую вы можете себе позволить для своей торговли. Он будет выполнен по самым выгодным ценам, точно так же, как Market Order, но не хуже вашего введенного лимита.",
            "tr": "Alım satım işleminiz için alabileceğiniz en kötü fiyatla Limit komutunu kullanmanız önerilir. Bu, Piyasa Komutu gibi en iyi fiyatlarla yürütülür, ancak girdiğiniz limitten daha kötü değildir.",
            "uk": "Доцільно використовувати Limit Order з найгіршою ціною, яку ви можете собі дозволити для своєї торгівлі. Він буде виконаний за найвигіднішими цінами, точно так само, як Market Order, але не гірше вашого введеного ліміту.",
            "zh": "最好用你能负担得起的最低价的限价单。它将以最好的价格执行，就像市场秩序一样，但不会比您输入的限额差。"
        }
    },
    "modal_deleteApikey": {},
    "modal_deposit": {
        "deposit_description": {
            "en": "To deposit {4} ({0}), please send {0} to this [blockchains.{1}] address:",
            "fr": "Pour déposer {4} ({0}), veuillez envoyer {0} à cette [blockchains.{1}] adresse:",
            "it": "Per depositare {4} ({0}), invia {0} a questo indirizzo [blockchains.{1}]:",
            "ja": "{4} ({0})を入金するには、{0}をこの[blockchains.{1}]アドレスに送信してください：",
            "ko": "{0}을 입금하려면 이 [blockchains.{1}] 주소로 보내주십시오 :",
            "ru": "Для пополнения {4} ({0}), пожалуйста отправьте {0} на этот [blockchains.{1}] адрес: ",
            "tr": "{4} ({0}) öğesine para yatırmak için, lütfen bu [blockchains.{1}] adresine {0} öğesini gönderin:",
            "uk": "Для поповнення {4} ({0}), будь ласка, відправте {0} на цю [blockchains.{1}] адресу:",
            "zh": "若要存放{4}（{0}），请将{0}发送到此[blockchains.{1}]地址："
        },
        "tagAlert_description_1": {
            "en": "Using this TAG ({tag_name})",
            "fr": "Utilisez ce TAG ({tag_name})",
            "it": "Usare questo TAG ({tag_name})",
            "ja": "このタグを使用 ({tag_name})",
            "ko": "이 태그를 사용하십시오 ({tag_name})",
            "ru": "Используйте этот ТЭГ ({tag_name})",
            "tr": "Bu ETİKETİ kullanma ({tag_name})",
            "uk": "Використовуйте цей ТЭГ ({tag_name})",
            "zh": "使用此标记"
        },
        "tagAlert_description_2": {
            "en": "WARNING! You must include this TAG ({tag_name}) in your transaction or your tokens will be lost! TAG must be unencrypted.",
            "fr": "AVERTISSEMENT! Vous devez inclure ce TAG ({tag_name}) dans votre transaction, sinon vos jetons seront perdus! TAG doit être non chiffré!",
            "it": "AVVERTIMENTO! Devi includere questo TAG ({tag_name}) nella tua transazione o i tuoi token andranno persi! TAG non deve essere crittografato!",
            "ja": "警告！このタグをトランザクションに含める必要があります。これを怠るとトークンが失われます。 ({tag_name}) タグは暗号化しないでください！",
            "ko": "경고! 귀하의 트랜잭션에 이 태그를 포함해야하며 그렇지 않으면 토큰을 분실하게 될 것입니다! ({tag_name})! TAG는 암호화되지 않아야합니다!",
            "ru": "ВНИМАНИЕ! Вы должны включить этот TAG ({tag_name}) в вашу транзакцию или ваши токены будут потеряны! TAG должен быть незашифрованным!",
            "tr": "UYARI! Bu ETİKETİ ({tag_name}) işleminize eklemeniz gerekir, aksi takdirde tokenlerini kaybolacaktır! TAG şifrelenmemiş olmalıdır!",
            "uk": "УВАГА! Ви повинні включити цей TAG ({tag_name}) в вашу транзакцію або ваші токени будуть втрачені! TAG повинен бути незашифрованим!",
            "zh": "警告！您必须在交易中包含此标记，否则您的标记将丢失！{tag_name} 标记必须未加密！"
        }
    },
    "modal_depositInfo": {},
    "modal_editApikey": {
        "ipRestriction_label": {
            "en": "IP restrictions",
            "fr": "Restrictions IP",
            "it": "Restrizioni IP",
            "ja": "IP制限",
            "ko": "IP 제한",
            "ru": "Ограничение по IP",
            "tr": "IP kısıtlamaları",
            "uk": "Обмеження IP",
            "zh": "知识产权限制"
        },
        "tradeEnabled_label": {
            "en": "Trade enabled",
            "fr": "Échange activé",
            "it": "Scambi attivati",
            "ja": "取引を有効にする",
            "ko": "거래 가능",
            "ru": "Доступ к торговле",
            "tr": "Alım satım işlemi etkinleştirildi",
            "uk": "Доступ до торгівлі",
            "zh": "使能贸易"
        },
        "withdrawEnabled_label": {
            "en": "Withdrawal enabled",
            "fr": "Retrait activé",
            "it": "Prelievi attivati",
            "ja": "出金を有効にする",
            "ko": "출금 가능",
            "ru": "Доступ к выводу",
            "tr": "Para çekme etleştirildi",
            "uk": "Доступ до виведення",
            "zh": "已启用撤回"
        }
    },
    "modal_error": {
    },
    "modal_forgotPass": {
    },
    "modal_help": {
    },
    "modal_limitsDefault": {
        "description": {
            "en": "Do you really want to reset settings?",
            "fr": "Voulez-vous vraiment réinitialiser les paramètres?",
            "it": "Vuoi davvero ripristinare le impostazioni?",
            "ja": "設定をリセットしますか？",
            "ru": "Вы уверены, что хотите вернуть настройки по умолчанию?",
            "tr": "Ayarları gerçekten sıfırlamak istiyor musunuz?",
            "uk": "Ви впевнені, що хочете повернути налаштування за замовчуванням?",
            "zh": "是否确实要重置设置？"
        }
    },
    "modal_massCancel": {
		"deprecated": "deprecated",
        "body_description": {
            "en": "Do you really want to cancel all {type} [bs.order.{bs}] orders?",
            "fr": "Voulez-vous vraiment annuler toutes les commandes de type {type} [bs.order.{bs}]?",
            "it": "Vuoi davvero annullare tutti gli ordini di {type} [bs.order.{bs}]?",
            "ja": "全ての{type} [bs.order.{bs}]の注文をキャンセルしても宜しいですか？",
            "ru": "Вы уверены, что хотите отменить все {type} ордера [bs.order.{bs}]?",
            "tr": "Tüm {type} [bs.order.{bs}] komutlarını gerçekten iptal etmek istiyor musunuz?",
            "uk": "Ви впевнені, що хочете відмнити всі {type} ордера [bs.order.{bs}]?",
            "zh": "是否确实要取消所有{type}[bs.order.{bs}]订单？"
        }
    },
    "modal_masterKeyGet": {
        "text2": {
            "en": "<b>Master Key will allow you to send all your tokens to your Emergency Withdrawal Address (EWA) without providing additional passwords or OTP. Master Key must be stored securely offline!!!</b>",
            "fr": "<b>La clé principale vous permettra d'envoyer tous vos jetons à votre adresse de retrait d'urgence (EWA) sans fournir de mots de passe ou d'OTP supplémentaires. La clé principale doit être stockée en toute sécurité hors ligne !!!</b>",
            "it": "<b> La chiave principale ti consentirà di inviare tutti i token al tuo indirizzo di prelievo di emergenza (EWA) senza fornire password o OTP aggiuntive. La chiave principale deve essere archiviata in modo sicuro offline !!! </b>",
            "ja": "<b>マスターキーを使用すると、追加のパスワードやOTPを提供せずに、すべてのトークンを緊急出金アドレス（EWA）に送信できます。マスターキーはオフラインで安全に保存する必要があります!!! </b>",
            "ru": "<b>Мастер-ключ позволит вам вывести свои токены на ваши Адреса Аварийного Вывода (EWA) без ввода паролей и кодов 2FA в случае утраты доступа к сайту. Храните его в безопасном месте оффлайн!!!</b>",
            "tr": "<b>Ana Anahtar, tüm tokenlerinizi ek parolalar veya OTP sağlamadan Acil Durum Para Çekme Adresinize (EWA) göndermenizi sağlar. Ana Anahtar güvenli bir şekilde çevrimdışı olarak saklanmalıdır!!!</b>",
            "uk": "<b>Майстер-ключ дозволить вам вивести свої токени на ваші Адреси Аварійного Виведення (EWA) без введення паролів і кодів 2FA в разі втрати доступу до сайту. Зберігайте його в безпечному місці оффлайн!!!</b>",
            "zh": "<b>主密钥将允许您将所有令牌发送到紧急取款地址（EWA），而无需提供额外的密码或OTP。主密钥必须安全地脱机存储！!!</b>"
        },
        "text3": {
            "en": "<b>Master Key cannot be used to withdraw Tokens to any addresses except your EWA. Likewise, it cannot be used to get access to your account.</b>",
            "fr": "<b> La clé principale ne peut pas être utilisée pour retirer des jetons à des adresses autres que votre EWA. De même, il ne peut pas être utilisé pour accéder à votre compte. </b>",
            "it": "<b> La chiave master non può essere utilizzata per ritirare token a indirizzi diversi dal tuo EWA. Allo stesso modo, non può essere utilizzato per ottenere l'accesso al tuo account. </b>",
            "ja": "<b>マスターキーを使用して、トークンをEWA以外のアドレスに引き出すことはできません。同様に、アカウントへのアクセスには使用できません。</b>",
            "ru": "<b>Мастер-ключ не дает возможности вывести токены на адреса отличные от ваших Адресов Аварийного Вывода, также не восстанавливает доступ в аккаунт.</b>",
            "tr": "<b>Ana Anahtar, EWA'nız dışındaki herhangi bir adrese Tokenleri çekmek için kullanılamaz. Benzer şekilde, hesabınıza erişim için de kullanılamaz.</b>",
            "uk": "<b>Майстер-ключ не дає можливості вивести токени на адреси відмінні від ваших Адрес Аварійного Виведення, також не відновлює доступ до аккаунта.</b>",
            "zh": "<b>主密钥不能用于将令牌撤回到除您的EWA之外的任何地址。同样，它也不能用于访问您的帐户</b>"
        }
    },
    "modal_masterKeySet": {
        "_header": {
            "en": "Activate your MASTER KEY",
            "fr": "Activez votre MASTER KEY",
            "it": "Attiva il tuo MASTER KEY",
            "ja": "マスターキーを有効にする",
            "ru": "Активируйте свой Мастер-ключ",
            "tr": "ANA ANAHTARINIZI etkinleştirin",
            "uk": "Активуйте свій Майстер-ключ",
            "zh": "激活主密钥"
        },
        "button_activate": {
            "en": "Activate Master Key",
            "fr": "Activer la clé principale",
            "it": "Attiva chiave principale",
            "ja": "マスターキーを有効にする",
            "ru": "Активировать Мастер-ключ",
            "tr": "Ana Anahtarı Etkinleştir",
            "uk": "Активувати Майстер-ключ",
            "zh": "激活主密钥"
        },
        "lastChars": {
            "en": "Enter last {domain.lastMaterKeyChars} characters of your Master Key to set it on your account",
            "fr": "Entrez les derniers {domain.lastMaterKeyChars} caractères de votre clé principale pour la définir sur votre compte",
            "it": "Inserisci gli ultimi caratteri {domain.lastMaterKeyChars} della tua chiave master per impostarla sul tuo account",
            "ja": "アカウントに設定するには、マスターキーの最後の{domain.lastMaterKeyChars}文字を入力してください。",
            "ru": "Введите последние {domain.lastMaterKeyChars} символов вашего Мастер-ключа чтобы активировать его на вашем аккаунте",
            "tr": "Hesabınızda ayarlamak için Ana Anahtarınızın son {domain.lastMaterKeyChars} karakterlerini girin",
            "uk": "Введіть останні {domain.lastMaterKeyChars} символів вашого Майстер-ключа, щоб активувати його на вашому аккаунті",
            "zh": "输入主密钥的最后 {domain.lastMaterKeyChars}个字符以在您的帐户上设置它"
        },
        "text1": {
            "en": "Let's check if you wrote it down correctly. Master Key cannot be changed after the activation.",
            "fr": "Vérifions si vous l'avez bien écrit. La clé principale ne peut pas être modifiée après l'activation.",
            "it": "Controlliamo se l'hai scritto correttamente. La chiave principale non può essere modificata dopo l'attivazione.",
            "ja": "正しく書き留めたかどうか確認しましょう。マスターキーは有効化後に変更できません。",
            "ru": "Давайте убедимся, что вы записали Мастер-ключ правильно. После активации изменить Мастер-ключ будет нельзя.",
            "tr": "Doğru yazıp yazmadığınızı kontrol edelim. Etkinleştirme sonrasında Ana Anahtar değiştirilemez.",
            "uk": "Давайте переконаємося, що ви записали Майстер-ключ правильно. Після активації змінити Майстер-ключ буде неможливо.",
            "zh": "让我们看看你写得是否正确。激活后无法更改主密钥。"
        },
        "text2": {
            "en": "<b>Enter last {domain.lastMaterKeyChars} symbols of your Master Key</b>",
            "fr": "<b> Saisissez les derniers {domain.lastMaterKeyChars} symboles de votre clé principale </b>",
            "it": "<b> Inserisci gli ultimi {domain.lastMaterKeyChars} simboli della tua chiave master </b>",
            "ja": "<b>マスターキーの最後の{domain.lastMaterKeyChars}桁を入力します。</b>",
            "ru": "<b>Введите последние {domain.lastMaterKeyChars} символов Мастер-ключа</b>",
            "tr": "<b>Ana Anahtarınızın son {domain.lastMaterKeyChars} sembollerini girin</b>",
            "uk": "<b>Введіть останні {domain.lastMaterKeyChars} символів Майстер-ключа</b>",
            "zh": "<b>输入主密钥的最后{domain.lastMaterKeyChars}符号</b>"
        },
        "text3": {
            "en": "Should there be any problems with activation, reload the page and try again to receive a new Master Key.",
            "fr": "En cas de problème d'activation, rechargez la page et essayez à nouveau de recevoir une nouvelle clé principale.",
            "it": "In caso di problemi con l'attivazione, ricaricare la pagina e riprovare a ricevere una nuova chiave master.",
            "ja": "有効化に問題がある場合は、ページを再読み込みして、新しいマスターキーの取得を再試行してください。",
            "ru": "В случае проблем с активацией, перезагрузите страницу и выполните снова процедуру получения Мастер-ключа.",
            "tr": "Etkinleştirmeyle ilgili herhangi bir sorun olması halinde, sayfayı yeniden yükleyin ve yeni bir Ana Anahtar almayı tekrar deneyin.",
            "uk": "У разі проблем з активацією, перезавантажте сторінку і виконайте знову процедуру отримання Майстер-ключа.",
            "zh": "如果激活有任何问题，请重新加载该页，然后再次尝试接收新的主密钥。"
        }
    },
    "modal_masterKeyShow": {
        "_header": {
            "en": "Write down your MASTER KEY",
            "fr": "Notez votre CLÉ MAÎTRE",
            "it": "Scrivi il tuo MASTER KEY",
            "ja": "マスターキーを書き留めてください",
            "ru": "Запишите свой Мастер-ключ",
            "tr": "ANA ANAHTARINIZI yazın",
            "uk": "Запишіть свій Майстер-ключ",
            "zh": "记下你的万能钥匙"
        },
        "text1": {
            "en": ""
        },
        "text2": {
            "en": "<b>Write down your Master Key on paper and store offline in a safe place!</b>",
            "fr": "<b> Notez votre clé principale sur papier et conservez-la hors ligne dans un endroit sûr! </b>",
            "it": "<b> Scrivi la tua chiave master su carta e conservala offline in un luogo sicuro! </b>",
            "ja": "<b>マスターキーを紙に書き留め、安全な場所にオフラインで保管してください！</b>",
            "ru": "<b>Запишите свой Мастер-ключ на бумаге и храните в надежном месте!</b>",
            "tr": "<b>Ana Anahtarınızı kağıda yazın ve çevrimdışı olarak güvenli bir yerde saklayın!</b>",
            "uk": "<b>Запишіть свій Майстер-ключ на папері і зберігайте в надійному місці!</b>",
            "zh": "<b>把你的万能钥匙写在纸上，离线储存在一个安全的地方！</b>"
        },
        "text3": {
            "en": ""
        }
    },
    "modal_order2Position": {
		"deprecated": "deprecated",
        "_header": {
            "en": "Confirm order to position conversion",
            "fr": "Confirmer la conversion de position en ordre",
            "it": "Conferma l'ordine per posizionare la conversione",
            "ja": "注文のポジションの変化を確認する",
            "ru": "Подтвердите преобразование ордера в позицию",
            "tr": "Dönüşümü konumlandırmak için komutu onaylayın",
            "uk": "Підтвердіть перетворення ордера в позицію",
            "zh": "确认订单到位置转换"
        },
        "text2": {
            "en": "Your order {oid} will become a position with the volume being equal to filled volume at the time of conversion. SLTP will be activated for the filled part.",
            "fr": "Votre commande {oid} deviendra une position dont le volume sera égal au volume rempli au moment de la conversion. SLTP sera activé pour la pièce remplie.",
            "it": "Il tuo ordine {oid} diventerà una posizione con il volume pari al volume riempito al momento della conversione. SLTP verrà attivato per la parte riempita.",
            "ja": "注文{oid}は、変換時の入力されたボリュームを伴うポジションになります。入力された部分に対してSLTPが有効になります。",
            "ru": "Ваш ордер {oid} превратится в Позицию с объемом, равным уже исполненному объему. Будет активирован SLTP ордер на исполненный объем.",
            "tr": "{oid} komutunuz, dönüşüm sırasında işlem hacmi ile, tamamlanmış işlem hacmine eşit olacak şekilde bir konum alacaktır. Tamamlanmış kısım için SLTP etkinleştirilecektir.",
            "uk": "Ваш ордер {oid} перетвориться в Позицію з об'ємом, рівним вже виконаному обсягу. Буде активовано SLTP ордер на виконаний обсяг.",
            "zh": "您的订单{oid}在转换时将变成一个容量等于填充容量的位置。填充部分将激活SLTP。"
        }
    },
    "modal_orderClose": {
		"deprecated": "deprecated",
        "_header": {
            "en": "Closing order {oid}",
            "fr": "Ordre de clôture {oid}",
            "it": "Ordine di chiusura {oid}",
            "ja": "注文{oid}の締め切り",
            "ru": "Закрытие ордера {oid}",
            "tr": "Kapanış komutu {oid}",
            "uk": "Закриття ордера {oid}",
            "zh": "结束订单{oid}"
        },
        "text1": {
            "en": "Closing [bs.order.{bs}] order {oid} for {vol} {sym1} at {rate} {sym2}",
            "fr": "Clôture de [bs.order.{bs}] commande {oid} pour {vol} {sym1} à {rate} {sym2}",
            "it": "Chiudere [bs.order.{bs}] ordine {oid} per {vol} {sym1} a {rate} {sym2}",
            "ja": "[bs.order.{bs}]注文{oid}を{vol} {sym1}、{rate} {sym2}にて締め切ります。",
            "ru": "Закрытие ордера [bs.order.{bs}] {oid} на {vol} {sym1} по цене {rate} {sym2}",
            "tr": "{rate} {sym2} oranında {vol} {sym1} için {bsorder.{bs}] kapanış {oid} komutu",
            "uk": "Закриття ордера [bs.order.{bs}] {oid} на {vol} {sym1} за ціною {rate} {sym2}",
            "zh": "以 {rate} {sym2}关闭{vol} {sym1}的[bs.order.{bs}]订单{oid}"
        },
        "text2": {
            "en": "Do you really want to close this order?",
            "fr": "Voulez-vous vraiment clôturer cette commande?",
            "it": "Vuoi davvero chiudere questo ordine?",
            "ja": "この注文を確定しても宜しいですか？",
            "ru": "Вы уверены, что хотите закрыть этот ордер?",
            "tr": "Bu komutu gerçekten kapatmak istiyor musunuz?",
            "uk": "Ви впевнені, що хочете закрити цей ордер?",
            "zh": "你真的想结束这个订单吗？"
        },
        "text3": {
            "en": ""
        }
    },
    "modal_orderEdit": {
        "editSLTP": {
            "en": "Revert changes and edit SLTP",
            "ru": "Отменить изменения и редактировать SLTP"
        }
    },
    "modal_otpChange": {
        "text1": {
            "en": "If your <b>OTP generating device is lost</b>, but you know your Seed Private 2FA OTP Key, you should get a new device with Authenticator app and add your Seed Private 2FA OTP Key in the Authenticator app. Synchronize your device with the internet time and set a correct timezone if needed. Change your Seed Private 2FA OTP Key and activate a new one in the next window.",
            "fr": "Si votre <b> périphérique de génération OTP est perdu </b>, mais que vous connaissez votre clé OTP Seed Private 2FA, vous devez obtenir un nouvel appareil avec l'application Authenticator et ajouter votre clé OTP Seed Private 2FA dans l'application Authenticator. Synchronisez votre appareil avec l'heure Internet et définissez un fuseau horaire correct si nécessaire. Modifiez votre clé OTP Seed Private 2FA et activez-en une nouvelle dans la fenêtre suivante.",
            "it": "Se il tuo <b> dispositivo di generazione OTP viene perso </b>, ma conosci la tua chiave OTP Seed Private 2FA, dovresti ottenere un nuovo dispositivo con l'app Authenticator e aggiungere la chiave OTP Seed Private 2FA nell'app Authenticator. Sincronizza il tuo dispositivo con l'ora di Internet e imposta un fuso orario corretto, se necessario. Cambia la tua chiave OTP privata 2FA Seed e attivane una nuova nella finestra successiva.",
            "ja": "<b>OTP生成デバイスを紛失してしまった場合</b>には、シードプライベート2FA OTPキーを記憶している限り、認証アプリを新しいデバイスで取得し、シードプライベート2FA OTPキーを追加することができます。デバイスをインターネット時間と同期し、必要に応じて正しいタイムゾーンを設定します。シードプライベート2FA OTPキーを変更し、次のウィンドウで新しいキーを有効にしてください。",
            "ru": "Если вы <b>потеряли устройство с генератором однократных кодов</b> но у вас <b>есть Секретный Ключ 2FA</b> для генерации однократных паролей - возьмите новое устройство с приложением генерации однократных кодов Authenticator и добавьте в него Секретный Ключ 2FA, при необходимости синхронизируйте время устройства с интернет и установите правильный часовой пояс. Получите новый Секретный Ключ 2FA в следующем окне и активируйте его.",
            "tr": "<b>OTP oluşturma cihazınızın kaybolması durumunda</b>, ancak Seed Özel 2FA OTP Anahtarınızı biliyorsanız, Kimlik Doğrulama uygulamasıyla yeni bir cihaz almalı ve Kimlik Doğrulama uygulamasına Seed Özel 2FA OTP Anahtarınızı eklemelisiniz. Cihazınızı internet saati ile senkronize edin ve gerekirse doğru bir saat dilimine ayarlayın. Seed Özel 2FA OTP Anahtarınızı değiştirin ve bir sonraki pencerede yeni bir taneyi etkinleştirin.",
            "uk": "Якщо ви <b>втратили пристрій з генератором одноразових кодів</b> але у вас <b>є Приватний Ключ 2FA</b> для генерації одноразових паролів - візьміть новий пристрій з додатком генерації одноразових кодів Authenticator і додайте в нього Приватний Ключ 2FA, при необхідності синхронізуйте час пристрою з інтернет і встановіть правильний часовий пояс. Отримайте новий Приватний Ключ 2FA в наступному вікні та активуйте його.",
            "zh": "如果您的OTP生成设备丢失，但您知道Seed Private 2FA OTP密钥，则应使用Authenticator app获取新设备，并在Authenticator app中添加Seed Private 2FA OTP密钥。将设备与网络时间同步，并根据需要设置正确的时区。更改Seed Private 2FA OTP密钥并在下一个窗口中激活一个新密钥。"
        },
        "text2": {
            "en": "If your <b>OTP generating device AND Seed Private Key for 2FA OTP codes are lost</b>, you should use Master Key to withdraw tokens to your Emergency Withdrawal Addresses and terminate current account in the TERMINAL -> Terminate Account section.",
            "fr": "Si votre <b> périphérique de génération OTP ET votre clé privée de démarrage pour les codes OTP 2FA sont perdus </b>, vous devez utiliser la clé principale pour retirer des jetons à vos adresses de retrait d'urgence et fermer le compte courant dans la section TERMINAL -> Terminer le compte.",
            "it": "Se si perdono il <b> dispositivo di generazione OTP E la chiave privata seme per i codici OTP 2FA </b>, è necessario utilizzare la chiave principale per ritirare i token agli indirizzi di prelievo di emergenza e chiudere l'account corrente nella sezione TERMINAL -> Termina account.",
            "ja": "<b>OTP生成デバイスと2FA OTPコードのシードプライベートキーを紛失してしまった場合</b>には、マスターキーを使用して緊急出金アドレスにトークンを引き出し、「終了」->「アカウントの終了」セクションで現在のアカウントを終了する必要があります。",
            "ru": "Если вы <b>потеряли устройство с генератором однократных кодов и свой Секретный Ключ 2FA</b>, воспользуйтесь Мастер-ключом для вывода всех токенов на ваши Адреса Аварийного Вывода (EWA) в разделе Терминал -> Удаление Аккаунта.",
            "tr": "<b>OTP oluşturan cihazınız VE 2FA OTP kodları için Seed Özel Anahtarınızın kaybolması durumunda</b>, Acil Durum Para Çekme Adreslerinize tokenleri çekmek ve TERMINAL -> Hesabı Sonlandır bölümünde, geçerli hesabı sonlandırmak için Ana Anahtar'ı kullanmalısınız.",
            "uk": "Якщо ви <b>втратили пристрій з генератором одноразових кодів і свій Приватний Ключ</b>, скористайтеся Майстер-ключем для виведення всіх токенів на ваші Адреси Аварійного Виведення (EWA) в розділі Термінал -> Видалення Аккаунта.",
            "zh": "如果您的OTP生成设备和2FA OTP代码的Seed私钥丢失，您应该使用主密钥将令牌提取到紧急提款地址，并在“终端->终止帐户”部分终止当前帐户。"
        },
        "text3": {
            "en": "If your <b>Seed Private 2FA OTP Key is lost</b>, but you have OTP codes, get a new Seed Private 2FA OTP Key in the next window, add it to the Authenticator app and enter a new OTP to activate a new key. If you do not enter the correct OTP from the new Key, your old key will be active until a new one has been properly activated.",
            "fr": "Si votre <b> clé OTP privée 2FA Seed est perdue </b>, mais que vous avez des codes OTP, obtenez une nouvelle clé OTP privée 2FA Seed dans la fenêtre suivante, ajoutez-la à l'application Authenticator et entrez une nouvelle OTP pour activer un nouvelle clé. Si vous n'entrez pas le bon OTP à partir de la nouvelle clé, votre ancienne clé sera active jusqu'à ce qu'une nouvelle soit correctement activée.",
            "it": "Se la tua <b> Chiave OTP 2FA privata del seme viene persa </b>, ma hai i codici OTP, ottieni una nuova chiave OTP 2FA privata del seme nella finestra successiva, aggiungila all'app Authenticator e inserisci un nuovo OTP per attivare un nuova chiave. Se non si inserisce l'OTP corretto dalla nuova chiave, la vecchia chiave sarà attiva fino a quando una nuova non sarà stata correttamente attivata.",
            "ja": "<b>シードプライベート2FA OTPキーを紛失したものの</b>、OTPコードがある場合には、次のウィンドウで新しいシードプライベート2FA OTPキーを取得、認証アプリに追加し、新しいOTPを入力して新しいキーを有効にできます。新しいキーから正しいOTPを入力しないと、新しいキーが適切に有効化されるまで、古いキーが有効になります。",
            "ru": "Если вы <b>потеряли Секретный Ключ 2FA</b> для генерации однократных паролей, <b>но осталось устройство генерирующее однократные коды</b> - смените ваш Секретный Ключ 2FA введя текущий однократный код и получив новый Секретный Ключ 2FA в следующем окне, после чего введите сгенерированный им код для активации нового ключа. Ваш старый ключ действует до момента, пока вы успешно не введете сгенерированный код от нового ключа.",
            "tr": "<b>Seed Özel 2FA OTP Anahtarınız kaybolması durumunda</b>, ancak OTP kodlarınız bulunuyorsa, bir sonraki pencerede yeni bir Seed Özel 2FA OTP Anahtarı edinin, Kimlik Denetleyicisi uygulamasına ekleyin ve yeni anahtarı etkinleştirmek için yeni bir OTP girin. Yeni Anahtardan doğru OTP'yi girmezseniz, yeni anahtarınız doğru şekilde etkinleştirilene kadar eski anahtarınız etkin olacaktır.",
            "uk": "Якщо ви <b>втратили Приватний Ключ 2FA</b> для генерації одноразових паролів, <b>але залишився пристрій що генерує одноразові коди</b> - змініть ваш Приватний Ключ 2FA ввівши поточний одноразовий код і отримавши новий Приватний Ключ 2FA в наступному вікні, після чого введіть згенерований їм код для активації нового ключа. Ваш старий ключ діє до моменту, поки ви успішно не введете згенерований код від нового ключа.",
            "zh": "如果您的<b>Seed Private 2FA OTP密钥丢失，但您有OTP代码，请在下一个窗口中获取新的Seed Private 2FA OTP密钥，将其添加到Authenticator应用程序并输入新的OTP以激活新密钥。如果没有从新密钥中输入正确的OTP，则旧密钥将处于活动状态，直到新密钥被正确激活。"
        }
    },
    "modal_otpDisable": {
    },
    "modal_otpEnable": {
        "text2": {
            "en": "You must save your Private OTP Key offline in a secure place. If you will lose this key, you might be unable to recover tokens from your account",
            "fr": "Vous devez enregistrer votre clé d'authentification hors ligne dans un endroit sûr. Si vous perdez cette clé, vous ne pourrez peut-être pas récupérer les jetons de votre compte",
            "it": "È necessario salvare la chiave di autenticazione offline in un luogo sicuro. Se perdi questa chiave, potresti non essere in grado di recuperare i token dal tuo account",
            "ja": "認証キーを安全な場所にオフラインで保存する必要があります。このキーを紛失すると、アカウントからトークンを回復できない場合があります。",
            "ko": "Authenticator 키를 오프라인의 안전한 장소에 보관해야 합니다. 이 키를 잃어버리면 계정에서 토큰을 복구하지 못할 수 있습니다.",
            "ru": "ЭТО ВАЖНО !!! Вы должны сохранить Секретный Ключ 2FA в надежном месте, желательно на бумаге. Без него вы не сможете восстановить доступ в аккаунт!!!",
            "tr": "Kimlik Denetleyicisi Anahtarınızı çevrimdışı olarak güvenli bir yere kaydetmeniz gereklidir. Bu anahtarı kaybetmeniz durumunda, tokenleri hesabınızdan geri kazanamayabilirsiniz",
            "uk": "ЦЕ ВАЖЛИВО !!! Ви повинні зберегти Секретний Ключ 2FA в надійному місці, бажано на папері. Без нього ви не зможете відновити доступ до аккаунта!!!",
            "zh": "必须将身份验证器密钥脱机保存在安全的地方。如果您将丢失此密钥，则可能无法从您的帐户中恢复代币"
        },
        "text3": {
            "en": "Please add this SEED private key to your Google Authenticator application and enter code here (valid for 30 sec)",
            "fr": "Veuillez ajouter cette clé privée SEED à votre application Google Authenticator et entrez le code ici (valable 30 secondes)",
            "it": "Aggiungi questa chiave privata SEED alla tua applicazione Google Authenticator e inserisci il codice qui (valido per 30 secondi)",
            "ja": "このシードプライベートキーをGoogle認証システムアプリケーションに追加し、ここにコードを入力してください（30秒間有効）",
            "ko": "이 SEED 프라이빗 키를 Google Authenticator 앱에 추가하고 코드를 여기에 입력하십시오(30초 내에 입력).",
            "ru": "Введите этот секретный ключ в приложение Google Authenticator и сгенерированный им временный 6-значный код введите сюда (код из приложения действителен 30 секунд)",
            "tr": "Lütfen bu SEED özel anahtarını Google Kimlik Denetleyicisi uygulamanıza ekleyin ve kodu buraya girin (30 saniye için geçerlidir)",
            "uk": "Введіть цей приватний секретний ключ в додаток Google Authenticator і згенерований їм тимчасовий 6-значний код введіть сюди (код з додатку дійсний 30 секунд)",
            "zh": "请将此种子私钥添加到您的谷歌验证器应用程序并在此处输入代码（有效期为30秒）"
        }
    },
    "modal_pmaClearing": {
        "_header": {
            "en": "PMA id {pmaid} clearing",
            "fr": "PMA id {pmaid} effacement",
            "it": "PMA id {pmaid} clearing",
            "ja": "PMA id {pmaid}の決済中",
            "ru": "Клиринг PMA id {pmaid}",
            "tr": "PMA kimlik {pmaid} mahsubu",
            "uk": "Кліринг PMA id {pmaid}",
            "zh": "PMA id{pmaid}清除"
        },
        "description": {
            "en": "Do you really want to distribute profit from PMA {pmaid}?",
            "fr": "Voulez-vous vraiment distribuer les bénéfices de PMA {pmaid}?",
            "it": "Vuoi davvero distribuire i profitti da PMA {pmaid}?",
            "ja": "本当にPMA {pmaid}から利益を分配しますか？",
            "ru": "Вы уверены, что хотите распределить прибыль с PMA {pmaid}?",
            "tr": "PMA {pmaid} öğesinden gerçekten kâr dağıtmak istiyor musunuz?",
            "uk": "Ви впевнені, що хочете розподілити прибуток з PMA {pmaid}?",
            "zh": "你真的想从PMA{pmaid}中分配利润吗？"
        }
    },
    "modal_pmaClose": {
        "_header": {
            "en": "Close PMA id {pmaid}",
            "fr": "Fermer l'identifiant PMA {pmaid}",
            "it": "Chiudi ID PMA {pmaid}",
            "ja": "PMA id {pmaid}を締め切る",
            "ru": "Закрыть PMA id {pmaid}",
            "tr": "PMA kimliğini {pmaid} kapat",
            "uk": "Закрити PMA id {pmaid}",
            "zh": "关闭PMA id{pmaid}"
        },
        "description": {
            "en": "Do you really want to close this PMA?",
            "fr": "Voulez-vous vraiment fermer ce PMA?",
            "it": "Vuoi davvero chiudere questo PMA?",
            "ja": "このPMAを本当に閉じますか？",
            "ru": "Вы уверены, что хотите закрыть PMA?",
            "tr": "Bu PMA'yı gerçekten kapatmak istiyor musunuz?",
            "uk": "Ви впевнені, що хочете закрити PMA?",
            "zh": "你真的要关闭这个PMA吗？"
        }
    },
    "modal_pmaCloseCancel": {
        "_header": {
            "en": "Cancel PMA id {pmaid} closing request",
            "fr": "Annuler la demande de fermeture de l'identifiant PMA {pmaid}",
            "it": "Annulla la richiesta di chiusura dell'ID PMA {pmaid}",
            "ja": "PMA id {pmaid}終了リクエストをキャンセル",
            "ru": "Отменить закрытие PMA id {pmaid}",
            "tr": "PMA kimliğini {pmaid} kapatma talebini iptal et",
            "uk": "Відмінити закриття PMA id {pmaid}",
            "zh": "取消PMA id{pmaid}关闭请求"
        },
        "text1": {
            "en": "Do you really want to cancel the PMA closing request?",
            "fr": "Voulez-vous vraiment annuler la demande de clôture de PMA?",
            "it": "Vuoi davvero annullare la richiesta di chiusura PMA?",
            "ja": "PMA終了リクエストを本当にキャンセルしますか？",
            "ru": "Вы уверены, что хотите отменить закрытие PMA?",
            "tr": "PMA kapatma talebini gerçekten iptal etmek istiyor musunuz?",
            "uk": "Ви впевнені, що хочете відмінити закриття PMA?",
            "zh": "是否确实要取消PMA关闭请求？"
        }
    },
    "modal_pmaCloseDeposit": {
        "_header": {
            "en": "Closing PMA deposit id {dep_id}",
            "fr": "Clôture de l'ID de dépôt PMA {dep_id}",
            "it": "Chiusura ID deposito PMA {dep_id}",
            "ja": "PMA入金id {dep_id}の締め切り",
            "ru": "Закрытие PMA депозита id {dep_id}",
            "tr": "PMA mevduat kimliğini {dep_id} kapatma",
            "uk": "Закриття PMA депозиту id {dep_id}",
            "zh": "关闭PMA存款id{dep_id}"
        },
        "description": {
            "en": "Do you really want to close PMA deposit {dep_id} and withdraw your remaining share valued at {nlv} {basesym}? You will get a corresponding share of each token balance on the PMA",
            "fr": "Voulez-vous vraiment fermer le dépôt PMA {dep_id} et retirer votre part restante évaluée à {nlv} {basesym}? Vous obtiendrez une part correspondante de chaque solde de jetons sur le PMA",
            "it": "Vuoi davvero chiudere il deposito PMA {dep_id} e ritirare la tua quota rimanente valutata {nlv} {basesym}? Otterrai una quota corrispondente di ciascun saldo di token sul PMA",
            "ja": "PMAの入金{dep_id}を締め切り、{nlv} {basesym}と評価された残りの持分を引き出しますか？PMAのトークン残高に対応する持分を取得することになります。",
            "ru": "Вы правда хотите закрыть депозит {dep_id} и вывести остаток вашей доли эквивалентный {nlv} {basesym} на свой аккаунт? Вывод будет произведен пропорционально, в тех токенах которые на данный момент есть на балансе PMA.",
            "tr": "PMA mevduatını {dep_id} gerçekten kapatmak ve {nlv} {basesym} öğesinde değerlendirilen kalan payınızı geri çekmek istiyor musunuz? PMA'daki her token bakiyesinden bir ilgili pay alacaksınız",
            "uk": "Ви правда хочете закрити депозит {dep_id} і вивести залишок вашої частки еквівалентний {nlv} {basesym} на свій аккаунт? Виведення буде проведене пропорційно, в тих токенах які на даний момент є на балансі PMA.",
            "zh": "你真的想结束PMA存款{dep_id}并提取你剩余的价值为{nlv}{basesym}的股份吗？您将在PMA上获得每个代币余额的相应份额"
        }
    },
    "modal_pmaDeposit": {
        "_header": {
            "en": "Deposit to PMA {pmaid}",
            "fr": "Déposer PMA {pmaid}",
            "it": "Deposito PMA {pmaid}",
            "ja": "PMA{pmaid}を入金しますか？",
            "ru": "Депозит на PMA {pmaid}",
            "tr": "PMA yatırılsın mı {pmaid}?",
            "uk": "Депозит на PMA: {pmaid}",
            "zh": "存放PMA{pmaid}"
        }
    },
    "modal_pmaWithdraw": {
        "_header": {
            "en": "Withdraw PMA {pmaid} deposits",
            "fr": "Retirer des dépôts PMA {pmaid}",
            "it": "Preleva depositi PMA {pmaid}",
            "ja": "PMA {pmaid}入金の引き出し",
            "ru": "Вывод из PMA: {pmaid}",
            "tr": "PMA {pmaid} mevduatlarını çekme",
            "uk": "Виведення з PMA: {pmaid}",
            "zh": "提取PMA{pmaid}存款"
        },
        "list_title": {
            "DEPRECATED": "DEPRECATED",
            "en": "Deposits list",
            "fr": "Liste des dépôts",
            "it": "Elenco dei depositi",
            "ja": "入金リスト",
            "ru": "Список депозитов",
            "tr": "Mevduat listesi",
            "uk": "Список депозитів",
            "zh": "存款清单"
        },
        "noDeposites": {
            "en": "No deposits in this PMA",
            "fr": "Aucun dépôt dans ce PMA",
            "it": "Nessun deposito in questo PMA",
            "ja": "このPMAに入金はありません。",
            "ru": "Нет депозитов по данному PMA",
            "tr": "Bu PMA'da mevduat yok",
            "uk": "Немає депозитів у цьому PMA",
            "zh": "此PMA中没有存款"
        }
    },
    "modal_positionClose": {
        "_header": {
            "en": "Closing order {oid}, position and SLTP",
            "fr": "Ordre de clôture {oid}, position et SLTP",
            "it": "Ordine di chiusura {oid}, posizione e SLTP",
            "ja": "注文{oid}、入金、SLTPの締め切り",
            "ru": "Закрытие ордера {oid}, позиции и SLTP",
            "tr": "Kapanış komutu {oid}, konum ve SLTP",
            "uk": "Закриття ордера {oid}, позиції і SLTP",
            "zh": "关闭订单{oid}、位置和SLTP"
        },
        "text1": {
            "en": "Do you really want to close this order?",
            "fr": "Voulez-vous vraiment clôturer cette commande?",
            "it": "Vuoi davvero chiudere questo ordine?",
            "ja": "この注文を本当に終了しますか？",
            "ru": "Вы уверены, что хотите закрыть этот ордер?",
            "tr": "Bu komutu gerçekten kapatmak istiyor musunuz?",
            "uk": "Ви впевнені, що хочете закрити цей ордер?",
            "zh": "你真的想结束这个订单吗？"
        },
        "text2": {
            "en": "You are going to close the SLTP order and the 'position'.",
            "fr": "Vous allez fermer l'ordre SLTP et la «position».",
            "it": "Stai per chiudere l'ordine SLTP e la 'posizione'.",
            "ja": "SLTP注文と「ポジション」を締め切ります。",
            "ru": "Вы удалите SLTP ордер и закроете учетную позицию.",
            "tr": "SLTP komutunu ve 'konumu' kapatacaksınız.",
            "uk": "Ви видалите SLTP ордер і закриєте облікову позицію.",
            "zh": "您将关闭SLTP订单和“位置”。"
        },
        "text3": {
            "en": "You will be able to trade or withdraw the funds involved manually, but SLTP order will be unavailable for the closed position.",
            "fr": "Vous pourrez échanger ou retirer manuellement les fonds concernés, mais l'ordre SLTP ne sera pas disponible pour la position fermée.",
            "it": "Sarai in grado di negoziare o ritirare manualmente i fondi coinvolti, ma l'ordine SLTP non sarà disponibile per la posizione chiusa.",
            "ja": "関連する資金を手動で取引または引き出しできますが、SLTP注文は締め切り状態にあるポジションでは利用できません。",
            "ru": "Вы сможете в дальнейшем вручную продать/вывести задействованные в ней средства, но выставить SLTP для закрытой позиции уже нельзя.",
            "tr": "İlgili fonları manuel olarak alıp satabilecek veya çekebileceksiniz, ancak kapalı pozisyon için SLTP komutu kullanılamayacaktır.",
            "uk": "Ви зможете в подальшому вручну продати/вивести задіяні в ній кошти, але виставити SLTP для закритої позиції вже не можна.",
            "zh": "您将可以手动交易或提取所涉及的资金，但SLTP订单将无法用于关闭的位置。"
        }
    },
    "modal_profit": {
    },
    "modal_settingsAlert": {
        "_header": {
            "en": "Settings saving error",
            "fr": "Erreur d'enregistrement des paramètres",
            "it": "Errore nel salvataggio delle impostazioni",
            "ja": "設定保存エラー",
            "ru": "Ошибка при сохранении настроек",
            "tr": "Ayarları kaydetme hatası",
            "uk": "Помилка при збереженні налаштувань",
            "zh": "设置保存错误"
        }
    },
    "modal_signIn": {
    },
    "modal_signUp": {
        "_banner": {
            "en": "Do not have an account yet? Click here and open new account 10 minutes!",
            "ru": "Не зарегистрированы? Нажмите здесь, аккаунт будет готов к работе уже через 10 минут!"
        }
    },
    "modal_terminateAccount": {
        "text1": {
            "en": "If you lost your 2-Factor Authentication device with OTP code generating app AND 2-Factor Authentication OTP SEED KEY and can not login anymore, you can use your Master Key to terminate the account and automatically withdraw all tokens from the account to your Emergency Withdrawal Addresses (EWA). If you have not set EWA for some tokens, they will be changed using market order to BITCOIN (in case BTC EWA was set) or other tokens and sent to your EWA with account termination upon success. You may signup to the system with the same e-mail after the termination of your old account has been completed.",
            "fr": "Si vous avez perdu votre appareil d'authentification à 2 facteurs avec l'application de génération de code OTP ET la clé de semence d'authentification à 2 facteurs et que vous ne pouvez plus vous connecter, vous pouvez utiliser votre clé principale pour fermer le compte et retirer automatiquement tous les jetons du compte vers votre retrait d'urgence. Adresses (EWA). Si vous n'avez pas défini EWA pour certains jetons, ils seront modifiés en utilisant l'ordre du marché en BITCOIN (dans le cas où BTC EWA a été défini) ou d'autres jetons et envoyés à votre EWA avec la fermeture du compte en cas de succès. Vous pouvez vous inscrire au système avec le même e-mail une fois la résiliation de votre ancien compte terminée.",
            "it": "Se hai perso il tuo dispositivo di autenticazione a 2 fattori con l'app di generazione del codice OTP E la chiave di autenticazione a 2 fattori OTP SEED KEY e non riesci più ad accedere, puoi utilizzare la chiave principale per chiudere l'account e ritirare automaticamente tutti i token dall'account al tuo ritiro di emergenza Indirizzi (EWA). Se non hai impostato l'EWA per alcuni token, questi verranno modificati utilizzando l'ordine di mercato in BITCOIN (nel caso in cui sia stato impostato BTW EWA) o altri token e inviati al tuo EWA con la chiusura dell'account in caso di successo. È possibile iscriversi al sistema con la stessa e-mail dopo che è stata completata la chiusura del vecchio account.",
            "ja": "OTPコード生成アプリの入った2要素認証デバイスと、2要素認証OTPシードキーの両方を紛失し、ログインできなくなった場合には、マスターキーを使用してアカウントを終了し、アカウントからすべてのトークンを自動で緊急出金アドレス（EWA）に引き出すことができます。一部のトークンにEWAを設定していない場合、成行注文を使用してビットコイン（BTC EWAが設定されている場合）または他のトークンに変更され、成功時にアカウント終了とともにEWAに送信されます。このアカウントの終了が完了した後、同じメールアドレスでシステムにサインアップできます。",
            "ru": "Если вы не можете зайти в свой аккаунт потому что потеряли девайс для генерации однократных кодов и Секретный Ключ 2FA для генерации кодов, или уверены, что доступ был получен третьими лицами - вы можете использовать Мастер-ключ к своему аккаунту для вывода остатка средств на Адреса Аварийного Вывода (EWA) и закрытия аккаунта. Если для некоторых токенов не указаны EWA, остатки будут обменены на Биткоин или на те токены, для которых вы указали адреса вывода, рыночным ордером, после чего выведены на ваши EWA. После завершения процедуры вы сможете заново открыть аккаунт на Бирже с тем же email.",
            "tr": "OTP kodu üreten uygulamayla 2 Faktörlü Kimlik Doğrulama cihazınızı VE 2 Faktörlü Kimlik Doğrulama OTP SEED ANAHTARINI kaybettiyseniz ve artık giriş yapamıyorsanız, Ana Anahtarınızı kullanarak hesabı sonlandırabilir ve tüm tokenleri otomatik olarak Acil Para Çekme Adreslerinize (EVA) çekebilirsiniz. EWA'yı bazı tokenler için ayarlamadıysanız, piyasa komutu kullanılarak BITCOIN (BTC EWA ayarlanmışsa) veya diğer tokenler olarak değiştirileceklerdir ve hesap sonlandırmasının başarıya ulaşmasıyla EWA'nıza gönderilecektir. Eski hesabınızın sonlandırılması tamamlandıktan sonra aynı e-posta ile sisteme kaydolabilirsiniz.",
            "uk": "Якщо ви не можете зайти в свій аккаунт бо втратили пристрій для генерації одноразових кодів і Приватний Ключ для генерації кодів, або впевнені, що доступ був отриманий третіми особами - ви можете використати Майстер-ключ до свого аккаунта для виведення залишку коштів на Адреси Аварійного Виведення (EWA) і закриття акаунта. Якщо для деяких токенів не вказані EWA, залишки будуть обмінені на біткоїни або на ті токени, для яких ви вказали адреси виведення, ринковим ордером, після чого виведені на ваші EWA. Після завершення процедури ви зможете заново відкрити аккаунт на Біржі з тим же email.",
            "zh": "如果您丢失了带有OTP代码生成应用程序和2-Factor Authentication OTP种子密钥的2-Factor身份验证设备，并且无法再登录，则可以使用主密钥终止帐户并自动将帐户中的所有令牌提取到您的紧急提取地址（EWA）。如果您尚未为某些代币设置EWA，则将使用市场订单将其更改为比特币（如果设置了BTC EWA）或其他代币，并在成功后随帐户终止发送到您的EWA。在旧帐户终止后，您可以使用相同的电子邮件注册到系统。"
        },
        "text2": {
            "en": "<b>Account termination cannot be reverted, all data for this account will be deleted. All tokens will be sent to your Emergency Withdrawal Addresses.</b><br><br> If you have valid OTP generated on your device or have a SEED KEY to restore it, consider changing OTP SEED using SETTINGS area of the Terminal instead of terminating your account completely.",
            "fr": "<b> La résiliation du compte ne peut pas être annulée, toutes les données de ce compte seront supprimées. Tous les jetons seront envoyés à vos adresses de retrait d'urgence. </b> <br> <br> Si vous avez un OTP valide généré sur votre appareil ou si vous avez une clé SEED pour le restaurer, envisagez de changer OTP SEED à l'aide de la zone SETTINGS du terminal. de résilier complètement votre compte.",
            "it": "<b> Non è possibile ripristinare la chiusura dell'account, tutti i dati per questo account verranno eliminati. Tutti i token verranno inviati ai tuoi indirizzi di prelievo di emergenza. </b> <br> <br> Se hai un OTP valido generato sul tuo dispositivo o hai un CHIAVE DI SEMINA per ripristinarlo, considera invece di cambiare SEED OTP utilizzando l'area IMPOSTAZIONI del Terminale di chiudere completamente il tuo account.",
            "ja": "<b>アカウントの終了は元に戻せません。このアカウントのデータはすべて削除されます。すべてのトークンは緊急出金アドレスに送信されます。</b><br><br>デバイスで有効なOTPが生成されている場合、または復元するシードキーがある場合は、アカウントを完全に終了する代わりに、「終了」の「設定」エリアを使用してOTPシードを変更することを検討してください。",
            "ru": "<b>Закрытие аккаунта не может быть отменено, вся информация с аккаунта станет недоступна. Имеющиеся на балансе токены будут отправлены на Адреса Аварийного Вывода.</b><br><br>Если у вас генерятся однократные коды, или есть приватный ключ для генерации однократных кодов, рекомендуется восстановить доступ к аккаунту или поменять Секретный Ключ 2FA для однократных кодов в разделе НАСТРОЙКИ вместо полного закрытия аккаунта с выводом средств.",
            "tr": "<b>Hesap sonlandırma geri alınamaz, bu hesaba ait tüm veriler silinecektir. Tüm tokenler Acil Durum Para Çekme Adreslerinize gönderilecektir.</b> <br> <br> Cihazınızda geçerli OTP oluşturumunuz varsa veya geri yüklemek için SEED ANAHTARINIZ varsa, hesabınızı tamamen sona erdirmek yerine Terminalin AYARLAR alanını kullanarak OTP SEED öğesini değiştirmeyi düşününüz.",
            "uk": "<b>Закриття облікового запису не може бути відмінено, вся інформація з аккаунта стане недоступна. Наявні на балансі токени будуть відправлені на Адреси Аварійного Виведення.</b><br><br>Якщо у вас генеруються одноразові коди, або є приватний ключ для генерації одноразових кодів, рекомендується відновити доступ до аккаунту або поміняти Приватний Ключ для одноразових кодів в розділі НАЛАШТУВАННЯ замість повного закриття акаунта з виведенням коштів.",
            "zh": "<b>无法还原帐户终止，将删除此帐户的所有数据。所有代币都将发送到您的紧急取款地址。<b><br><br>如果您的设备上生成了有效的OTP或有一个种子密钥来还原它，请考虑使用终端的设置区域更改OTP种子，而不是完全终止您的帐户。"
        },
        "text3": {
            "en": "If you happened to lose a Master Key from your account as well as the OTP device and the OTP SEED KEY, please wait 180 days from your last successful login to the system and use this form leaving Master Key field blank.",
            "fr": "Si vous avez perdu une clé principale de votre compte ainsi que le périphérique OTP et la clé de semence OTP, veuillez attendre 180 jours après votre dernière connexion réussie au système et utilisez ce formulaire en laissant le champ Clé principale vide.",
            "it": "Se ti è capitato di perdere una chiave master dal tuo account, nonché il dispositivo OTP e la chiave SEED OTP, attendi 180 giorni dall'ultimo accesso riuscito al sistema e utilizza questo modulo lasciando vuoto il campo chiave master.",
            "ja": "アカウント、OTPデバイス、OTPシードキーからマスターキーを紛失した場合、最後にシステムにログインしてから180日間待って、マスターキーフィールドを空白のままにしてこのフォームを使用してください。",
            "ru": "Если вы умудрились потерять Мастер-ключ к своему аккаунту, устройство которое генерило однократные коды, а также Секретный ключ 2FA для генерации однократных кодов, подождите 180 дней с момента последнего успешного входа в систему и используйте эту форму, введя вместо Мастер-Ключа ваш логин.",
            "tr": "Hesabınızdan, bir Ana Anahtarı ayrıca OTP cihazını ve OTP SEED ANAHTARINI kaybederseniz, lütfen sisteme son başarılı giriş tarihinizden itibaren 180 gün bekleyin ve Ana Anahtar alanını boş bırakarak bu formu kullanın.",
            "uk": "Якщо ви примудрилися втратити Майстер-ключ до свого аккаунта, пристрій який генерує одноразові коди, а також Приватний ключ для генерації одноразових кодів, почекайте 180 днів з моменту останнього успішного входу в систему і використовуйте цю форму, ввівши замість Майстер-Ключа ваш логін.",
            "zh": "如果您碰巧丢失了帐户中的主密钥以及OTP设备和OTP种子密钥，请在上次成功登录系统后等待180天，并使用此表单将主密钥字段留空。"
        }
    },
    "modal_terminateAccountConfirmation": {
        "_header": {
            "en": "WARNING! Your account will be terminated!",
            "fr": "AVERTISSEMENT! Votre compte sera fermé!",
            "it": "AVVERTIMENTO! Il tuo account verrà chiuso!",
            "ja": "警告！ アカウントが完全に削除されます！",
            "ru": "ВНИМАНИЕ! Ваш аккаунт будет удален!",
            "tr": "UYARI! Hesabınız sonlandırılacaktır!",
            "uk": "УВАГА! Ваш аккаунт буде видалений!",
            "zh": "警告！您的帐户将被终止！"
        },
        "button_terminateAccount": {
            "en": "Yes, terminate account and withdraw tokens to my EWA.",
            "fr": "Oui, fermez le compte et retirez les jetons sur mon EWA.",
            "it": "Sì, chiudi l'account e ritira i token sul mio EWA.",
            "ja": "了解した上で、アカウントを終了し、トークンをEWAに引き出す",
            "ru": "Да, удалить аккаунт и вывести остатки на мои EWA.",
            "tr": "Evet, hesabı sonlandır ve tokenleri EWA'ma çek.",
            "uk": "Так, видалити аккаунт і вивести залишки на мої EWA.",
            "zh": "是的，终止帐户并将代币提取到我的电子钱包。"
        },
        "text1": {
            "en": "Last warning.",
            "fr": "Dernier avertissement.",
            "it": "Ultimo avvertimento.",
            "ja": "最後の警告です。",
            "ru": "Последнее предупреждение.",
            "tr": "Son uyarı.",
            "uk": "Останнє попередження.",
            "zh": "最后警告。"
        },
        "text2": {
            "en": "<b>You are terminating your account and withdrawing all tokens to your Emergency Withdrawal Addresses (EWA)</b>",
            "fr": "<b> Vous clôturez votre compte et retirez tous les jetons de vos adresses de retrait d'urgence (EWA) </b>",
            "it": "<b> Stai chiudendo il tuo account e ritirando tutti i token ai tuoi Indirizzi di prelievo di emergenza (EWA) </b>",
            "ja": "<b>アカウントを完全に削除し、すべてのトークンを緊急出金アドレス（EWA）に引き出します</b>",
            "ru": "<b>Вы удаляете свой аккаунт и выводите токены на Адреса Аварийного Вывода (EWA)</b>",
            "tr": "<b>Hesabınızı sonlandırıyorsunuz ve tüm tokenleri Acil Durum Para Çekme Adreslerinize (EWA) çekiyorsunuz</b>",
            "uk": "<b>Ви видаляєте свій аккаунт і виводите токени на Адреси Аварійного Виведення (EWA)</b>",
            "zh": "<b>您将终止您的帐户并将所有代币提取到您的紧急取款地址（EWA）</b>"
        },
        "text3": {
            "en": ""
        }
    },
    "tokenContractInfo": {
        "text1": {
            "en": "This token was issued by the smart-contract <b>{contract_address}</b> with  {decimals_on_blockchain} decimals on [blockchains.{blockchain}] blockchain.",
            "fr": "Ce jeton a été émis par le contrat intelligent <b>{contract_address}</b> avec {decimals_on_blockchain} décimales sur [blockchains.{blockchain}] blockchain.",
            "it": "Questo token è stato emesso dallo smart contract <b>{contract_address}</b> con {decimals_on_blockchain} decimali su [blockchains.{blockchain}] blockchain.",
            "ja": "このトークンは、[blockchains.{blockchain}]ブロックチェーンで、小数{decimals_on_blockchain}にて、スマートコントラクト<b>{contract_address}</b>によって発行されました。",
            "ru": "Этот токен выпущен смарт-контрактом <b>{contract_address}</b> c {decimals_on_blockchain} знаков после запятой на блокчейне [blockchains.{blockchain}].",
            "tr": "Bu token, [blockchains.{blockchain}] blok zinciri üzerinde bulunan {decimals_on_blockchain} ondalık sayıyla akıllı sözleşme <b>{contract_address}</b> tarafından yayınlanmıştır.",
            "uk": "Цей токен випущений смарт-контрактом <b>{contract_address}</b> з {decimals_on_blockchain} знаками після коми на блокчейні [blockchains.{blockchain}].",
            "zh": "此代币是由区块链[blockchains.{blockchain}]上具有{decimals_on_blockchain}小数的智能合约<b>{contract_address}</b> 颁发的。"
        }
    },
    "modal_tokenNoEWA": {
        "_header": {
            "en": "Warning! {blockchain} EWA was not set!",
            "fr": "Avertissement! {blockchain} EWA n'a pas été défini!",
            "it": "Avvertimento! {blockchain} EWA non è stato impostato!",
            "ja": "警告！{blockchain} EWAが設定されていません！",
            "ru": "Внимание! Для {blockchain} не задан EWA!",
            "tr": "Uyarı! {blockchain} EWA ayarlanmadı!",
            "uk": "Увага! Для {blockchain} не заданий EWA!",
            "zh": "警告！{blockchain}未设置EWA！"
        },
        "text2": {
            "en": "You have {sym} tokens on your account but the Emergency Withdrawal Address (EWA) for {blockchain} was not set.",
            "fr": "Vous disposez de {sym} jetons sur votre compte, mais l'adresse de retrait d'urgence (EWA) n'a pas été définie.",
            "it": "Hai token {sym} sul tuo account ma l'indirizzo di prelievo di emergenza (EWA) non è stato impostato.",
            "ja": "アカウントに{sym}トークンがありますが、緊急出金アドレス（EWA）が設定されていません。",
            "ru": "У вас есть токены {sym} но не задан {blockchain} Адрес Аварийного Вывода (EWA) для них.",
            "tr": "Hesabınızda {sym} tokenler var, ancak Acil Durum Para Çekme Adresi (EWA) ayarlanmadı.",
            "uk": "У вас є токени {sym} але не задана Адреса Аварійного Виведення (EWA) для них.",
            "zh": "您的帐户上有{sym}代币，但未设置紧急取款地址（EWA）。"
        }
    },
    "modal_tradelog": {
        "_header": {
            "en": "Trade operation",
            "fr": "Opération commerciale",
            "it": "Operazione commerciale",
            "ja": "取引操作",
            "ru": "Торговая операция",
            "tr": "Alım satım operasyonu",
            "uk": "Торгова операція",
            "zh": "贸易经营"
        }
    },
    "modal_wallet": {
    },
    "modal_withdraw": {
		"address": {
			"en": "Address on the [blockchains.{blockchain}] blockchain", 
			"fr": "Adresse sur la blockchain [blockchains.{blockchain}]", 
			"it": "Indirizzo sulla blockchain [blockchains.{blockchain}]", 
			"ja": "[blockchains.{blockchain}]ブロックチェーン上のアドレス", 
			"ko": "[blockchains.{blockchain}] 블록 체인 주소", 
			"ru": "Адрес на блокчейне [blockchains.{blockchain}]", 
			"tr": "[blockchains.{blockchain}] blok zincirindeki adres", 
			"uk": "Адреса на блокчейні [blockchains.{blockchain}]", 
			"zh": "在[blockchains.{blockchain}]区块链上的地址"
		}, 
        "commission_description": {
            "en": "If you send {sym} to top-up addresses on the {domain.name} exchange, only <b>{internal_transfer_fee} {sym}</b>  will be charged as withdrawal fee. Otherwise, the withdrawal fee depends on the current [blockchains.{blockchain}] network load.", 
			"fr": "Si vous envoyez {sym} à des adresses de rechargement sur l'échange {domain.name}, seul <b>{internal_transfer_fee} {sym}</b>  sera facturé comme frais de retrait. Sinon, les frais de retrait dépendent de la charge actuelle du réseau [blockchains.{blockchain}].",
			"it": "Se invii {sym} a indirizzi di ricarica sulla borsa {domain.name}, solo <b>{internal_transfer_fee} {sym}</b>  verrà addebitato come commissione di prelievo. In caso contrario, la commissione di prelievo dipende dall'attuale carico di rete [blockchains.{blockchain}].", 
			"ja": "{domain.name}取引所のトップアップアドレスに{sym}を送信した場合、引き出し手数料として<b>{internal_transfer_fee} {sym}</b> のみが請求されます。それ以外の場合、引き出し手数料は現在の[blockchains.{blockchain}]ネットワークの負荷によって異なります。", 
			"ko": "{domain.name} 거래소의 충전 주소로 {sym}을 보내면 <b>{internal_transfer_fee} {sym}</b>  만 인출 수수료로 청구됩니다. 그렇지 않으면 출금 수수료는 현재 [blockchains.{blockchain}] 네트워크 부하에 따라 다릅니다.",
            "ru": "Если вы отправите {sym} на адреса пополнения на бирже {domain.name}, то комиссия составит только <b>{internal_transfer_fee} {sym}</b> . В противном случае комиссия за вывод зависит от текущей загрузки сети [blockchains.{blockchain}].", 
			"tr": "{domain.name} borsasındaki kontör adreslerine {sym} gönderirseniz, para çekme ücreti olarak yalnızca <b>{internal_transfer_fee} {sym}</b>  tahsil edilecektir. Aksi takdirde, para çekme ücreti mevcut [blockchains.{blockchain}] ağ yüküne bağlıdır.", 
			"uk": "Якщо ви надішлете {sym} на адреси для поповнення на біржі {domain.name}, як комісія за зняття стягуватиметься лише <b>{internal_transfer_fee} {sym}</b> . В іншому випадку плата за зняття коштів залежить від поточного навантаження мережі [blockchains.{blockchain}].", 
			"zh": "如果您将{sym}发送到{domain.name}交易所的充值地址，则仅收取<b>{internal_transfer_fee} {sym}</b> 作为提款费。否则，取款费用取决于当前的[blockchains.{blockchain}]网络负载。"
        },
        "addressConfirmation_title": {
            "en": "I confirm that this address is on the [blockchains.{blockchain}] blockchain and amount is correct.", 
			"fr": "Je confirme que cette adresse est sur la blockchain [blockchains.{blockchain}] et que le montant est correct.",
			"it": "Confermo che questo indirizzo si trova sulla blockchain [blockchains.{blockchain}] e l'importo è corretto.", 
			"ja": "このアドレスが[blockchains.{blockchain}]ブロックチェーン上にあり、金額が正しいことを確認しました。", 
			"ko": "이 주소가 [blockchains.{blockchain}] 블록 체인에 있으며 금액이 정확함을 확인합니다.",
            "ru": "Подтверждаю, что это адрес именно на блокчейне [blockchains.{blockchain}] и сумма введена правильно.", 
			"tr": "Bu adresin [blockchains.{blockchain}] blockchain'de olduğunu ve miktarın doğru olduğunu onaylıyorum.", 
			"uk": "Я підтверджую, що ця адреса на блокчейні [blockchains.{blockchain}], і сума правильна.", 
			"zh": "我确认此地址位于[blockchains.{blockchain}]区块链上，金额正确。"
        },
        "feeChangeConfirmation_title": {
            "en": "The fee has been changed! The current commission is {fee}, the recipient will receive {amount}",
			"fr": "La commission a été changée! Les frais actuels sont de {fee}, le destinataire recevra {amount}",
			"it": "La commissione è stata cambiata! La tariffa attuale è {fee}, il destinatario riceverà {amount}", 
			"ja": "手数料が変更になりました！現在の料金は{fee}で、受取人は{amount}を受け取ります", 
			"ko": "커미션이 변경되었습니다! 현재 수수료는 {fee}이며 수취인은 {amount}를 받게됩니다.",
            "ru": "Комиссия изменилась! Текущая комиссия составляет {fee}, получатель получит {amount}", 
			"tr": "Komisyon değiştirildi! Mevcut ücret {fee}, alıcı {amount} alacak", 
			"uk": "Комісію змінили! Поточна комісія - {fee}, одержувач отримає {amount}", 
			"zh": "佣金已更改！当前费用为{fee}，收件人将收到{amount}"
        },
        "button_send": {
            "en": "Send {sym}",
            "fr": "Envoyer {sym}",
            "it": "Invia {sym}",
            "ja": "{sym}を送信",
            "ko": "보내기 {sym}",
            "ru": "Отправить {sym}",
            "tr": "{sym} öğesini gönder",
            "uk": "Відправити {sym}",
            "zh": "发送{sym}"
        },
        "checkbox_noTag": {
            "en": "No TAG ({tag_name})",
            "fr": "Aucun TAG ({tag_name})",
            "it": "Nessun TAG ({tag_name})",
            "ja": "タグなし ({tag_name})",
            "ru": "Tag ({tag_name}) не нужен",
            "tr": "ETİKET ({tag_name}) yok",
            "uk": "Tag ({tag_name}) не потрібен",
            "zh": "没有标签 ({tag_name})"
        },
        "checkbox_tag": {
            "en": "TAG ({tag_name})",
            "fr": "TAG ({tag_name})",
            "it": "TAG ({tag_name})",
            "ja": "タグ ({tag_name})",
            "ru": "ТЭГ ({tag_name})",
            "tr": "ETİKET ({tag_name})",
            "uk": "Tag ({tag_name})",
            "zh": "标签 ({tag_name})"
        },
        "warning_tag": {
            "en": "TAG ({tag_name}) should be used in most cases for {sym} transfers. Turn off TAG selector to send {sym} without specifying the TAG.",
            "fr": "TAG ({tag_name}) doit être utilisé dans la plupart des cas pour les transferts {sym}. Veuillez confirmer que vous voulez vraiment envoyer {sym} sans spécifier le TAG ({tag_name}). Désactivez le sélecteur TAG pour envoyer {sym} sans spécifier le TAG.",
            "it": "TAG ({tag_name}) dovrebbe essere utilizzato nella maggior parte dei casi per trasferimenti {sym}. Conferma di voler davvero inviare {sym} senza specificare il TAG ({tag_name}). Disattiva il selettore TAG per inviare {sym} senza specificare il TAG.",
            "ja": "ほとんどの場合、{sym}転送にはタグを使用する必要があります。タグを指定せずに{sym}を本当に送信しても宜しいですか？TAGセレクターをオフにして、TAGを指定せずに{sym}を送信します。",
            "ru": "Как правило, транзакции {sym} используют ТЭГ ({tag_name}) в дополнение к адресу. Подтвердите, что вы хотите отправить {sym} без указания ТЭГА ({tag_name}). Отключите селектор TAG для отправки {sym} без указания тега.",
            "tr": "ETİKET ({tag_name}) çoğu durumda {sym} aktarımları için kullanılmalıdır. Lütfen gerçekten ETİKET ({tag_name}) belirtmeden {sym} göndermek istediğinizi onaylayın. TAG belirtmeden {sym} göndermek için TAG seçiciyi kapatın.",
            "uk": "Як правило, транзакції {sym} використовують ТЕГ ({tag_name}) на додаток до адреси. Підтвердіть, що ви хочете відправити {sym} без вказівки тега ({tag_name}). Вимкніть селектор TAG для надсилання {sym}, не вказуючи TAG.",
            "zh": "标签应该在大多数情况下用于{sym}传输。请确认确实要发送{sym}而不指定标记。关闭TAG选择器以发送{sym}而不指定TAG({tag_name})。"
        }
    },
    "modal_withdrawalCancellation": {
		"deprecated": "deprecated",
        "_header": {
            "en": "Confirm Withdrawal Cancellation",
            "fr": "Confirmer l'annulation du retrait",
            "it": "Conferma annullamento prelievo",
            "ja": "出金キャンセルの確認",
            "ru": "Подтвердите отмену вывода токенов",
            "tr": "Para Çekme İptalini Onayla",
            "uk": "Підтвердіть выдмыну виведення токенів",
            "zh": "确认取消取款"
        },
        "text2": {
            "en": "Your withdrawal order {oid} for {amount} {symbol} will be cancelled.",
            "fr": "Votre commande de retrait {oid} pour {amount} {symbol} sera annulée.",
            "it": "Il tuo ordine di prelievo {oid} per {amount} {symbol} verrà annullato.",
            "ja": "{vol} {symbol}の出金注文{oid}はキャンセルされます。",
            "ru": "Ваш ордер {oid} на вывод {amount} {symbol} будет отменен.",
            "tr": "{amount} {symbol} için para çekme komutunuz {oid} iptal edilecektir.",
            "uk": "Ваш ордер {oid} на виведення {amount} {symbol} буде відмінений.",
            "zh": "您的{amount}{symbol}提款单{oid}将被取消。"
        }
    },
    "modal_withdrawalDelay": {
        "text1": {
            "en": "You can set your own delay for withdrawal orders and for change requests of your Emergency Withdrawal Addresses (EWA). Received orders will be put on hold for specified time and executed upon delay expiration. You can increase delay period any time you want, but reducing or canceling the delay will be implemented with the same delay as was set before for withdrawal orders.",
            "fr": "Vous pouvez définir votre propre délai pour les ordres de retrait et pour les demandes de modification de vos adresses de retrait d'urgence (EWA). Les commandes reçues seront mises en attente pendant une durée spécifiée et exécutées à l'expiration du délai. Vous pouvez augmenter la période de retard à tout moment, mais la réduction ou l'annulation du délai sera mise en œuvre avec le même délai que celui défini précédemment pour les ordres de retrait.",
            "it": "Puoi impostare il tuo ritardo per gli ordini di prelievo e per le richieste di modifica dei tuoi Indirizzi di prelievo di emergenza (EWA). Gli ordini ricevuti verranno messi in attesa per il tempo specificato ed eseguiti alla scadenza del ritardo. Puoi aumentare il periodo di ritardo ogni volta che lo desideri, ma ridurre o annullare il ritardo verrà implementato con lo stesso ritardo impostato in precedenza per gli ordini di prelievo.",
            "ja": "出金注文および緊急出金アドレス（EWA）の変更リクエストに対して、独自の遅延を設定できます。受け取った注文は指定された時間保留され、期限が切れると実行されます。遅延期間はいつでも延長できますが、遅延の削減またはキャンセルは、出金注文の前に設定されたのと同じ遅延で実行されます。",
            "ru": "Вы можете установить свою задержку исполнения ордеров на вывод токенов и изменений ваших Адресов Аварийного Вывода (EWA). Ордера будут находится в ожидании указанное количество времени и выполняться по истечении срока задержки. Увеличить ранее введенную задержку можно в любое время, но уже принятые ордера выполнятся со старой задержкой. Запрос на уменьшение задержки будет применен через ранее установленный в качестве задержки срок с момента последнего запроса на изменение задержки. Новый запрос отменяет ранее отправленные, но еще не примененные запросы на уменьшение срока.",
            "tr": "Para çekme komutları ve Acil Para Çekme Adreslerinizin (EWA) değişiklik talepleri için kendi ertelemenizi ayarlayabilirsiniz. Alınan komutlar belirtilen süre boyunca beklemeye alınacaktır ve erteleme süresi dolduktan sonra yerine getirilecektir. Erteleme süresini istediğiniz zaman artırabilirsiniz, ancak ertelemenin azaltılması veya iptal edilmesi durumunda, para çekme komutları için önceden ayarlanan erteleme uygulanacaktır.",
            "uk": "Ви можете встановити свою затримку виконання ордерів на виведення токенів і зміни ваших Адрес Аварійного Виведення (EWA). Ордери будуть знаходитися в очікуванні вказану кількість часу і виконуватимуться після закінчення терміну затримки. Збільшити раніше введену затримку можна в будь-який час, але вже прийняті ордера виконуватимуться зі старою затримкою. Запит на зменшення затримки буде застосований через раніше встановлений параметром затримки термін з моменту останнього запиту на зміну затримки. Новий запит відміняє раніше відправлені, але ще не застосовані запити на зменшення терміну.",
            "zh": "您可以自行设置取款单和紧急取款地址（EWA）更改请求的延迟。收到的订单将被保留指定时间，并在延迟到期时执行。您可以随时增加延迟时间，但减少或取消延迟的时间将与之前为提款单设置的延迟时间相同。"
        },
        "text2": {
            "en": "You will be able to cancel any withdrawal order on hold during the delay period.",
            "fr": "Vous pourrez annuler tout ordre de retrait en attente pendant la période de retard.",
            "it": "Sarai in grado di annullare qualsiasi ordine di prelievo in sospeso durante il periodo di ritardo.",
            "ja": "遅延期間中に保留中の出金注文をキャンセルすることができます。",
            "ru": "Вы сможете отменить любой запрос на вывод средств в то время, как он находится в ожидании.",
            "tr": "Erteleme süresi boyunca beklemedeki herhangi bir para çekme komutunu iptal edebilirsiniz.",
            "uk": "Ви зможете відмінити будь-який запит на виведення коштів в той час, як він знаходиться в очікуванні.",
            "zh": "您可以在延迟期间取消任何暂停的提款单。"
        },
        "text3": {
            "en": "This feature gives you some time to stop any withdrawals from your account in case someone gets access to your devices and the account. You can also use your Master Key to perform Emergency cancellation of delayed orders and withdraw all your tokens to your EWA.",
            "fr": "Cette fonctionnalité vous donne le temps d'arrêter tout retrait de votre compte au cas où quelqu'un aurait accès à vos appareils et au compte. Vous pouvez également utiliser votre clé principale pour effectuer une annulation d'urgence des commandes retardées et retirer tous vos jetons sur votre EWA.",
            "it": "Questa funzione ti dà il tempo di interrompere qualsiasi prelievo dal tuo account nel caso in cui qualcuno ottenga l'accesso ai tuoi dispositivi e all'account. Puoi anche utilizzare la tua chiave master per eseguire l'annullamento di emergenza di ordini in ritardo e ritirare tutti i token sul tuo EWA.",
            "ja": "この機能により、誰かがデバイスとアカウントにアクセスできるようになった場合に、アカウントからの引き出しを停止する時間が与えられます。マスターキーを使用して、遅延注文の緊急キャンセルを実行し、すべてのトークンをEWAに引き出すこともできます。",
            "ru": "Эта функция даст вам время отменить вывод средств с вашего аккаунта в случае получения доступа к нему третьими лицами. Вы также сможете использовать Мастер-ключ чтобы отменить все ордера на ожидании и вывести средства на ваши Адреса Аварийного Вывода (EWA)",
            "tr": "Bu özellik, birinin cihazlarınıza ve hesabınıza erişmesi durumunda hesabınızdan herhangi bir para çekme işlemini durdurmak için biraz zaman tanır. Ana Anahtarınızı, ertelenmiş komutların Acil Durum iptalini gerçekleştirmek ve tüm tokenlerinizi EWA'nıza çekmek için de kullanabilirsiniz.",
            "uk": "Ця функція дасть вам час відмінити виведення коштів з вашого аккаунта в разі отримання доступу до нього третіми особами. Ви також зможете використовувати Майстер-ключ щоб відмінити всі ордера на очікуванні та вивести кошти на ваші Адреси Аварійного Виведення (EWA)",
            "zh": "此功能使您有时间停止从您的帐户中提款，以防有人访问您的设备和帐户。您还可以使用您的主密钥执行延迟订单的紧急取消，并将您的所有令牌撤回到您的电子钱包。"
        }
    },
    "modal_withdrawalInfo": {
    },
    "modal_withdrawalCancelation": {
        "text1": {
            "en": "Do you really want to delete queued withdrawal order {oid}?",
            "fr": "Voulez-vous vraiment supprimer l'ordre de retrait en attente {oid}?",
            "it": "Vuoi veramente cancellare l'ordine di prelievo in coda {oid}?",
            "ja": "キューにある出金注文{oid}を本当に削除しますか？",
            "ru": "Вы правда хотите удалить находящийся в очереди ордер на вывод № {oid}?",
            "tr": "Sıraya alınmış para çekme komutunu {oid} gerçekten silmek istiyor musunuz?",
            "uk": "Ви правда хочете видалити орлдер що знаходиться в черзі на виведення № {oid}?",
            "zh": "是否确实要删除排队的取款单{oid}？"
        }
    },
    "modal_wotpDisable": {
    },
    "modal_wotpEnable": {
        "text1": {
            "en": "You are going to set an additional OTP for withdrawals and EWA changes.",
            "fr": "Vous allez définir un OTP supplémentaire pour les retraits et les modifications EWA.",
            "it": "Stai per impostare un OTP aggiuntivo per i prelievi e le modifiche EWA.",
            "ja": "出金とEWAの変更のために追加のOTPを設定します。",
            "ru": "Вы устанавливаете дополнительный OTP (однократный код) для операций вывода токенов и изменений адресов аварийного вывода.",
            "tr": "Para çekme ve EWA değişiklikleri için ek bir OTP ayarlayacaksınız.",
            "uk": "Ви встановлюєте додатковий OTP (одноразовий код) для операцій виведення токенів і зміни Адрес Аварійного Виведення (EWA).",
            "zh": "您将为取款和EWA更改设置额外的OTP。"
        },
        "text2": {
            "en": "You must save your OTP SEED Private Key offline in a secure place. If you will lose this key, you might be unable to withdraw tokens or set EWA.",
            "fr": "Vous devez enregistrer votre clé privée OTP SEED hors ligne dans un endroit sécurisé. Si vous perdez cette clé, vous ne pourrez peut-être pas retirer les jetons ou définir EWA.",
            "it": "È necessario salvare la chiave privata OTP SEED offline in un luogo sicuro. Se perdi questa chiave, potresti non essere in grado di ritirare i token o impostare EWA.",
            "ja": "OTPシードプライベートキーを安全な場所にオフラインで保存する必要があります。このキーを紛失すると、トークンを引き出したり、EWAを設定できなくなる可能性があります。",
            "ko": "Authenticator 키를 오프라인의 안전한 장소에 보관해야 합니다. 이 키를 잃어버리면 계정에서 토큰을 복구하지 못할 수 있습니다.",
            "ru": "ЭТО ВАЖНО !!! Вы должны сохранить Секретный Ключ 2FA в надежном месте, желательно на бумаге. Без него вы не сможете выводить токены и менять EWA!!!",
            "tr": "OTP SEED Özel Anahtarınızı güvenli bir yere çevrimdışı olarak kaydetmeniz gerekmektedir. Bu anahtarı kaybetmeniz durumunda, tokenleri çekemeyebilir veya EWA'yı ayarlayamayabilirsiniz.",
            "uk": "ЦЕ ВАЖЛИВО !!! Ви повинні зберегти Секретний Ключ 2FA в надійному місці, бажано на папері. Без нього ви не зможете виводити токени і міняти EWA !!!",
            "zh": "您必须将OTP种子私钥脱机保存在安全的地方。如果您将丢失此密钥，则可能无法撤回令牌或设置EWA。"
        },
        "text3": {
            "en": "Please add this SEED private key to your Google Authenticator application and enter code here (valid for 30 sec)",
            "fr": "Veuillez ajouter cette clé privée SEED à votre application Google Authenticator et entrez le code ici (valable 30 secondes)",
            "it": "Aggiungi questa chiave privata SEED alla tua applicazione Google Authenticator e inserisci il codice qui (valido per 30 secondi)",
            "ja": "このシードプライベートキーをGoogle認証システムアプリケーションに追加し、ここにコードを入力してください（30秒間有効）",
            "ko": "이 SEED 프라이빗 키를 Google Authenticator 앱에 추가하고 코드를 여기에 입력하십시오(30초 내에 입력).",
            "ru": "Введите этот Cекретный Ключ 2FA в приложение Google Authenticator и сгенерированный им временный 6-значный код введите сюда (код из приложения действителен 30 секунд)",
            "tr": "Lütfen bu SEED özel anahtarını Google Kimlik Denetleyicisi uygulamasına ekleyin ve kodu buraya girin (30 saniye için geçerlidir)",
            "uk": "Введіть цей Секретний Ключ в додаток Google Authenticator і згенерований їм тимчасовий 6-значний код введіть сюди (код з додатку дійсний 30 секунд)",
            "zh": "请将此种子私钥添加到您的谷歌验证器应用程序并在此处输入代码（有效期为30秒）"
        }
    },
    "nav": {
    },
    "notifications": {
        "pmaCreated": {
            "en": "New PMA {pmaid} has been created.",
            "ru": "Новый PMA {pmaid} успешно создан."
        },
        "telegramID": {
            "en": "New Telegram user {telegramID} has been connected to your account.",
            "ru": "К вашему аккаунту привязан новый пользователь Telegram с ID {telegramID}"
        },
        "EWAset": {
            "en": "New {sym} EWA has been set: {address}",
            "fr": "Le nouvel {sym} EWA a été défini: {address}",
            "it": "Nuovo {sym} EWA impostato: {address}",
            "ja": "新しい{sym} EWAが設定されています：{address}",
            "ru": "Установлен новый EWA для {sym}: {address}",
            "tr": "Yeni {sym} EWA ayarlandı: {address}",
            "uk": "Встановлено новий EWA для {sym}: {address}",
            "zh": "已设置新的{sym}EWA:{address}"
        },
        "apikeyChanged": {
            "en": "API key was successfully changed",
            "fr": "La clé API a été modifiée avec succès",
            "it": "La chiave API è stata cambiata correttamente",
            "ja": "APIキーが変更されました",
            "ru": "API ключ был успешно изменен",
            "tr": "API anahtarı başarıyla değiştirildi",
            "uk": "API ключ був успішно змінений",
            "zh": "已成功更改API密钥"
        },
        "apikeyCreated": {
            "en": "API key was successfully created",
            "fr": "La clé API a été créée avec succès",
            "it": "La chiave API è stata creata correttamente",
            "ja": "APIキーが作成されました",
            "ru": "API ключ бы успешно создан",
            "tr": "API anahtarı başarıyla oluşturuldu",
            "uk": "API ключ був успішно створений",
            "zh": "已成功创建API密钥"
        },
        "apikeyDeleted": {
            "en": "API key was successfully deleted",
            "fr": "La clé API a été supprimée avec succès",
            "it": "La chiave API è stata eliminata correttamente",
            "ja": "APIキーが削除されました",
            "ru": "API ключ был успешно удален",
            "tr": "API anahtarı başarıyla silindi",
            "uk": "API ключ був успішно видалений",
            "zh": "已成功删除API密钥"
        },
        "buyChangeRateWarning": {
            "en": "You are going to change the price of your BUY order from {rateFrom} to {rate} which is {diff}% worse than before. Do you really want to do this?",
            "fr": "Vous allez changer le prix de votre commande ACHAT de {rateFrom} à {rate}, ce qui est {diff}% pire qu'avant. Voulez-vous vraiment faire ça?",
            "it": "Stai per cambiare il prezzo del tuo ordine ACQUISTA da {rateFrom} a {rate}, che è {diff}% peggiore di prima. Vuoi davvero farlo?",
            "ja": "買い注文の価格を{rateFrom}から{rate}に変更します。これは以前よりも{diff}％悪化しています。 本当にこれを実行しますか？",
            "ru": "Вы изменяете цену ордера покупки с {rateFrom} на {rate}, что на {diff}% хуже предыдущей. Вы уверены, что хотите изменить цену ордера на {rate}?",
            "tr": "ALIŞ komutunuzun fiyatını {rateFrom} yerine, öncekinden % {diff} daha kötü olan {rate} olarak değiştireceksiniz. Bunu gerçekten yapmak istiyor musunuz?",
            "uk": "Ви змінюєте ціну ордера покупки з {rateFrom} на {rate}, що на {diff}% гірша за попередню. Ви впевнені, що хочете змінити ціну ордера?",
            "zh": "你要把你的定购单的价格从{rateFrom}改为{rate}，比以前差了 {diff}%。你真的想这么做吗？"
        },
        "buyPriceWarning": {
            "en": "The price in your order seems to be too high, the current market price is {market} and the difference is >{diff}%. Do you really want to place a BUY order with the price {price} ?",
            "fr": "Le prix de votre commande semble trop élevé, le prix actuel du marché est {market} et la différence est> {diff}%. Voulez-vous vraiment passer une commande d'achat avec le prix {price}?",
            "it": "Il prezzo nel tuo ordine sembra essere troppo alto, il prezzo di mercato corrente è {market} e la differenza è> {diff}%. Vuoi davvero effettuare un ordine ACQUISTA con il prezzo {price}?",
            "ja": "注文の価格が高すぎるようです。現在の市場価格は{market}で、差は>{diff}％です。本当に{price}で買い注文を実行しますか？",
            "ko": "주문 가격이 너무 높습니다. 현재 시장가는 {market}입니다. 정말로 {price} (>{diff}%) 가격으로 매수 주문을 거시겠습니까?",
            "ru": "Цена в вашем ордере слишком высокая, разница >{diff}% относительно текущей цены на продажу {market}. Вы правда хотите выставить ордер на ПОКУПКУ с ценой {price} (>{diff}%)",
            "tr": "Komutunuzdaki fiyat çok yüksek görünüyor, mevcut piyasa fiyatı {market} ve fark> % {diff}'dir.  Gerçekten {price} fiyatıyla bir ALIŞ komutu vermek istiyor musunuz ?",
            "uk": "Ціна в вашому ордері занадто висока, різниця >{diff}% щодо поточної ціни на продаж {market}. Ви правда хочете виставити ордер на КУПІВЛЮ з ціною {price}?",
            "zh": "你方订单的价格似乎太高，目前的市场价格是{market}，差额是{diff}%。你真的想以{price}的价格下单吗？"
        },
        "colorsRestore": {
            "en": "Colors were restored to default",
            "fr": "Les couleurs ont été restaurées par défaut",
            "it": "I colori sono stati ripristinati ai valori predefiniti",
            "ja": "色がデフォルトに復元されました。",
            "ru": "Восстановлены цвета по умолчанию",
            "tr": "Renkler varsayılana geri yüklendi",
            "uk": "Відновлено кольори за замовчуванням",
            "zh": "颜色恢复为默认值"
        },
        "colorsSave": {
            "en": "Colors saved",
            "fr": "Couleurs enregistrées",
            "it": "Colori salvati",
            "ja": "色が保存されました。",
            "ru": "Цвета сохранены",
            "tr": "Renkler kaydedildi",
            "uk": "Кольори збережені",
            "zh": "保存的颜色"
        },
        "incomeTransaction_done": {
            "en": "Incoming transaction received<br>Txh:{txh}<br>Status:[transactions.status.{state}]<br>+{amount} {symbol}",
            "fr": "Transaction entrante reçue <br> Txh: {txh} <br> Statut:[transactions.status.{state}]<br>+{amount} {symbol}",
            "it": "Transazione in entrata ricevuta <br> Txh: {txh} <br> Stato:[transactions.status.{state}]<br>+{amount} {symbol}",
            "ja": "トランザクション受信<br>Txh:{txh}<br>ステータス：[transactions.status.{state}]<br>+{amount} {symbol}",
            "ko": "수신중인 트랜잭션 <br>Txh: {txh}<br> 상태:[transactions.status.{state}]<br>+{amount} {symbol}",
            "ru": "Входящая транзакция<br>Txh:{txh}<br>Статус:[transactions.status.{state}]<br>+{amount} {symbol}",
            "tr": "Gelen işlem alındı<br>Txh:{txh}<br>Durum:[transactions.status.{state}]<br>+{amount} {symbol}",
            "uk": "Вхідна транзакція<br>Txh: {txh}<br>Статус:[transactions.status.{state}]<br>+{amount} {symbol}",
            "zh": "接收到的传入事务d<br>Txh:{txh}<br>状态：[transactions.status.{state}]<br>+{amount} {symbol}"
        },
        "incomeTransaction_wait": {
            "en": "New incoming transaction<br>Status: [transactions.status.{state}]<br>Txh:{txh}<br>+{amount} {symbol}",
            "fr": "Nouvelle transaction entrante <br> Statut: [transactions.status.{state}]<br> Txh: {txh}<br>+{amount} {symbol}",
            "it": "Nuova transazione in entrata <br> Stato: [transactions.status.{state}]<br> Txh: {txh}<br>+{amount} {symbol}",
            "ja": "トランザクション受信<br>ステータス：[transactions.status.{state}]<br>Txh:{txh}<br>+{amount}{symbol}",
            "ko": "수신중인 트랜잭션 <br> 상태: [transactions.status.{state}]<br>Txh: {txh}<br>+{amount}{symbol}",
            "ru": "Входящая транзакция<br>Статус: [transactions.status.{state}]<br>Txh:{txh}<br>+{amount} {symbol}",
            "tr": "Yeni gelen işlem<br>Durum: [transactions.status.{state}]<br>Txh:{txh}<br>+{amount} {symbol}",
            "uk": "Вхідна транзакція<br>Статус: [transactions.status.{state}]<br>Txh: {txh}<br>+{amount} {symbol}",
            "zh": "新收入交易<br>状态: [transactions.status.{state}]<br>Txh:{txh}<br>+{amount}{symbol}"
        },
        "loginSuccess": {
            "en": "You have logged in successfully",
            "fr": "Vous vous êtes connecté avec succès",
            "it": "Hai effettuato l'accesso correttamente",
            "ja": "ログインに成功しました。",
            "ru": "Вы успешно авторизованы",
            "tr": "Başarıyla giriş yaptınız",
            "uk": "Ви успішно авторизовані",
            "zh": "您已成功登录"
        },
        "looutSuccess": {
            "en": "You have logged out successfully",
            "fr": "Vous vous êtes déconnecté avec succès",
            "it": "Ti sei disconnesso correttamente",
            "ja": "ログアウトに成功しました。",
            "ru": "Вы успешно вышли из аккаунта",
            "tr": "Başarıyla çıkış yaptınız",
            "uk": "Ви успішно вийшли зі свого аккаунта",
            "zh": "您已成功注销"
        },
        "looutSuccessAll": {
            "en": "You have logged out successfully from all devices",
            "fr": "Vous vous êtes déconnecté avec succès de tous les appareils",
            "it": "Ti sei disconnesso correttamente da tutti i dispositivi",
            "ja": "全てのデバイスからログアウトしました。",
            "ru": "Вы успешно вышли из всех устройств",
            "tr": "Tüm cihazlardan başarıyla çıkış yaptınız",
            "uk": "Ви успішно вийшли з усіх пристроїв",
            "zh": "您已从所有设备成功退出登录"
        },
        "massCancelType": {
            "all": {
                "en": "ALL",
                "fr": "TOUS",
                "it": "TUTTO",
                "ja": "全て",
                "ko": "모두",
                "ru": "все",
                "tr": "TÜMÜ",
                "uk": "ВСІ",
                "zh": "全部"
            },
            "pair": {
                "en": "{pair}",
                "fr": "{pair}",
                "it": "{pair}",
                "ja": "{pair}",
                "ko": "{pair}",
                "ru": "{pair}",
                "tr": "{pair}",
                "uk": "{pair}",
                "zh": "{pair}"
            },
            "sym": {
                "en": "{sym}",
                "fr": "{sym}",
                "it": "{sym}",
                "ja": "{sym}",
                "ko": "{sym}",
                "ru": "{sym}",
                "tr": "{sym}",
                "uk": "{sym}",
                "zh": "{sym}"
            }
        },
        "masterkeySet": {
            "en": "Master Key has been set.",
            "fr": "La clé principale a été définie.",
            "it": "La chiave principale è stata impostata.",
            "ja": "マスターキーが設定されました。",
            "ru": "Мастер-ключ активирован.",
            "tr": "Ana Anahtar ayarlandı.",
            "uk": "Майстер-ключ активований.",
            "zh": "主密钥已设置。"
        },
        "okTrue": {
            "en": "Request received by the system.",
            "fr": "Demande reçue par le système.",
            "it": "Richiesta ricevuta dal sistema.",
            "ja": "システムがリクエストを受信しました。",
            "ru": "Запрос получен системой.",
            "tr": "Sistem tarafından istek alındı.",
            "uk": "Запит отримано системою.",
            "zh": "系统接收到的请求。"
        },
        "orderCancel": {
            "en": "Canceled {bs}{vol} {sym} order",
            "fr": "Commande {bs}{vol} {sym} annulée",
            "it": "Ordine {bs} {vol} {sym} annullato",
            "ja": "{bs}{vol} {sym}の注文をキャンセルしました。",
            "ko": "{bs} {vol} {sym}의 주문이 취소되었습니다",
            "ru": "Отменен ордер на {bs} {vol} {sym}",
            "tr": "{bs}{vol} {sym} komutu iptal edildi",
            "uk": "Відмінений ордер на {bs} {vol} {sym}",
            "zh": "取消{bs}{vol}{sym}顺序"
        },
        "orderChange": {
            "en": "Changed order parameters: {params}",
            "fr": "Paramètres d'ordre modifiés: {params}",
            "it": "Parametri ordine modificati: {params}",
            "ja": "注文のパラメーター：{params}を変更しました。",
            "ru": "Изменены параметры ордера: {params}",
            "tr": "Değiştirilen komut parametreleri: {params}",
            "uk": "Змінені параметри ордера: {params}",
            "zh": "变更订单参数： {params}"
        },
        "orderFilled": {
            "en": "Order {oid} for [bs.order.{bs}] {vol} {sym1} has been fulfilled.",
            "fr": "La commande {oid} a été exécutée.",
            "it": "L'ordine {oid} è stato adempiuto.",
            "ja": "注文{oid}は既に確定しています。",
            "ru": "Ордер {oid} [bs.order.{bs}] {vol} {sym1} исполнен.",
            "tr": "{oid} komutu gerçekleştirilmiştir.",
            "uk": "Ордер {oid} виконаний.",
            "zh": "订单{oid}已完成。"
        },
        "params": {
        },
        "partialFill": {
            "en": "{pair} order {oid} [bs.order.{bs}] {vol} {sym1} has been partially filled for {ev_sym1} {sym1} at a price of {rate} {sym2}. The order is already filled for {filled_vol} {sym1}.",
            "de": "{pair}-Order {oid} [bs.order.{bs}] {vol} {sym1} wurde für einen Betrag von {ev_sym1} {sym1} zum Preis von {rate} {sym2} teilweise ausgeführt. Der Auftrag ist bereits ausgeführt für {filled_vol} {sym1}.",
            "fr": "{pair} l'ordre {oid} [bs.order.{bs}] {vol} {sym1} a été partiellement exécuté pour un montant de {ev_sym1} {sym1} au prix de {rate} {sym2}. L'ordre est déjà exécuté pour {filled_vol} {sym1}.",
            "it": "{pair} order {oid} [bs.order.{bs}] {vol} {sym1} è stato parzialmente eseguito per un importo di {ev_sym1} {sym1} al prezzo di {rate} {sym2}. L'ordine è già stato eseguito per {fill_vol} {sym1}.",
            "ja": "注文{oid}は一部が確定しています。{pair} order {oid} [bs.order。{bs}] {vol} {sym1}は、{rate} {sym2}の価格で{ev_sym1} {sym1}の金額で部分的に実行されました。注文はすでに{filled_vol} {sym1}に対して実行されています",
            "ru": "{pair} ордер {oid} [bs.order.{bs}] {vol} {sym1} частично исполненен на {ev_sym1} {sym1} по цене {rate} {sym2}. Уже исполнено {filled_vol} {sym1}.",
            "tr": "{oid} komutu kısmen gerçekleştirilmiştir. {pair} emri {oid} [bs.order.{bs}] {vol} {sym1}, {rate} {sym2} fiyatında {ev_sym1} {sym1} miktarı için kısmen yerine getirildi. {filled_vol} {sym1} için sipariş zaten yürütüldü.",
            "uk": "Часткове виконання в ордері {oid}. {pair} ордер {oid} [bs.order. {bs}] {vol} {sym1} частково виконано на суму {ev_sym1} {sym1} за ціною {rate} {sym2}. Вже виконано для {fill_vol} {sym1}.",
            "zh": "{pair} 订单 {oid} [bs.order.{bs}] {vol} {sym1} 已部分执行，金额为 {ev_sym1} {sym1}，价格为 {rate} {sym2}。订单已为 {fill_vol} {sym1} 执行"
        },
        "passwordChanged": {
            "en": "Password was successfully changed!",
            "fr": "Le mot de passe a été changé avec succès!",
            "it": "La password è stata cambiata con successo!",
            "ja": "パスワードを変更しました！",
            "ru": "Ваш пароль успешно изменен!",
            "tr": "Parola başarıyla değiştirildi!",
            "uk": "Ваш пароль успішно змінено!",
            "zh": "密码更改成功！"
        },
        "pmaClearing": {
            "en": "PMA clearing was successful",
            "fr": "La compensation PMA a réussi",
            "it": "La liquidazione del PMA è stata effettuata con successo",
            "ja": "PMAの決済が完了しました。",
            "ru": "Запрос на клиринг успешно выполнен",
            "tr": "PMA mahsubu başarılı oldu",
            "uk": "Запит на кліринг успішно виконаний",
            "zh": "PMA清算成功"
        },
        "pmaClose": {
            "en": "PMA closing request has been sent",
            "fr": "La demande de clôture PMA a été envoyée",
            "it": "La richiesta di chiusura PMA è stata inviata",
            "ja": "PMAの締め切りリクエストが送信されました。",
            "ru": "Запрос на закрытие PMA отправлен",
            "tr": "PMA kapatma isteği gönderildi",
            "uk": "Запит на закриття PMA відправлений",
            "zh": "已发送PMA关闭请求"
        },
        "pmaCloseCancel": {
            "en": "PMA closing request was cancelled",
            "fr": "La demande de fermeture de PMA a été annulée",
            "it": "La richiesta di chiusura PMA è stata annullata",
            "ja": "PMAの締め切りリクエストがキャンセルされました。",
            "ru": "Запрос на закрытие PMA успешно отменен",
            "tr": "PMA kapatma isteği iptal edildi",
            "uk": "Запит на закриття PMA успішно відмінений",
            "zh": "PMA关闭请求已取消"
        },
        "pmaDepositClosed": {
            "en": "Deposit {deposit_id} withdrawal request for {vol} {basesym} has been sent",
            "fr": "Le dépôt {deposit_id} demande de retrait pour {vol} {basesym} a été envoyé",
            "it": "È stata inviata la richiesta di prelievo del deposito {deposit_id} per {vol} {basesym}",
            "ja": "入金{deposit_id}の{vol} {basesym}引き出しリクエストが送信されました。",
            "ru": "Запрос на закрытие депозита {deposit_id} на сумму {vol} {basesym} отправлен",
            "tr": "{vol} {basesym} için mevduat {deposit_id} para çekme talebi gönderildi",
            "uk": "Запит на закриття депозиту {deposit_id} на суму {vol} {basesym} відправлений",
            "zh": "已发送{vol} {basesym}的存款{deposit_id}取款请求"
        },
        "pmaDepositOpened": {
            "en": "Opened deposit {deposit_id} for {vol} {basesym}",
            "fr": "Dépôt ouvert {deposit_id} pour {vol} {basesym}",
            "it": "Deposito aperto {deposit_id} per {vol} {basesym}",
            "ja": "未決済の入金{deposit_id}--{vol} {basesym}",
            "ru": "Открыт депозит {deposit_id} на сумму {vol} {basesym}",
            "tr": "{vol} {basesym} için açılan mevduat {deposit_id}",
            "uk": "Відкрито депозит {deposit_id} на суму {vol} {basesym}",
            "zh": "为{vol} {basesym}打开的存款{deposit_id}"
        },
        "pmaLogin": {
            "en": "You have successfully logged in at PMA {pmaid}",
            "fr": "Vous vous êtes connecté avec succès à PMA {pmaid}",
            "it": "Hai effettuato correttamente l'accesso a PMA {pmaid}",
            "ja": "PMA {pmaid}でログインしました。",
            "ru": "Вы успешно авторизованы в PMAе {pmaid}",
            "tr": "PMA {pmaid} adresinde başarıyla giriş yaptınız",
            "uk": "Ви успішно авторизовані в PMA {pmaid}",
            "zh": "您已成功登录PMA{pmaid}"
        },
        "pmaLogout": {
            "en": "You have successfully returned to the main account",
            "fr": "Vous êtes revenu avec succès sur le compte principal",
            "it": "Sei tornato correttamente all'account principale",
            "ja": "メインアカウントへ戻りました。",
            "ru": "Вы вернулись в главный аккаунт",
            "tr": "Ana hesaba başarıyla döndünüz",
            "uk": "Ви повернулися в головний акаунт",
            "zh": "您已成功返回主帐户"
        },
        "pmaSuccessOpened": {
            "en": "You have successfully opened PMA",
            "fr": "Vous avez ouvert avec succès un PMA",
            "it": "PMA è stato aperto correttamente",
            "ja": "PMAの開設に成功しました。",
            "ru": "Вы успешно создали PMA",
            "tr": "PMA'yı başarıyla açtınız",
            "uk": "Ви успішно створили PMA",
            "zh": "您已成功打开PMA"
        },
        "sellChangeRateWarning": {
            "en": "You are going to change the price of your SELL order from {rateFrom} to {rate} which is {diff}% worse than before. Do you really want to do this?",
            "fr": "Vous allez changer le prix de votre commande SELL de {rateFrom} à {rate}, ce qui est {diff}% pire qu'avant. Voulez-vous vraiment faire ça?",
            "it": "Stai per cambiare il prezzo del tuo ordine SELL da {rateFrom} a {rate}, che è {diff}% peggiore di prima. Vuoi davvero farlo?",
            "ja": "売り注文の価格を{rateFrom}から{rate}に変更します。これは以前よりも{diff}％悪くなります。本当にこれを実行しますか？",
            "ru": "Вы изменяете цену ордера продажи с {rateFrom} на {rate}, что  на {diff}% хуже предыдущей. Вы уверены, что хотите изменить цену ордера на {rate}?",
            "tr": "SATIŞ komutunuzun fiyatını {rateFrom} yerine, öncekinden % {diff} daha kötü olan {rate} olarak değiştireceksiniz. Bunu gerçekten yapmak istiyor musunuz?",
            "uk": "Ви змінюєте ціну ордера продажу з {rateFrom} на {rate}, що на {diff}% гірша за попередню. Ви впевнені, що хочете змінити ціну ордера?",
            "zh": "你要把你的销售订单的价格从{rateFrom}改为{rate}，比以前差了{diff}%。你真的想这么做吗？"
        },
        "sellPriceWarning": {
            "en": "The price in your order seems to be too low, the current market price is {market} and the difference is >{diff}%. Do you really want to place a SELL order with the price {price} ?",
            "fr": "Le prix de votre commande semble être trop bas, le prix actuel du marché est {market} et la différence est> {diff}%. Voulez-vous vraiment passer une commande de VENTE avec le prix {price}?",
            "it": "Il prezzo nel tuo ordine sembra essere troppo basso, il prezzo di mercato corrente è {market} e la differenza è> {diff}%. Vuoi davvero effettuare un ordine VENDITA con il prezzo {price}?",
            "ja": "注文の価格が低すぎるようです。現在の市場価格は{market}で、差は>{diff}％です。本当に{price}で売り注文を出しますか？",
            "ko": "주문 가격이 너무 낮습니다. 현재 시장가는 {market}입니다. 정말로 {price} (>{diff}%) 가격으로 매도 주문을 거시겠습니까?",
            "ru": "Цена в вашем ордере слишком низкая, разница >{diff}% относительно текущей цены на продажу {market}. Вы правда хотите выставить ордер на ПРОДАЖУ с ценой {price} (>{diff}%)",
            "tr": "Komutunuzdaki fiyat çok düşük görünüyor, mevcut piyasa fiyatı {market} ve fark> % {diff}'dir.  Gerçekten {price} fiyatıyla bir SATIŞ komutu vermek istiyor musunuz ?",
            "uk": "Ціна в вашому ордері занадто низька, різниця >{diff}% щодо поточної ціни на продаж {market}. Ви правда хочете виставити ордер на ПРОДАЖ з ціною {price}?",
            "zh": "你方订单的价格似乎太低，目前的市场价格是{market}，差额是{diff}%。你真的想以{price}的价格下单吗？"
        },
        "settingsDefault": {
            "en": "Default settings were restored.",
            "fr": "Les paramètres par défaut ont été restaurés.",
            "it": "Le impostazioni predefinite sono state ripristinate.",
            "ja": "デフォルト設定が復元されました。",
            "ru": "Возвращены настройки по умолчанию.",
            "tr": "Varsayılan ayarlar geri yüklendi.",
            "uk": "Повернуто налаштування за замовчуванням.",
            "zh": "已还原默认设置。"
        },
        "settingsSaved": {
            "en": "Changes have been saved.",
            "fr": "Les modifications ont été enregistrées.",
            "it": "I cambiamenti sono stati salvati.",
            "ja": "変更が保存されました。",
            "ko": "변경 사항이 저장되었습니다.",
            "ru": "Изменения сохранены.",
            "tr": "Değişiklikler kaydedildi.",
            "uk": "Зміни збережені.",
            "zh": "已保存更改。"
        },
        "twofactorDisabled": {
            "en": "2FA OTP has been disabled on this account",
            "fr": "2FA OTP a été désactivé sur ce compte",
            "it": "2FA OTP è stato disabilitato su questo account",
            "ja": "このアカウントで2FA OTPが無効になっています。",
            "ru": "2FA деактивирована(!)",
            "tr": "2FA OTP bu hesapta devre dışı bırakıldı",
            "uk": "2FA деактивована(!)",
            "zh": "2FA OTP已对此帐户禁用"
        },
        "twofactorEnabled": {
            "en": "New 2FA KEY has been successfully enabled!",
            "fr": "La nouvelle clé 2FA a été activée avec succès!",
            "it": "La nuova chiave 2FA è stata abilitata correttamente!",
            "ja": "新しい2FAキーが有効になりました！",
            "ru": "Новый ключ Двухфакторной Авторизации активирован успешно!",
            "tr": "Yeni 2FA ANAHTARI başarıyla etkinleştirildi!",
            "uk": "Новий ключ Двухфакторної Авторизації активований успішно!",
            "zh": "已成功启用新的2FA密钥！"
        },
        "withdrawCancel": {
            "en": "Withdrawal order {oid} has been cancelled",
            "fr": "L'ordre de retrait {oid} a été annulé",
            "it": "L'ordine di prelievo {oid} è stato annullato",
            "ja": "出金の注文{oid}がキャンセルされました。",
            "ru": "Транзакция {oid} на вывод токенов успешно отменена",
            "tr": "{oid} para çekme komutu iptal edildi",
            "uk": "Транзакція {oid} на виведення токенів успішно відмінена",
            "zh": "取款单{oid}已取消"
        },
        "withdrawTransaction_confirmed": {
            "en": "New withdrawal transaction<br>Status:[transactions.status.{state}]<br>Address: {to_addr}<br>-{amount} {symbol}",
            "fr": "Nouvelle transaction de retrait <br> Statut: [transactions.status.{state}] <br> Adresse: {to_addr}<br>-{amount} {symbol}",
            "it": "Nuova transazione di prelievo <br> Stato: [transactions.status.{state}] <br> Indirizzo: {to_addr}<br>-{amount} {symbol}",
            "ja": "新しい出金取引<br>ステータス：[transactions.status.{state}]<br>住所：{to_addr}<br>-{amount} {symbol}",
            "ko": "거래 철회 상태 :[transactions.status.{state}] <br>주소: {to_addr}<br>-{amount} {symbol}",
            "ru": "Исходящая транзакция<br>Статус:[transactions.status.{state}]<br>Адрес: {to_addr}<br>-{amount} {symbol}",
            "tr": "Yeni para çekme işlemi<br>Durum:[transactions.status.{state}]<br>Adres: {to_addr}<br>-{amount} {symbol}",
            "uk": "Вихідна транзакція<br>Статус: [transactions.status.{state}]<br>Адреса: {to_addr}<br>-{amount} {symbol}",
            "zh": "新提款交易<br>状态:[transactions.status.{state}]<br>地址: {to_addr}<br>-{amount} {symbol}"
        },
        "withdrawTransaction_done": {
            "en": "Withdrawal transaction<br>Txh: {out_txh}<br>Status:[transactions.status.{state}]<br>-{amount} {symbol}",
            "fr": "Opération de retrait <br> Txh: {out_txh} <br> Statut: [transactions.status.{state}]<br>-{amount} {symbol}",
            "it": "Transazione di prelievo <br> Txh: {out_txh} <br> Stato: [transactions.status.{state}]<br>-{amount} {symbol}",
            "ja": "出金トランザクション<br>Txh：{out_txh}<br>ステータス：[transactions.status.{state}]<br>-{amount} {symbol}",
            "ko": "거래 철회 <br>Txh: {out_txh}<br>상태 :[transactions.status.{state}]<br>-{amount} {symbol}",
            "ru": "Исходящая транзакция<br>Txh: {out_txh}<br>Статус:[transactions.status.{state}]<br>-{amount} {symbol}",
            "tr": "Para çekme işlemi<br>Txh: {out_txh}<br>Durum:[transactions.status.{state}]<br>-{amount} {symbol}",
            "uk": "Вихідна транзакція<br>Txh: {out_txh}<br>Статус: [transactions.status.{state}]<br>-{amount} {symbol}",
            "zh": "提款交易<br>Txh: {out_txh}<br>状态:[transactions.status.{state}]<br>-{amount} {symbol}"
        }
    },
    "orderbook": {
        "orderReverse_title": {
            "en": "Order placed in reverse pair",
            "fr": "Commande passée en paire inversée",
            "it": "Ordine effettuato in coppia inversa",
            "ja": "反対のペアで注文を実施",
            "ko": "역 쌍으로 배치 된 주문",
            "ru": "Ордер находится в обратной паре",
            "tr": "Ters çift komutu yerleştirildi",
            "uk": "Ордер знаходиться в зворотній парі",
            "zh": "反向订购"
        },
        "orderbookMode_title": {
            "avPrice": {
                "en": "Average price",
                "fr": "Prix moyen",
                "it": "Prezzo medio",
                "ja": "平均価格",
                "ru": "Средняя цена",
                "tr": "Ortalama fiyat",
                "uk": "Середня ціна",
                "zh": "平均价格"
            },
            "sym1vol": {
                "en": "Total {sym1}",
                "fr": "Total {sym1}",
                "it": "Totale {sym1}",
                "ja": "合計 {sym1}",
                "ko": "총합 {sym1}",
                "ru": "Всего {sym1}",
                "tr": "Toplam {sym1}",
                "uk": "Всього {sym1}",
                "zh": "总计 {sym1}"
            },
            "sym2": {
                "en": "Amount {sym2}",
                "fr": "Montant {sym2}",
                "it": "Quantità {sym2}",
                "ja": "数量 {sym2}",
                "ko": "볼륨 {sym2}",
                "ru": "Кол-во {sym2}",
                "tr": "Tutar {sym2}",
                "uk": "Кількість {sym2}",
                "zh": "数量 {sym2}"
            },
            "sym2sum": {
                "en": "Total {sym2}",
                "fr": "Total {sym2}",
                "it": "Totale {sym2}",
                "ja": "合計 {sym2}",
                "ko": "총합 {sym2}",
                "ru": "Всего {sym2}",
                "tr": "Toplam {sym2}",
                "uk": "Всього {sym2}",
                "zh": "总计 {sym2}"
            },
            "userOrders": {
                "en": "My volume",
                "fr": "Mon  volume",
                "it": "Il mio volume",
                "ja": "自分の数量",
                "ru": "Моё кол-во",
                "tr": " İşlem hacmim",
                "uk": "Моя к-сть",
                "zh": "我的容量"
            }
        }
    },
    "orderlist": {},
    "pairSelect": {
        "_header": {
            "en": "Select pair",
            "fr": "Sélectionnez une paire",
            "it": "Seleziona coppia",
            "ja": "ペアを選択",
            "ko": "쌍 선택",
            "ru": "Выбор пары",
            "tr": "Çift seçin",
            "uk": "Вибір пари",
            "zh": "选择对"
        }
    },
    "pma": {
	    "basesymPCT": {
	        "en" : "Base currency current share",
	        "ru" : "Текущая доля активов в базовой валюте"
        },
	    "overload_description": {
	        "en" : "This PMA is currently overloaded with the deposits and therefor the Manager's share is less than required. New deposits are unavailable until Manager will increase his share or some subscriber's deposits will be closed.",
	        "ru" : "Этот PMA переполнен депозитами и в результате Доля Средств Менеджера упала ниже требуемого значения. Новые депозиты в этот PMA не принимаются пока Менеджер не увеличит свою долю или пока часть депозитов не будет закрыта подписчиками."
        },
        "accountName_TH": {
            "en": "Name",
            "fr": "Nom",
            "it": "Nome",
            "ja": "名前",
            "ko": "이름",
            "ru": "Имя",
            "tr": "İsim",
            "uk": "Ім'я",
            "zh": "姓名"
        },
        "accountName_description": {
            "en": "Account name is visible in the PMA ranking list, on the PMA's page and in the trading terminal.",
            "fr": "Le nom du compte est visible dans la liste de classement PMA, sur la page PMA et dans le terminal de trading.",
            "it": "Il nome dell'account è visibile nella classifica PMA, nella pagina PMA e nel terminale di trading.",
            "ja": "アカウント名は、PMAランキングリスト、PMAのページ、および取引端末に表示されます。",
            "ko": "계정 이름은 PMA 순위 리스트, PMS 페이지 그리고 트레이딩 터미널에서 볼 수 있습니다.",
            "ru": "Имя аккаунта отображается для пользователей при поиске и на странице статистика PMA.",
            "tr": "Hesap adı PMA sıralama listesinde, PMA sayfasında ve alım satım terminalinde görülebilir.",
            "uk": "Ім'я аккаунта відображається для користувачів при пошуку і на домашній сторінці аккаунта (для PMA), а також в торговому терміналі.",
            "zh": "账户名称在PMA排名表、PMA页面和交易终端中可见。"
        },
        "accountName_label": {
            "en": "Public Name",
            "fr": "Nom public",
            "it": "Nome pubblico",
            "ja": "公開する名前",
            "ko": "공개된 이름",
            "ru": "Видимое Имя",
            "tr": "Genel Ad",
            "uk": "Видиме Ім'я",
            "zh": "公共名称"
        },
        "age_title": {
            "en": "Age in days from the first trade",
            "fr": "Âge en jours à partir du premier échange",
            "it": "Età in giorni dal primo scambio",
            "ja": "最初の取引からの経過日数",
            "ko": "기간은 첫 거래가 시작된 시점에서부터의 현재까지의 일수입니다.",
            "ru": "Возраст в днях с момента первой сделки",
            "tr": "İlk alım satım işleminden itibaren gün cinsinden yaş",
            "uk": "Вік у днях з моменту першої операції",
            "zh": "从第一次交易开始的天数"
        },
        "allowStoploss": {
            "en": "Stoploss restrictions",
            "fr": "Restrictions Stoploss",
            "it": "Restrizioni Stoploss",
            "ja": "ストップロスの制限",
            "ru": "Разрешена продажа с убытком",
            "tr": "Stoploss (zararı durdurma satışı) kısıtlamaları",
            "uk": "Дозволений продаж зі збитками",
            "zh": "止损限制"
        },
        "allowStoploss_TH": {
            "en": "SL",
            "fr": "SL",
            "it": "SL",
            "ja": "SL",
            "ko": "SL",
            "ru": "SL",
            "tr": "SL",
            "uk": "SL",
            "zh": "SL"
        },
        "allowStoploss_description": {
            "en": "If cross-trading is disabled, the manager can restrict himself from selling assets with the loss. In this way users can be sure that the manager is unable to wipe out the equity in a series of loosing trades. This option should not be activated if your strategy requires stoploss or trailing stop.",
            "fr": "Si le cross-trading est désactivé, le gestionnaire peut se limiter à vendre des actifs avec la perte. De cette façon, les utilisateurs peuvent être sûrs que le gestionnaire n'est pas en mesure d'effacer les capitaux propres dans une série de transactions perdantes. Cette option ne doit pas être activée si votre stratégie nécessite un stoploss ou un stop suiveur.",
            "it": "Se il cross-trading è disabilitato, il gestore può limitarsi a vendere attività con la perdita. In questo modo gli utenti possono essere certi che il gestore non è in grado di spazzare via l'equità in una serie di operazioni in perdita. Questa opzione non dovrebbe essere attivata se la tua strategia richiede stoploss o trailing stop.",
            "ja": "クロストレーディングを無効にすると、管理者による損失を伴う資産の販売が制限されます。このようにして、ユーザーは、マネジャーによる一連の負け取引での株式一掃を避けることができます。取引戦略にストップロスまたはトレーリングストップが必要な場合には、このオプションを有効にしないでください。",
            "ko": "자전거래(cross-trading)가 비활성화되면 매니저가 손실이 발생한 자산의 판매를 할 수 없도록 제한 할 수 있습니다. 이러한 방법으로 유저는 매니저가 일련의 손실 거래로 자산을 탕진할 수 없도록 하는 것에 확신 할 수 있습니다. 이 옵션은 당신의 전략이 스탑로스나 트레일링 스탑을 필요로 할 때는 활성화해서는 안 된다.",
            "ru": "Если торговля ведется только в парах с базовой валютой, управляющий может запретить на PMA продажу активов с убытком, это защищает вкладчиков от возможной потери активов в серии убыточных сделок. Эту опцию не надо активировать, если ваша торговая стратегия требует применения стоплоссов.",
            "tr": "Çapraz alım satım işlemi devre dışı bırakılırsa, yönetici zararına varlıkları satma konusunda kendini kısıtlayabilir. Bu şekilde, kullanıcılar, yöneticinin bir dizi kaybedilen alım satımdaki özkaynağı silemediğinden emin olabilirler. Stratejiniz stoploss (zararı durdurma satışı) veya trailing stop (takip eden zararı durdur emri) gerektiriyorsa, bu seçenek etkinleştirilmemelidir.",
            "uk": "Якщо торгівля ведеться тільки в парах з базовою валютою, керуючий може заборонити на PMA продаж активів зі збитками, це захищає вкладників від можливої втрати активів в серії збиткових угод. Цю опцію не треба активовувати, якщо ваша торгова стратегія вимагає застосування стоплоссів.",
            "zh": "如果交叉交易被禁用，经理可以限制自己出售有损失的资产。通过这种方式，用户可以确信经理无法在一系列的亏损交易中抹去股本。如果您的策略需要止损或尾随止损，则不应激活此选项。"
        },
        "allowStoploss_option": {
            "0": {
                "en": "Deny selling coins with loss",
                "fr": "Refuser de vendre des pièces avec perte",
                "it": "Nega la vendita di monete con perdita",
                "ja": "損失を伴うコインの販売を拒否",
                "ko": "손실이 발생한 코인을 팔지 못하도록 한다.",
                "ru": "Продажа с убытком запрещена",
                "tr": "Zararına coin satışını reddet",
                "uk": "Продаж зі збитками заборонений",
                "zh": "否认亏本卖硬币"
            },
            "1": {
                "en": "Allow selling coins with loss",
                "fr": "Autoriser la vente de pièces avec perte",
                "it": "Consentire la vendita di monete con perdita",
                "ja": "損失を伴うコインの販売を許可",
                "ko": "손실이 발생한 코인을 팔도록 허용한다.",
                "ru": "Продажа с убытком разрешена",
                "tr": "Zararına coin satışına izin ver",
                "uk": "Продаж зі збитками дозволений",
                "zh": "允许亏本出售硬币"
            }
        },
	    "sym2": {
	        "en" : "Second currency in the Basket PMA",
			"de": "Zweite Währung im Basket PMA",
			"fr": "Deuxième devise du Panier PMA",
			"it": "Seconda valuta nel Basket PMA",
			"ja": "バスケットPMAの2番目の通貨",
			"ko": "바구니 PMA의 두 번째 통화",
			"ru": "Вторая валюта в двухвалютном ПМА",
			"tr": "Sepet PMA'daki ikinci jeton",
			"uk": "Друга монета у кошику PMA",
			"zh": "篮子 PMA 中的第二种货币"
        },
	    "sym2_description": {
	        "en" : "The Basket PMA is a special type of PMA with only two tokens available with an advanced metrics adapted for dual currency accounts. The deposits to Basket PMA must be made in both tokens and not in the base token as for regular PMA.",
            "de": "Die Basket PMA ist eine spezielle Art von PMA mit nur zwei verfügbaren Token mit erweiterten Metriken, die für Doppelwährungskonten angepasst sind. Die Einzahlungen in den Basket PMA müssen in beiden Token erfolgen und nicht wie bei einem regulären PMA im Basis-Token.",
            "fr": "Le Basket PMA est un type spécial de PMA avec seulement deux jetons disponibles avec des métriques avancées adaptées aux comptes à double devise. Les dépôts au Basket PMA doivent être effectués dans les deux tokens et non dans le token de base comme pour le PMA ordinaire.",
            "it": "Il Basket PMA è un tipo speciale di PMA con solo due token disponibili con metriche avanzate adattate per conti a doppia valuta. I depositi su Basket PMA devono essere effettuati in entrambi i token e non nel token base come per il normale PMA.",
            "ja": "バスケットPMAは、デュアル通貨アカウントに適合した高度なメトリックで使用できるトークンが2つしかない特殊なタイプのPMAです。バスケットPMAへの入金は、通常のPMAのようにベーストークンではなく、両方のトークンで行う必要があります。",
            "ko": "바스켓 PMA는 이중 통화 계정에 맞게 조정된 고급 메트릭과 함께 사용할 수 있는 토큰이 두 개뿐인 특별한 유형의 PMA입니다. Basket PMA에 대한 입금은 일반 PMA와 같이 기본 토큰이 아닌 두 토큰 모두에서 이루어져야 합니다.",
            "ru": "Basket PMA - это особый тип PMA, в котором доступны только два токена с расширенными метриками, адаптированными для двухвалютных счетов. Депозиты в Basket PMA должны производиться в обоих токенах, а не в базовом токене, как в обычном PMA.",
            "tr": "Sepet PMA, çift para birimi hesapları için uyarlanmış gelişmiş metriklerle birlikte yalnızca iki jetona sahip özel bir PMA türüdür. Sepet PMA'ya yapılan para yatırma işlemleri, normal PMA'da olduğu gibi temel jetonda değil, her iki jetonda yapılmalıdır.",
            "uk": "Кошик PMA - це особливий тип PMA, у якому доступні лише два маркери з розширеними метриками, адаптованими для рахунків з двома валютами. Депозити в кошик PMA повинні бути здійснені в обох маркерах, а не в базовому токені, як для звичайного PMA.",
            "zh": "篮子 PMA 是一种特殊类型的 PMA，只有两个代币可用，具有适用于双币账户的高级指标。向 Basket PMA 存款必须以两种代币形式进行，而不是像常规 PMA 那样以基础代币形式进行。"
        },
        "basketPMA_description": {
            "en": "The Dual Currency Liquidity Pool is a basket of two tokens, always in equal proportion at the current rate of the pool. Performance indicators ([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]) are calculated based on the Basket Index, which shows the accumulated profit after the rate returns to the starting point.",
            "de": "Der Dual Currency Liquidity Pool ist ein Korb aus zwei Währungen, immer im gleichen Verhältnis zum aktuellen Kurs des Pools. Leistungsindikatoren ([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]) werden basierend auf dem Basket-Index berechnet, der den kumulierten Gewinn nach Rückkehr des Kurses zum Ausgangspunkt anzeigt.",
            "fr": "Le Pool de liquidité à double devise est un panier de deux devises, toujours en proportion égale au taux actuel du pool. Les indicateurs de performance ([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]) sont calculés sur la base de l'indice du panier, qui montre le profit accumulé après le retour du taux au point de départ.",
            "it": "Il Dual Currency Liquidity Pool è un paniere di due valute, sempre in egual proporzione al tasso corrente del pool. Gli indicatori di performance ([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]) sono calcolati in base all'Indice Basket, che mostra il profitto accumulato dopo che il tasso è tornato al punto di partenza.",
            "ja": "二重通貨流動性プールは2つの通貨のバスケットであり、プールの現在のレートで常に等しい比率です。パフォーマンス指標([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]）は、レートが開始点に戻った後の累積利益を示すバスケットインデックスに基づいて計算されます。",
            "ru": "Бивалютный Пул Ликвидности - это корзина из двух валют, всегда в равной пропорции по текущему курсу пула. Показатели доходности ([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]) рассчитываются на основе Индекса Корзины, который показывает накопленную прибыль после возврата курса в начальную точку.",
            "tr": "Çift Para Birimi Likidite Havuzu, her zaman havuzun mevcut oranıyla eşit oranda iki para biriminden oluşan bir sepettir. Performans göstergeleri ([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]), oran başlangıç   noktasına döndükten sonra birikmiş karı gösteren Sepet Endeksine göre hesaplanır.",
            "uk": "Бівалютного Пул Ліквідності - це кошик з двох валют, завжди в рівній пропорції за поточним курсом пулу. Показники прибутковості ([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]) розраховуються на основі Індексу Кошики, який показує накопичену прибуток після повернення курсу в початкову точку.",
            "zh": "双币流动性池是由两种货币组成的一篮子货币，按池中的当前汇率始终保持相等的比例。业绩指标 ([pma.ath_TH], [pma.performancePCT], [pma.ddPCT], [pma.maxDDPCT]) 是根据篮子指数计算的，显示了汇率回到起点后的累计收益。"
        },
        "ath": {
            "en": "All Time High(ATH)",
            "fr": "Tous les temps (ATH)",
            "it": "Il più alto (ATH)",
            "ja": "オールタイムハイ(ATH)",
            "ru": "Максимум за все время (ATH)",
            "tr": "En yüksek seviye(ATH)",
            "uk": "Максимум за весь час (ATH)",
            "zh": "一直很高(ATH)"
        },
        "ath_TH": {
            "en": "ATH",
            "fr": "ATH",
            "it": "ATH",
            "ja": "ATH",
            "ru": "ATH",
            "tr": "ATH",
            "uk": "ATH",
            "zh": "ATH"
        },
        "basesym": {
            "en": "Base Token",
            "fr": "Jeton de base",
            "it": "Gettone di Base",
            "ja": "ベーストークン",
            "ru": "Базовый Токен",
            "tr": "Baz Token",
            "uk": "Базовий Токен",
            "zh": "基本代币"
        },
        "basesym_TH": {
            "en": "Base",
            "fr": "Base",
            "it": "Base",
            "ja": "ベース",
            "ru": "Base",
            "tr": "Baz",
            "uk": "Base",
            "zh": "基础"
        },
        "basesym_description": {
            "en": "Base Token that will be used for the performance accounting, depositing to the PMA and profit distribution.",
            "fr": "Jeton de base qui sera utilisé pour la comptabilité de performance, le dépôt au PMA et la distribution des bénéfices.",
            "it": "Token di base che verrà utilizzato per la contabilità delle prestazioni, il deposito presso la PMA e la distribuzione degli utili.",
            "ja": "パフォーマンスアカウンティング、PMAへの入金、利益分配に使用されるベーストークンです。",
            "ru": "Базовый Токен используется для депозитов на PMA, вывода и учета прибыли.",
            "tr": "Performans hesaplaması, PMA'ya para yatırma ve kâr dağıtımı için Baz Token kullanılacaktır.",
            "uk": "Базовий Токен використовується для депозитів на PMA, виведення та обліку прибутку.",
            "zh": "用于绩效会计、存入PMA和利润分配的基本代币。"
        },
        "basesym_title": {
            "en": "Base Token of accounting and depositing",
            "fr": "Jeton de base de comptabilité et de dépôt",
            "it": "Gettone di base di contabilità e deposito",
            "ja": "会計、入金に使用されるベーストークン",
            "ru": "Базовый Токен пополнения, вывода и учета прибыли",
            "tr": "Hesaplama ve para yatırma Baz Tokeni",
            "uk": "Базовий Токен поповнення, виведення та обліку прибутку",
            "zh": "记帐存款基本代币"
        },
        "basketIndex": {
            "en": "Basket Index",
            "de": "Warenkorb-Index",
            "fr": "Indice de panier",
            "it": "Indice del carrello",
            "ja": "バスケットインデックス",
            "ko": "바스켓 인덱스",
            "ru": "Индекс корзины",
            "tr": "Sepet İndeksi",
            "uk": "Індекс кошика",
            "zh": "篮子指数"
        },
        "cdaComparison": {
            "en": "Profitability against initial deposit amounts",
            "de": "Rentabilität gegenüber anfänglichen Einzahlungsbeträgen",
            "fr": "Rentabilité par rapport aux montants des dépôts initiaux",
            "it": "Redditività rispetto agli importi del deposito iniziale",
            "ja": "初期預金額に対する収益性",
            "ko": "초기 입금액 대비 수익성",
            "ru": "Доходность от начальных сумм депозита",
            "tr": "İlk mevduat tutarlarına karşı karlılık",
            "uk": "Рентабельність проти початкових сум депозиту",
            "zh": "初始存款金额的盈利能力"
        },
        "button_dashboard": {
            "en": "Dashboard",
            "fr": "Tableau de bord",
            "it": "Dashboard",
            "ja": "ダッシュボード",
            "ru": "Посмотреть",
            "tr": "Gösterge paneli",
            "uk": "Подивитися",
            "zh": "仪表板"
        },
        "capitalization": {
            "en": "Profit capitalization",
            "fr": "Capitalisation des bénéfices",
            "it": "Capitalizzazione dei guadagni",
            "ja": "収益資本化",
            "ko": "수익 자본환원",
            "ru": "Капитализация прибыли",
            "tr": "Kâra göre kapitalizasyon",
            "uk": "Капіталізація прибутку",
            "zh": "利润资本化"
        },
        "capitalization_description": {
            "en": "If Profit Capitalization is ON, profit will be left in the PMA as a deposit instead of being distributed to your account during the clearing.",
            "fr": "Si la capitalisation des bénéfices est activée, les bénéfices seront laissés dans le PMA sous forme de dépôt au lieu d'être distribués sur votre compte lors de la compensation.",
            "it": "Se la capitalizzazione degli utili è attivata, il profitto verrà lasciato nella PMA come deposito anziché essere distribuito sul tuo conto durante la compensazione.",
            "ja": "利益の資本化がオンの場合、利益は清算時にアカウントに分配されるのではなく、入金としてPMAに残されます。",
            "ko": "수익 자본환원이 ON 되어 있다면 청산 시점에서 발생한 수익금이 당신의 계정에 바로 분배되지 않고 입출금 전까지 PMA에 투자될 것입니다.",
            "ru": "Если выбрана Капитализация Прибыли, то вместо распределения на ваш аккаунт при клиринге, прибыль будет добавляться к вашему депозиту на PMA.",
            "tr": "Kâra Göre Kapitalizasyon AÇIK ise, kâr mahsup sırasında hesabınıza dağıtılmak yerine, PMA'da bir mevduat olarak bırakılacaktır.",
            "uk": "Якщо обрана Капіталізація Прибутку, то замість розподілу на ваш аккаунт при клірингу, прибуток буде додаватися до вашого депозиту на PMA.",
            "zh": "如果启用利润资本化，则利润将作为存款留在PMA中，而不是在清算期间分配到您的帐户。"
        },
        "cda": {
            "en": "Current Deposited Amount",
            "fr": "Montant déposé actuel",
            "it": "Importo depositato corrente",
            "ja": "現在の入金額",
            "ru": "Сумма Депозитов Входящая (CDA)",
            "tr": "Mevcut Yatırılmış Tutar",
            "uk": "Сума Депозитів Вхідна (CDA)",
            "zh": "本期存款金额"
        },
        "cda_TH": {
            "en": "CDA",
            "fr": "CDA",
            "it": "CDA",
            "ja": "CDA",
            "ru": "CDA",
            "tr": "CDA",
            "uk": "CDA",
            "zh": "CDA"
        },
        "closeDDPCT": {
            "en": "Auto-close drawdown level (%)",
            "fr": "Niveau de rabattement à fermeture automatique (%)",
            "it": "Livello di prelievo con chiusura automatica (%)",
            "ja": "自動終了減少レベル（%）",
            "ru": "Автозакрытие при просадке более (%)",
            "tr": "Otomatik kapanma düşüş seviyesi (%)",
            "uk": "Автозакриття при просіданні більше (%)",
            "zh": "自动关闭下降率 (%)"
        },
        "closeDDPCT_description": {
            "en": "Account will be terminated in case Net Liquidation Value drops from confirmed ATH by more than {value}%",
            "fr": "Le compte sera fermé en cas de baisse de la valeur nette de liquidation de l'ATH confirmé de plus de {value}%",
            "it": "L'account verrà chiuso nel caso in cui il valore della liquidazione netta diminuisca dall'ATH confermato di oltre il {value}%",
            "ja": "正味清算価値が確認済みのATHから{value}％以上低下した場合、アカウントは終了します。",
            "ru": "Аккаунт будет автоматически ликвидирован, если текущая Чистая Ликвидационная Стоимость активов упадет на {value}% от Исторического Максимального Значения ЧЛС аккаунта.",
            "tr": "Net Likiditasyon Değerinin, onaylanmış ATH değerinden % {value}'dan fazla düşmesi durumunda hesap sonlandırılacaktır",
            "uk": "Аккаунт буде автоматично ліквідовано якщо поточна Чиста Ліквідаційна Вартість активів впаде на {value}% від Історичного Максимального Значення ЧЛС аккаунта.",
            "zh": "如果净清算价值从确认的ATH下降超过{value}%，账户将被终止"
        },
        "created": {
            "en": "Registration date",
            "fr": "Date d'inscription",
            "it": "Data di registrazione",
            "ja": "登録日",
            "ru": "Дата создания",
            "tr": "Kayıt tarihi",
            "uk": "Дата створення",
            "zh": "注册日期"
        },
        "crossTrading": {
            "en": "Cross-trading",
            "fr": "Cross-trading",
            "it": "Cross-trading",
            "ja": "クロストレード",
            "ru": "Кросс-трейдинг",
            "tr": "Çapraz alım satım işlemi",
            "uk": "Кросс-трейдинг",
            "zh": "交叉交易"
        },
        "crossTrading_TH": {
            "en": "Cross",
            "fr": "Traverser",
            "it": "Cross",
            "ja": "クロス",
            "ru": "Кроссы",
            "tr": "Çapraz",
            "uk": "Кросси",
            "zh": "交叉"
        },
        "crossTrading_description": {
            "en": "Manager is able to trade in {number} pairs between following coins: {array}",
            "fr": "Le gestionnaire peut échanger {number} paires entre les pièces suivantes: {array}",
            "it": "Il gestore è in grado di scambiare {number} coppie tra le seguenti monete: {array}",
            "ja": "マネジャーは、次のコイン間で{number}のペアで取引できます：{array}",
            "ru": "Управляющий может торговать в {number} парах между следующими монетами:  {array}",
            "tr": "Yönetici şu coinler arasında {number} çift alım satım yapabilir: {array}",
            "uk": "Керуючий може торгувати в {number} парах між наступними монетами: {array}",
            "zh": "管理器可以在下列硬币之间交换{number}对：{array}"
        },
        "crossTrading_option": {
            "0": {
                "en": "Allow only base coin trading",
                "fr": "Autoriser uniquement le trading de pièces de base",
                "it": "Consenti solo il trading di monete base",
                "ja": "ベースコインの取引のみを許可",
                "ru": "Торговля только к базовой валюте",
                "tr": "Sadece baz coin alım satım işlemine izin ver",
                "uk": "Торгівля тільки до базової валюти",
                "zh": "只允许基币交易"
            },
            "1": {
                "en": "Can trade any pairs with allowed coins",
                "fr": "Peut échanger n'importe quelle paire avec des pièces autorisées",
                "it": "Può scambiare qualsiasi coppia con monete consentite",
                "ja": "許可したコインでの任意のペアで取引が可能",
                "ru": "Торговля в любых парах между разрешенными монетами",
                "tr": "İzin verilen coin ile herhangi bir çift alım satımı yapabilirsiniz",
                "uk": "Торгівля в будь-яких парах між дозволеними монетами",
                "zh": "可以用允许的硬币交易任何一对硬币"
            }
        },
        "ddPCT": {
            "en": "Drawdown from ATH",
            "fr": "Retrait d'ATH",
            "it": "Drawdown da ATH",
            "ja": "ATHからの減少",
            "ru": "Просадка с последнего хая",
            "tr": "ATH'den düşüş",
            "uk": "Просадка з останнього хая",
            "zh": "从ATH提取"
        },
        "ddPCT_TH": {
            "en": "DD",
            "fr": "DD",
            "it": "DD",
            "ja": "DD",
            "tr": "DD",
            "uk": "DD",
            "zh": "DD"
        },
        "pmaDepositInfo": {
            "en": "Deposit {id} Info (PMA {pmaid} {name})",
            "fr": "Dépôt {id} (PMA {pmaid} {name})",
            "it": "Deposito {id} (PMA {pmaid} {name})",
            "ja": "預金{id} (PMA {pmaid} {name})",
            "ru": "Депозит {id} (PMA {pmaid} {name})",
            "tr": "Mevduat {id} (PMA {pmaid} {name})",
            "uk": "Депозит {id} (PMA {pmaid} {name})",
            "zh": "存款{id} (PMA {pmaid} {name})"
        },
        "depositid": {
            "en": "PMA Deposit ID",
            "fr": "ID de dépôt PMA",
            "it": "ID del deposito PMA",
            "ja": "PMA預金ID",
            "ru": "ID депозита в PMA",
            "tr": "PMA Mevduat kimliği",
            "uk": "ID депозиту в PMA",
            "zh": "PMA存款ID"
        },
        "depositid_TH": {
            "en": "Deposit id",
            "fr": "Identifiant de dépôt",
            "it": "ID del deposito",
            "ja": "入金id",
            "ru": "Депозит id",
            "tr": "Mevduat kimliği",
            "uk": "Депозит id",
            "zh": "存款id"
        },
        "depositstate": {
            "en": "Deposit state",
            "fr": "État de dépôt",
            "it": "Stato del deposito",
            "ja": "預金の状態",
            "ru": "Cтатус депозита",
            "tr": "Mevduat durumu",
            "uk": "Cтатус депозиту",
            "zh": "存款状态"
        },
        "depositstate_TH": {
            "en": "State",
            "fr": "État",
            "it": "Stato",
            "ja": "状態",
            "ru": "Cтатус",
            "tr": "Durum",
            "uk": "Cтатус",
            "zh": "国家"
        },
        "disclosureLevel_option": {
            "0": {
                "en": "Only metrics will be shown",
                "fr": "Seules les mesures seront affichées",
                "it": "Verranno visualizzate solo le metriche",
                "ja": "基準のみが表示されます。",
                "ru": "Показывать только метрики",
                "tr": "Yalnızca metrikler gösterilecektir",
                "uk": "Показувати тільки метрики",
                "zh": "只显示指标"
            },
            "1": {
                "en": "Trades with 7 days delay will be shown",
                "fr": "Les transactions avec un retard de 7 jours seront affichées",
                "it": "Verranno mostrati scambi con 7 giorni di ritardo",
                "ja": "7日遅れの取引が表示されます。",
                "ru": "Сделки будут показаны через 7 дней",
                "tr": "7 gün ertelemeli alım satım işlemleri gösterilecektir",
                "uk": "Угоди будуть показані через 7 днів",
                "zh": "将显示延迟7天的交易"
            },
            "2": {
                "en": "Balances with 7 days delay will be shown",
                "fr": "Les soldes avec 7 jours de retard seront affichés",
                "it": "Verranno visualizzati i saldi con un ritardo di 7 giorni",
                "ja": "7日遅れの残高が表示されます。",
                "ru": "Балансы будут показаны через 7 дней",
                "tr": "7 gün ertelemeyle bakiyeler gösterilecektir",
                "uk": "Баланси будуть показані через 7 днів",
                "zh": "将显示延迟7天的余额"
            },
            "3": {
                "en": "Trades & balances with 7 days delay will be shown",
                "fr": "Les transactions et soldes avec un retard de 7 jours seront affichés",
                "it": "Verranno visualizzati scambi e saldi con un ritardo di 7 giorni",
                "ja": "7日遅れの取引と残高が表示されます。",
                "ru": "Сделки и балансы будут показаны через 7 дней",
                "tr": "7 gün ertelemeli alım satım işlemleri ve bakiyeler gösterilecektir",
                "uk": "Угоди і баланси будуть показані через 7 днів",
                "zh": "将显示延迟7天的交易和余额"
            },
            "4": {
                "en": "Trades with 3 days delay will be shown",
                "fr": "Les transactions avec un retard de 3 jours seront affichées",
                "it": "Verranno mostrati scambi con 3 giorni di ritardo",
                "ja": "3日遅れの取引が表示されます。",
                "ru": "Сделки будут показаны через 3 дня",
                "tr": "3 gün ertelemeli alım satım işlemleri gösterilecektir",
                "uk": "Угоди будуть показані через 3 дні",
                "zh": "将显示延迟3天的交易"
            },
            "5": {
                "en": "Balances with 3 days delay will be shown",
                "fr": "Les soldes avec un retard de 3 jours seront affichés",
                "it": "Verranno visualizzati i saldi con un ritardo di 3 giorni",
                "ja": "3日遅れの残高が表示されます。",
                "ru": "Балансы будут показаны через 3 дня",
                "tr": "3 gün ertelemeyle bakiyeler gösterilecektir",
                "uk": "Баланси будуть показані через 3 дні",
                "zh": "将显示延迟3天的余额"
            },
            "6": {
                "en": "Trades & balances with 3 days delay will be shown",
                "fr": "Les transactions et soldes avec un retard de 3 jours seront affichés",
                "it": "Verranno visualizzati scambi e saldi con un ritardo di 3 giorni",
                "ja": "3日遅れの取引と残高が表示されます。",
                "ru": "Сделки и балансы будут показаны через 3 дня",
                "tr": "3 gün ertelemeli alım satım işlemleri ve bakiyeler gösterilecektir",
                "uk": "Угоди і баланси будуть показані через 3 дні",
                "zh": "将显示延迟3天的交易和余额"
            },
            "7": {
                "en": "Trades with 24H delay will be shown",
                "fr": "Les transactions avec un délai de 24H seront affichées",
                "it": "Verranno mostrati gli scambi con ritardo 24H",
                "ja": "24時間遅れの取引が表示されます。",
                "ru": "Сделки будут показаны с задержкой 24 часа",
                "tr": "24 saat ertelemeli alım satım işlemleri gösterilecektir",
                "uk": "Угоди будуть показані через 24 години",
                "zh": "将显示24小时延迟的交易"
            },
            "8": {
                "en": "Balances with 24H delay will be shown",
                "fr": "Les soldes avec un retard de 24H seront affichés",
                "it": "Verranno visualizzati i saldi con ritardo 24H",
                "ja": "24時間遅れの残高が表示されます。",
                "ru": "Балансы будут показаны через 24 часа",
                "tr": "24 saat ertelemeyle bakiyeler gösterilecektir",
                "uk": "Баланси будуть показані через 24 години",
                "zh": "显示24小时延迟的余额"
            },
            "9": {
                "en": "Trades & balances with 24H delay will be shown",
                "fr": "Les transactions et soldes avec un retard de 24H seront affichés",
                "it": "Verranno visualizzati scambi e saldi con ritardo di 24 ore",
                "ja": "24時間遅れの取引と残高が表示されます。",
                "ru": "Сделки и балансы будут показаны через 24 часа",
                "tr": "24 saat ertelemeli alım satım işlemleri ve bakiyeler gösterilecektir",
                "uk": "Угоди і баланси будуть показані через 24 години",
                "zh": "将显示24小时延迟的交易和余额"
            }
        },
        "disclosurePublic": {
            "en": "Disclosure level for the visitors",
            "fr": "Niveau de divulgation pour les visiteurs",
            "it": "Livello di divulgazione per i visitatori",
            "ja": "訪問者に対する開示レベル",
            "ru": "Степень раскрытия для всех",
            "tr": "Ziyaretçiler için açıklama seviyesi",
            "uk": "Ступінь розкриття для всіх",
            "zh": "对访客的公开程度"
        },
        "disclosurePublic_description": {
            "en": "Manager can decide to show trades, balances or just the performance metrics with a different delay to the visitors on the PMA homepage.",
            "fr": "Le gestionnaire peut décider d'afficher les transactions, les soldes ou simplement les mesures de performance avec un délai différent pour les visiteurs sur la page d'accueil PMA.",
            "it": "Il manager può decidere di mostrare operazioni, saldi o solo le metriche delle prestazioni con un ritardo diverso rispetto ai visitatori sulla homepage di PMA.",
            "ja": "マネジャーは、PMAホームページで訪問者に対して、（異なる遅延に基づき）取引、残高、またはパフォーマンス指標のみを表示することを決定できます。",
            "ru": "Управляющий определяет, будут ли показываться для неприсоединившихся пользователей сделки, балансы, или только статистика по PMA c выбранной задержкой.",
            "tr": "Yönetici, PMA ana sayfasındaki ziyaretçilere farklı bir ertelemeyle alım satım işlemleri, bakiyer veya yalnızca performans metriklerini göstermeye karar verebilir.",
            "uk": "Керуючий визначає, чи будуть показуватися для користувачів, що не приєдналися,  угоди, баланси, або тільки статистика по PMA c обраною затримкою.",
            "zh": "经理可以决定在PMA主页上向访问者显示交易、余额或只是具有不同延迟的绩效指标。"
        },
        "disclosureUsers": {
            "en": "Disclosure level for the subscribers",
            "fr": "Niveau de divulgation pour les abonnés",
            "it": "Livello di divulgazione per gli abbonati",
            "ja": "購読者に対する開示レベル",
            "ru": "Степень раскрытия для подписчиков",
            "tr": "Aboneler için açıklama seviyesi",
            "uk": "Ступінь розкриття для підписників",
            "zh": "订阅服务器的公开级别"
        },
        "disclosureUsers_description": {
            "en": "Manager can decide to show trades, balances or just the performance metrics with different delay to the subscribers of the PMA.",
            "fr": "Le gestionnaire peut décider d'afficher les transactions, les soldes ou simplement les mesures de performance avec un délai différent pour les abonnés de la PMA.",
            "it": "Il manager può decidere di mostrare le negoziazioni, i saldi o solo le metriche di performance con diverso ritardo rispetto agli abbonati della PMA.",
            "ja": "マネジャーは、PMAのサブスクライバーに対して（異なる遅延に基づいて）取引、残高、またはパフォーマンス指標のみを表示することを決定できます。",
            "ru": "Управляющий определяет, будут ли показываться вкладчикам сделки, балансы, или только статистика по PMA c выбранной задержкой.",
            "tr": "Yönetici, PMA aboneleri için farklı erteleme ile alım satım işlemleri, bakiye veya sadece  performans metriklerini göstermeye karar verebilir.",
            "uk": "Керуючий визначає, чи будуть показуватися вкладникам угоди, баланси, або тільки статистика по PMA c обраною затримкою.",
            "zh": "经理可以决定向PMA的订户显示交易、余额或只是具有不同延迟的性能指标。"
        },
        "enterPmaId": {
            "en": "Enter PMA ID",
            "fr": "Entrez l'ID PMA",
            "it": "Immettere l'ID PMA",
            "ja": "PMA IDを入力",
            "ru": "Введите PMA ID",
            "tr": "PMA Kimliğini girin",
            "uk": "Введіть PMA ID",
            "zh": "输入PMA ID"
        },
        "feeA2Afor": {
            "en": "{qty} {type} will be taken from your account for",
            "fr": "{qty} {type} sera prélevé de votre compte pour",
            "it": "{qty} {type} verrà prelevato dal tuo account per",
            "ja": "{qty} {type}があなたのアカウントから取得されます",
            "ru": "{qty} {type} будет списано с вашего аккаунта за ",
            "tr": "{qty} {type} hesabınızdan alınacaktır",
            "uk": "{qty} {type} буде списано з вашого аккаунта за",
            "zh": "{qty}{type}将从您的帐户中提取"
        },
        "feeA2AinSYMfor": {
            "en": "The equivalent of {fee} A2A tokens will be taken in {sym} from your account for",
            "fr": "L'équivalent de {fee} jetons A2A sera prélevé dans {sym} de votre compte pour",
            "it": "L'equivalente di {fee} token A2A verrà preso in {sym} dal tuo account",
            "ja": "{fee} A2Aトークン相当が、アカウントから{sym}で取得されます。",
            "ru": "Эквивалент {fee} токенов A2A будет списан в токенах {sym} с вашего аккаунта за ",
            "tr": "{fee} A2A tokenlerinin eşdeğeri {sym} olarak hesabınızdan alınacaktır",
            "uk": "Еквівалент {fee} токенів A2A буде списаний в токенах {sym} з вашого аккаунта за",
            "zh": "相当于{fee}A2A代币的{sym}将从您的帐户中获取"
        },
        "feeNonRefundable": {
            "en": "This is one time fee and is not refundable.",
            "fr": "Il s'agit de frais uniques et non remboursables.",
            "it": "Questa è una tantum e non è rimborsabile.",
            "ja": "これは1回限りの料金であり、返金できません。",
            "ru": "Это однократное списание и оно не подлежит возврату.",
            "tr": "Bu bir kerelik ücrettir ve iade edilmez.",
            "uk": "Це одноразове списання і воно не підлягає поверненню.",
            "zh": "这是一次性费用，不可退还。"
        },
        "feeSetupPma": {
            "en": "Setup fee for PMA opening:",
            "fr": "Frais d'installation pour l'ouverture de PMA:",
            "it": "Commissione di installazione per l'apertura PMA:",
            "ja": "PMA開始のセットアップ料金：",
            "ru": "Комиссия за создание PMA:",
            "tr": "PMA açılışı için kurulum ücreti:",
            "uk": "Комісія за створення PMA:",
            "zh": "PMA开户手续费："
        },
        "findPMA_tab": {
            "en": "Find PMA",
            "fr": "Trouver PMA",
            "it": "Trova PMA",
            "ja": "PMAを探す",
            "ru": "Подбор PMA",
            "tr": "PMA'yı bulun",
            "uk": "Підбір PMA",
            "zh": "查找PMA"
        },
        "loadPCT": {
            "en": "Current share in altcoins",
            "fr": "Part actuelle des altcoins",
            "it": "Quota attuale in altcoin",
            "ja": "アルトコインの現在の配分",
            "ru": "Процент активов в альткоинах",
            "tr": "Altcoins'deki mevcut pay",
            "uk": "Відсоток активів в альткоінах",
            "zh": "当前在金币中的份额"
        },
        "loadPCT_TH": {
            "en": "LOAD",
            "fr": "CHARGER",
            "it": "CARICA",
            "ja": "読み込む",
            "ru": "Загрузка",
            "tr": "YÜKLE",
            "uk": "Завантаження",
            "zh": "加载"
        },
        "lockupPeriod": {
            "en": "Lock-up period for the deposits",
            "fr": "Période de blocage des dépôts",
            "it": "Periodo di blocco per i depositi",
            "ja": "預金のロックアップ期間",
            "ru": "Период заморозки вывода депозита",
            "tr": "Mevduatlar için kilitlenme süresi",
            "uk": "Період заморозки виведення депозиту",
            "zh": "存款锁定期"
        },
        "lockupPeriod_TH": {
            "en": "LockUp",
            "fr": "LockUp",
            "it": "LockUp",
            "ja": "ロックアップ",
            "ru": "Локап",
            "tr": "Kilitle",
            "uk": "Локап",
            "zh": "封锁"
        },
        "lockupPeriod_description": {
            "en": "Users are unable to withdraw funds by closing their deposits for {value} days from deposit date.",
            "fr": "Les utilisateurs ne sont pas en mesure de retirer des fonds en clôturant leurs dépôts pendant {value} jours à compter de la date de dépôt.",
            "it": "Gli utenti non sono in grado di prelevare fondi chiudendo i loro depositi per {value} giorni dalla data del deposito.",
            "ja": "ユーザーは、入金日から{value}日間、預金を閉鎖して資金を引き出すことができません。",
            "ru": "Пользователи не могут закрыть депозит и вывести средства до истечения {value} дней с даты депозита.",
            "tr": "Kullanıcılar, para yatırma tarihinden itibaren {value} gün boyunca mevduatlarının kapanmasıyla para çekemezler.",
            "uk": "Користувачі не можуть закрити депозит і вивести кошти раніше ніж через {value} днів з дати депозиту.",
            "zh": "用户无法从存款日起{value}天内结清存款来提取资金。"
        },
        "loginto_TH": {
            "en": "Log in",
            "fr": "S'identifier",
            "it": "Registrati",
            "ja": "ログイン",
            "ru": "Войти",
            "tr": "Oturum aç",
            "uk": "Увійти",
            "zh": "登录"
        },
        "loginto_title": {
            "en": "Log in to this PMA",
            "fr": "Connectez-vous à ce PMA",
            "it": "Accedi a questo PMA",
            "ja": "このPMAにログイン",
            "ru": "Войти в этот аккаунт",
            "tr": "Bu PMA'da oturum açın",
            "uk": "Увійти в цей аккаунт",
            "zh": "登录此PMA"
        },
        "lpd": {
            "en": "Last Profit Distribution",
            "fr": "Dernière répartition des bénéfices",
            "it": "Distribuzione dell'ultimo profitto",
            "ja": "前回の収益の分配",
            "ru": "Последнее распределение прибыли",
            "tr": "Son kâr dağıtımı",
            "uk": "Останнє розподілення прибутку",
            "zh": "上次利润分配"
        },
        "lpd_TH": {
            "en": "Distributed",
            "fr": "Distribué",
            "it": "Distribuito",
            "ja": "配分済み",
            "ru": "Распределено",
            "tr": "Dağıtılmış",
            "uk": "Розподілено",
            "zh": "分布的"
        },
        "m_atr": {
            "en": "All-time manager’s reward",
            "fr": "Récompense du manager de tous les temps",
            "it": "Ricompensa totale del manager",
            "ja": "全期間のマネジャーの報酬",
            "ru": "Премия менеджера за все время",
            "tr": "Yöneticinin şimdiye kadarki ödülü",
            "uk": "Сума винагороди менеджера",
            "zh": "全勤经理奖励"
        },
        "m_holdPCT": {
            "en": "Manager’s current reward on hold",
            "fr": "Récompense actuelle du gestionnaire en attente",
            "it": "Premio attuale del gestore in attesa",
            "ja": "マネジャーの保留中の報酬",
            "ru": "Невыведенная награда менеджера",
            "tr": "Yöneticinin bekleyen mevcut ödülü",
            "uk": "Невиведена нагорода менеджера",
            "zh": "经理目前的奖励暂缓"
        },
        "m_sharePCT": {
            "en": "Manager’s current share excluding reward.",
            "fr": "Part actuelle du gestionnaire hors récompense.",
            "it": "Quota corrente del gestore esclusa la ricompensa.",
            "ja": "報酬を除くマネージャーの現在の持ち分",
            "ru": "Доля менеджера за вычетом вознаграждения",
            "tr": "Yöneticinin ödül hariç mevcut payı.",
            "uk": "Частка менеджера за вирахуванням винагороди",
            "zh": "经理当前的股份，不包括报酬。"
        },
        "m_totalPCT": {
            "en": "Manager’s total share",
            "fr": "Part totale du gestionnaire",
            "it": "Quota totale del gestore",
            "ja": "マネジャーの合計シェア",
            "ru": "Полная доля менеджера",
            "tr": "Yöneticinin toplam payı",
            "uk": "Повна частка менеджера",
            "zh": "经理的总份额"
        },
        "m_totalPCT_TH": {
            "en": "MTS",
            "fr": "MTS",
            "it": "MTS",
            "ja": "MTS",
            "ru": "MTS",
            "tr": "MTS",
            "uk": "MTS",
            "zh": "MTS"
        },
        "marketProtectionLevel": {
            "en": "Low-liquidity protection",
            "fr": "Protection à faible liquidité",
            "it": "Protezione a bassa liquidità",
            "ja": "低流動性からの保護",
            "ru": "Защита от неликвидов",
            "tr": "Düşük likidite koruması",
            "uk": "Захист від неліквідів",
            "zh": "低流动性保护"
        },
        "marketProtectionLevel_TH": {
            "en": "MaxSpread",
            "fr": "MaxSpread",
            "it": "MaxSpread",
            "ja": "マックススプレッド",
            "ru": "MaxSpread",
            "tr": "Maksinum Alım-Satım Marjı",
            "uk": "MaxSpread",
            "zh": "最大传播"
        },
        "marketProtectionLevel_description": {
            "en": "Account is restricted for market trades with spread more than {value}% from similar offers.",
            "fr": "Le compte est limité pour les transactions sur le marché avec un écart supérieur à {value}% à partir d'offres similaires.",
            "it": "L'account è limitato per le negoziazioni di mercato con spread superiori al {value}% di offerte simili.",
            "ja": "アカウントは、同様のオファーからスプレッドが{value}％以上である成行注文が制限されています。",
            "ru": "Запрещено выставление сделок со спредом более {value}% от аналогичных оферов.",
            "tr": "Benzer komutlardan % {value} daha fazla alım-satım marjı alan piyasa alım satım işlemleri için hesap kısıtlanmıştır.",
            "uk": "Заборонено виставлення угод зі спредом більше {value}% від аналогічних оферів.",
            "zh": "对于来自类似报价的价差超过{value}%的市场交易，账户受到限制。"
        },
        "marketProtectionLevel_option": {
            "en": "Deny market trades if spread is more than {value}%",
            "fr": "Refuser les transactions sur le marché si l'écart est supérieur à {value}%",
            "it": "Nega le negoziazioni di mercato se lo spread è superiore al {value}%",
            "ja": "スプレッドが{value}％を超える場合、成行注文を拒否します。",
            "ru": "Запретить рыночные сделки если спред более {value}%",
            "tr": "Alım-satım marjı  % {value} değerinden fazlaysa, piyasa alım satım işlemlerini reddet",
            "uk": "Заборонити ринкові угоди якщо спред понад {value}%",
            "zh": "如果价差大于{value}%，则拒绝市场交易"
        },
        "maxCoinShare": {
            "en": "Maximum asset share on PMA",
            "fr": "Part maximale des actifs sur PMA",
            "it": "Quota massima di attività su PMA",
            "ja": "PMAでの最大資産シェア",
            "ru": "Максимальная доля актива в PMA",
            "tr": "PMA bulunan maksimum varlık payı",
            "uk": "Максимальна частка активу в PMA",
            "zh": "PMA的最大资产份额"
        },
        "maxCoinShare_description": {
            "en": "Manager can't put in one asset more equity than specified in this section. The limits are checked on every order placement / change / cancellation",
            "fr": "Le gestionnaire ne peut pas mettre dans un actif plus de capitaux propres que spécifié dans cette section. Les limites sont vérifiées à chaque passation / modification / annulation de commande",
            "it": "Il gestore non può inserire in una risorsa più capitale di quanto specificato in questa sezione. I limiti vengono controllati su ogni ordine / modifica / annullamento dell'ordine",
            "ja": "マネジャーは、このセクションで指定されている以上の資本を1つの資産に入れることはできません。制限はすべての注文の実施/変更/キャンセルで確認されます。",
            "ru": "Менеджер не может перевести в конкретный актив больше средств чем указано в лимитах на этот актив. Это контролируется на этапе выставления / изменения / отмены ордера.",
            "tr": "Yönetici, bu bölümde belirtilenden daha fazla özkaynak varlığı koyamaz. Limitler her komut yerleştirme / değişiklik / iptal işleminde kontrol edilir",
            "uk": "Менеджер не може перевести в конкретний актив більше коштів ніж зазначено в лімітах на цей актив. Це контролюється на етапі виставлення / зміни / відміни ордера.",
            "zh": "经理不能在一项资产中投入超过本节规定的股本。每次下单/更改/取消时都要检查限额"
        },
        "maxDDPCT": {
            "en": "All-time maximum drawdown in percent",
            "fr": "Rabais maximal absolu en pourcentage",
            "it": "Drawdown massimo di tutti i tempi in percentuale",
            "ja": "過去最大のドローダウン（パーセント）",
            "ru": "Максимальная просадка за все время(%)",
            "tr": "Yüzde cinsinden şimdiye kadar ki maksimum düşüş",
            "uk": "Максимальне просідання за весь час(%)",
            "zh": "所有时间最大降幅百分比"
        },
        "maxDDPCT_TH": {
            "en": "MaxDD",
            "fr": "MaxDD",
            "it": "MaxDD",
            "ja": "最大DD",
            "tr": "MaksimumDD",
            "uk": "MaxDD",
            "zh": "最大DD"
        },
        "maxDDPCT_description": {
            "en": "All-time maximum drawdown of the adjusted NLV in percent from the previos high shows worst moment in the PMA's history, also shows the maximum amount of losses in momentum for the hypothetical user that joined the PMA exactly at the previous NLV high.",
            "fr": "Le tirage maximal absolu du NLV ajusté en pourcentage du plus haut précédent montre le pire moment de l'histoire du PMA, montre également la quantité maximale de pertes de momentum pour l'utilisateur hypothétique qui a rejoint le PMA exactement au plus haut précédent du NLV.",
            "it": "L'estrazione massima di tutti i tempi del NLV corretto in percentuale dal massimo precedente mostra il momento peggiore nella storia della PMA, mostra anche la quantità massima di perdite di moto per l'ipotetico utente che si è unito alla PMA esattamente al precedente massimo NLV.",
            "ja": "前の最高値からパーセントで調整済みのNLVの常時最大ドローダウンは、PMAの履歴における最悪の瞬間を示し、以前のNLV最高値でPMAに正確に参加した場合の仮想ユーザーの最大損失も示します。",
            "ru": "Максимальная просадка взвешенной ЧЛС за все время в процентах от предыдущего максимума показывает худший момент за историю этого PMA, также соответствует потерям в моменте для гипотетического пользователя, если бы он зашел в ПМА на предыдущем Максимуме Доходности.",
            "tr": "Önceden ayarlanmış NLV'nin yüzde cinsinden şimdiye kadarki maksimum düşüşü PMA'nın geçmişindeki en kötü anı gösterir, aynı zamanda PMA'ya bir önceki NLV yüksekliğinde tam olarak katılan varsayımsal kullanıcı için maksimum momentum kaybını da gösterir.",
            "uk": "Максимальне просідання зваженої ЧЛС за весь час у відсотках від попереднього максимуму показує найгірший момент за історію цього PMA, також відповідає втратам в моменті для гіпотетичного користувача, якби він зайшов в ПМА на попередньому Максимумі Прибутковості.",
            "zh": "调整后的NLV从PrviOS高的所有时间最大降幅显示PMA的历史中最坏的时刻，也显示了假设用户在前一个NLV高的情况下加入PMA的动量损失的最大量。"
        },
        "minDeposit": {
            "en": "Minimal deposit",
            "fr": "Dépôt minimal",
            "it": "Deposito minimo",
            "ja": "最小入金額",
            "ru": "Минимальный депозит",
            "tr": "Minimal para yatırma",
            "uk": "Мінімальний депозит",
            "zh": "最低存款额"
        },
        "minDeposit_TH": {
            "en": "min DEPO",
            "fr": "min DEPO",
            "it": "min DEPO",
            "ja": "最小入金",
            "ru": "мин ДЕПО",
            "tr": "minimum PARA YATIRMA",
            "uk": "мін ДЕПО",
            "zh": "最小DEPO"
        },
        "minDeposit_description": {
            "en": "User's are unable to make deposit less than {value} {basesym} to this PMA.",
            "fr": "L'utilisateur n'est pas en mesure d'effectuer un dépôt inférieur à {value} {basesym} sur ce PMA.",
            "it": "L'utente non è in grado di effettuare versamenti inferiori a {value} {basesym} a questo PMA.",
            "ja": "ユーザーは、このPMAに{value} {basesym}未満の入金を行うことはできません。",
            "ru": "Минимальная сумма депозита на этот PMA {value} {basesym}.",
            "tr": "Kullanıcı bu PMA'ya {value} {basesym} değerinden daha az para yatıramaz.",
            "uk": "Мінімальна сума депозиту на цей PMA {value} {basesym}.",
            "zh": "用户无法将小于{value}{basesym}的存款存入此PMA。"
        },
        "minOwnFunds": {
            "en": "Minimal share of Manager's own assets",
            "fr": "Part minimale des actifs propres du gestionnaire",
            "it": "Quota minima delle attività proprie del Gestore",
            "ja": "マネジャー自身の資産の最小シェア",
            "ru": "Минимальная доля активов менеджера",
            "tr": "Yöneticinin kendi varlıklarının minimum payı",
            "uk": "Мінімальна частка активів менеджера",
            "zh": "管理者自有资产的最小份额"
        },
        "minOwnFunds_TH": {
            "en": "MAN %",
            "fr": "MAN %",
            "it": "MAN %",
            "ja": "MAN %",
            "ru": "MAN %",
            "tr": "% MAN",
            "uk": "MAN %",
            "zh": "人%"
        },
        "minOwnFunds_description": {
            "en": "After manager's own funds on the account will become less than {value}% from total account's funds, new users will be unable to deposit the funds to your PMA till your own funds will be increased or some users will withdraw their funds.",
            "fr": "Une fois que les fonds propres du gestionnaire sur le compte deviendront inférieurs à {value}% du total des fonds du compte, les nouveaux utilisateurs ne pourront pas déposer les fonds sur votre PMA jusqu'à ce que vos propres fonds soient augmentés ou que certains utilisateurs retirent leurs fonds.",
            "it": "Dopo che i fondi del gestore sul conto diventeranno inferiori al {value}% dal totale dei fondi del conto, i nuovi utenti non saranno in grado di depositare i fondi sul tuo PMA fino a quando i tuoi fondi non saranno aumentati o alcuni utenti ritireranno i loro fondi.",
            "ja": "アカウントのマネジャー自身の資金がアカウントの合計資金から{value}％未満になった後、新しいユーザーは、自分の資金が増加するか、一部のユーザーが資金を引き出すまで、PMAに資金を入金できません。",
            "ru": "После того как доля собственных средств управляющего станет меньше {value}% от всех средств на аккаунте, новые пользователи не смогут делать депозиты в данный PMA до увеличения доли менеджера.",
            "tr": "Yöneticinin, hesaptaki kendi fonları toplam hesabın fonlarından % {value} daha az hale geldikten sonra, kendi fonlarınız artırılıncaya veya bazı kullanıcılar fonlarını çekene kadar yeni kullanıcılar PMA'nıza para yatıramaz.",
            "uk": "Після того як частка власних коштів керуючого стане менше {value}% від всіх коштів на акаунті, нові користувачі не зможуть робити депозити в даний PMA до збільшення частки менеджера.",
            "zh": "当经理在帐户上的自有资金少于帐户总资金的{value}%时，新用户将无法将资金存入您的PMA，直到您的自有资金增加或某些用户将提取他们的资金。"
        },
        "myDepositsListEmpty_description": {
            "en": "You do not have PMA deposits.",
            "fr": "Vous n'avez pas de dépôts PMA.",
            "it": "Non hai depositi PMA.",
            "ja": "PMAの預金がありません。",
            "ru": "У вас нет открытых PMA депозитов",
            "tr": "PMA mevduatınız yok.",
            "uk": "У вас немає відкритих PMA депозитів",
            "zh": "您没有PMA存款。"
        },
        "myDepositsList_description": {
            "en": "You have following PMA deposits:",
            "fr": "Vous disposez des dépôts PMA suivants:",
            "it": "Hai i seguenti depositi PMA:",
            "ja": "次のPMAの預金があります：",
            "ru": "У вас открыты PMA депозиты:",
            "tr": "Aşağıdaki PMA mevduatlarınız vardır:",
            "uk": "У вас відкриті PMA депозити:",
            "zh": "您有以下PMA存款："
        },
        "myDeposits_tab": {
            "DEPREACATED": "DEPRECATED",
            "en": "My Deposits",
            "fr": "Mes dépôts",
            "it": "I miei depositi",
            "ja": "自分の入金",
            "ru": "Мои депозиты",
            "tr": "Mevduatlarım",
            "uk": "Мої депозити",
            "zh": "我的存款"
        },
        "myPMA_tab": {
            "DEPREACATED": "DEPRECATED",
            "en": "My PMA",
            "fr": "Mes PMA",
            "it": "I miei PMA",
            "ja": "自分のPMA",
            "ru": "Мои PMA",
            "tr": "PMA'm",
            "uk": "Мої PMA",
            "zh": "我的PMA"
        },
        "myPmaListEmpty_description": {
            "en": "You do not have PMA under management yet.",
            "fr": "Vous n'avez pas encore de PMA sous gestion.",
            "it": "Non hai ancora gestito PMA.",
            "ja": "PMAがまだ管理下にありません。",
            "ru": "У вас пока нет Мастер-счетов (PMA) под управлением.",
            "tr": "Henüz yönetim altında olan PMA'nız yoktur.",
            "uk": "У вас поки немає Майстер-рахунків (PMA) під керуванням.",
            "zh": "您尚未管理PMA。"
        },
        "myPmaList_description": {
            "en": "You are the manager of the following PMAs:",
            "fr": "Vous êtes le gestionnaire des PMA suivants:",
            "it": "Sei il responsabile dei seguenti PMA:",
            "ja": "あなたは次のPMAのマネジャーです。",
            "ru": "Вы управляете Мастер-счетами (PMA):",
            "tr": "Aşağıdaki PMA'ların yöneticisisiniz:",
            "uk": "Ви керуєте Майстер-рахунками (PMA):",
            "zh": "您是以下PMA的经理："
        },
        "nlv": {
            "en": "Net Liquidation Value",
            "fr": "Valeur nette de liquidation",
            "it": "Valore netto di liquidazione",
            "ja": "正味流動価値",
            "ru": "Чистая Ликвидационная Стоимость (NLV)",
            "tr": "Net Likiditasyon Değeri",
            "uk": "Чиста Ліквідаційна Вартість (NLV)",
            "zh": "净清算值"
        },
        "nlv_TH": {
            "en": "NLV",
            "fr": "NLV",
            "it": "NLV",
            "ja": "NLV",
            "tr": "NLV",
            "uk": "NLV",
            "zh": "NLV"
        },
        "npd": {
            "en": "Next Profit Distribution",
            "fr": "Prochaine distribution des bénéfices",
            "it": "Prossima distribuzione dei guadagni",
            "ja": "次の正味分配額",
            "ru": "Следующее распределение прибыли",
            "tr": "Sonraki kar dağıtımı",
            "uk": "Наступне розподілення прибутку",
            "zh": "下一次利润分配"
        },
        "npd_TH": {
            "en": "Next",
            "fr": "Suite",
            "it": "Il prossimo",
            "ja": "次へ",
            "ru": "Следующее",
            "tr": "Sonraki",
            "uk": "Наступне",
            "zh": "下一个"
        },
        "performancePCT": {
            "en": "All Time Performance (%)",
            "fr": "Performances absolues (%)",
            "it": "Performance di tutti i tempi (%)",
            "ja": "全期間のパフォーマンス（％）",
            "ru": "Доходность за все время (ATP, %)",
            "tr": "Şimdiye Kadarki Performans (%)",
            "uk": "Прибутковість за весь час (ATP,%)",
            "zh": "所有时间性能(%)"
        },
        "performancePCT_TH": {
            "en": "ATP",
            "fr": "ATP",
            "it": "ATP",
            "ja": "ATP",
            "ru": "ATP",
            "tr": "ATP",
            "uk": "ATP",
            "zh": "ATP"
        },
        "permitedSym": {
            "en": "Coins permitted for trading",
            "fr": "Pièces autorisées pour le commerce",
            "it": "Monete permesse per il trading",
            "ja": "取引が許可されているコイン",
            "ru": "Монеты, разрешенные к торговле",
            "tr": "Alım satım işlemi için izin verilen coinler",
            "uk": "Монети, дозволені до торгівлі",
            "zh": "允许交易的硬币"
        },
        "permitedSymSelected": {
            "en": "Selected coins",
            "fr": "Pièces sélectionnées",
            "it": "Monete selezionate",
            "ja": "選択済みのコイン",
            "ru": "Выбранные монеты",
            "tr": "Seçili coinler",
            "uk": "Обрані монети",
            "zh": "精选硬币"
        },
        "permitedSym_TH": {
            "en": "Coins",
            "fr": "Monnaies",
            "it": "Monete",
            "ja": "コイン",
            "ru": "Монеты",
            "tr": "Coinler",
            "uk": "Монети",
            "zh": "硬币"
        },
        "permitedSym_description": {
            "en": "Manager can trade only in pairs that includes only coins selected in this section. Manager cannot put more equity in each asset than set in this section.",
            "fr": "Le gestionnaire ne peut échanger que par paires qui comprend uniquement les pièces sélectionnées dans cette section. Le gestionnaire ne peut pas placer plus de capitaux propres dans chaque actif de négociation que ce qui est défini dans cette section.",
            "it": "Il gestore può scambiare solo in coppie che includono solo monete selezionate in questa sezione. Il gestore non può mettere più equity in ogni asset di trading di quanto impostato in questa sezione.",
            "ja": "マネジャーは、このセクションで選択したコインを含むペアでのみ取引できます。 マネージャーは、このセクションで設定されているよりも多くの株式を各取引資産に入れることはできません。",
            "ru": "Менеджер может торговать только между монетами указанными в этой секции. Менеджер не может переместить в каждый актив больше капитала чем указано в этом разделе.",
            "tr": "Yönetici bu bölümde yalnızca seçili coinleri içeren çiftler halinde alım satım işlemi yapabilir. Yönetici, her bir varlığa bu bölümde belirtilenden daha fazla öz sermaye koyamaz.",
            "uk": "Менеджер може торгувати тільки між монетами зазначеними в цій секції.",
            "zh": "经理只能成对交易，仅包括本节中选择的硬币。经理不能在每个交易资产中投入比本节中所设置的更多的股权。"
        },
        "pma": {
            "en": "Professional Master Account",
            "fr": "Compte maître professionnel",
            "it": "Conto master professionale",
            "ja": "プロフェッショナルマスターアカウント",
            "ru": "Профессиональный Мастер-счет (PMA)",
            "tr": "Profesyonel Ana Hesap",
            "uk": "Професійний Майстер-рахунок (PMA)",
            "zh": "专业主账户"
        },
        "pmaLowShare": {
            "en": "The share of your own funds in this PMA is less than the allowed level, new deposits are not accepted. To let other users make deposits to this PMA, make a deposit of at least {need} {basesym}",
            "fr": "La part de vos fonds propres dans ce PMA est inférieure au niveau autorisé, les nouveaux dépôts ne sont pas acceptés. Pour permettre aux autres utilisateurs d'effectuer des dépôts sur ce PMA, effectuez un dépôt d'au moins {need} {basesym}",
            "it": "La quota dei fondi propri in questa PMA è inferiore al livello consentito, non vengono accettati nuovi depositi. Per consentire ad altri utenti di effettuare depositi su questo PMA, effettua un deposito di almeno {need} {basesym}",
            "ja": "このPMAでのあなた自身の資金のシェアは許容レベルを下回っています。新しい入金は受け入れられません。他のユーザーにこのPMAへの入金を許可するには、少なくとも{need} {basesym}の入金が必要です。",
            "ko": "이 PMA에서의 당신 자산 비율이 허용된 수준보다 낮습니다. 새로운 투자금 유치가 불가능합니다. 다른 유저들의 투자금을 이 PMA에 유치하기 위해서는 최소한 {need} {basesym} 의 예치금이 필요합니다.",
            "ru": "Доля ваших собственных средств в этом PMA менее разрешенного в настройках уровня, новые депозиты не принимаются. Чтобы активировать прием депозитов от других пользователей, сделайте депозит на сумму не менее {need} {basesym}",
            "tr": "Bu PMA'da bulunan fonlarınızın payı izin verilen seviyenin altındadır, yeni para yatırma kabul edilmez. Diğer kullanıcıların bu PMA'ya para yatırmasına izin vermek için, en az {need} {basesym} tutarında olacak şekilde para yatırın",
            "uk": "Частка ваших власних коштів в цьому PMA менш дозволеного в налаштуваннях рівня, нові депозити не приймаються. Щоб активувати прийом депозитів від інших користувачів, зробіть депозит на суму не менше {need} {basesym}",
            "zh": "您在本PMA中的自有资金份额低于允许的水平，不接受新的存款。若要让其他用户向此PMA存款，请至少存款{need}{basesym}"
        },
        "pmaMy": {
            "en": "My PMA",
            "fr": "Mes PMA",
            "it": "I miei PMA",
            "ja": "自分のPMA",
            "ko": "나의 PMA",
            "ru": "Мой PMA",
            "tr": "PMA'm",
            "uk": "Мій PMA",
            "zh": "我的PMA"
        },
        "pmaid": {
            "en": "Unique PMA ID",
            "fr": "ID PMA unique",
            "it": "ID PMA univoco",
            "ja": "固有PMA ID",
            "ru": "Уникальный PMA ID",
            "tr": "Benzersiz PMA kimliği",
            "uk": "Унікальний PMA ID",
            "zh": "独特的PMA ID"
        },
        "pmaid_TH": {
            "en": "PMAid",
            "fr": "PMAid",
            "it": "PMAid",
            "ja": "PMAid",
            "ru": "PMAid",
            "tr": "PMAkimliği",
            "uk": "PMAid",
            "zh": "PMAid"
        },
        "pmas": {
            "en": "Professional Master Accounts",
            "fr": "Comptes Master Professionnels",
            "it": "Conti master professionali",
            "ja": "プロフェッショナルマスターアカウント",
            "ru": "Профессиональные Мастер-счета (PMA)",
            "tr": "Profesyonel Ana Hesaplar",
            "uk": "Професійні Майстер-рахунки (PMA)",
            "zh": "专业主账户"
        },
        "profitDistributionCycle": {
            "en": "Profit distribution every",
            "fr": "Répartition des bénéfices tous les",
            "it": "Distribuzione dei guadagni ogni",
            "ja": "利益分配の単位：",
            "ru": "Распределение прибыли каждые",
            "tr": "Her kâr dağıtımı",
            "uk": "Розподілення прибутку кожні",
            "zh": "每日利润分配"
        },
        "profitDistributionCycle_TH": {
            "en": "Cycle",
            "fr": "Cycle",
            "it": "Ciclo",
            "ja": "サイクル",
            "ru": "Цикл",
            "tr": "Döngü",
            "uk": "Цикл",
            "zh": "循环"
        },
        "profitDistributionCycle_description": {
            "en": "The system will automatically distribute profit (if there is any) from the PMA every {value} days",
            "fr": "Le système distribuera automatiquement les bénéfices (s'il y en a) de la PMA tous les {value} jours",
            "it": "Il sistema distribuirà automaticamente i profitti (se presenti) dal PMA ogni {value} giorni",
            "ja": "システムは、{value}日ごとに、PMAからの利益（ある場合）を自動的に分配します。",
            "ru": "Система автоматически распределяет чистую прибыль (если она есть) среди владельцев депозитов в этом PMA каждые {value} дней.",
            "tr": "Sistem, PMA'dan her {value} günde bir otomatik olarak (varsa) kâr dağıtımı yapar",
            "uk": "Система автоматично розподіляє чистий прибуток (якщо він є) серед власників депозитів в цьому PMA кожні {value} днів.",
            "zh": "系统将每隔{value}天自动从PMA分配利润（如果有的话）"
        },
        "currentProfit": {
            "en": "Current profit",
            "fr": "Bénéfice actuel",
            "it": "Guadagno attuale",
            "ja": "現在の収益",
            "ru": "Текущая прибыль",
            "tr": "Cari kâr",
            "uk": "Поточний прибуток",
            "zh": "当期利润"
        },
        "profitPCT": {
            "en": "Current profit (%)",
            "fr": "Bénéfice actuel (%)",
            "it": "Guadagno attuale (%)",
            "ja": "現在の収益 (%)",
            "ru": "Текущая прибыль(%)",
            "tr": "Cari kâr(%)",
            "uk": "Поточний прибуток(%)",
            "zh": "当期利润(%)"
        },
        "profitPCT_TH": {
            "en": "CP",
            "fr": "CP",
            "it": "CP",
            "ja": "CP",
            "ru": "CP",
            "tr": "CP",
            "uk": "CP",
            "zh": "CP"
        },
        "rank": {
            "en": "Adjusted PMA profitability score",
            "fr": "Score de rentabilité PMA ajusté",
            "it": "Punteggio di redditività PMA rettificato",
            "ja": "調整したPMA収益性スコア",
            "ru": "Показатель стабильности прибыли PMA",
            "tr": "Düzeltilmiş PMA kârlılık skoru",
            "uk": "Показник стабільності прибутку PMA",
            "zh": "调整后的PMA盈利能力得分"
        },
        "rank_TH": {
            "en": "Rank",
            "fr": "Rang",
            "it": "Grado",
            "ja": "ランク",
            "ru": "Rank",
            "tr": "Düzey sırası",
            "uk": "Rank",
            "zh": "等级"
        },
        "referralGiveaway": {
            "en": "50x50 referral giveaway from the manager's reward",
            "fr": "Cadeau de parrainage 50x50 de la récompense du manager",
            "it": "Omaggio di riferimento 50x50 dalla ricompensa del gestore",
            "ja": "マネジャー報酬からの50x50紹介報酬",
            "ru": "Доля участника 50x50 от вознаграждения менеджера",
            "tr": "Yöneticinin ödülünden verilen 50x50 referans hediyesi",
            "uk": "Частка учасника 50x50 від винагороди менеджера",
            "zh": "50x50经理奖励的推荐赠品"
        },
        "referralGiveaway_TH": {
            "en": "50x50",
            "fr": "50x50",
            "it": "50x50",
            "ja": "50x50",
            "ru": "50x50",
            "tr": "50x50",
            "uk": "50x50",
            "zh": "50x50"
        },
        "referralGiveaway_description": {
            "en": "This share will be paid out of the manager's reward to the 50x50 referral program partners for bringing PMA users to the system.",
            "fr": "Cette part sera versée sur la récompense du gestionnaire aux partenaires du programme de référence 50x50 pour avoir amené des utilisateurs PMA dans le système.",
            "it": "Questa quota verrà pagata dalla ricompensa del gestore ai partner del programma di riferimento 50x50 per aver portato gli utenti PMA nel sistema.",
            "ja": "このシェアは、マネジャーの報酬から、50x50紹介プログラムパートナー（PMAユーザーをシステムへともたらすことに対する報酬として）へ支払われます。",
            "ru": "Доля участника партнерки 50x50 в процентах от премии управляющего, выплачиваемая за привлечение пользователя в PMA.",
            "tr": "Bu pay, PMA kullanıcılarını sisteme getirdikleri için 50x50 referans programı ortaklarına yöneticinin ödülülünden ödenecektir.",
            "uk": "Частка учасника партнерки 50x50 у відсотках від премії керуючого, що виплачується за залучення користувача в PMA.",
            "zh": "此份额将从经理奖励中支付给50x50推荐计划合作伙伴，用于将PMA用户带到系统中。"
        },
        "rewardPCT": {
            "en": "Manager's reward in percent (from net profit)",
            "fr": "Récompense du manager en pourcentage (du bénéfice net)",
            "it": "Premio del manager in percentuale (dall'utile netto)",
            "ja": "マネジャーの報酬（パーセント）（純利益から）",
            "ru": "Вознаграждение менеджера за управление в % от чистой прибыли",
            "tr": "Yöneticinin,  yüzde cinsinden ödülü (net kâr üzerinden)",
            "uk": "Винагорода менеджера за управління в % від чистого прибутку",
            "zh": "经理奖励百分比（来自净利润）"
        },
        "rewardPCT_TH": {
            "en": "S.FEE",
            "fr": "S.FEE",
            "it": "S.FEE",
            "ja": "S.FEE",
            "ru": "Комис.",
            "tr": "S.FEE (B.ÜCRETİ)",
            "uk": "Коміс.",
            "zh": "S.FEE"
        },
        "rewardPCT_description": {
            "en": "Success fee. Manager's reward in percent from net profit distributed.",
            "fr": "Frais de réussite. Récompense du gestionnaire en pourcentage du bénéfice net distribué.",
            "it": "Commissione di successo. Premio del gestore in percentuale rispetto all'utile netto distribuito.",
            "ja": "成功報酬であり、分配した純利益に対するマネジャーの報酬です。",
            "ru": "Вознаграждение менеджера за управление в процентах от чистой распределенной прибыли.",
            "tr": "Başarı ücreti. Yöneticinin, dağıtılan net kâr üzerinden yüzde cinsinden ödülü.",
            "uk": "Винагорода менеджера за управління в процентах від чистого розподіленого прибутку.",
            "zh": "成功费。经理从分配的净利润中按百分比计算的报酬。"
        },
        "selectAll_checkbox": {
            "en": "Select ALL",
            "fr": "Tout sélectionner",
            "it": "Seleziona tutto",
            "ja": "全て選択",
            "ru": "Выбрать ВСЕ",
            "tr": "TÜMÜNÜ seç",
            "uk": "Вибрати ВСЕ",
            "zh": "全选"
        },
        "select_placeholder": {
            "en": "select",
            "fr": "sélectionner",
            "it": "Seleziona",
            "ja": "選択",
            "ru": "выберите",
            "tr": "seç",
            "uk": "виберіть",
            "zh": "选择"
        },
        "strategy": {
            "en": "Strategy Description",
            "fr": "Description de la stratégie",
            "it": "Descrizione della strategia",
            "ja": "戦略の説明",
            "ru": "Описание торговой стратегии",
            "tr": "Strateji Açıklaması",
            "uk": "Опис торгової стратегії",
            "zh": "策略描述"
        },
        "strategy_placeholder": {
            "en": "Please tell as much as you can about your trading strategy, risks and expected profit",
            "fr": "Veuillez en dire autant que vous le pouvez sur votre stratégie de trading, les risques et les bénéfices attendus",
            "it": "Indica il più possibile la tua strategia di trading, i rischi e il profitto atteso",
            "ja": "取引戦略、リスク、期待利益についてできるだけ詳しく教えてください。",
            "ru": "Расскажите подробнее о методах торговли, рисках и ожидаемых результатах",
            "tr": "Lütfen alım satım stratejiniz, riskleriniz ve beklenen kârınız hakkında mümkün olduğunca bilgi verin",
            "uk": "Розкажіть докладніше про методи торгівлі, ризики та очікувані результати",
            "zh": "请尽可能多地说明你的交易策略、风险和预期利润"
        },
        "trust_TH": {
            "en": "TRUST",
            "fr": "CONFIANCE",
            "it": "FIDUCIA",
            "ja": "信頼",
            "tr": "GÜVEN",
            "uk": "TRUST",
            "zh": "信任"
        },
        "trust_title": {
            "en": "The level of scam-protection based on PMA restrictions",
            "fr": "Le niveau de protection contre les arnaques basé sur les restrictions PMA",
            "it": "Il livello di protezione dalle truffe basato sulle restrizioni PMA",
            "ja": "PMA制限に基づく詐欺保護のレベル",
            "ru": "Уровень доверия на основе ограничений PMA (Trust Level)",
            "tr": "PMA kısıtlamalarına dayalı sahtekarlık koruması düzeyi",
            "uk": "Рівень довіри на основі обмежень PMA (Trust Level)",
            "zh": "基于PMA限制的诈骗防护等级"
        },
        "users": {
            "en": "Subscribers",
            "fr": "Abonnés",
            "it": "Abbonati",
            "ja": "購読者",
            "ru": "Вкладчики",
            "tr": "Aboneler",
            "uk": "Вкладники",
            "zh": "订阅人"
        },
        "users_TH": {
            "en": "USERS",
            "fr": "UTILISATEURS",
            "it": "UTENTI",
            "ja": "ユーザー",
            "tr": "KULLANICILAR",
            "uk": "USERS",
            "zh": "用户"
        },
        "value_sym_tokens": {
            "en": "{qty} {type} tokens",
            "fr": "{qty} {type} jetons",
            "it": "{qty} {type} gettoni",
            "ja": "{qty} {type}トークン",
            "ru": "{qty} {type} токенов",
            "tr": "{qty} {type} tokenler",
            "uk": "{qty} {type} токенів",
            "zh": "{qty} {type} 代币"
        },
        "yield": {
            "en": "Yield in percent",
            "fr": "Rendement en pourcentage",
            "it": "Resa in percentuale",
            "ja": "利回りの割合",
            "ru": "Годовая доходность (%)",
            "tr": "Yüzde cinsinden kazanç",
            "uk": "Річна прибутковість (%)",
            "zh": "收益率百分比"
        },
        "yield_TH": {
            "en": "Yield",
            "fr": "Rendement",
            "it": "Rendimento",
            "ja": "利回り",
            "ru": "Годовых",
            "tr": "Kazanç",
            "uk": "Річних",
            "zh": "利润"
        }
    },
    "pmaDashboard": {
        "_header": {
            "en": "PMA dashboard",
            "fr": "Tableau de bord PMA",
            "it": "PMA dashboard",
            "ja": "PMAダッシュボード",
            "ru": "Инфопанель PMA",
            "tr": "PMA gösterge tablosu",
            "uk": "Інфопанель PMA",
            "zh": "PMA仪表板"
        },
        "button_clearing": {
            "en": "Clearing",
            "fr": "Rapprochement",
            "it": "Liquidazione",
            "ja": "決済中",
            "ru": "Клиринг",
            "tr": "Mahsup",
            "uk": "Кліринг",
            "zh": "清理"
        },
        "button_close": {
            "en": "Close PMA",
            "fr": "Fermer PMA",
            "it": "Chiudi PMA",
            "ja": "PMAを閉じる",
            "ru": "Закрыть PMA",
            "tr": "PMA'yı kapat",
            "uk": "Закрити PMA",
            "zh": "关闭PMA"
        },
        "noTrades": {
            "en": "There were no trades on this PMA yet.",
            "fr": "Il n'y a pas encore eu d'opérations sur ce PMA.",
            "it": "Non c'erano ancora operazioni su questo PMA.",
            "ja": "このPMAにはまだ取引がありませんでした",
            "ru": "На этом PMA еще не совершалось сделок.",
            "tr": "Bu PMA üzerinde henüz alım satım işlemi yapılmadı.",
            "uk": "На цьому PMA ще не здійснювалися угоди.",
            "zh": "这个PMA还没有交易。"
        },
        "onlyMetrics": {
            "en": "The manager decided to share just the performance metrics. Balances and trades are hidden.",
            "fr": "Le gestionnaire a décidé de partager uniquement les mesures de performance. Les soldes et les transactions sont cachés.",
            "it": "Il manager ha deciso di condividere solo le metriche delle prestazioni. I saldi e gli scambi sono nascosti.",
            "ja": "マネージャーは、パフォーマンス指標のみを共有することにしました。残高と取引は隠されています。",
            "ru": "Менеджер разрешил показ только статистики для этого PMA, балансы и трейды недоступны для просмотра.",
            "tr": "Yönetici yalnızca performans metriklerini paylaşmaya karar verdi. Bakiyeler ve alım satım işlemleri gizlenir.",
            "uk": "Менеджер дозволив показ тільки статистики для цього PMA, баланси і трейди недоступні для перегляду.",
            "zh": "经理决定只分享业绩指标。平衡和交易是隐藏的。"
        },
        "trades_header": {
            "en": "Trade history",
            "fr": "Historiques des échanges",
            "it": "Trade passati",
            "ja": "取引履歴",
            "ru": "История торговли",
            "tr": "Alım satım işlem geçmişi",
            "uk": "Історія торгівлі",
            "zh": "交易历史"
        }
    },
    "pmaDeposits": {
        "_header": {
            "en": "My PMA Deposits",
            "fr": "Mes dépôts PMA",
            "it": "I miei depositi PMA",
            "ja": "自分のPMA入金",
            "ru": "Мои депозиты в PMA",
            "tr": "PMA Mevduatlarım",
            "uk": "Мої депозити в PMA",
            "zh": "我的PMA存款"
        }
    },
    "pmaList": {
        "_header": {
            "en": "Active PMAs",
            "fr": "PMA actifs",
            "it": "PMA Attivi",
            "ja": "有効なPMA",
            "ru": "Активные PMA",
            "tr": "Aktif PMA'lar",
            "uk": "Активні PMA",
            "zh": "活跃的PMAs"
        }
    },
    "pmaOpen": {
        "1_description": {
            "en": "Detailed PMA description can be found at <a href = '{domain.pmaurl}'>{domain.pmaurl}</a>",
            "fr": "La description détaillée du PMA est disponible à <a href ='{domain.pmaurl}'> {domain.pmaurl} </a>",
            "it": "La descrizione dettagliata di PMA è disponibile all'indirizzo <a href ='{domain.pmaurl}'> {domain.pmaurl} </a>",
            "ja": "詳細なPMAの説明は、<a href ='{domain.pmaurl}'>{domain.pmaurl}</a>にあります。",
            "ru": "Подробное описание сервиса доступно на <a href = '{domain.pmaurl}'>{domain.pmaurl}</a>",
            "tr": "Detaylı PMA açıklaması <a href = '{domain.pmaurl}'>{domain.pmaurl}</a> adresinde bulunabilir.",
            "uk": "Детальний опис сервісу є на <a href='{domain.pmaurl}'>{domain.pmaurl}</a>",
            "zh": "详细的PMA描述可以在<a href = '{domain.pmaurl}'>{domain.pmaurl}找到</a>"
        },
        "2_description": {
            "en": ""
        },
        "3_description": {
            "en": "Please select preferrable settings of your new PMA. You will not be able to change them after PMA will be created!!!",
            "fr": "Veuillez sélectionner les paramètres préférables de votre nouveau PMA. Vous ne pourrez pas les modifier après la création de PMA !!!",
            "it": "Seleziona le impostazioni preferibili del tuo nuovo PMA. Non sarai in grado di cambiarli dopo la creazione di PMA !!!",
            "ja": "新しいPMAの設定を選択してください。PMAが作成された後には変更することはできません!!!",
            "ru": "Постарайтесь найти баланс между необходимостью и свободой торговли. Настройте ограничения PMA под свою торговую стратегию. Вы не сможете изменить эти настройки после создания PMA !!!",
            "tr": "Lütfen yeni PMA'nızın tercih edilen ayarlarını seçin. PMA oluşturulduktan sonra bunları değiştiremeyeceksiniz!!!",
            "uk": "Постарайтеся знайти баланс між необхідністю і свободою торгівлі. Налаштуйте обмеження PMA під свою торгову стратегію. Ви не зможете змінити ці налаштування після створення PMA !!!",
            "zh": "请选择新PMA的首选设置。创建PMA后，您将无法更改它们！!!"
        },
        "4_description": {
            "en": "Remember, more restrict options give your PMA more trust in the rank and from the user's poin of view are more secure.Try to find a balance between your trading needs and freedom.",
            "fr": "N'oubliez pas que des options plus restreintes donnent à votre PMA plus de confiance dans le classement et, du point de vue de l'utilisateur, sont plus sécurisées. Essayez de trouver un équilibre entre vos besoins commerciaux et votre liberté.",
            "it": "Ricorda, le opzioni più restrittive danno alla tua PMA una maggiore fiducia nella classifica e dal punto di vista dell'utente sono più sicuri. Prova a trovare un equilibrio tra le tue esigenze di trading e la libertà.",
            "ja": "多くの制限オプションを使用すると、PMAのランクに対する信頼が高まり、ユーザーの視点からはより安全になります。取引ニーズと自由度のバランスを見つけてください。",
            "ru": "Помните, дополнительные ограничения добавляют трастовости вашему аккаунту и влияют на рэнкинг в системе.",
            "tr": "Unutmayın, daha fazla kısıtlama seçeneği, PMA'nıza sıralamada daha fazla güven sağlar ve kullanıcının bakış açısıyla daha güvenlidir.Alım satım işlemi ihtiyaçlarınız ve özgürlüğünüz arasında bir denge bulmaya çalışın.",
            "uk": "Пам'ятайте, додаткові обмеження додають трастовості вашому профілю і впливають на ренкінг в системі.",
            "zh": "请记住，更多的限制选项会让你的PMA在排名上获得更多的信任，从用户的角度来看更安全。试着在你的交易需求和自由之间找到一个平衡点。"
        },
        "_header": {
            "en": "Configure Your New PMA",
            "fr": "Configurez votre nouveau PMA",
            "it": "Configura il tuo nuovo PMAConfigura il tuo nuovo PMA",
            "ja": "新しいPMAを設定する",
            "ru": "Настройка нового PMA",
            "tr": "Yeni PMA'nızı Yapılandırın",
            "uk": "Налаштування нового PMA",
            "zh": "配置新的PMA"
        },
        "button_createPma": {
            "en": "Create New PMA",
            "fr": "Créer un nouveau PMA",
            "it": "Crea nuovo PMA",
            "ja": "新しいPMAを作成",
            "ru": "Создать новый PMA",
            "tr": "Yeni PMA Oluştur",
            "uk": "Створити новий PMA",
            "zh": "创建新PMA"
        }
    },
    "settings": {
        "_header": {
            "en": "Settings",
            "fr": "Réglages",
            "it": "Impostazioni",
            "ja": "設定",
            "ko": "설정",
            "ru": "Настройки",
            "tr": "Ayarlar",
            "uk": "Налаштування",
            "zh": "设置"
        },
        "apikeyList_label": {
            "en": "API keys list",
            "fr": "Liste des clés API",
            "it": "Elenco chiavi API",
            "ja": "APIキーリスト",
            "ko": "API 키 목록",
            "ru": "Список API ключей",
            "tr": "API anahtarları listesi",
            "uk": "Список API ключів",
            "zh": "API密钥列表"
        },
        "bigSpread": {
            "en": "The difference between the order price and the market is more than (3-20%)",
            "fr": "La différence entre le prix de la commande et le marché est supérieure à (3-20%)",
            "it": "La differenza tra il prezzo dell'ordine e il mercato è superiore al (3-20%)",
            "ja": "注文価格と市場の差は（3-20％）以上です",
            "ko": "시장가와 지정가 주문 가격에 큰 차이가 있을 때 경고 (3-20%)",
            "ru": "Цена ордера хуже рыночной более чем на (3-20%)",
            "tr": "Komut fiyatı ve piyasa arasındaki fark (% 3-20) seviyesinden daha fazladır",
            "uk": "Ціна ордера гірше ринкової більш ніж на (3-20%)",
            "zh": "订单价与市场价差大于（3-20%）"
        },
        "button_restoreColors": {
            "en": "Default colors",
            "fr": "Couleurs par défaut",
            "it": "Colori predefiniti",
            "ja": "デフォルトの色",
            "ru": "Цвета по умоланию",
            "tr": "Varsayılan renkler",
            "uk": "Кольори за замовчуванням",
            "zh": "默认颜色"
        },
        "button_saveColors": {
            "en": "Save colors",
            "fr": "Enregistrer les couleurs",
            "it": "Salva i colori",
            "ja": "色を保存する",
            "ru": "Сохранить цвета",
            "tr": "Renkleri kaydet",
            "uk": "Зберегти кольори",
            "zh": "保存颜色"
        },
        "changePassword_button": {
            "en": "Change password",
            "fr": "Changer le mot de passe",
            "it": "Cambia la password",
            "ja": "パスワードを変更",
            "ko": "비밀번호 변경",
            "ru": "Сменить пароль",
            "tr": "Parolayı değiştir",
            "uk": "Змінити пароль",
            "zh": "更改密码"
        },
        "changePassword_label": {
            "en": "Change password",
            "fr": "Changer le mot de passe",
            "it": "Cambia la password",
            "ja": "パスワードを変更",
            "ko": "비밀번호 변경",
            "ru": "Сменить пароль",
            "tr": "Parolayı değiştir",
            "uk": "Змінити пароль",
            "zh": "更改密码"
        },
        "colorBuy": {
            "en": "Buy",
            "fr": "Acheter",
            "it": "Acquista",
            "ja": "購入",
            "ru": "Покупка",
            "tr": "Alış",
            "uk": "Купівля",
            "zh": "购买"
        },
        "colorDark": {
            "en": "Dark theme",
            "fr": "Thème sombre",
            "it": "Tema scuro",
            "ja": "ダークテーマ",
            "ru": "Темная тема",
            "tr": "Koyu tema",
            "uk": "Темна тема",
            "zh": "黑色主题"
        },
        "colorError": {
            "en": "Error / cancel / withdrawal",
            "fr": "Erreur / annulation / retrait",
            "it": "Errore / annullamento / prelevamento",
            "ja": "エラー/キャンセル/出金",
            "ru": "Ошибка / отмена / списание",
            "tr": "Hata / iptal / para çekme",
            "uk": "Помилка / відміна / списання",
            "zh": "错误/取消/撤回"
        },
        "colorLight": {
            "en": "Light theme",
            "fr": "Thème claire",
            "it": "Tema chiaro",
            "ja": "ライトテーマ",
            "ru": "Светлая тема",
            "tr": "Açık tema",
            "uk": "Світла тема",
            "zh": "轻主题"
        },
        "colorSell": {
            "en": "Sell",
            "fr": "Vendre",
            "it": "Vendi",
            "ja": "売却",
            "ru": "Продажа",
            "tr": "Satış",
            "uk": "Продаж",
            "zh": "出售"
        },
        "colorSuccess": {
            "en": "Success / income",
            "fr": "Succès / revenu",
            "it": "Successo / reddito",
            "ja": "成功/収益",
            "ru": "Успех / пополнение",
            "tr": "Başarı / gelir",
            "uk": "Успіх / поповнення",
            "zh": "成功/收入"
        },
        "colors_header": {
            "en": "Colors",
            "fr": "Couleurs",
            "it": "Colori",
            "ja": "色",
            "ru": "Цвета",
            "tr": "Renkler",
            "uk": "Кольори",
            "zh": "颜色"
        },
        "common_header": {
            "en": "Common",
            "fr": "Commun",
            "it": "Comune",
            "ja": "共通",
            "ru": "Общие",
            "tr": "Genel",
            "uk": "Загальні",
            "zh": "普通的"
        },
        "copyShift_label": {
            "en": "Price shift upon orderbook copying",
            "fr": "Changement de prix lors de la copie du carnet de commandes",
            "it": "Spostamento di prezzo al momento della copia del book di negoziazione",
            "ja": "注文帳コピー時の価格変動",
            "ru": "Сдвиг цены при копировании из ордербука",
            "tr": "Komut defterinin kopyalanması üzerine fiyat değişimi",
            "uk": "Зміщення ціни при копіюванні з ордербука",
            "zh": "订单复制时的价格变化"
        },
        "limits_header": {
            "en": "Limits",
            "fr": "Limites",
            "it": "Limiti",
            "ja": "制限",
            "ru": "Лимиты",
            "tr": "Limitler",
            "uk": "Ліміти",
            "zh": "限制"
        },
        "notificationSound": {
            "en": "Notification sound",
            "fr": "Son de notification",
            "it": "Suono di notifica",
            "ja": "通知音",
            "ru": "Звук уведомлений",
            "tr": "Bildirim sesi",
            "uk": "Звук повідомлень",
            "zh": "通知声音"
        },
        "sessionLifetime_description": {
            "en": "Min:{domain.sessionLifetimeMin}, Max:{domain.sessionLifetimeMax}",
            "fr": "Min:{domain.sessionLifetimeMin}, Max:{domain.sessionLifetimeMax}",
            "it": "Min:{domain.sessionLifetimeMin}, Max:{domain.sessionLifetimeMax}",
            "ja": "最小:{domain.sessionLifetimeMin}, 最大:{domain.sessionLifetimeMax}",
            "ru": "Можно поставить значение от {domain.sessionLifetimeMin} до {domain.sessionLifetimeMax}",
            "tr": "Minimum:{domain.sessionLifetimeMin}, Maksimum:{domain.sessionLifetimeMax}",
            "uk": "Можна встановити значення від {domain.sessionLifetimeMin} до {domain.sessionLifetimeMax}",
            "zh": "最小:{domain.sessionLifetimeMin}, 最大:{domain.sessionLifetimeMax}"
        },
        "sessionLifetime_label": {
            "en": "Session lifetime in minutes",
            "fr": "Durée de vie de la session en minutes",
            "it": "Durata della sessione in minuti",
            "ja": "分単位のセッション存続期間",
            "ru": "Время жизни сессии в минутах",
            "tr": "Dakika cinsinden oturum ömrü",
            "uk": "Час життя сесії в хвилинах",
            "zh": "会话生存期（分钟）"
        },
        "sound": {
            "execution": {
                "en": "Only for trades",
                "fr": "Uniquement pour les échanges",
                "it": "Solo per scambi",
                "ja": "取引専用",
                "ru": "Только для исполнений",
                "tr": "Sadece alım satım için",
                "uk": "Тільки для виконань",
                "zh": "仅用于交易"
            },
            "off": {
                "en": "OFF",
                "fr": "Déactivé",
                "it": "OFF",
                "ja": "オフ",
                "ru": "ВЫКЛЮЧЕН",
                "tr": "KAPALI",
                "uk": "ВИКЛЮЧЕНИЙ",
                "zh": "关闭"
            },
            "on": {
                "en": "ON",
                "fr": "Activé",
                "it": "ON",
                "ja": "オン",
                "ru": "ВКЛЮЧЕН",
                "tr": "AÇIK",
                "uk": "ВКЛЮЧЕНИЙ",
                "zh": "打开"
            }
        },
        "twoFactor_label": {
            "en": "Two Factor Authentication",
            "fr": "Authentification à deux facteurs",
            "it": "Autenticazione a due fattori",
            "ja": "二要素認証",
            "ko": "이중 인증",
            "ru": "Двухфакторная авторизация",
            "tr": "İki Faktörlü Kimlik Doğrulama",
            "uk": "Двофакторна авторизація",
            "zh": "双因素身份验证"
        },
        "wotp": {
            "en": "WOTP - Additional Withdrawal OTP",
            "fr": "WOTP - Retrait supplémentaire OTP",
            "it": "WOTP - Prelievo aggiuntivo OTP",
            "ja": "WOTP-追加の出金OTP",
            "ru": "WOTP - Дополнительный код 2FA для Выводов",
            "tr": "WOTP - Ek Para Çekme İşlemi OTP'si",
            "uk": "WOTP - Додатковий код 2FA для Виведення",
            "zh": "WOTP-附加提款OTP"
        },
        "wotp_description": {
            "en": "We recommend running it on a separate device, and it is strongly recommended in case you rarely withdraw but login frequently to trade.",
            "fr": "Vous pouvez activer une clé OTP distincte pour les retraits et les modifications de l'EWA, appelée Retrait OTP. Nous vous recommandons de l'exécuter sur un appareil distinct, et il est fortement recommandé de vous retirer rarement mais de vous connecter fréquemment pour échanger.",
            "it": "È possibile abilitare una chiave OTP separata per i prelievi e le modifiche dell'EWA, denominata OTP di prelievo. Ti consigliamo di eseguirlo su un dispositivo separato ed è fortemente consigliato di ritirarti raramente ma accedi frequentemente per scambiare.",
            "ja": "EWAの引き出しと変更のために、引き出しOTPという別のOTPキーを有効にできます。別のデバイスで実行することをお勧めします。取引を取り消すことはめったにせず、頻繁にログインすることを強くお勧めします。",
            "ru": "Вы можете использовать дополнительный Однократный Код для подтверждения вывода токенов и изменения Адресов Аварийного Вывода. Рекомендуется генерировать такие однократные коды на отдельном устройстве, а не на том, с которого осуществляется вход на биржу, и не на том, на котором идет генерация однократных кодов Двухфакторной Авторизации. Особенно, если вы редко выводите токены, но часто заходите на биржу для торговли.",
            "tr": "Para çekme işlemleri ve ve EWA değişiklikler için, Para Çekme İşlemi OTP'si denilen ayrı bir OTP anahtarını etkinleştirebilirsiniz. Bunu ayrı bir cihazda çalıştırmanızı öneririz ve nadiren para çekmeniz, ancak alım satım işlemi yapmak için sık sık giriş yapmanız önemle tavsiye edilir.",
            "uk": "Ви можете використовувати додатковий Одноразовий Код для підтвердження виведення токенів і зміни Адрес Аварійного Виведення. Рекомендується генерувати такі одноразові коди на окремому пристрої, а не на тому, з якого здійснюється вхід на біржу, і не на тому, на якому йде генерація одноразових кодів Двофакторної Авторизації. Особливо, якщо ви рідко виводите токени, але часто заходите на біржу для торгівлі.",
            "zh": "您可以为提取和更改EWA启用一个单独的OTP密钥，称为提取OTP。我们建议您在单独的设备上运行它，强烈建议您很少退出，但经常登录交易。"
        }
    },
    "tradeLog": {
        "_header": {
            "en": "Trade log",
            "fr": "Journal de commerce",
            "it": "Registro commerciale",
            "ja": "取引ログ",
            "ko": "나의 거래",
            "ru": "Моя торговля",
            "tr": "Alım satım işlemleri günlüğü",
            "uk": "Моя торгівля",
            "zh": "交易日志"
        },
        "switch_types_TH": {
            "all": {
                "en": "All",
                "fr": "Tous",
                "it": "Tutti",
                "ja": "全て",
                "ko": "모두",
                "ru": "Все",
                "tr": "Tümü",
                "uk": "Всі",
                "zh": "全部"
            },
            "closed": {
                "en": "",
                "ko": "닫기",
                "ru": "Закрытие"
            },
            "pair": {
                "en": "Pair filter",
                "fr": "Filtre de paires",
                "it": "Filtro per coppia",
                "ja": "ペアフィルター",
                "ko": "쌍",
                "ru": "Только пара",
                "tr": "Çift filtresi",
                "uk": "Тільки пара",
                "zh": "成对滤波器"
            },
            "placed": {
                "en": "Opened",
                "fr": "Ouvert",
                "it": "Aperto",
                "ja": "開始済み",
                "ko": "개시",
                "ru": "Открыт",
                "tr": "Açık",
                "uk": "Відкритий",
                "zh": "开的"
            },
            "trade": {
                "en": "Trades",
                "fr": "Échanges",
                "it": "Trades",
                "ja": "取引",
                "ko": "거래",
                "ru": "Торговля",
                "tr": "Alım satım işlemleri",
                "uk": "Торгівля",
                "zh": "交易"
            }
        }
    },
    "transactions": {
        "findCoin_placeholder": {
            "en": "Find coin",
            "fr": "Trouver la monnaie",
            "it": "Trova una moneta",
            "ja": "探索アイコン",
            "ko": "코인 찾기",
            "ru": "Поиск монеты",
            "tr": "Coin bul",
            "uk": "Пошук монети",
            "zh": "找到硬币"
        },
        "incomingEmpty_description": {
            "en": "There are no incoming transactions",
            "fr": "Il n'y a aucune transaction entrante",
            "it": "Non ci sono transazioni in entrata",
            "ja": "トランザクションの受信はありません。",
            "ko": "수신 트랜잭션이 없습니다",
            "ru": "Нет входящих транзакции",
            "tr": "Gelen işlem yok",
            "uk": "Немає вхідних транзакцій",
            "zh": "没有收入交易"
        },
        "status": {},
        "withdrawEmpty_description": {
            "en": "There are no withdrawal transactions",
            "fr": "Il n'y a pas d'opérations de retrait",
            "it": "Non ci sono transazioni di prelievo",
            "ja": "出金トランザクションがありません。",
            "ko": "인출 거래는 없습니다",
            "ru": "Нет исходящих транзакции",
            "tr": "Para çekme işlemi yok",
            "uk": "Немає вихідних транзакцій",
            "zh": "没有提款交易"
        }
    },
    "wallets": {
    },
	"status": {
		"error_min_xrp_activation": {
			"en": "You are sending to the unactivated XRP address. New XRP addresses require minimum 20 XRP to be sent for the activation.",
			"ru": "Ошибка: Вы указали неактивированный адрес XRP. Требуется послать минимум 20 XRP для его активации."
		},
		"error_missing_tag": {
			"en": "Error: Tag Required",
			"ru": "Ошибка: Обязательно нужно указать TAG (тег)"
		},
		"error_invalid_public_key": {
			"en": "Invalid public key",
			"ru": "Неверный публичный ключ"
		},
		"error_invalid_tag": {
			"en": "Error: Invalid Tag",
			"ru": "Ошибка: Неправильный TAG (тег)"
		},
		"repaid": {
			"en": "Repaid",
			"ru": "Возвращен"
		},
		"notStarted": {
			"en": "Not started yet",
			"ru": "Ожидает отмены"
		},
		"inProgress": {
			"en": "In Progress",
			"ru": "Продолжается"
		},
		"finished": {
			"en": "Finished",
			"ru": "Завершено"
		},
		"awaitingCancellation": {
			"en": "Аwaiting cancellation",
			"fr": "Attendre l'annulation",
			"it": "Attendi l'annullamento",
			"ja": "キャンセル待ち",
			"ko": "취소 대기",
			"ru": "Ожидает отмены",
			"tr": "İptali için bekleyin",
			"uk": "Очікує відміни",
			"zh": "等待取消"
		},
		"canceling": {
			"en": "Canceling",
			"fr": "En cours d'annulation",
			"it": "In corso d'annullamento",
			"ja": "キャンセル中",
			"ko": "취소 중",
			"ru": "Отмена",
			"tr": "İptal",
			"uk": "Відміна",
			"zh": "取消"
		},
		"canceled": {
			"en": "Cancelled",
			"fr": "Annulé",
			"it": "Annullato",
			"ja": "キャンセル済み",
			"ko": "취소됨",
			"ru": "Отменен",
			"tr": "İptal edildi",
			"uk": "Відмінений",
			"zh": "取消了"
		},
		"canceledByUser": {
			"en": "Cancelled by the user",
			"fr": "Annulé par l'utilisateur",
			"it": "Annullate dall'utente",
			"ja": "ユーザーによりキャンセル",
			"ru": "Отменена пользователем",
			"tr": "Kullanıcı tarafından iptal edildi",
			"uk": "Відмінена користувачем",
			"zh": "被用户取消"
		},
		"confirmed": {
			"en": "Сonfirmed",
			"fr": "Confirmé",
			"it": "Confermato",
			"ja": "確認済み",
			"ru": "Подтверждена",
			"tr": "Onaylandı",
			"uk": "Підтверджена",
			"zh": "确认的"
		},
		"closedPosition": {
			"en": "Closed position",
			"fr": "Position fermée",
			"it": "Posizione chiusa",
			"ja": "確定済みのポジション",
			"ko": "닫힌 포지션",
			"ru": "Закрытая позиция",
			"tr": "Kapalı pozisyon",
			"uk": "Закрита позиція",
			"zh": "关闭位置"
		},
		"canceledPosition": {
			"en": "Canceled position",
			"fr": "Position annulée",
			"it": "Posizione cancellata",
			"ja": "キャンセルしたポジション",
			"ru": "Отмененная позиция",
			"tr": "İptal edilmiş konum",
			"uk": "Відмінена позиція",
			"zh": "取消的职位"
		},
		"finishedPosition": {
			"en": "Finished Position",
			"fr": "Position Achevée",
			"it": "Posizione finale",
			"ja": "終了したポジション",
			"ru": "Завершенная Позиция",
			"tr": "Tamamlanmış Konum",
			"uk": "Завершена Позиція",
			"zh": "完成位置"
		},
		"done": {
			"en": "Done",
			"fr": "Éxecuté",
			"it": "Eseguito",
			"ja": "完了",
			"ru": "Выполнено",
			"tr": "Tamamlandı",
			"uk": "Ок",
			"zh": "完毕"
		},
		"error_invalid_address": {
			"en": "Invalid address",
			"fr": "Adresse invalide",
			"it": "Indirizzo non valido",
			"ja": "アドレスが有効ではありません。",
			"ru": "Неверный формат адреса",
			"tr": "Geçersiz adres",
			"uk": "Невірний формат адреси",
			"zh": "无效地址"
		},
		"error_required_memo": {
			"en": "TAG (memo) required",
			"ru": "Нужен TAG(memo)"
		},
		"error_user_blocked": {
			"en": "User blocked",
			"fr": "Utilisateur bloqué",
			"it": "Utente bloccato",
			"ja": "ユーザーがブロックされました。",
			"ru": "Пользователь заблокирован",
			"tr": "Kullanıcı engellendi",
			"uk": "Користувач заблокований",
			"zh": "用户被阻止"
		},
		"error_wd_disabled": {
			"en": "Withdrawal disabled",
			"fr": "Retrait désactivé",
			"it": "Prelievi disabilitati",
			"ja": "出金が無効になっています。",
			"ru": "Вывод отключен",
			"tr": "Para çekme işlemi devre dışı bırakıldı",
			"uk": "Виведення відключене",
			"zh": "取款已禁用"
		},
		"fulfilled": {
			"en": "Fulfilled",
			"fr": "Réalisée",
			"it": "Effettuato",
			"ja": "確定済み",
			"ko": "완전히 이행됨",
			"ru": "Исполнен",
			"tr": "Gerçekleştirilmiş",
			"uk": "Виконаний",
			"zh": "完成了"
		},
		"new": {
			"en": "New",
			"fr": "Nouveau",
			"it": "Nuovo",
			"ja": "新規",
			"ru": "Новая",
			"tr": "Yeni",
			"uk": "Нова",
			"zh": "新的"
		},
		"ok": {
			"en": "Ok",
			"fr": "Ok",
			"it": "Ok",
			"ja": "OK",
			"ru": "Ок",
			"tr": "Tamam",
			"uk": "Ок",
			"zh": "好啊"
		},
		"fail": {
			"en": "Fail",
			"ru": "Ошибка"
		},
		"openPosition": {
			"en": "Open position",
			"fr": "Position ouverte",
			"it": "Posizione apperta",
			"ja": "未決済のポジション",
			"ko": "열린 포지션",
			"ru": "Открытая позиция",
			"tr": "Açık pozisyon",
			"uk": "Відкрита позиція",
			"zh": "打开位置"
		},
		"placed": {
			"en": "Placed",
			"fr": "Placé",
			"it": "Effettuato",
			"ja": "注文済み",
			"ko": "호스팅됨",
			"ru": "Размещен",
			"tr": "Yerleştirilmiş",
			"uk": "Розміщений",
			"zh": "放置"
		},
		"partiallyFilled": {
			"en": "Partially filled",
			"fr": "Partiellement réalisé",
			"it": "Parzialmente Effettuato",
			"ja": "一部確定",
			"ko": "부분 이행됨",
			"ru": "Частично исполнен",
			"tr": "Kısmen yerine getirilmiş",
			"uk": "Частково виконаний",
			"zh": "部分填充"
		},
		"suspended": {
			"en": "Suspended",
			"fr": "Suspendu",
			"it": "Sospeso",
			"ja": "保留",
			"ru": "Ожидание",
			"tr": "Askıya alındı",
			"uk": "Очікування",
			"zh": "暂停的"
		},
		"waiting": {
			"en": "Waiting",
			"fr": "En cours d'attente",
			"it": "In attesa",
			"ja": "待機中",
			"ru": "Ожидание",
			"tr": "Bekleme",
			"uk": "Очікування",
			"zh": "等待"
		},
		"delayed": {
			"en": "Delayed",
			"ru": "Задержка"
		},
		"granted": {
			"en": "Granted",
			"ru": "Предоставлен"
		},
		"replacementRequired": {
			"en": "Replacement Required",
			"ru": "Нуждается в замене"
		},
		"repayable": {
			"en": "Repayable",
			"ru": "Готов к возврату"
		}
	}
}